'use strict';

var _get = require("/Users/tongjie/Desktop/pili-rtc-web/pili-rtc-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _slicedToArray = require("/Users/tongjie/Desktop/pili-rtc-web/pili-rtc-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _defineProperty2 = require("/Users/tongjie/Desktop/pili-rtc-web/pili-rtc-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _toConsumableArray = require("/Users/tongjie/Desktop/pili-rtc-web/pili-rtc-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _assertThisInitialized = require("/Users/tongjie/Desktop/pili-rtc-web/pili-rtc-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _wrapNativeSuper = require("/Users/tongjie/Desktop/pili-rtc-web/pili-rtc-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _regeneratorRuntime = require("/Users/tongjie/Desktop/pili-rtc-web/pili-rtc-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/tongjie/Desktop/pili-rtc-web/pili-rtc-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _possibleConstructorReturn = require("/Users/tongjie/Desktop/pili-rtc-web/pili-rtc-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/tongjie/Desktop/pili-rtc-web/pili-rtc-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/tongjie/Desktop/pili-rtc-web/pili-rtc-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/Users/tongjie/Desktop/pili-rtc-web/pili-rtc-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/tongjie/Desktop/pili-rtc-web/pili-rtc-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var __chunk_1 = require('./chunk-b806d793.js');

require('detect-browser');

require('semver');

require('mobile-detect');

require('./shim.js');

var EventEmitter = _interopDefault(require('wolfy87-eventemitter'));

var remove = _interopDefault(require('lodash.remove'));

var Fingerprint2 = _interopDefault(require('fingerprintjs2'));

var localforage = _interopDefault(require('localforage'));

var pako = _interopDefault(require('pako'));

var md5 = _interopDefault(require('blueimp-md5'));

var groupBy = _interopDefault(require('lodash.groupby'));

var uniqBy = _interopDefault(require('lodash.uniqby'));

var sdpTransform = _interopDefault(require('sdp-transform'));
/*
 * device.ts
 * Copyright (C) 2018 disoul <disoul@DiSouldeMacBook-Pro.local>
 *
 * Distributed under terms of the MIT license.
*/


var REC_AUDIO_ENABLE = function REC_AUDIO_ENABLE(config) {
  return !!config && !!config.audio && config.audio.enabled;
};

var REC_VIDEO_ENABLE = function REC_VIDEO_ENABLE(config) {
  return !!config && !!config.video && config.video.enabled;
};

var REC_SCREEN_ENABLE = function REC_SCREEN_ENABLE(config) {
  return !!config && !!config.screen && config.screen.enabled;
};
/**
 * Note that "display-capture"(code value is 2) is the name for screen display permission,
 * but it is not supported now
 */


var PermissionNameCode;

(function (PermissionNameCode) {
  PermissionNameCode[PermissionNameCode["camera"] = 0] = "camera";
  PermissionNameCode[PermissionNameCode["microphone"] = 1] = "microphone";
})(PermissionNameCode || (PermissionNameCode = {}));

var PermissionStateCode;

(function (PermissionStateCode) {
  PermissionStateCode[PermissionStateCode["prompt"] = 1] = "prompt";
  PermissionStateCode[PermissionStateCode["denied"] = 2] = "denied";
  PermissionStateCode[PermissionStateCode["granted"] = 3] = "granted";
})(PermissionStateCode || (PermissionStateCode = {}));
/*
 * result.ts
 * Copyright (C) 2number18 disoul <disoul@DiSouldeMacBook-Pro.local>
 *
 * Distributed under terms of the MIT license.
*/


function isDefined(argument) {
  return argument !== undefined;
}
/**
 * 网络质量等级枚举
 */


var NetworkGrade;

(function (NetworkGrade) {
  /**
   * 网络等级还未获取
   */
  NetworkGrade[NetworkGrade["INVALID"] = -1] = "INVALID";
  /**
   * 网络优
   */

  NetworkGrade[NetworkGrade["EXCELLENT"] = 1] = "EXCELLENT";
  /**
   * 网络良
   */

  NetworkGrade[NetworkGrade["GOOD"] = 2] = "GOOD";
  /**
   * 网络一般
   */

  NetworkGrade[NetworkGrade["FAIR"] = 3] = "FAIR";
  /**
   * 网络较差
   */

  NetworkGrade[NetworkGrade["POOR"] = 4] = "POOR";
})(NetworkGrade || (NetworkGrade = {}));
/*
 * stream.ts
 * Copyright (C) 2018 disoul <disoul@DiSouldeMacBook-Pro.local>
 *
 * Distributed under terms of the MIT license.
*/


var TrackConnectStatus;

(function (TrackConnectStatus) {
  TrackConnectStatus[TrackConnectStatus["Idle"] = 0] = "Idle";
  TrackConnectStatus[TrackConnectStatus["Connecting"] = 1] = "Connecting";
  TrackConnectStatus[TrackConnectStatus["Connect"] = 2] = "Connect";
})(TrackConnectStatus || (TrackConnectStatus = {}));

var TrackSourceType;

(function (TrackSourceType) {
  TrackSourceType[TrackSourceType["NORMAL"] = 0] = "NORMAL";
  TrackSourceType[TrackSourceType["EXTERNAL"] = 1] = "EXTERNAL";
  TrackSourceType[TrackSourceType["MIXING"] = 2] = "MIXING";
})(TrackSourceType || (TrackSourceType = {}));
/*
 * merger.ts
 * Copyright (C) 2018 disoul <disoul@DiSouldeMacBook-Pro.local>
 *
 * Distributed under terms of the MIT license.
*/


var defaultMergeJob = {
  publishUrl: "",
  height: 720,
  width: 1080,
  fps: 25,
  kbps: 1000,
  audioOnly: false,
  stretchMode: "aspectFill"
};
var AudioSourceState;

(function (AudioSourceState) {
  AudioSourceState["IDLE"] = "idle";
  AudioSourceState["LOADING"] = "loading";
  AudioSourceState["PLAY"] = "play";
  AudioSourceState["PAUSE"] = "pause";
  AudioSourceState["END"] = "end";
})(AudioSourceState || (AudioSourceState = {})); // 类型根据这个页面来定：https://cf.qiniu.io/pages/viewpage.action?pageId=21006743


var QosEventType = {
  Init: 1,
  UnInit: 2,
  JoinRoom: 3,
  MCSAuth: 4,
  SignalAuth: 5,
  LeaveRoom: 6,
  PublisherPC: 7,
  PublishTracks: 8,
  UnPublishTracks: 9,
  SubscriberPC: 10,
  SubscribeTracks: 11,
  UnSubscribeTracks: 13,
  MuteTracks: 14,
  ICEConnectionState: 15,
  CallbackStatistics: 16,
  KickoutUser: 17,
  RoomStateChanged: 18,
  AudioDeviceInOut: 19,
  VideoDeviceInOut: 20,
  SDKError: 21,
  ApplicationState: 22,
  CreateMergeJob: 24,
  UpdateMergeTracks: 25,
  StopMerge: 26,
  AuthorizationStatus: 27,
  DeviceChanged: 28,
  DefaultSetting: 29,
  MediaStatistics: 30,
  AbnormalDisconnect: 31,
  CreateForwardJob: 36,
  StopForwardJob: 37,
  WebsocketConnect: 40,
  NetworkChange: 46,
  SystemRequirementsTest: 47,
  AutoplayFail: 49,
  TrackEnded: 50,
  WebSDKException: 51,
  VideoPlayQuality: 53,
  AudioPlayQuality: 54,
  JoinRoomResult: 55,
  SetClientRole: 56,
  StartMediaRelay: 57,
  UpdateMediaRelay: 58,
  StopMediaRelay: 59,
  MCURelayAuth: 60
};
/**
 * SDK版本号
 */

var version = "4.1.2"; // @internal

var LogModel =
/*#__PURE__*/
function () {
  function LogModel(level) {
    _classCallCheck(this, LogModel);

    this.level = level;
  }

  _createClass(LogModel, [{
    key: "setLevel",
    value: function setLevel(level) {
      this.level = level;
    }
  }, {
    key: "log",
    value: function log() {
      var _console;

      if (this.level !== "log") {
        return;
      }

      var pretitle = "".concat(getLogTimeString(), " %cLOG-QNRTC");
      var style = "color: #66ccff; font-weight: bold;";

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      (_console = console).info.apply(_console, [pretitle, style].concat(args));
    }
  }, {
    key: "debug",
    value: function debug() {
      var _console2;

      if (this.level !== "log" && this.level !== "debug") {
        return;
      }

      var pretitle = "".concat(getLogTimeString(), " %cDEBUG-QNRTC");
      var style = "color: #A28148; font-weight: bold;";

      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      (_console2 = console).info.apply(_console2, [pretitle, style].concat(args));
    }
  }, {
    key: "warning",
    value: function warning() {
      var _console3;

      if (this.level === "disable") {
        return;
      }

      var pretitle = "".concat(getLogTimeString(), " %cWARNING-QNRTC");
      var style = "color: #E44F44; font-weight: bold;";

      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      (_console3 = console).warn.apply(_console3, [pretitle, style].concat(args));
    }
  }]);

  return LogModel;
}();

function getLogTimeString() {
  var date = new Date();

  function padingStart(num) {
    var str = num.toString();

    if (str.length < 2) {
      return "0" + str;
    }

    return str;
  }

  var hours = padingStart(date.getHours());
  var mins = padingStart(date.getMinutes());
  var secs = padingStart(date.getSeconds());
  var msecs = date.getMilliseconds();
  return "[".concat(hours, ":").concat(mins, ":").concat(secs, ".").concat(msecs, "]");
}

var log = new LogModel("log");

var TaskQueue =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(TaskQueue, _EventEmitter);

  function TaskQueue(name) {
    var _this16;

    var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    _classCallCheck(this, TaskQueue);

    _this16 = _possibleConstructorReturn(this, _getPrototypeOf(TaskQueue).call(this)); // Closed flag.

    _this16._closed = false; // Busy running a command.

    _this16._busy = false; // Queue for pending commands. Each command is an Object with method,
    // resolve, reject, and other members (depending the case).

    _this16._queue = [];
    _this16.name = name || "TaskQueue";
    _this16.isDebug = debug;
    return _this16;
  }

  _createClass(TaskQueue, [{
    key: "close",
    value: function close() {
      this._closed = true;
    }
  }, {
    key: "push",
    value: function push(method, data) {
      var _this17 = this;

      if (this.isDebug) {
        log.debug("".concat(this.name, " push()"), method, data);
      }

      return new Promise(function (resolve, reject) {
        var queue = _this17._queue; // Append command to the queue.

        queue.push({
          method: method,
          data: data,
          resolve: resolve,
          reject: reject
        });

        _this17._handlePendingCommands();
      });
    }
  }, {
    key: "_handlePendingCommands",
    value: function _handlePendingCommands() {
      var _this18 = this;

      if (this._busy) {
        return;
      }

      var queue = this._queue; // Take the first command.

      var command = queue[0];

      if (!command) {
        return;
      }

      this._busy = true; // Execute it.

      this._handleCommand(command).then(function () {
        _this18._busy = false; // Remove the first command (the completed one) from the queue.

        queue.shift(); // And continue.

        _this18._handlePendingCommands();
      });
    }
  }, {
    key: "_handleCommand",
    value: function _handleCommand(command) {
      var _this19 = this;

      if (this.isDebug) {
        log.debug("".concat(this.name, " _handleCommand() "), command.method, command.data);
      }

      if (this._closed) {
        command.reject(new InvalidStateError("closed"));
        return Promise.resolve();
      }

      var promiseHolder = {
        promise: null
      };
      this.emit("exec", command, promiseHolder);
      return Promise.resolve().then(function () {
        return promiseHolder.promise;
      }).then(function (result) {
        if (_this19.isDebug) {
          log.debug("".concat(_this19.name, " _handleCommand() | command succeeded"), command.method);
        }

        if (_this19._closed) {
          command.reject(new InvalidStateError("closed"));
          return;
        } // Resolve the command with the given result (if any).


        command.resolve(result);
      }).catch(function (error) {
        if (_this19.isDebug) {
          log.warning("".concat(_this19.name, " _handleCommand() | command failed [method:%s]: %o"), command.method, error);
        } // Reject the command with the error.


        command.reject(error);
      });
    }
  }]);

  return TaskQueue;
}(EventEmitter);

var QNRTC_EVENTS_STORATE_KEY = "qnrtcqosevents";

var QosModel =
/*#__PURE__*/
function () {
  function QosModel() {
    var _this20 = this;

    _classCallCheck(this, QosModel);

    this.events = [];
    this.lastSubmitTime = Date.now();
    this.submitQueue = new TaskQueue("qossubmit", false);
    getDeviceId().then(function (deviceId) {
      _this20.deviceId = deviceId;
      _this20.base.device_id = _this20.deviceId;
    }).catch(function () {
      _this20.deviceId = "unknow";
      _this20.base.device_id = _this20.deviceId;
    });
    this.base = {
      qos_version: "2.0",
      device_id: "",
      bundle_id: "",
      url: window.location.href,
      app_version: "",
      sdk_version: version,
      device_model: "".concat(__chunk_1.browser.name).concat(__chunk_1.browser.version),
      os_platform: "Web",
      os_version: "",
      host_environment: __chunk_1.browser.os
    };
    this.initSubmitQueue();
    this.submitQueue.push("resume").catch(noop);
  }

  _createClass(QosModel, [{
    key: "setSessionId",
    value: function setSessionId(sessionId) {
      for (var i = this.events.length - 1; i >= 0; i -= 1) {
        var event = this.events[i];
        if (event.session_id) break;
        event.session_id = sessionId;
      }

      this.sessionId = sessionId;
    }
  }, {
    key: "setUserBase",
    value: function setUserBase(userName, roomName, appId) {
      this.userBase = {
        user_id: userName,
        room_name: roomName,
        app_id: appId
      };

      for (var i = this.events.length - 1; i >= 0; i -= 1) {
        var event = this.events[i];
        if (event.user_base) break;
        event.user_base = this.userBase;
      }
    }
  }, {
    key: "addEvent",
    value: function addEvent(eventType, data, isForce) {
      var event = __chunk_1._objectSpread({
        timestamp: Date.now(),
        event_id: QosEventType[eventType],
        event_name: eventType
      }, data);

      this.submitQueue.push("add", event).catch(noop);
      this.submit(isForce);
    }
  }, {
    key: "submit",
    value: function submit() {
      var isForce = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.submitQueue.push("submit", isForce).catch(noop);
    }
  }, {
    key: "initSubmitQueue",
    value: function initSubmitQueue() {
      var _this21 = this;

      this.submitQueue.on("exec", function (command, ph) {
        switch (command.method) {
          case "submit":
            {
              ph.promise = _this21._submit(command.data);
              return;
            }

          case "add":
            {
              ph.promise = _this21._addEvent(command.data);
              return;
            }

          case "resume":
            {
              ph.promise = _this21._recoverStoredEvents();
              return;
            }
        }
      });
    }
  }, {
    key: "_recoverStoredEvents",
    value: function () {
      var _recoverStoredEvents2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return localforage.getItem(QNRTC_EVENTS_STORATE_KEY);

              case 2:
                res = _context.sent;
                log.log("get item", res);
                _context.next = 6;
                return localforage.removeItem(QNRTC_EVENTS_STORATE_KEY);

              case 6:
                if (res) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return");

              case 8:
                this.events = JSON.parse(window.atob(decodeURIComponent(res))); // 没有 sessionid 或者 user_base 的数据将被丢弃

                this.events = this.events.filter(function (e) {
                  return !!e.session_id && !!e.user_base;
                }).sort(function (a, b) {
                  return a.event.timestamp - b.event.timestamp;
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _recoverStoredEvents() {
        return _recoverStoredEvents2.apply(this, arguments);
      }

      return _recoverStoredEvents;
    }()
  }, {
    key: "_addEvent",
    value: function _addEvent(event) {
      this.events.push({
        user_base: this.userBase,
        event: event,
        session_id: this.sessionId
      });
      this.submit();
      return Promise.resolve();
    }
  }, {
    key: "saveEvents",
    value: function saveEvents() {
      var events = encodeURIComponent(window.btoa(JSON.stringify(this.events)));
      localforage.setItem(QNRTC_EVENTS_STORATE_KEY, events).catch(noop);
    }
  }, {
    key: "submitCheck",
    value: function submitCheck() {
      if (!this.sessionId || !this.deviceId || !this.userBase) return false;
      if (Date.now() - this.lastSubmitTime > 60000 * 5) return true;
      if (this.events.length >= 30) return true;
      return false;
    }
  }, {
    key: "_submit",
    value: function () {
      var _submit2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var isForce,
            result,
            submitData,
            _iteratorNormalCompletion,
            _didIteratorError,
            _iteratorError,
            _iterator,
            _step,
            data,
            res,
            _args2 = arguments;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                isForce = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : false;
                result = isForce ? true : this.submitCheck();

                if (result) {
                  _context2.next = 5;
                  break;
                }

                this.saveEvents();
                return _context2.abrupt("return");

              case 5:
                _context2.prev = 5;
                submitData = this.encodeQosSubmitData();
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 10;
                _iterator = submitData[Symbol.iterator]();

              case 12:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context2.next = 22;
                  break;
                }

                data = _step.value;
                _context2.next = 16;
                return fetch("https://pili-rtc-qos.qiniuapi.com/v1/rtcevent", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/x-gzip"
                  },
                  body: data.buffer
                });

              case 16:
                res = _context2.sent;

                if (res.ok) {
                  _context2.next = 19;
                  break;
                }

                throw ERROR_FATAL("rtcevent error");

              case 19:
                _iteratorNormalCompletion = true;
                _context2.next = 12;
                break;

              case 22:
                _context2.next = 28;
                break;

              case 24:
                _context2.prev = 24;
                _context2.t0 = _context2["catch"](10);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 28:
                _context2.prev = 28;
                _context2.prev = 29;

                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }

              case 31:
                _context2.prev = 31;

                if (!_didIteratorError) {
                  _context2.next = 34;
                  break;
                }

                throw _iteratorError;

              case 34:
                return _context2.finish(31);

              case 35:
                return _context2.finish(28);

              case 36:
                this.lastSubmitTime = Date.now();
                this.events = [];
                _context2.next = 40;
                return localforage.removeItem(QNRTC_EVENTS_STORATE_KEY);

              case 40:
                _context2.next = 45;
                break;

              case 42:
                _context2.prev = 42;
                _context2.t1 = _context2["catch"](5);
                log.log(_context2.t1);

              case 45:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[5, 42], [10, 24, 28, 36], [29,, 31, 35]]);
      }));

      function _submit() {
        return _submit2.apply(this, arguments);
      }

      return _submit;
    }()
  }, {
    key: "encodeQosSubmitData",
    value: function encodeQosSubmitData() {
      var submitDataGroup = groupBy(this.events, function (e) {
        return e.session_id || "" + JSON.stringify(e.user_base);
      });
      var data = [];

      for (var key in submitDataGroup) {
        var events = submitDataGroup[key];
        if (events.length === 0) continue;
        var submitData = {
          session_id: events[0].session_id,
          user_base: events[0].user_base,
          base: this.base,
          items: events.map(function (e) {
            return e.event;
          })
        };
        log.log("encode", submitData);
        var byteArray = new Uint8Array(pako.gzip(toUTF8Array(JSON.stringify(submitData))));
        data.push(byteArray);
      }

      return data;
    }
  }]);

  return QosModel;
}();

function getDeviceId() {
  return new Promise(function (resolve, reject) {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(function () {
        Fingerprint2.get(function (components) {
          var deviceId = md5(JSON.stringify(components));
          resolve(deviceId);
        });
      });
    } else {
      setTimeout(function () {
        Fingerprint2.get(function (components) {
          var deviceId = md5(JSON.stringify(components));
          resolve(deviceId);
        });
      }, 500);
    }
  });
}

function toUTF8Array(str) {
  var utf8 = [];

  for (var i = 0; i < str.length; i++) {
    var charcode = str.charCodeAt(i);
    if (charcode < 0x80) utf8.push(charcode);else if (charcode < 0x800) {
      utf8.push(0xc0 | charcode >> 6, 0x80 | charcode & 0x3f);
    } else if (charcode < 0xd800 || charcode >= 0xe000) {
      utf8.push(0xe0 | charcode >> 12, 0x80 | charcode >> 6 & 0x3f, 0x80 | charcode & 0x3f);
    } // surrogate pair
    else {
        i++; // UTF-16 encodes 0x10000-0x10FFFF by
        // subtracting 0x10000 and splitting the
        // 20 bits of 0x0-0xFFFFF into two halves

        charcode = 0x10000 + ((charcode & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff);
        utf8.push(0xf0 | charcode >> 18, 0x80 | charcode >> 12 & 0x3f, 0x80 | charcode >> 6 & 0x3f, 0x80 | charcode & 0x3f);
      }
  }

  return new Uint8Array(utf8);
}

var qos = new QosModel();
/**
 * setup permissions qos event
 */

{
  var sendQosPermission = function sendQosPermission(state, permissionNameCode) {
    var permissionStateCode;

    switch (state) {
      case "prompt":
        permissionStateCode = PermissionStateCode["prompt"];
        break;

      case "granted":
        permissionStateCode = PermissionStateCode["granted"];
        break;

      case "denied":
        permissionStateCode = PermissionStateCode["denied"];
        break;

      default:
        return;
    }

    qos.addEvent("AuthorizationStatus", {
      type: permissionNameCode,
      status: permissionStateCode
    });
  };

  var queryPermission = function queryPermission(qosPermissionName) {
    if (n && n.permissions) {
      n.permissions.query({
        name: qosPermissionName
      }).then(function (permissionStatus) {
        sendQosPermission(permissionStatus.state, PermissionNameCode[qosPermissionName]);

        permissionStatus.onchange = function () {
          sendQosPermission(permissionStatus.state, PermissionNameCode[qosPermissionName]);
        };
      }).catch(function (error) {
        log.debug("error when queryPermission", error);
      });
    }
  };

  var n = navigator;
  queryPermission("camera");
  queryPermission("microphone");
}
/**
 * setup page visibility qos event
 */

{
  if (!!document.visibilityState) {
    document.addEventListener("visibilitychange", function () {
      qos.addEvent("ApplicationState", {
        state: document.visibilityState === "visible" ? 0 : 2
      });
    });
  }
}

var qnCheckNetworkChangeQos = function () {
  var networkGrade = NetworkGrade.INVALID;
  var networkName = "unknow";

  var getNetworkTypeByNetworkName = function getNetworkTypeByNetworkName(name) {
    var networkType;

    switch (name) {
      case "cellular":
        networkType = 0;
        break;

      case "wifi":
        networkType = 1;
        break;

      case "ethernet":
        networkType = 2;
        break;

      default:
        networkType = -1;
    }

    return networkType;
  };

  var addQos = function addQos() {
    qos.addEvent("NetworkChange", {
      network_type: getNetworkTypeByNetworkName(networkName),
      network_name: networkName,
      network_grade: networkGrade
    });
  };

  var n = navigator;
  var connection = n.connection || n.mozConnection || n.webkitConnection;

  if (connection && connection.type) {
    networkName = connection.type;

    connection.onchange = function () {
      if (networkName !== connection.type) {
        networkName = connection.type;
        addQos();
      }
    };
  }

  addQos();
  return function (g) {
    if (g !== networkGrade) {
      networkGrade = g;
      addQos();
    }
  };
}();
/*
 * error.ts
 * Copyright (C) 2018 disoul <disoul@DiSouldeMacBook-Pro.local>
 *
 * Distributed under terms of the MIT license.
*/


var QNRTCError =
/*#__PURE__*/
function (_Error) {
  _inherits(QNRTCError, _Error);

  function QNRTCError(code, message) {
    var _this22;

    _classCallCheck(this, QNRTCError);

    _this22 = _possibleConstructorReturn(this, _getPrototypeOf(QNRTCError).call(this, message));
    _this22.code = code;
    _this22.error = message;
    qos.addEvent("SDKError", {
      error_code: code,
      error_msg: message
    });
    return _this22;
  }

  return QNRTCError;
}(_wrapNativeSuper(Error)); // 各端错误码统一
// 客户端自定义的，按照这个文档：https://cf.qiniu.io/pages/viewpage.action?pageId=75957748
// 服务端返回的，直接使用服务端返回的 error code
// 客户端自定义 code


var ERROR_INVALID_PARAMETER = function ERROR_INVALID_PARAMETER(msg) {
  return new QNRTCError(10053, "invalid parameters: ".concat(msg));
};

var ERROR_FATAL = function ERROR_FATAL(msg) {
  return new QNRTCError(21005, "piliRTC: unexpected error ".concat(msg));
};

var ERROR_AUTH_FAILED = function ERROR_AUTH_FAILED(msg) {
  return new QNRTCError(21001, "enterRoom error, can not get accessToken. Error: ".concat(msg, "\n please check enterRoom arguments"));
};

var ERROR_RECONNECT_FAILED = function ERROR_RECONNECT_FAILED(msg) {
  return new QNRTCError(21003, "reconnect failed\uFF01".concat(msg));
};

var ERROR_NOT_SUPPORT = function ERROR_NOT_SUPPORT(msg) {
  return new QNRTCError(21006, "not support! ".concat(msg));
};

var ERROR_PLAY_NOT_ALLOWED = function ERROR_PLAY_NOT_ALLOWED(msg) {
  return new QNRTCError(21007, "track play is not allowed: ".concat(msg));
};

var ERROR_PLUGIN_NOT_AVAILABLE = function ERROR_PLUGIN_NOT_AVAILABLE(msg) {
  return new QNRTCError(23003, "plugin not avaliable! ".concat(msg));
};

var ERROR_DEVICE_NOT_ALLOWED = function ERROR_DEVICE_NOT_ALLOWED(msg) {
  return new QNRTCError(23004, "NotAllowedError: no permission to access media device. ".concat(msg));
};

var ERROR_AUDIO_DECODE_ERROR = function ERROR_AUDIO_DECODE_ERROR(e) {
  return new QNRTCError(22011, "can not decode audio data, ".concat(e.toString()));
};

var CREATE_SCREEN_AUDIO_ERROR = function CREATE_SCREEN_AUDIO_ERROR() {
  return new QNRTCError(23005, "no audio track when createScreenVideoTrack withAudio enable");
};

var ERROR_ELECTRON_REQUIRE_ERROR = function ERROR_ELECTRON_REQUIRE_ERROR(msg) {
  return new QNRTCError(23008, "require('electron') error, please checkout if electron environment is ok: ".concat(msg));
};

var ERROR_RELAY_TOKEN = function ERROR_RELAY_TOKEN(msg) {
  return new QNRTCError(24000, "relay error, can not get relayToken. Error: ".concat(msg));
};

var ERROR_INVALID_CLIENT_MODE = function ERROR_INVALID_CLIENT_MODE(msg) {
  return new QNRTCError(24001, "invalid client mode, ".concat(msg));
};

var ERROR_INVALID_CLIENT_ROLE = function ERROR_INVALID_CLIENT_ROLE(msg) {
  return new QNRTCError(24002, "invalid client role, ".concat(msg));
};

var WS_ABORT = function WS_ABORT() {
  return ERROR_FATAL("websocket abort");
};

var NO_MERGE_JOB = function NO_MERGE_JOB(id) {
  return ERROR_INVALID_PARAMETER("can not set merge layout stream, no merge job id ".concat(id));
};

var SCREEN_PERMISSION_DENIED = function SCREEN_PERMISSION_DENIED() {
  return ERROR_DEVICE_NOT_ALLOWED("can not sharing screen/window on chrome");
};

var SUB_PUB_ABORT = function SUB_PUB_ABORT() {
  return ERROR_FATAL("subscribe/publish operation is aborted");
};

var PRESET_NOT_FOUND = function PRESET_NOT_FOUND() {
  return ERROR_INVALID_PARAMETER("cannot found preset");
}; // 服务端返回 code


var PUBLISH_ERROR = function PUBLISH_ERROR(code, msg) {
  return new QNRTCError(code, "publish error, signaling code: ".concat(code, ", msg: ").concat(msg));
};

var CREATE_MERGE_JOB_ERROR = function CREATE_MERGE_JOB_ERROR(code, msg) {
  return new QNRTCError(code, "create merge job error, signaling code: ".concat(code, ", msg: ").concat(msg));
};

var CREATE_FORWARD_JOB_ERROR = function CREATE_FORWARD_JOB_ERROR(code, msg) {
  return new QNRTCError(code, "create forward job error, signaling code: ".concat(code, ", msg: ").concat(msg));
};

var UNSUPPORT_FMT = function UNSUPPORT_FMT(code, msg) {
  return new QNRTCError(code, "media format not support, ".concat(msg));
};

var JOIN_ROOM_ERROR = function JOIN_ROOM_ERROR(code, msg) {
  return new QNRTCError(code, "joinRoom error, code: ".concat(code, ", ").concat(msg));
};

var SUB_ERROR = function SUB_ERROR(code, msg) {
  return new QNRTCError(code, "subscribe error, signaling code: ".concat(code, ", msg: ").concat(msg));
};

var UNPUBLISH_ERROR = function UNPUBLISH_ERROR(code, msg) {
  return new QNRTCError(code, "unpublish error, code: ${code}, msg: ${msg}");
};

var UNSUB_ERROR = function UNSUB_ERROR(code, msg) {
  return new QNRTCError(code, "unsubscribe error, code: ${code}, msg: ${msg}");
};

var CONTROL_ERROR = function CONTROL_ERROR(code, msg) {
  return new QNRTCError(code, "send control error, code: ".concat(code, ", msg: ").concat(msg));
};

var SERVER_ERROR = function SERVER_ERROR(code, msg) {
  return new QNRTCError(code, msg);
};

var SERVER_UNAVAILABLE = function SERVER_UNAVAILABLE() {
  return new QNRTCError(10052, "server unavailable");
};
/**
 * Error produced when calling a method in an invalid state.
 */


var InvalidStateError =
/*#__PURE__*/
function (_Error2) {
  _inherits(InvalidStateError, _Error2);

  function InvalidStateError(message) {
    var _this23;

    _classCallCheck(this, InvalidStateError);

    _this23 = _possibleConstructorReturn(this, _getPrototypeOf(InvalidStateError).call(this, message));
    _this23.name = "InvalidStateError";

    if (Error.hasOwnProperty("captureStackTrace")) {
      // Just in V8.
      Error.captureStackTrace(_assertThisInitialized(_assertThisInitialized(_this23)), InvalidStateError);
    } else {
      _this23.stack = new Error(message).stack;
    }

    return _this23;
  }

  return InvalidStateError;
}(_wrapNativeSuper(Error));

var error =
/*#__PURE__*/
Object.freeze({
  QNRTCError: QNRTCError,
  ERROR_INVALID_PARAMETER: ERROR_INVALID_PARAMETER,
  ERROR_FATAL: ERROR_FATAL,
  ERROR_AUTH_FAILED: ERROR_AUTH_FAILED,
  ERROR_RECONNECT_FAILED: ERROR_RECONNECT_FAILED,
  ERROR_NOT_SUPPORT: ERROR_NOT_SUPPORT,
  ERROR_PLAY_NOT_ALLOWED: ERROR_PLAY_NOT_ALLOWED,
  ERROR_PLUGIN_NOT_AVAILABLE: ERROR_PLUGIN_NOT_AVAILABLE,
  ERROR_DEVICE_NOT_ALLOWED: ERROR_DEVICE_NOT_ALLOWED,
  ERROR_AUDIO_DECODE_ERROR: ERROR_AUDIO_DECODE_ERROR,
  CREATE_SCREEN_AUDIO_ERROR: CREATE_SCREEN_AUDIO_ERROR,
  ERROR_ELECTRON_REQUIRE_ERROR: ERROR_ELECTRON_REQUIRE_ERROR,
  ERROR_RELAY_TOKEN: ERROR_RELAY_TOKEN,
  ERROR_INVALID_CLIENT_MODE: ERROR_INVALID_CLIENT_MODE,
  ERROR_INVALID_CLIENT_ROLE: ERROR_INVALID_CLIENT_ROLE,
  WS_ABORT: WS_ABORT,
  NO_MERGE_JOB: NO_MERGE_JOB,
  SCREEN_PERMISSION_DENIED: SCREEN_PERMISSION_DENIED,
  SUB_PUB_ABORT: SUB_PUB_ABORT,
  PRESET_NOT_FOUND: PRESET_NOT_FOUND,
  PUBLISH_ERROR: PUBLISH_ERROR,
  CREATE_MERGE_JOB_ERROR: CREATE_MERGE_JOB_ERROR,
  CREATE_FORWARD_JOB_ERROR: CREATE_FORWARD_JOB_ERROR,
  UNSUPPORT_FMT: UNSUPPORT_FMT,
  JOIN_ROOM_ERROR: JOIN_ROOM_ERROR,
  SUB_ERROR: SUB_ERROR,
  UNPUBLISH_ERROR: UNPUBLISH_ERROR,
  UNSUB_ERROR: UNSUB_ERROR,
  CONTROL_ERROR: CONTROL_ERROR,
  SERVER_ERROR: SERVER_ERROR,
  SERVER_UNAVAILABLE: SERVER_UNAVAILABLE,
  InvalidStateError: InvalidStateError
});

function getPayloadFromJwt(jwttoken) {
  var payloadString = jwttoken.split(".")[1];

  if (!payloadString) {
    throw new Error("parse jwt error, can not find payload string.");
  }

  var decoedString = atob(payloadString);
  return JSON.parse(decoedString);
}

function getRoomAccessFromToken(roomToken) {
  try {
    var roomAccessString = roomToken.split(":")[2];
    var decoedString = atob(roomAccessString);
    return JSON.parse(decoedString);
  } catch (e) {
    throw ERROR_FATAL("can not parse roomToken, ".concat(e));
  }
}

function removeElementFromArray(array, key, value) {
  var newArray = [];
  var removeElement = null;

  for (var i = 0; i < array.length; i += 1) {
    var element = array[i];

    if (element[key] === value) {
      removeElement = array[i];
      continue;
    }

    newArray.push(array[i]);
  }

  return {
    removeElement: removeElement,
    newArray: newArray
  };
}

function getElementFromArray(array, key, value) {
  if (!value) {
    return null;
  }

  for (var i = 0; i < array.length; i += 1) {
    var item = array[i];

    if (item[key] === value) {
      return item;
    }
  }

  return null;
}

function noop() {}

function removeUndefinedKey(obj) {
  var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (depth >= 4) {
    return obj;
  }

  for (var key in obj) {
    if (obj[key] === undefined) {
      delete obj[key];
    }

    if (obj[key] instanceof File) continue;
    if (obj[key] instanceof ArrayBuffer) continue;

    if (typeof obj[key] === "object") {
      obj[key] = removeUndefinedKey(obj[key], depth + 1);
    }
  }

  return obj;
}

function nextTick(func) {
  var p = Promise.resolve();
  p.then(func);
}

function getMissingUserEvent(currentUserId, lastTracksInfo, currentTracksInfo, lastUsers, currentUsers) {
  var missingEvent = {
    join: [],
    leave: [],
    add: [],
    remove: [],
    mute: []
  };
  var lastTracksIds = lastTracksInfo.map(function (info) {
    return info.trackid;
  });
  var currentTracksIds = currentTracksInfo.map(function (info) {
    return info.trackid;
  });
  lastTracksIds.forEach(function (trackID, i) {
    if (lastTracksInfo[i].playerid === currentUserId) {
      return;
    }

    if (currentTracksIds.indexOf(trackID) === -1) {
      missingEvent.remove.push(lastTracksInfo[i]);
    } else {
      var currentTracksInfoItem = currentTracksInfo.find(function (t) {
        return t.trackid === trackID;
      });
      var lastTrackInfoItem = lastTracksInfo[i]; // 如果重连后 trackid 相同但是 versionid 不同，抛出 track-remove 和 track-add

      if (currentTracksInfoItem.versionid !== lastTrackInfoItem.versionid) {
        missingEvent.remove.push(lastTrackInfoItem);
        missingEvent.add.push(currentTracksInfoItem);
      }
    }
  });
  currentTracksIds.forEach(function (trackID, i) {
    if (currentTracksInfo[i].playerid === currentUserId) {
      return;
    }

    var index = lastTracksIds.indexOf(trackID);

    if (index === -1) {
      missingEvent.add.push(currentTracksInfo[i]);
      missingEvent.mute.push({
        trackid: trackID,
        muted: currentTracksInfo[i].muted
      });
    } else {
      if (currentTracksInfo[i].muted !== lastTracksInfo[index].muted) {
        missingEvent.mute.push({
          trackid: trackID,
          muted: currentTracksInfo[i].muted
        });
      }
    }
  });
  lastUsers.forEach(function (userID) {
    if (userID === currentUserId) {
      return;
    }

    if (currentUsers.indexOf(userID) === -1) {
      missingEvent.leave.push({
        playerid: userID
      });
    }
  });
  currentUsers.forEach(function (userID) {
    if (userID === currentUserId) {
      return;
    }

    if (lastUsers.indexOf(userID) === -1) {
      missingEvent.join.push({
        playerid: userID
      });
    }
  });
  return missingEvent;
}

function dec2hex(dec) {
  return ("0" + dec.toString(16)).substr(-2);
}

function randomStringGen() {
  var strLength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
  var arr = new Uint8Array((strLength || 40) / 2);
  window.crypto.getRandomValues(arr);
  return Array.from(arr, dec2hex).join("");
}

function timeout(ms) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      resolve();
    }, ms);
  });
}

var runOnceFlag = {};
/**
 * 对于相同 key 的调用，只会执行一次
 */

function runOnce(func, key) {
  if (!runOnceFlag[key]) {
    runOnceFlag[key] = true;
    return func();
  }
}

function showPlayWarn(e) {
  log.warning("play failed!", e);
  log.warning("play failed due to browser security policy, see: http://s.qnsdk.com/s/Txsdz");
}
/**
 * 计算字符串字节数
 * @param {string} strs 字符串
 * @returns {number} 字符串字节数
 */


function calcCharacterLength(strs) {
  return new Blob([strs]).size;
}
/*
 * http.js
 * Copyright (C) 2018 disoul <disoul@DiSouldeMacBook-Pro.local>
 *
 * Distributed under terms of the MIT license.
 */


function request(url, timeout) {
  function rejectByStatus(status, statusText, reject) {
    if (status >= 400) {
      reject({
        retry: false,
        message: statusText
      });
    }

    if (status !== 200) {
      reject({
        retry: true,
        message: statusText
      });
    }
  }

  return new Promise(function (resolve, reject) {
    var promise;

    if ("AbortController" in window) {
      var abortController = new AbortController();
      setTimeout(function () {
        return abortController.abort();
      }, timeout);
      promise = fetch(url, {
        signal: abortController.signal
      });
    } else {
      promise = fetch(url);
    }

    promise.then(function (res) {
      rejectByStatus(res.status, res.statusText, reject);
      return res.json();
    }).then(resolve).catch(reject);
  });
}

function resolveIceHost(_x) {
  return _resolveIceHost.apply(this, arguments);
}

function _resolveIceHost() {
  _resolveIceHost = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee117(host) {
    var ipv6Match, ipv4Match, res, data;
    return _regeneratorRuntime.wrap(function _callee117$(_context117) {
      while (1) {
        switch (_context117.prev = _context117.next) {
          case 0:
            ipv6Match = host.match(/(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))/);
            ipv4Match = host.match(/^([01]?\d\d?|2[0-4]\d|25[0-5])\.([01]?\d\d?|2[0-4]\d|25[0-5])\.([01]?\d\d?|2[0-4]\d|25[0-5])\.([01]?\d\d?|2[0-4]\d|25[0-5])$/);

            if (!(!!ipv4Match || !!ipv6Match)) {
              _context117.next = 4;
              break;
            }

            return _context117.abrupt("return", host);

          case 4:
            _context117.prev = 4;
            _context117.next = 7;
            return fetch("https://".concat(host, "/ip"));

          case 7:
            res = _context117.sent;
            _context117.next = 10;
            return res.json();

          case 10:
            data = _context117.sent;
            return _context117.abrupt("return", data.ip);

          case 14:
            _context117.prev = 14;
            _context117.t0 = _context117["catch"](4);
            log.warning("resolve ice failed, retry", _context117.t0);
            _context117.next = 19;
            return timeout(1000);

          case 19:
            _context117.next = 21;
            return resolveIceHost(host);

          case 21:
            return _context117.abrupt("return", _context117.sent);

          case 22:
          case "end":
            return _context117.stop();
        }
      }
    }, _callee117, this, [[4, 14]]);
  }));
  return _resolveIceHost.apply(this, arguments);
}

var ExceptionStatus;

(function (ExceptionStatus) {
  ExceptionStatus[ExceptionStatus["AudioLevelUnusual"] = 0] = "AudioLevelUnusual";
})(ExceptionStatus || (ExceptionStatus = {}));

var WebSDKException =
/*#__PURE__*/
function () {
  _createClass(WebSDKException, null, [{
    key: "create",
    value: function create(qosInfo) {
      if (!this.instance) {
        this.instance = new WebSDKException();
      }

      var validStandard = this.instance.getValidStandard(qosInfo.code);
      this.instance.qosAddEvent(__chunk_1._objectSpread({
        valid_standard: validStandard
      }, qosInfo));
      return this.instance;
    }
  }]);

  function WebSDKException() {
    _classCallCheck(this, WebSDKException);
  }

  _createClass(WebSDKException, [{
    key: "qosAddEvent",
    value: function qosAddEvent(qosInfo) {
      qos.addEvent("WebSDKException", qosInfo);
    }
  }, {
    key: "getValidStandard",
    value: function getValidStandard(code) {
      switch (code) {
        case ExceptionStatus.AudioLevelUnusual:
          return '0-1';
      }
    }
  }]);

  return WebSDKException;
}();

var ExpFilter =
/*#__PURE__*/
function () {
  function ExpFilter(filterType) {
    var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ExpFilter.AlphaForPacketLossFractionSmoother;

    _classCallCheck(this, ExpFilter);

    this.mLastFilteredTimestamp = Date.now();
    this.mMax = ExpFilter.kValueUndefined;
    this.smooth_interval = filterType === "audio" ? ExpFilter.SMOOTH_AUDIO_INTERVAL : ExpFilter.SMOOTH_VIDEO_INTERVAL;
    this.Reset(alpha);
  } // Resets the filter to its initial state, and resets filter factor base to
  // the given value |alpha|.


  _createClass(ExpFilter, [{
    key: "Reset",
    value: function Reset(alpha) {
      this.mAlpha = alpha;
      this.mFiltered = ExpFilter.kValueUndefined;
    } // Applies the filter with a given exponent on the provided sample:
    // y(k) = min(alpha_^ exp * y(k-1) + (1 - alpha_^ exp) * sample, max_).

  }, {
    key: "Apply",
    value: function Apply(sample) {
      var exp = Date.now() - this.mLastFilteredTimestamp; // only when sample === 0 then it may be false report

      if (exp < this.smooth_interval && sample === 0) {
        this.applied = false;
        return;
      }

      var value;

      if (this.mFiltered === ExpFilter.kValueUndefined) {
        // Initialize filtered value.
        value = sample;
      } else if (exp === 1.0) {
        value = this.mAlpha * this.mFiltered + (1 - this.mAlpha) * sample;
      } else {
        var alpha = Math.pow(this.mAlpha, exp);
        value = alpha * this.mFiltered + (1 - alpha) * sample;
      } // Math.pow above may get NaN


      if (!isNaN(value)) {
        this.mFiltered = value;
      }

      if (this.mMax !== ExpFilter.kValueUndefined && this.mFiltered > this.mMax) {
        this.mFiltered = this.mMax;
      }

      this.mLastFilteredTimestamp = Date.now();
      this.applied = true;
    } // Returns current filtered value.

  }, {
    key: "Filtered",
    value: function Filtered() {
      return this.mFiltered;
    }
  }, {
    key: "LastFilteredTime",
    value: function LastFilteredTime() {
      return this.mLastFilteredTimestamp;
    } // Changes the filter factor base to the given value |alpha|.

  }, {
    key: "UpdateBase",
    value: function UpdateBase(alpha) {
      this.mAlpha = alpha;
    }
  }]);

  return ExpFilter;
}();

ExpFilter.kValueUndefined = -1;
ExpFilter.AlphaForPacketLossFractionSmoother = 0.9999;
/**
 * the smooth should be done when rtcp packet arrive/send, but we can't get the rtcp
 * packet arrive/send time. according to webrtc and media server, the default rtcp
 * interval is:
 *
 * kDefaultVideoReportInterval = 1000;
 * kDefaultAudioReportInterval = 5000;
 * so we define the value accordingly
 */

ExpFilter.SMOOTH_VIDEO_INTERVAL = 1000;
ExpFilter.SMOOTH_AUDIO_INTERVAL = 5000;
/**
 * Each one ssrc which has an unique id has its own ExpFilter
 */

function manageExpFilter() {
  var filters = {};
  return function (id, filterType) {
    if (id in filters) {
      return filters[id];
    } else {
      filters[id] = new ExpFilter(filterType);
      return filters[id];
    }
  };
}
/**
 * TrackStatsReport and MediaStatisticStatsWithCalculationReport use different timer
 * So two filters for each here.
 */


var getReportExpFilter = manageExpFilter();
var getStatisticExpFilter = manageExpFilter();

var defaultTrackStatsReport = function defaultTrackStatsReport() {
  return {
    id: "",
    kind: "audio",
    packetLossRate: 0,
    bitrate: 0,
    bytes: 0,
    packets: 0,
    packetLoss: 0,
    frameRate: 0,
    rtt: 0,
    timestamp: Date.now(),
    networkGrade: NetworkGrade.INVALID
  };
};

function getNetworkGrade(maxLostRate, maxRtt) {
  var networkGrade;

  if (maxLostRate > 9 || maxRtt > 100) {
    networkGrade = NetworkGrade.POOR;
  } else if (maxLostRate > 5 || maxRtt > 80) {
    networkGrade = NetworkGrade.FAIR;
  } else if (maxLostRate > 1 || maxRtt > 40) {
    networkGrade = NetworkGrade.GOOD;
  } else {
    networkGrade = NetworkGrade.EXCELLENT;
  } // connection is not in this version's typescript


  var n = navigator;

  if (n.connection && n.connection.effectiveType && ['slow-2g', '2g', '3g'].includes(n.connection.effectiveType)) {
    networkGrade = NetworkGrade.POOR;
  }

  return networkGrade;
}

function getStats(_x2, _x3, _x4) {
  return _getStats.apply(this, arguments);
}

function _getStats() {
  _getStats = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee118(pc, track, pctype) {
    var report, statsReportList, _iteratorNormalCompletion55, _didIteratorError55, _iteratorError55, _iterator55, _step55, item, statsReport, remoteItem;

    return _regeneratorRuntime.wrap(function _callee118$(_context118) {
      while (1) {
        switch (_context118.prev = _context118.next) {
          case 0:
            _context118.prev = 0;
            _context118.next = 3;
            return pc.getStats(track);

          case 3:
            report = _context118.sent;
            _context118.next = 10;
            break;

          case 6:
            _context118.prev = 6;
            _context118.t0 = _context118["catch"](0);
            log.debug("get stats error, fallback to default", _context118.t0);
            return _context118.abrupt("return", []);

          case 10:
            if (report) {
              _context118.next = 13;
              break;
            }

            log.debug("get null stats, fallback to default");
            return _context118.abrupt("return", []);

          case 13:
            statsReportList = [];
            _iteratorNormalCompletion55 = true;
            _didIteratorError55 = false;
            _iteratorError55 = undefined;
            _context118.prev = 17;

            for (_iterator55 = report.values()[Symbol.iterator](); !(_iteratorNormalCompletion55 = (_step55 = _iterator55.next()).done); _iteratorNormalCompletion55 = true) {
              item = _step55.value;

              /**
               * isRemote is for compatible with old browsers.
               * see: https://blog.mozilla.org/webrtc/getstats-isremote-66/
               */
              if (pctype === "send" && item.type === "outbound-rtp" && !item.isRemote || pctype === "recv" && item.type === "inbound-rtp" && !item.isRemote) {
                statsReport = defaultTrackStatsReport();
                remoteItem = report.get(item.remoteId);
                statsReport.packetLoss = getPacketsLost(item, remoteItem) || 0;
                statsReport.bytes = pctype === "send" ? item.bytesSent : item.bytesReceived;
                statsReport.packets = pctype === "send" ? item.packetsSent : item.packetsReceived;
                statsReport.rtt = getRtt(item) || getRtt(remoteItem) || 0;
                statsReport.id = item.id;
                statsReport.kind = item.kind;

                if (item.frameWidth) {
                  statsReport.width = item.frameWidth;
                }

                if (item.frameHeight) {
                  statsReport.height = item.frameHeight;
                }

                if (item.framesPerSecond) {
                  statsReport.frameRate = item.framesPerSecond;
                } // for Firefox/81


                if (item.framerateMean) {
                  statsReport.frameRate = Math.ceil(item.framerateMean);
                }

                statsReportList.push(statsReport);
              }
            }

            _context118.next = 25;
            break;

          case 21:
            _context118.prev = 21;
            _context118.t1 = _context118["catch"](17);
            _didIteratorError55 = true;
            _iteratorError55 = _context118.t1;

          case 25:
            _context118.prev = 25;
            _context118.prev = 26;

            if (!_iteratorNormalCompletion55 && _iterator55.return != null) {
              _iterator55.return();
            }

          case 28:
            _context118.prev = 28;

            if (!_didIteratorError55) {
              _context118.next = 31;
              break;
            }

            throw _iteratorError55;

          case 31:
            return _context118.finish(28);

          case 32:
            return _context118.finish(25);

          case 33:
            return _context118.abrupt("return", statsReportList);

          case 34:
          case "end":
            return _context118.stop();
        }
      }
    }, _callee118, this, [[0, 6], [17, 21, 25, 33], [26,, 28, 32]]);
  }));
  return _getStats.apply(this, arguments);
}

var defaultAudioExtraStats = {
  track_audio_volume: 0,
  jitter_buffer_delay: 0,
  bytes_sent: 0,
  bytes_received: 0
};
var defaultVideoExtraStats = {
  nack_count: 0,
  fir_count: 0,
  pli_count: 0,
  width: 0,
  height: 0,
  jitter_buffer_delay: 0,
  bytes_sent: 0,
  frame_encoded: 0,
  bytes_received: 0,
  frame_decoded: 0
};
var defaultCalculationStats = {
  frames_received: 0,
  frames_sent: 0,
  packets_lost: 0,
  packets_received: 0,
  packets_sent: 0,
  timestamp: 0,
  bytes_sent: 0,
  bytes_received: 0
};
var MediaType;

(function (MediaType) {
  MediaType["Video"] = "video";
  MediaType["Audio"] = "audio";
})(MediaType || (MediaType = {}));

var StatsReportType;

(function (StatsReportType) {
  StatsReportType["MediaSource"] = "media-source";
  StatsReportType["Track"] = "track";
  StatsReportType["OutBoundRtp"] = "outbound-rtp";
  StatsReportType["InBoundRtp"] = "inbound-rtp";
  StatsReportType["RemoteInBound"] = "remote-inbound-rtp";
})(StatsReportType || (StatsReportType = {}));

var BoundType;

(function (BoundType) {
  BoundType["In"] = "in";
  BoundType["Out"] = "out";
})(BoundType || (BoundType = {}));

function getDefaultMediaStatisticWithCalculationReport(id, trackID, mediaType) {
  var report = {
    id: id,
    track_id: trackID,
    kind: "audio",
    kbps: 0,
    framerate: 0,
    packet_lost_rate: 0,
    rtt: 0,
    extra_stats: null,
    calculation_stats: __chunk_1._objectSpread({}, defaultCalculationStats)
  };

  if (mediaType === MediaType.Audio) {
    report.extra_stats = __chunk_1._objectSpread({}, defaultAudioExtraStats);
  } else {
    report.extra_stats = __chunk_1._objectSpread({}, defaultVideoExtraStats);
  }

  return report;
}

function getQualityStats(_x5, _x6) {
  return _getQualityStats.apply(this, arguments);
}

function _getQualityStats() {
  _getQualityStats = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee119(pc, core) {
    var report, items, stats;
    return _regeneratorRuntime.wrap(function _callee119$(_context119) {
      while (1) {
        switch (_context119.prev = _context119.next) {
          case 0:
            _context119.prev = 0;
            _context119.next = 3;
            return pc.getStats();

          case 3:
            report = _context119.sent;
            _context119.next = 10;
            break;

          case 6:
            _context119.prev = 6;
            _context119.t0 = _context119["catch"](0);
            runOnce(function () {
              log.debug("get media statistic stats error, fallback to default", _context119.t0);
            }, "getStats error");
            return _context119.abrupt("return", []);

          case 10:
            if (report) {
              _context119.next = 13;
              break;
            }

            runOnce(function () {
              log.debug("get null media statistic stats, fallback to default");
            }, "getStats error");
            return _context119.abrupt("return", []);

          case 13:
            items = _toConsumableArray(report.values());
            stats = core.subscribedTracks.map(function (track) {
              var mediaTrack = track.mediaTrack;
              var trackItem = items.find(function (item) {
                return item.type === StatsReportType.Track && item.trackIdentifier === mediaTrack.id;
              });
              if (!trackItem) return undefined;
              var inboundItem = items.find(function (item) {
                return item.type === StatsReportType.InBoundRtp && item.trackId === trackItem.id;
              });
              if (!inboundItem) return undefined;
              return {
                time: Date.now(),
                trackID: track.info.trackID,
                kind: inboundItem.kind === "video" ? "video" : "audio",
                framesDecoded: inboundItem.framesDecoded || -1,
                totalSamplesReceived: inboundItem.totalSamplesReceived || -1
              };
            }).filter(isDefined);
            return _context119.abrupt("return", stats);

          case 16:
          case "end":
            return _context119.stop();
        }
      }
    }, _callee119, this, [[0, 6]]);
  }));
  return _getQualityStats.apply(this, arguments);
}

function getMediaStatisticStats(_x7, _x8) {
  return _getMediaStatisticStats.apply(this, arguments);
}

function _getMediaStatisticStats() {
  _getMediaStatisticStats = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee120(pc, core) {
    var report, reportList, statisticReports;
    return _regeneratorRuntime.wrap(function _callee120$(_context120) {
      while (1) {
        switch (_context120.prev = _context120.next) {
          case 0:
            _context120.prev = 0;
            _context120.next = 3;
            return pc.getStats();

          case 3:
            report = _context120.sent;
            _context120.next = 10;
            break;

          case 6:
            _context120.prev = 6;
            _context120.t0 = _context120["catch"](0);
            log.debug("get media statistic stats error, fallback to default", _context120.t0);
            return _context120.abrupt("return", []);

          case 10:
            if (report) {
              _context120.next = 13;
              break;
            }

            log.debug("get null media statistic stats, fallback to default");
            return _context120.abrupt("return", []);

          case 13:
            reportList = _toConsumableArray(report.values());
            statisticReports = reportList.filter(function (reportItem) {
              return (
                /*  遍历 reportList 数组,判断当前遍历对象类型是否为 InBoundRtp 或者 OutBoundRtp 类型,
                    同时判断是否存在另一个对象其类型为 track 并且 id 值等于当前遍历对象的 trackId 值。
                    如若找不到该值,则说明当前遍历的对象所对应的 track 已不存在。
                */
                (reportItem.type === StatsReportType.InBoundRtp || reportItem.type === StatsReportType.OutBoundRtp) && reportList.find(function (item) {
                  return item.id === reportItem.trackId && item.type === 'track';
                })
              );
            }).map(function (item) {
              return createStatisticReport(item, reportList, core);
            });
            return _context120.abrupt("return", statisticReports);

          case 16:
          case "end":
            return _context120.stop();
        }
      }
    }, _callee120, this, [[0, 6]]);
  }));
  return _getMediaStatisticStats.apply(this, arguments);
}

function parseVideoInOutBound(item, report) {
  report.kind = item.kind;
  report.extra_stats.nack_count = item.nackCount;
  report.extra_stats.fir_count = item.firCount;
  report.extra_stats.pli_count = item.pliCount;
  report.extra_stats.bytes_sent = item.bytesSent || 0;
  report.extra_stats.frame_encoded = item.framesEncoded || 0;
  report.extra_stats.bytes_received = item.bytesReceived || 0;
  report.extra_stats.frame_decoded = item.framesDecoded || 0;
  report.calculation_stats.bytes_received = item.bytesReceived || 0;
  report.calculation_stats.bytes_sent = item.bytesSent || 0;
  report.calculation_stats.packets_received = item.packetsReceived || 0;
  report.calculation_stats.packets_sent = item.packetsSent || 0;
  report.calculation_stats.timestamp = item.timestamp || 0;
  return report;
}

function parseVideoMediaSource(item, report) {
  report.framerate = item.framesPerSecond;
  return report;
}

function parseVideoTrack(item, report, core) {
  var pcTracks = _toConsumableArray(core.publishedTracks).concat(_toConsumableArray(core.subscribedTracks));

  var currentTrack = pcTracks.find(function (track) {
    return track.mediaTrack.id === item.trackIdentifier;
  });
  report.track_id = currentTrack ? currentTrack.info ? currentTrack.info.trackID || "" : "" : "";
  report.extra_stats.width = item.frameWidth;
  report.extra_stats.height = item.frameHeight;
  report.extra_stats.jitter_buffer_delay = item.jitterBufferDelay || 0;
  report.calculation_stats.frames_sent = item.framesSent || 0;
  report.calculation_stats.frames_received = item.framesReceived || 0;
  return report;
}

function checkAudioLevel(audioLevel, type) {
  var result = audioLevel || 0;
  var unusualBorwserVersion = {
    chrome: ['86.0.4240', '87.0.4280']
  };

  if (unusualBorwserVersion[__chunk_1.browser.name] && unusualBorwserVersion[__chunk_1.browser.name].includes(__chunk_1.browser.version) && type === StatsReportType.InBoundRtp) {
    // 某些浏览器的bug，当类型是inbound时，获取的audioLevel大于一 https://bugs.chromium.org/p/chromium/issues/detail?id=1142626&q=audioLevel&can=1
    result = Math.min(audioLevel / 32767, 1);
    WebSDKException.create({
      code: ExceptionStatus.AudioLevelUnusual,
      actual_value: audioLevel,
      extra_info: {
        stats_report_type: type
      }
    });
  } else if (result > 1 || result < 0) {
    WebSDKException.create({
      code: ExceptionStatus.AudioLevelUnusual,
      actual_value: audioLevel,
      extra_info: {
        stats_report_type: type
      }
    });
  }

  return result;
}

function parseAudioInOutBound(item, report) {
  report.kind = item.kind;
  report.extra_stats.bytes_sent = item.bytesSent || 0;
  report.extra_stats.bytes_received = item.bytesReceived || 0;
  report.extra_stats.track_audio_volume = checkAudioLevel(item.audioLevel, item.type);
  report.calculation_stats.bytes_received = item.bytesReceived || 0;
  report.calculation_stats.bytes_sent = item.bytesSent || 0;
  report.calculation_stats.packets_received = item.packetsReceived || 0;
  report.calculation_stats.packets_sent = item.packetsSent || 0;
  report.calculation_stats.timestamp = item.timestamp || 0;
  return report;
}

function parseAudioMediaSource(item, report) {
  report.extra_stats.track_audio_volume = checkAudioLevel(item.audioLevel, item.type);
  return report;
}

function parseAudioTrack(item, report, core) {
  var pcTracks = _toConsumableArray(core.publishedTracks).concat(_toConsumableArray(core.subscribedTracks));

  var currentTrack = pcTracks.find(function (track) {
    return track.mediaTrack.id === item.trackIdentifier;
  });
  report.track_id = currentTrack ? currentTrack.info ? currentTrack.info.trackID || "" : "" : "";
  report.extra_stats.jitter_buffer_delay = item.jitterBufferDelay || 0;
  report.calculation_stats.frames_sent = item.framesSent || 0;
  report.calculation_stats.frames_received = item.framesReceived || 0;
  return report;
}
/** get rtt(round trip time) from one type data of RTCStatsReport
 *
 * Rtt was in outbound-rtp or inbound-rtp in older versions of chrome and Firefox and now in remote-inbound-rtp.
 * see https://github.com/w3c/webrtc-stats/pull/167 and https://developer.mozilla.org/en-US/docs/Mozilla/Firefox/Releases/55#WebRTC
 *
 * Older versions of Chrome and Firefox implement prefix version of rtt,
 * which is googRtt in Chrome and mozRtt in Firefox, and using milliseconds as unit.
 * Now its roundTripTime and it uses seconds.
 * see https://github.com/w3c/webrtc-stats/pull/44/commits and https://groups.google.com/g/discuss-webrtc/c/xp4dMYElqBQ
 *
 * @param item one type data of RTCStatsReport
 * @returns value of rtt in miliseconds and undefined for not found
 */


function getRtt(item) {
  if (!item) return;

  if (item.roundTripTime) {
    return item.roundTripTime * 1000;
  }

  if (item.googRtt) {
    return item.googRtt;
  }

  if (item.mozRtt) {
    return item.mozRtt;
  }
}
/** get packetsLost from one type data of RTCStatsReport
 *
 * if item.type === "outbound-rtp", then packetsLost is in remote-inbound-rtp.packetsLost
 * if item.type === "inbound-rtp", then packetsLost is in inbound-rtp.packetsLost
 *
 * item/remoteItem: one type data of RTCStatsReport
 * @param item "inbound-rtp" | "outbound-rtp"
 * @param remoteItem "remote-inbound-rtp" | undefined
 * @returns packetsLost
 */


function getPacketsLost(item, remoteItem) {
  if (item.type === "inbound-rtp") {
    return item.packetsLost;
  }

  if (item.type === "outbound-rtp" && remoteItem) {
    return remoteItem.packetsLost;
  }
}
/**
 * Note that:
 * - packetsLost means total number of RTP packets lost for this SSRC and can be negative if more packets are received than sent.
 * - packetsTrans stands for packetsSent in outbound-rtp or packetsReceived in inbound-rtp.
 *   - packetsSent means total number of RTP packets sent for this SSRC.
 *   - packetsReceived means total number of RTP packets received for this SSRC.
 *
 * So we calculate packets lost rate by following math:
 *    packetsLostRate = difference of packetsLost between two gatherings / difference of packetsTrans between two gatherings
 */


function calculatePacketsLostRate(lastPacketsLost, currentPacketsLost, lastPacketsTrans, currentPacketsTrans) {
  var diffPacketsLost = currentPacketsLost - lastPacketsLost;
  var diffPacketsTrans = currentPacketsTrans - lastPacketsTrans;
  if (diffPacketsLost <= 0 || diffPacketsTrans <= 0) return 0;
  var packetsLostRate = diffPacketsLost / diffPacketsTrans;
  return packetsLostRate > 1 ? 1 : packetsLostRate;
}

function createStatisticReport(item, reports, core) {
  var _reportMap;

  var reportMap = (_reportMap = {}, _defineProperty2(_reportMap, StatsReportType.MediaSource, reports.filter(function (reportItem) {
    return reportItem.type === StatsReportType.MediaSource;
  }).find(function (reportItem) {
    return reportItem.id === item.mediaSourceId;
  })), _defineProperty2(_reportMap, StatsReportType.Track, reports.filter(function (reportItem) {
    return reportItem.type === StatsReportType.Track;
  }).find(function (reportItem) {
    return reportItem.id === item.trackId;
  })), _defineProperty2(_reportMap, StatsReportType.RemoteInBound, reports.filter(function (reportItem) {
    return reportItem.type === StatsReportType.RemoteInBound;
  }).find(function (reportItem) {
    return reportItem.id === item.remoteId;
  })), _reportMap);
  var report = getDefaultMediaStatisticWithCalculationReport(item.id, item.trackID, item.mediaType);
  report.rtt = getRtt(reportMap[StatsReportType.RemoteInBound]) || getRtt(item) || 0;
  report.calculation_stats.packets_lost = getPacketsLost(item, reportMap[StatsReportType.RemoteInBound]) || 0;

  if (item.mediaType === MediaType.Video) {
    report = parseVideoInOutBound(item, report);

    if (reportMap[StatsReportType.MediaSource]) {
      report = parseVideoMediaSource(reportMap[StatsReportType.MediaSource], report);
    }

    if (reportMap[StatsReportType.Track]) {
      report = parseVideoTrack(reportMap[StatsReportType.Track], report, core);
    }
  } else {
    report = parseAudioInOutBound(item, report);

    if (reportMap[StatsReportType.MediaSource]) {
      report = parseAudioMediaSource(reportMap[StatsReportType.MediaSource], report);
    }

    if (reportMap[StatsReportType.Track]) {
      report = parseAudioTrack(reportMap[StatsReportType.Track], report, core);
    }
  }

  return report;
}

function calculationMediaStatisticReport(calculation, lastCalculation, expFilter) {
  if (!calculation || !lastCalculation) {
    return {
      framerate: 0,
      kbps: 0,
      packet_lost_rate: 0
    };
  }

  var gapTime = (calculation.timestamp - lastCalculation.timestamp) / 1000;
  var framerate = gapTime === 0 ? 0 : (calculation.frames_sent - lastCalculation.frames_sent + (calculation.frames_received - lastCalculation.frames_received)) / gapTime;
  var kbps = gapTime === 0 ? 0 : (calculation.bytes_sent - lastCalculation.bytes_sent + (calculation.bytes_received - lastCalculation.bytes_received)) / (gapTime * 1024 / 8);
  /**
   * Note that we do not distinguish send and receive here.
   * if it's inbound, then send should be 0, the reverse is the same.
   */

  var packetLostRate = calculatePacketsLostRate(lastCalculation.packets_lost, calculation.packets_lost, lastCalculation.packets_received + lastCalculation.packets_sent, calculation.packets_received + calculation.packets_sent);
  expFilter.Apply(packetLostRate); // scale value from 0-1 to 0-100

  var packet_lost_rate = expFilter.Filtered() < 0 ? 0 : expFilter.Filtered() * 100;
  return {
    framerate: Math.ceil(framerate),
    kbps: Math.ceil(kbps),
    packet_lost_rate: Math.ceil(packet_lost_rate)
  };
}

function createPC() {
  var rtcOptions = {
    bundlePolicy: "max-bundle",
    rtcpMuxPolicy: "require",
    iceServers: []
  };

  if (__chunk_1.browserReport.unifiedPlan) {
    rtcOptions.sdpSemantics = "unified-plan";
  } else {
    rtcOptions.sdpSemantics = "plan-b";
  }

  var pc = new RTCPeerConnection(rtcOptions);

  if (__chunk_1.browserReport.unifiedPlan && __chunk_1.browserReport.supportTransceivers) {
    // stub transceiver is needed;
    pc.addTransceiver("audio", {
      direction: "inactive"
    });
    pc.addTransceiver("video", {
      direction: "inactive"
    });
  }

  return pc;
}

function addTransceiver(_x9, _x10, _x11) {
  return _addTransceiver.apply(this, arguments);
}

function _addTransceiver() {
  _addTransceiver = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee121(track, pc, lowStreamConfig) {
    var bitrate,
        sendEncodings,
        _args121 = arguments;
    return _regeneratorRuntime.wrap(function _callee121$(_context121) {
      while (1) {
        switch (_context121.prev = _context121.next) {
          case 0:
            bitrate = _args121.length > 3 && _args121[3] !== undefined ? _args121[3] : 600;

            if (lowStreamConfig) {
              _context121.next = 7;
              break;
            }

            _context121.next = 4;
            return pc.addTransceiver(track, {
              direction: "sendonly"
            });

          case 4:
            return _context121.abrupt("return", _context121.sent);

          case 7:
            sendEncodings = [{
              rid: "hi",
              active: true,
              maxBitrate: bitrate * 1000
            }, {
              rid: "lo",
              active: true,
              maxBitrate: lowStreamConfig.bitrate * 1000,
              scaleResolutionDownBy: lowStreamConfig.scaleResolutionDownBy
            }];
            _context121.next = 10;
            return pc.addTransceiver(track, {
              direction: "sendonly",
              sendEncodings: sendEncodings
            });

          case 10:
            return _context121.abrupt("return", _context121.sent);

          case 11:
          case "end":
            return _context121.stop();
        }
      }
    }, _callee121, this);
  }));
  return _addTransceiver.apply(this, arguments);
}

function getPCStats(_x12, _x13, _x14, _x15) {
  return _getPCStats.apply(this, arguments);
}

function _getPCStats() {
  _getPCStats = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee122(pc, track, pctype, lastReportList) {
    var stats;
    return _regeneratorRuntime.wrap(function _callee122$(_context122) {
      while (1) {
        switch (_context122.prev = _context122.next) {
          case 0:
            if (!__chunk_1.browserReport.stats) {
              _context122.next = 7;
              break;
            }

            _context122.next = 3;
            return getStats(pc, track, pctype);

          case 3:
            stats = _context122.sent;
            return _context122.abrupt("return", getRateStats(stats, lastReportList));

          case 7:
            runOnce(function () {
              log.warning("your browser does not support getStats");
            }, "not-support-stats-warning");
            return _context122.abrupt("return", []);

          case 9:
          case "end":
            return _context122.stop();
        }
      }
    }, _callee122, this);
  }));
  return _getPCStats.apply(this, arguments);
}

function getRateStats(reportList, lastReportList) {
  if (!lastReportList || lastReportList.length === 0) {
    return reportList;
  }

  if (lastReportList.length !== reportList.length) {
    return reportList;
  }

  var groupedReportLists = Object.values(groupBy(_toConsumableArray(reportList).concat(_toConsumableArray(lastReportList)), "id"));
  /** if there is no two report using the same id */

  if (!groupedReportLists.every(function (list) {
    return list.length === 2;
  })) {
    return reportList;
  }

  var newReportList = groupedReportLists.map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        report = _ref3[0],
        lastReport = _ref3[1];

    var time = (report.timestamp - lastReport.timestamp) / 1000;

    if (time <= 0) {
      return report;
    }

    var newReport = __chunk_1._objectSpread({}, report);

    var packetLossRate = calculatePacketsLostRate(lastReport.packetLoss, report.packetLoss, lastReport.packets, report.packets);
    newReport.networkGrade = getNetworkGrade(packetLossRate, newReport.rtt);
    var filter = getReportExpFilter(report.id, report.kind);
    filter.Apply(packetLossRate);
    newReport.packetLossRate = filter.Filtered() < 0 ? 0 : filter.Filtered();
    newReport.bitrate = 8 * (report.bytes - lastReport.bytes) / time;

    if (newReport.bitrate < 0) {
      return lastReport;
    }

    return newReport;
  });
  return newReportList;
}
/*
 * screen.ts
 * 屏幕共享
 * Copyright (C) 2018 disoul <disoul@DiSouldeMBP.lan>
 *
 * Distributed under terms of the MIT license.
*/


window.addEventListener("message", function (e) {
  if (e.origin !== window.location.origin) {
    return;
  }

  onMessageCallback(e.data);
}); // and the function that handles received messages

function onMessageCallback(data) {
  // "cancel" button is clicked
  if (data === "PermissionDeniedError") {
    chromeMediaSource = "PermissionDeniedError";

    if (screenCallback) {
      return screenCallback("PermissionDeniedError");
    } else {
      throw SCREEN_PERMISSION_DENIED();
    }
  } // extension notified his presence


  if (data === "qnrtc:rtcmulticonnection-extension-loaded") {
    chromeMediaSource = "desktop";
  } // old plugin version


  if (data === "rtcmulticonnection-extension-loaded") {
    log.warning("your chrome screen sharing plugin is not the latest version, or you have other screen sharing plugins.");
  } // extension shared temp sourceId


  if (data.sourceId && screenCallback) {
    screenCallback(sourceId = data.sourceId, data.canRequestAudioTrack === true);
  }
} // global variables


var chromeMediaSource = "screen";
var sourceId;
var screenCallback;

function _isChromeExtensionAvailable2() {
  return _isChromeExtensionAvailable.apply(this, arguments);
} // this function can be used to get "source-id" from the extension


function _isChromeExtensionAvailable() {
  _isChromeExtensionAvailable = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee123() {
    var promise;
    return _regeneratorRuntime.wrap(function _callee123$(_context123) {
      while (1) {
        switch (_context123.prev = _context123.next) {
          case 0:
            promise = function promise() {
              return new Promise(function (resolve, reject) {
                if (chromeMediaSource === "desktop") {
                  resolve(true);
                  return;
                } // ask extension if it is available


                window.postMessage("qnrtc:are-you-there", "*");
                setTimeout(function () {
                  if (chromeMediaSource === "screen") {
                    resolve(false);
                  } else {
                    resolve(true);
                  }
                }, 2000);
              });
            };

            _context123.next = 3;
            return promise();

          case 3:
            return _context123.abrupt("return", _context123.sent);

          case 4:
          case "end":
            return _context123.stop();
        }
      }
    }, _callee123, this);
  }));
  return _isChromeExtensionAvailable.apply(this, arguments);
}

function getSourceId(callback) {
  var screenOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var windowOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  screenCallback = callback;

  if (screenOnly) {
    window.postMessage("qnrtc:get-sourceId-screen", "*");
    return;
  }

  if (windowOnly) {
    window.postMessage("qnrtc:get-sourceId-window", "*");
    return;
  }

  window.postMessage("qnrtc:get-sourceId", "*");
} // this function can be used to get "source-id" from the extension


function getSourceIdWithAudio(callback) {
  if (sourceId) {
    return callback(sourceId);
  }

  screenCallback = callback;
  window.postMessage("qnrtc:audio-plus-tab", "*");
}

function getScreenConstraints(_x16, _x17) {
  return _getScreenConstraints.apply(this, arguments);
}

function _getScreenConstraints() {
  _getScreenConstraints = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee124(captureSourceIdWithAudio, screen) {
    var source, contraintPromise;
    return _regeneratorRuntime.wrap(function _callee124$(_context124) {
      while (1) {
        switch (_context124.prev = _context124.next) {
          case 0:
            source = screen.source;

            contraintPromise = function contraintPromise() {
              return new Promise(function (resolve, reject) {
                var firefoxScreenConstraints = {
                  mozMediaSource: source || "window",
                  mediaSource: source || "window",
                  height: screen.height,
                  width: screen.width
                };

                if (__chunk_1.isFirefox) {
                  resolve(firefoxScreenConstraints);
                  return;
                } // this statement defines getUserMedia constraints
                // that will be used to capture content of screen


                var screen_constraints = {
                  mandatory: {
                    chromeMediaSource: chromeMediaSource,
                    maxWidth: getNumberRangeMax(screen.width),
                    maxHeight: getNumberRangeMax(screen.height)
                  },
                  optional: []
                }; // this statement verifies chrome extension availability
                // if installed and available then it will invoke extension API
                // otherwise it will fallback to command-line based screen capturing API

                if (chromeMediaSource === "desktop") {
                  if (captureSourceIdWithAudio) {
                    getSourceIdWithAudio(function (sourceId, canRequestAudioTrack) {
                      screen_constraints.mandatory.chromeMediaSourceId = sourceId;

                      if (canRequestAudioTrack) {
                        screen_constraints.canRequestAudioTrack = true;
                      }

                      if (sourceId === "PermissionDeniedError") {
                        reject(SCREEN_PERMISSION_DENIED());
                        return;
                      }

                      resolve(screen_constraints);
                      return;
                    });
                  } else {
                    getSourceId(function (sourceId) {
                      screen_constraints.mandatory.chromeMediaSourceId = sourceId;

                      if (sourceId === "PermissionDeniedError") {
                        reject(SCREEN_PERMISSION_DENIED());
                        return;
                      }

                      resolve(screen_constraints);
                      return;
                    }, source === "screen", source === "window");
                  }

                  return;
                }

                resolve(screen_constraints);
              });
            };

            _context124.next = 4;
            return contraintPromise();

          case 4:
            return _context124.abrupt("return", _context124.sent);

          case 5:
          case "end":
            return _context124.stop();
        }
      }
    }, _callee124, this);
  }));
  return _getScreenConstraints.apply(this, arguments);
}

function createScreenSelectionUI(_x18) {
  return _createScreenSelectionUI.apply(this, arguments);
}

function _createScreenSelectionUI() {
  _createScreenSelectionUI = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee125(sources) {
    return _regeneratorRuntime.wrap(function _callee125$(_context125) {
      while (1) {
        switch (_context125.prev = _context125.next) {
          case 0:
            return _context125.abrupt("return", new Promise(function (resolve, reject) {
              var container = document.createElement("div");
              container.setAttribute('style', "position: fixed; z-index: 99999999; top: 50%; left: 50%; width: 620px; height: 525px; background: #ECECEC; border-radius: 4px; -webkit-transform: translate(-50%,-50%); transform: translate(-50%,-50%);");
              var title = document.createElement("div");
              title.setAttribute('style', "text-align: center; height: 25px; line-height: 25px; border-radius: 4px 4px 0 0; background: #D4D2D4; border-bottom:  solid 1px #B9B8B9;");
              title.innerText = "share screen";
              var contentContainer = document.createElement("div");
              contentContainer.setAttribute('style', "width: 100%; height: 500px; padding: 15px 25px ; box-sizing: border-box;");
              container.appendChild(title);
              container.appendChild(contentContainer);
              var desc = document.createElement("div");
              desc.setAttribute('style', "height: 12%;");
              desc.innerText = "QiNiu Web Screensharing wants to share the contents. Choose what you'd like to share.";
              var sourcesContainer = document.createElement("div");
              sourcesContainer.setAttribute('style', "width: 100%; height: 80%; background: #FFF; border:  solid 1px #CBCBCB; display: flex; flex-wrap: wrap; justify-content: space-around; overflow-y: scroll; padding: 0 15px; box-sizing: border-box;");
              var cancelBtn = document.createElement("button");
              cancelBtn.setAttribute('style', "width: 85px;");
              cancelBtn.innerText = "cancel";

              cancelBtn.onclick = function () {
                document.body.removeChild(container);
                reject(ERROR_DEVICE_NOT_ALLOWED("user cancel selection"));
              };

              var cancelBtnContainer = document.createElement("div");
              cancelBtnContainer.setAttribute('style', "text-align: right; padding: 16px 0;");
              cancelBtnContainer.appendChild(cancelBtn);
              contentContainer.appendChild(desc);
              contentContainer.appendChild(sourcesContainer);
              contentContainer.appendChild(cancelBtnContainer);
              var _iteratorNormalCompletion56 = true;
              var _didIteratorError56 = false;
              var _iteratorError56 = undefined;

              try {
                var _loop22 = function _loop22() {
                  var source = _step56.value;
                  var sourceContainer = document.createElement("div");
                  sourceContainer.setAttribute('style', "width: 30%; height: 160px; padding: 20px 0; text-align: center;box-sizing: content-box;");

                  sourceContainer.onclick = function () {
                    document.body.removeChild(container);
                    resolve(source.ID);
                  };

                  var iconContainer = document.createElement("div");
                  iconContainer.setAttribute('style', "height: 120px; display: table-cell; vertical-align: middle;");
                  var icon = document.createElement("img");
                  icon.setAttribute('style', "width: 100%; background: #333333; box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.2);");
                  icon.src = source.url;
                  iconContainer.appendChild(icon);
                  var sourceDesc = document.createElement("div");
                  sourceDesc.setAttribute('style', "height: 40px; line-height: 40px; display: inline-block; width: 70%; word-break: keep-all; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;");
                  sourceDesc.innerText = source.name;
                  sourceContainer.appendChild(iconContainer);
                  sourceContainer.appendChild(sourceDesc);
                  sourcesContainer.appendChild(sourceContainer);
                };

                for (var _iterator56 = sources[Symbol.iterator](), _step56; !(_iteratorNormalCompletion56 = (_step56 = _iterator56.next()).done); _iteratorNormalCompletion56 = true) {
                  _loop22();
                }
              } catch (err) {
                _didIteratorError56 = true;
                _iteratorError56 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion56 && _iterator56.return != null) {
                    _iterator56.return();
                  }
                } finally {
                  if (_didIteratorError56) {
                    throw _iteratorError56;
                  }
                }
              }

              document.body.appendChild(container);
            }));

          case 1:
          case "end":
            return _context125.stop();
        }
      }
    }, _callee125, this);
  }));
  return _createScreenSelectionUI.apply(this, arguments);
}

var User =
/*#__PURE__*/
function () {
  function User(userID, userData) {
    _classCallCheck(this, User);

    /**
     * 指这个用户在本地的 Track 对象，一般用来播放
     */
    this.tracks = [];
    /**
     * 指这个用户在这个房间内已经发布的流信息，一般用来发起订阅
     */

    this.publishedTrackInfo = [];
    this.userID = userID;
    this.userData = userData;
  }
  /**
   * 只要有 track 就认为其已经发布
   */


  _createClass(User, [{
    key: "addTracks",

    /* @internal */
    value: function addTracks(tracks) {
      var _this24 = this;

      this.tracks = this.tracks.concat(tracks);
      this.tracks = uniqBy(this.tracks, "mediaTrack");
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        var _loop = function _loop() {
          var track = _step2.value;
          track.once("release", function () {
            remove(_this24.tracks, function (t) {
              return t === track;
            });
          });
        };

        for (var _iterator2 = this.tracks[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          _loop();
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
    /* @internal */

  }, {
    key: "removeTracksByTrackId",
    value: function removeTracksByTrackId(trackIDs) {
      remove(this.tracks, function (track) {
        if (!track.info.trackID) return false;
        return trackIDs.indexOf(track.info.trackID) !== -1;
      });
    }
    /* @internal */

  }, {
    key: "addPublishedTrackInfo",
    value: function addPublishedTrackInfo(info) {
      this.publishedTrackInfo = this.publishedTrackInfo.concat(info);
      this.publishedTrackInfo = uniqBy(this.publishedTrackInfo, "trackID");
    }
    /* @internal */

  }, {
    key: "removePublishedTrackInfo",
    value: function removePublishedTrackInfo(trackIDs) {
      remove(this.publishedTrackInfo, function (info) {
        return trackIDs.indexOf(info.trackID) !== -1;
      });
    }
  }, {
    key: "published",
    get: function get() {
      return this.publishedTrackInfo.length > 0;
    }
  }]);

  return User;
}();

function createAudioElement(track) {
  var audio = document.createElement("audio");
  var stream = new MediaStream([track]);
  audio.style.visibility = "hidden";
  audio.className = "qnrtc-audio-player qnrtc-stream-player";
  audio.dataset.localid = track.id;
  audio.srcObject = stream;
  audio.autoplay = true;
  return audio;
}

function createVideoElement(track) {
  var video = document.createElement("video");
  var stream = new MediaStream([track]);
  video.style.width = "100%";
  video.style.height = "100%";
  video.style.objectFit = "contain";
  video.muted = true;
  video.className = "qnrtc-video-player qnrtc-stream-player";
  video.dataset.localid = track.id;
  video.setAttribute("playsinline", true);
  video.autoplay = true;
  video.srcObject = stream;

  if (__chunk_1.isIOS) {
    video.setAttribute("controls", true);
    nextTick(function () {
      if (video && video.srcObject) {
        video.removeAttribute("controls");
      }
    });
  }

  return video;
}

function webAudioUnlock(context) {
  return new Promise(function (resolve, reject) {
    if (context.state === "suspended") {
      log.log("audio context state is suspended");

      var unlock = function unlock() {
        context.resume().then(function () {
          document.body.removeEventListener("touchstart", unlock);
          document.body.removeEventListener("touchend", unlock);
          document.body.removeEventListener("mousedown", unlock);
          document.body.removeEventListener("mouseup", unlock);
          resolve(true);
        }).catch(reject);
      };

      document.body.addEventListener("touchstart", unlock, true);
      document.body.addEventListener("touchend", unlock, true);
      document.body.addEventListener("mousedown", unlock, true);
      document.body.addEventListener("mouseup", unlock, true);
      unlock();
    } else {
      resolve(false);
    }
  });
}

function getFrameFromVideo(video) {
  var canvas = document.createElement("canvas");
  canvas.width = video.videoWidth;
  canvas.height = video.videoHeight;
  var ctx = canvas.getContext("2d");

  if (!ctx) {
    return "data:,";
  }

  ctx.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
  return canvas.toDataURL();
}

var EnhancedEventEmitter =
/*#__PURE__*/
function (_EventEmitter2) {
  _inherits(EnhancedEventEmitter, _EventEmitter2);

  function EnhancedEventEmitter() {
    _classCallCheck(this, EnhancedEventEmitter);

    return _possibleConstructorReturn(this, _getPrototypeOf(EnhancedEventEmitter).apply(this, arguments));
  }

  _createClass(EnhancedEventEmitter, [{
    key: "safeEmit",
    value: function safeEmit(event) {
      try {
        for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
          args[_key5 - 1] = arguments[_key5];
        }

        this.emit.apply(this, [event].concat(args));
      } catch (error) {
        log.warning("safeEmit() | event listener threw an error [event:%s]:%o", event, error);
      }
    }
  }, {
    key: "safeEmitAsPromise",
    value: function safeEmitAsPromise(event) {
      var _this25 = this;

      for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        args[_key6 - 1] = arguments[_key6];
      }

      return new Promise(function (resolve, reject) {
        var callback = resolve;

        var errback = function errback(error) {
          log.warning("safeEmitAsPromise() | errback called [event:%s]:%o", event, error);
          reject(error);
        };

        _this25.safeEmit.apply(_this25, [event].concat(args, [callback, errback]));
      });
    }
  }]);

  return EnhancedEventEmitter;
}(EventEmitter);

function playTrack(mediaElement) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3000;

  var playFunc =
  /*#__PURE__*/
  function () {
    var _ref4 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!mediaElement.paused) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return", mediaElement.play());

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    return function playFunc() {
      return _ref4.apply(this, arguments);
    };
  }();

  return new Promise(function (resolve, reject) {
    var timeoutID = setTimeout(function () {
      playFunc().then(resolve).catch(reject);
    }, timeout);

    mediaElement.onloadedmetadata = function () {
      clearTimeout(timeoutID);
      playFunc().then(resolve).catch(reject);
    };

    if ('WeixinJSBridge' in window) {
      window.WeixinJSBridge.invoke('getNetworkType', {}, function () {
        playFunc().then(resolve).catch(noop);
      }, false);
    } else {
      document.addEventListener('WeixinJSBridgeReady', function () {
        playFunc().then(resolve).catch(noop);
      }, false);
    }
  });
}

var Track =
/*#__PURE__*/
function (_EnhancedEventEmitter) {
  _inherits(Track, _EnhancedEventEmitter);

  function Track(track, userID, direction, profiles) {
    var _this26;

    _classCallCheck(this, Track);

    _this26 = _possibleConstructorReturn(this, _getPrototypeOf(Track).call(this));
    _this26.master = false;
    _this26.stats = []; // 当前 track 是否被替换成了 image track

    _this26.isReplacedByImageTrack = false;
    /**
     * @internal
     */

    _this26.direction = "local";
    _this26.sourceType = TrackSourceType.NORMAL;
    /* @internal */

    _this26.onended =
    /*#__PURE__*/
    function () {
      var _ref5 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(event) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(_this26.direction === "local")) {
                  _context4.next = 10;
                  break;
                }

                log.warning("track ended", _this26.mediaTrack, _this26.info.trackID);

                if (!(_this26.info.trackID && _this26._selfEndedCallback)) {
                  _context4.next = 5;
                  break;
                }

                _context4.next = 5;
                return _this26._selfEndedCallback([_this26.info.trackID]);

              case 5:
                _this26.emit("ended", event);

                qos.addEvent("TrackEnded", {
                  track_id: _this26.info.trackID,
                  kind: _this26.info.kind,
                  label: _this26.mediaTrack.label
                });

                _this26.release();

                _context4.next = 11;
                break;

              case 10:
                _this26.emit("@ended", event);

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      return function (_x19) {
        return _ref5.apply(this, arguments);
      };
    }();

    _this26.mediaTrack = track;

    _this26.mediaTrack.addEventListener("ended", _this26.onended);

    _this26.userID = userID;

    if (direction) {
      _this26.direction = direction;
    }

    _this26.info = {
      kind: track.kind,
      muted: !track.enabled,
      userID: _this26.userID,
      versionid: 0,
      profiles: profiles || []
    };
    _this26.handleMediaPause = _this26.handleMediaPause.bind(_assertThisInitialized(_assertThisInitialized(_this26)));
    return _this26;
  }

  _createClass(Track, [{
    key: "setPlaybackDevice",
    value: function () {
      var _setPlaybackDevice = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(deviceId) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!__chunk_1.browserReport.setPlaybackDevice) {
                  ERROR_NOT_SUPPORT("setPlaybackDevice api not support");
                }

                this.playbackDevice = deviceId;

                if (!this.mediaElement) {
                  _context5.next = 4;
                  break;
                }

                return _context5.abrupt("return", this.mediaElement.setSinkId(deviceId));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function setPlaybackDevice(_x20) {
        return _setPlaybackDevice.apply(this, arguments);
      }

      return setPlaybackDevice;
    }()
  }, {
    key: "play",
    value: function play(container, muted) {
      var _this27 = this;

      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        mirror: false
      };
      return new Promise(function (resolve, reject) {
        _this27.removeMediaElement();

        var createEleFunc = _this27.info.kind === "video" ? createVideoElement : createAudioElement;
        _this27.mediaElement = createEleFunc(_this27.mediaTrack);

        if (_this27.info.kind === "audio" && muted !== undefined) {
          _this27.mediaElement.muted = muted;
        }

        if (config.mirror) {
          _this27.mediaElement.style.transform = 'rotateY(180deg)';
        } else {
          _this27.mediaElement.style.transform = '';
        }

        _this27.mediaElement.setAttribute("controls", true);

        container.appendChild(_this27.mediaElement);

        _this27.mediaElement.onplaying = function () {
          _this27.mediaElement.onplaying = null;
          resolve();
        };

        Promise.resolve().then(function () {
          _this27.mediaElement.removeAttribute("controls");

          if (_this27.playbackDevice) {
            return _this27.setPlaybackDevice(_this27.playbackDevice);
          }
        }).then(function () {
          playTrack(_this27.mediaElement).then(resolve).catch(function (playError) {
            var message = playError instanceof Error ? playError.name + ", " + playError.message : "play failed" + String(playError);

            if (playError.name === "NotAllowedError") {
              reject(ERROR_PLAY_NOT_ALLOWED(message));
              qos.addEvent("AutoplayFail", {
                track_id: _this27.info.trackID,
                local_id: _this27.mediaTrack.id,
                label: _this27.mediaTrack.label,
                kind: _this27.info.kind,
                reason: message
              });
            } else {
              reject(ERROR_FATAL(message));
            }
          });
        });
      });
    }
  }, {
    key: "handleMediaPause",
    value: function handleMediaPause() {
      var _this28 = this;

      // auto play try after 900ms
      setTimeout(function () {
        return _this28.mediaElement.play().catch(showPlayWarn);
      }, 900);
    }
    /**
     * @internal
     * @description 根据当前 isReplacedByImageTrack 状态确定正在播放的 track
     */

  }, {
    key: "switchPlayingTrack",
    value: function switchPlayingTrack() {
      if (!this.mediaElement) return;

      if (this.isReplacedByImageTrack && this.imageStreamTrack) {
        this.mediaElement.srcObject = new MediaStream([this.imageStreamTrack.mediaTrack]);
      } else if (!this.isReplacedByImageTrack && this.mediaTrack) {
        this.mediaElement.srcObject = new MediaStream([this.mediaTrack]);
      } else {
        return;
      }

      if (!this.mediaElement.paused) {
        this.mediaElement.play().catch(showPlayWarn);
      }
    }
    /**
     * @internal
     */

  }, {
    key: "resume",
    value: function resume(track) {
      this.mediaTrack.removeEventListener("ended", this.onended);
      this.mediaTrack.stop();
      this.mediaTrack = track;
      this.mediaTrack.addEventListener("ended", this.onended);

      if (this.mediaElement) {
        var stream = new MediaStream([track]);
        this.mediaElement.dataset.localid = track.id;
        this.mediaElement.srcObject = stream;
      }

      this.removeEvent("@get-stats");
      this.resetStats();
    }
  }, {
    key: "getStats",
    value: function getStats() {
      if (!this.statsInterval) {
        this.startGetStatsInterval();
      }

      return this.stats;
    }
  }, {
    key: "getCurrentFrameDataURL",
    value: function getCurrentFrameDataURL() {
      if (!this.mediaElement || !(this.mediaElement instanceof HTMLVideoElement)) {
        return "data:,";
      }

      return getFrameFromVideo(this.mediaElement);
    }
    /**
     * 设置 Track 为 Master SDK只允许发布一路 Audio Track 和一路 Video Track
     * @param master 是否为master
     */

  }, {
    key: "setMaster",
    value: function setMaster(master) {
      this.master = master;
    }
    /**
     * @internal
     */

  }, {
    key: "setMute",
    value: function setMute(muted) {
      this.info.muted = muted;
      this.mediaTrack.enabled = !muted;
      this.emit("mute", muted);
    }
    /**
     * @internal
     */

  }, {
    key: "setKbps",
    value: function setKbps(v) {
      this.info.kbps = v;
    }
    /**
     * @internal
     */

  }, {
    key: "setInfo",
    value: function setInfo(info) {
      this.info = __chunk_1._objectSpread({}, this.info, info);
    }
    /**
     * @internal
     */

  }, {
    key: "removeMediaElement",
    value: function removeMediaElement() {
      if (this.mediaElement) {
        this.mediaElement.removeEventListener("pause", this.handleMediaPause);
        this.mediaElement.remove();
        this.mediaElement = undefined;
      }
    }
  }, {
    key: "release",
    value: function release() {
      this.emit("release");
      this.removeEvent();

      if (this.statsInterval) {
        window.clearInterval(this.statsInterval);
      } // unified-plan 下订阅的 Track 会被复用，不能释放


      if (this.direction === "local" || !__chunk_1.browserReport.unifiedPlan) {
        this.mediaTrack.stop();
      }

      this.removeMediaElement();

      if (this.imageStreamTrack) {
        this.imageStreamTrack.release();
        this.imageStreamTrack = undefined;
      }
    }
    /**
     * @internal
     * 重置 trackID 和 userID，在 unpublish 的时候会自动调用
     */

  }, {
    key: "reset",
    value: function reset() {
      this.info.trackID = undefined;
      this.info.userID = undefined;
      this.info.versionid = 0;
      this.userID = undefined;
      this.resetStats();
    }
    /**
     * @internal
     * 重置 stats，每当 pc 重新构建的时候调用
     */

  }, {
    key: "resetStats",
    value: function resetStats() {
      this.stats = [];
      this.lastStats = [];
    }
    /**
     * @internal
     */

  }, {
    key: "startGetStatsInterval",
    value: function () {
      var _startGetStatsInterval = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var _this29 = this;

        var getStatsFunc;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                getStatsFunc =
                /*#__PURE__*/
                function () {
                  var _ref6 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee6() {
                    var handlers;
                    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            handlers = _this29.getListeners("@get-stats");

                            if (!(!handlers || handlers.length === 0)) {
                              _context6.next = 3;
                              break;
                            }

                            return _context6.abrupt("return", []);

                          case 3:
                            _context6.next = 5;
                            return _this29.safeEmitAsPromise("@get-stats", _this29.lastStats);

                          case 5:
                            _this29.stats = _context6.sent;
                            _this29.lastStats = _toConsumableArray(_this29.stats);

                          case 7:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6, this);
                  }));

                  return function getStatsFunc() {
                    return _ref6.apply(this, arguments);
                  };
                }();

                this.statsInterval = window.setInterval(getStatsFunc, 1000);

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function startGetStatsInterval() {
        return _startGetStatsInterval.apply(this, arguments);
      }

      return startGetStatsInterval;
    }()
  }, {
    key: "setVolume",

    /**
     * @abstract
     */
    value: function setVolume(value) {
      log.warning("not implement");
    }
    /**
     * @abstract
     */

  }, {
    key: "getCurrentTimeDomainData",
    value: function getCurrentTimeDomainData() {
      log.warning("not implement");
      return new Uint8Array();
    }
    /**
     * @abstract
     */

  }, {
    key: "getCurrentFrequencyData",
    value: function getCurrentFrequencyData() {
      log.warning("not implement");
      return new Uint8Array();
    }
    /**
     * @abstract
     */

  }, {
    key: "getVolume",
    value: function getVolume() {
      log.warning("not implement");
      return 0;
    }
    /**
     * @abstract
     */

  }, {
    key: "getCurrentVolumeLevel",
    value: function getCurrentVolumeLevel() {
      log.warning("not implement");
      return 0;
    }
    /**
     * @abstract
     */

  }, {
    key: "setLoop",
    value: function setLoop(loop) {
      log.warning("not implement");
    }
    /**
     * @abstract
     */

  }, {
    key: "startAudioSource",
    value: function startAudioSource() {
      log.warning("not implement");
    }
    /**
     * @abstract
     */

  }, {
    key: "pauseAudioSource",
    value: function pauseAudioSource() {
      log.warning("not implement");
    }
    /**
     * @abstract
     */

  }, {
    key: "resumeAudioSource",
    value: function resumeAudioSource() {
      log.warning("not implement");
    }
    /**
     * @abstract
     */

  }, {
    key: "stopAudioSource",
    value: function stopAudioSource() {
      log.warning("not implement");
    }
    /**
     * @abstract
     */

  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      log.warning("not implement");
      return 0;
    }
    /**
     * @abstract
     */

  }, {
    key: "setCurrentTime",
    value: function setCurrentTime(val) {
      log.warning("not implement");
    }
    /**
     * @abstract
     */

  }, {
    key: "getDuration",
    value: function getDuration() {
      log.warning("not implement");
      return 0;
    }
  }, {
    key: "selfEndedCallback",
    set: function set(cb) {
      this._selfEndedCallback = cb;
    }
  }]);

  return Track;
}(EnhancedEventEmitter);
/*
 * transfer.ts
 * Copyright (C) 2018 disoul <disoul@DiSouldeMacBook-Pro.local>
 *
 * Distributed under terms of the MIT license.
*/


function transferSignalingCustomMessageToCustomMessage(msg) {
  return {
    timestamp: msg.msgts,
    data: msg.text,
    userID: msg.playerid,
    type: msg.type,
    msgid: msg.msgid
  };
}

function transferSignalingTrackToTrackBaseInfo(track) {
  return {
    trackID: track.trackid,
    tag: track.tag,
    mid: track.mid || undefined,
    kind: track.kind,
    userID: track.playerid,
    muted: track.muted,
    versionid: track.versionid,
    profiles: track.profiles || []
  };
}

function transferTrackBaseInfoToSignalingTrack(track, isMaster) {
  return {
    trackid: track.trackID,
    mid: track.mid || undefined,
    kind: track.kind,
    master: isMaster,
    muted: !!track.muted,
    playerid: track.userID,
    tag: track.tag || "",
    versionid: track.versionid
  };
}

function transferTrackToPublishTrack(track) {
  if (!track.info.mid && __chunk_1.browserReport.unifiedPlan) {
    throw ERROR_FATAL("can not find track mid!");
  }

  return {
    localid: track.mediaTrack.id,
    localmid: track.info.mid || undefined,
    master: track.master,
    kind: track.info.kind,
    kbps: track.info.kbps,
    tag: track.info.tag
  };
}

function transferSignalingUserToUser(sigUser) {
  return new User(sigUser.playerid, sigUser.playerdata);
}

function createCustomTrack(mediaTrack, tag, kbps) {
  var track;

  if (mediaTrack.kind === "audio") {
    track = new AudioTrack(mediaTrack);
    track.initAudioManager(true);
  } else {
    track = new Track(mediaTrack);
  }

  if (kbps) {
    track.setKbps(kbps);
  }

  track.setInfo({
    tag: tag
  });
  return track;
}

function transferRecordOptionToMediaConstraints(_x21) {
  return _transferRecordOptionToMediaConstraints.apply(this, arguments);
}

function _transferRecordOptionToMediaConstraints() {
  _transferRecordOptionToMediaConstraints = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee126(options) {
    var screenOptions, plugin, audio, video, constraints;
    return _regeneratorRuntime.wrap(function _callee126$(_context126) {
      while (1) {
        switch (_context126.prev = _context126.next) {
          case 0:
            if (options) {
              _context126.next = 2;
              break;
            }

            return _context126.abrupt("return", {
              audio: true,
              video: true
            });

          case 2:
            if (!REC_SCREEN_ENABLE(options)) {
              _context126.next = 14;
              break;
            }

            if (!REC_VIDEO_ENABLE(options)) {
              _context126.next = 5;
              break;
            }

            throw ERROR_FATAL("can not get mediaStream with video and screen are all enabled");

          case 5:
            if (__chunk_1.browserReport.screenSharing) {
              _context126.next = 7;
              break;
            }

            throw ERROR_NOT_SUPPORT("your browser can not share screen");

          case 7:
            screenOptions = options.screen; // 只有在 chrome 下，用户强制指定用插件或者用户不支持 plugin free 采集才会检查插件

            if (!(__chunk_1.isChrome && (screenOptions.forceChromePlugin || !__chunk_1.browserReport.getDisplayMedia))) {
              _context126.next = 14;
              break;
            }

            _context126.next = 11;
            return _isChromeExtensionAvailable2();

          case 11:
            plugin = _context126.sent;

            if (plugin) {
              _context126.next = 14;
              break;
            }

            throw ERROR_PLUGIN_NOT_AVAILABLE("");

          case 14:
            audio = !options.audio || !options.audio.enabled || !!options.audio.source ? false : {
              deviceId: options.audio.deviceId,
              sampleRate: options.audio.sampleRate,
              sampleSize: options.audio.sampleSize,
              channelCount: options.audio.channelCount,
              autoGainControl: options.audio.autoGainControl,
              echoCancellation: options.audio.echoCancellation,
              noiseSuppression: options.audio.noiseSuppression
            };
            video = !options.video || !options.video.enabled ? false : {
              frameRate: options.video.frameRate,
              height: options.video.height,
              width: options.video.width,
              deviceId: options.video.deviceId,
              facingMode: options.video.facingMode
            };

            if (!(REC_SCREEN_ENABLE(options) && options.screen)) {
              _context126.next = 23;
              break;
            }

            if (!(__chunk_1.browserReport.getDisplayMedia && !options.screen.forceChromePlugin)) {
              _context126.next = 19;
              break;
            }

            return _context126.abrupt("return", createConstraints({
              audio: audio,
              video: {
                displaySurface: getDisplaySurfaceFromSourceOption(options.screen.source),
                width: options.screen.width,
                height: options.screen.height,
                frameRate: options.screen.frameRate
              }
            }));

          case 19:
            _context126.next = 21;
            return getScreenConstraints(false, options.screen);

          case 21:
            constraints = _context126.sent;
            return _context126.abrupt("return", createConstraints({
              audio: audio,
              video: constraints
            }));

          case 23:
            return _context126.abrupt("return", createConstraints({
              audio: audio,
              video: video
            }));

          case 24:
          case "end":
            return _context126.stop();
        }
      }
    }, _callee126, this);
  }));
  return _transferRecordOptionToMediaConstraints.apply(this, arguments);
}

function getDisplaySurfaceFromSourceOption(opt) {
  switch (opt) {
    case "window":
      return "application";

    case "screen":
      return ["window", "monitor"];

    default:
      return undefined;
  }
}

var createConstraints = function createConstraints(constraints) {
  return deleteConstraintsEmptyObject(processConstraints(removeUndefinedKey(constraints)));
};

function processConstraints(constraints) {
  if (__chunk_1.browserReport.minMaxWithIdeal) {
    return constraints;
  }

  var keys = ["video", "screen"];
  keys.forEach(function (key) {
    if (typeof constraints[key] === "object" && typeof constraints[key].width === "object" && constraints[key].width.ideal) {
      delete constraints[key].width.ideal;
    }

    if (typeof constraints[key] === "object" && typeof constraints[key].height === "object" && constraints[key].height.ideal) {
      delete constraints[key].height.ideal;
    }
  });
  return constraints;
} // fix old chrome


function deleteConstraintsEmptyObject(constraints) {
  if (Object.keys(constraints.audio).length === 0 && typeof constraints.audio !== "boolean") {
    constraints.audio = true;
  }

  if (Object.keys(constraints.video).length === 0 && typeof constraints.video !== "boolean") {
    constraints.video = true;
  }

  return constraints;
}

function getNumberRangeMax(range) {
  if (!range) {
    return undefined;
  }

  if (typeof range === "number") {
    return range;
  }

  if (range.exact) {
    return range.exact;
  }

  if (range.max) {
    return range.max;
  }

  if (range.ideal) {
    return range.ideal;
  }

  if (range.min) {
    return range.min;
  }

  return undefined;
}
/*
 * sdp.ts
 * Copyright (C) 2018 disoul <disoul@DiSouldeMacBook-Pro.local>
 *
 * Distributed under terms of the MIT license.
*/


var NEW_LINE = "\n";
/*
 * index.ts
 * Copyright (C) 2018 disoul <disoul@DiSouldeMacBook-Pro.local>
 *
 * Distributed under terms of the MIT license.
*/

/*
 * sdp.ts
 * Copyright (C) 2018 disoul <disoul@DiSouldeMacBook-Pro.local>
 *
 * Distributed under terms of the MIT license.
*/

var REMOTE_SERVER_NAME = "qiniu-rtc-client";

function iceCandidates2Candidates(iceCandidates) {
  return iceCandidates.map(function (iceCandidate) {
    var candidate = {
      component: 1,
      foundation: iceCandidate.foundation,
      ip: iceCandidate.ip,
      port: iceCandidate.port,
      priority: iceCandidate.priority,
      transport: iceCandidate.protocol,
      type: iceCandidate.type
    };

    if (iceCandidate.tcpType) {
      candidate.tcptype = iceCandidate.tcpType;
    }

    return candidate;
  });
}

var RemoteSdp =
/*#__PURE__*/
function () {
  function RemoteSdp(direction, rtpcap) {
    _classCallCheck(this, RemoteSdp);

    this.lastSubMids = [];
    this.sessionVersion = 0;
    this.direction = direction;
    this.extendedRtpCapabilities = rtpcap;
  }

  _createClass(RemoteSdp, [{
    key: "setTransportRemoteParameters",
    value: function () {
      var _setTransportRemoteParameters = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(remoteParameters) {
        var _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, candidate;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context8.prev = 3;
                _iterator3 = remoteParameters.iceCandidates[Symbol.iterator]();

              case 5:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context8.next = 13;
                  break;
                }

                candidate = _step3.value;
                _context8.next = 9;
                return resolveIceHost(candidate.ip);

              case 9:
                candidate.ip = _context8.sent;

              case 10:
                _iteratorNormalCompletion3 = true;
                _context8.next = 5;
                break;

              case 13:
                _context8.next = 19;
                break;

              case 15:
                _context8.prev = 15;
                _context8.t0 = _context8["catch"](3);
                _didIteratorError3 = true;
                _iteratorError3 = _context8.t0;

              case 19:
                _context8.prev = 19;
                _context8.prev = 20;

                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                  _iterator3.return();
                }

              case 22:
                _context8.prev = 22;

                if (!_didIteratorError3) {
                  _context8.next = 25;
                  break;
                }

                throw _iteratorError3;

              case 25:
                return _context8.finish(22);

              case 26:
                return _context8.finish(19);

              case 27:
                this._transportRemoteParameters = remoteParameters;

              case 28:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[3, 15, 19, 27], [20,, 22, 26]]);
      }));

      function setTransportRemoteParameters(_x22) {
        return _setTransportRemoteParameters.apply(this, arguments);
      }

      return setTransportRemoteParameters;
    }()
  }, {
    key: "createRemoteAnswer",
    value: function createRemoteAnswer(offer, midRidEncoding, removeMids) {
      log.log("create remote answer", midRidEncoding, removeMids);
      if (!this.transportRemoteParameters) throw ERROR_FATAL("no transportRemoteParameters!");

      if (__chunk_1.browserReport.unifiedPlan) {
        return createUnifiedPlanAnswerSdp(this.extendedRtpCapabilities, this.transportRemoteParameters, offer, midRidEncoding, removeMids);
      } else {
        return createPlanBAnswerSdp(this.extendedRtpCapabilities, this.transportRemoteParameters, offer);
      }
    }
  }, {
    key: "createRemoteOffer",
    value: function createRemoteOffer(consumerInfos) {
      if (!this.transportRemoteParameters) throw ERROR_FATAL("no transportRemoteParameters!");

      if (__chunk_1.browserReport.unifiedPlan) {
        var sortedConsumerInfos = sortConsumerInfos(consumerInfos, this.lastSubMids);
        this.lastSubMids = sortedConsumerInfos.map(function (c) {
          return c.mid;
        });
        this.sessionVersion += 1;
        return createUnifiedPlanOfferSdp(sortedConsumerInfos, this.extendedRtpCapabilities, this.transportRemoteParameters, this.sessionVersion);
      } else {
        var kind = new Set();
        consumerInfos.forEach(function (c) {
          return kind.add(c.kind);
        }); //  如果没有传入 consumerInfos 代表是创建 sub pc

        if (consumerInfos.length === 0) {
          kind.add("audio");
          kind.add("video");
        }

        return createPlanBOfferSdp(Array.from(kind), consumerInfos, this.extendedRtpCapabilities, this.transportRemoteParameters);
      }
    }
  }, {
    key: "updateICEData",
    value: function () {
      var _updateICEData = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9(iceParameters, iceCandidates) {
        var _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, candidate;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (this.transportRemoteParameters) {
                  _context9.next = 2;
                  break;
                }

                return _context9.abrupt("return");

              case 2:
                _iteratorNormalCompletion4 = true;
                _didIteratorError4 = false;
                _iteratorError4 = undefined;
                _context9.prev = 5;
                _iterator4 = iceCandidates[Symbol.iterator]();

              case 7:
                if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                  _context9.next = 15;
                  break;
                }

                candidate = _step4.value;
                _context9.next = 11;
                return resolveIceHost(candidate.ip);

              case 11:
                candidate.ip = _context9.sent;

              case 12:
                _iteratorNormalCompletion4 = true;
                _context9.next = 7;
                break;

              case 15:
                _context9.next = 21;
                break;

              case 17:
                _context9.prev = 17;
                _context9.t0 = _context9["catch"](5);
                _didIteratorError4 = true;
                _iteratorError4 = _context9.t0;

              case 21:
                _context9.prev = 21;
                _context9.prev = 22;

                if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                  _iterator4.return();
                }

              case 24:
                _context9.prev = 24;

                if (!_didIteratorError4) {
                  _context9.next = 27;
                  break;
                }

                throw _iteratorError4;

              case 27:
                return _context9.finish(24);

              case 28:
                return _context9.finish(21);

              case 29:
                this.transportRemoteParameters.iceCandidates = iceCandidates;
                this.transportRemoteParameters.iceParameters = iceParameters;

              case 31:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[5, 17, 21, 29], [22,, 24, 28]]);
      }));

      function updateICEData(_x23, _x24) {
        return _updateICEData.apply(this, arguments);
      }

      return updateICEData;
    }()
  }, {
    key: "transportRemoteParameters",
    get: function get() {
      return this._transportRemoteParameters;
    }
  }]);

  return RemoteSdp;
}();

function checkH264(_x25) {
  return _checkH.apply(this, arguments);
}

function _checkH() {
  _checkH = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee127(pc) {
    var offerOptions, offer;
    return _regeneratorRuntime.wrap(function _callee127$(_context127) {
      while (1) {
        switch (_context127.prev = _context127.next) {
          case 0:
            offerOptions = {
              offerToReceiveAudio: true,
              offerToReceiveVideo: true
            };
            _context127.next = 3;
            return pc.createOffer(offerOptions);

          case 3:
            offer = _context127.sent;

            if (offer.sdp) {
              _context127.next = 8;
              break;
            }

            return _context127.abrupt("return", {
              isH264: false,
              sdp: ""
            });

          case 8:
            return _context127.abrupt("return", {
              isH264: offer.sdp.toLowerCase().indexOf('h264') === -1 ? false : true,
              sdp: offer.sdp
            });

          case 9:
          case "end":
            return _context127.stop();
        }
      }
    }, _callee127, this);
  }));
  return _checkH.apply(this, arguments);
}

function getClientCapabilitiesSdp() {
  return _getClientCapabilitiesSdp.apply(this, arguments);
}

function _getClientCapabilitiesSdp() {
  _getClientCapabilitiesSdp = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee128() {
    var pc, _ref28, isH264, sdp, n, _ref29, capsdp;

    return _regeneratorRuntime.wrap(function _callee128$(_context128) {
      while (1) {
        switch (_context128.prev = _context128.next) {
          case 0:
            pc = createPC();
            _context128.next = 3;
            return checkH264(pc);

          case 3:
            _ref28 = _context128.sent;
            isH264 = _ref28.isH264;
            sdp = _ref28.sdp;
            n = 5;

          case 7:
            if (!(!isH264 && n > 0)) {
              _context128.next = 18;
              break;
            }

            pc.close();
            pc = createPC();
            _context128.next = 12;
            return checkH264(pc);

          case 12:
            _ref29 = _context128.sent;
            isH264 = _ref29.isH264;
            sdp = _ref29.sdp;
            n--;
            _context128.next = 7;
            break;

          case 18:
            if (__chunk_1.browserReport.needH264FmtpLine) {
              sdp += "a=fmtp:107 level-asymmetry-allowed=1;packetization-mode=1;profile-level-id=42e01f".concat(NEW_LINE);
            }

            sdp = removeAudioREDLine(sdp);
            sdp = removeVideOrientation(sdp);
            capsdp = {
              capsdp: sdp,
              agent: navigator.userAgent
            };
            pc.close();
            return _context128.abrupt("return", capsdp);

          case 24:
          case "end":
            return _context128.stop();
        }
      }
    }, _callee128, this);
  }));
  return _getClientCapabilitiesSdp.apply(this, arguments);
}

function createPlanBAnswerSdp(rtpcaps, data, offer) {
  var sdpObj = sdpTransform.parse(offer);
  sdpObj.version = 0;
  sdpObj.origin = {
    address: "0.0.0.0",
    ipVer: 4,
    netType: "IN",
    sessionId: "5975129998295344376",
    sessionVersion: 2,
    username: REMOTE_SERVER_NAME
  };
  sdpObj.name = "-";
  sdpObj.timing = {
    start: 0,
    stop: 0
  };
  sdpObj.icelite = data.iceParameters.iceLite ? "ice-lite" : undefined;
  sdpObj.msidSemantic = {
    semantic: "WMS",
    token: "*"
  };
  sdpObj.fingerprint = {
    type: data.dtlsParameters.fingerprints[0].algorithm,
    hash: data.dtlsParameters.fingerprints[0].value
  };
  var newMedia = [];
  var _iteratorNormalCompletion5 = true;
  var _didIteratorError5 = false;
  var _iteratorError5 = undefined;

  try {
    var _loop2 = function _loop2() {
      var _mSection = _step5.value;
      var kind = _mSection.type;
      var codec = rtpcaps.codecs.find(function (c) {
        return c.kind === kind;
      });
      var headerExtensions = (rtpcaps.headerExtensions || []).filter(function (h) {
        return h.kind === kind;
      });
      if (!codec) throw ERROR_FATAL("can not find codec" + kind);
      var mSection = {
        type: kind,
        mid: kind,
        port: 7,
        protocol: "RTP/SAVPF",
        connection: {
          ip: "127.0.0.1",
          version: 4
        },
        iceUfrag: data.iceParameters.usernameFragment,
        icePwd: data.iceParameters.password,
        candidates: iceCandidates2Candidates(data.iceCandidates),
        endOfCandidates: "end-of-candidates",
        iceOptions: "renomination",
        setup: data.dtlsParameters.role === "server" ? "actpass" : "active",
        direction: "recvonly",
        rtp: [{
          payload: codec.sendPayloadType,
          codec: codec.name,
          rate: codec.clockRate,
          encoding: codec.channels > 1 ? codec.channels : undefined
        }],
        rtcpFb: [],
        fmtp: [{
          payload: codec.sendPayloadType,
          config: Object.keys(codec.parameters).map(function (k) {
            return "".concat(k, "=").concat(codec.parameters[k], ";");
          }).join("")
        }],
        payloads: codec.sendPayloadType,
        rtcpMux: "rtcp-mux",
        rtcpRsize: "rtcp-rsize",
        ext: headerExtensions.map(function (ext) {
          return {
            uri: ext.uri,
            value: ext.sendId
          };
        })
      };

      if (codec.rtcpFeedback && codec.rtcpFeedback.length > 0) {
        codec.rtcpFeedback.forEach(function (rf) {
          mSection.rtcpFb.push({
            payload: codec.sendPayloadType,
            type: rf.type,
            subtype: rf.parameter
          });
        });
      }

      if (codec.sendRtxPayloadType) {
        mSection.rtp.push({
          payload: codec.sendRtxPayloadType,
          codec: "rtx",
          rate: codec.clockRate,
          encoding: codec.channels > 1 ? codec.channels : undefined
        });
        mSection.fmtp.push({
          payload: codec.sendRtxPayloadType,
          config: "apt=".concat(codec.sendPayloadType, ";")
        });
        mSection.payloads = "".concat(codec.sendPayloadType, " ").concat(codec.sendRtxPayloadType);
      }

      newMedia.push(mSection);
    };

    for (var _iterator5 = sdpObj.media[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
      _loop2();
    }
  } catch (err) {
    _didIteratorError5 = true;
    _iteratorError5 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
        _iterator5.return();
      }
    } finally {
      if (_didIteratorError5) {
        throw _iteratorError5;
      }
    }
  }

  sdpObj.media = newMedia;
  return sdpTransform.write(sdpObj);
}
/**
 * unified-plan 对 mid 顺序敏感，必须保证每次重协商顺序一致
 */


function sortConsumerInfos(infos, lastSubMids) {
  var newInfos = [];
  var _iteratorNormalCompletion6 = true;
  var _didIteratorError6 = false;
  var _iteratorError6 = undefined;

  try {
    var _loop3 = function _loop3() {
      var mid = _step6.value;
      var info = remove(infos, function (i) {
        return i.mid === mid;
      })[0];
      if (!info) return "continue";
      newInfos.push(info);
    };

    for (var _iterator6 = lastSubMids[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
      var _ret = _loop3();

      if (_ret === "continue") continue;
    }
  } catch (err) {
    _didIteratorError6 = true;
    _iteratorError6 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
        _iterator6.return();
      }
    } finally {
      if (_didIteratorError6) {
        throw _iteratorError6;
      }
    }
  }

  newInfos = newInfos.concat(infos);
  lastSubMids = newInfos.map(function (i) {
    return i.mid;
  });
  return newInfos;
}

function createUnifiedPlanOfferSdp(consumerInfos, rtpcaps, data, sessionVersion) {
  log.debug("consumerInfos", consumerInfos);
  var sdpObj = {};
  var mids = consumerInfos.map(function (i) {
    return i.mid;
  });
  sdpObj.version = 0;
  sdpObj.origin = {
    address: "0.0.0.0",
    ipVer: 4,
    netType: "IN",
    sessionId: "5975129998295344377",
    sessionVersion: sessionVersion,
    username: REMOTE_SERVER_NAME
  };
  sdpObj.name = "-";
  sdpObj.timing = {
    start: 0,
    stop: 0
  };
  sdpObj.icelite = data.iceParameters.iceLite ? "ice-lite" : undefined;
  sdpObj.msidSemantic = {
    semantic: "WMS",
    token: "*"
  };

  if (mids.length > 0) {
    sdpObj.groups = [{
      type: "BUNDLE",
      mids: mids.join(" ")
    }];
  }

  sdpObj.media = [];
  sdpObj.fingerprint = {
    type: data.dtlsParameters.fingerprints[0].algorithm,
    hash: data.dtlsParameters.fingerprints[0].value
  };
  var _iteratorNormalCompletion7 = true;
  var _didIteratorError7 = false;
  var _iteratorError7 = undefined;

  try {
    var _loop4 = function _loop4() {
      var info = _step7.value;
      var codecs = info.kind === "audio" ? rtpcaps.codecs[0] : rtpcaps.codecs[1];
      var headerExtensions = rtpcaps.headerExtensions.filter(function (h) {
        return h.kind === info.kind;
      });
      var mediaObj = {
        type: info.kind,
        port: 7,
        protocol: "RTP/SAVPF",
        connection: {
          ip: "127.0.0.1",
          version: 4
        },
        mid: info.mid,
        msid: "".concat(info.streamId, " ").concat(info.trackID),
        iceUfrag: data.iceParameters.usernameFragment,
        icePwd: data.iceParameters.password,
        candidates: iceCandidates2Candidates(data.iceCandidates),
        endOfCandidates: "end-of-candidates",
        iceOptions: "renomination",
        setup: data.dtlsParameters.role === "server" ? "actpass" : "active",
        direction: info.closed ? "inactive" : "sendonly",
        rtp: [{
          payload: codecs.recvPayloadType,
          codec: codecs.name,
          rate: codecs.clockRate,
          encoding: codecs.channels > 1 ? codecs.channels : undefined
        }],
        rtcpFb: [],
        fmtp: [{
          payload: codecs.recvPayloadType,
          config: Object.keys(codecs.parameters).map(function (k) {
            return "".concat(k, "=").concat(codecs.parameters[k], ";");
          }).join("")
        }],
        payloads: codecs.recvPayloadType,
        rtcpMux: "rtcp-mux",
        rtcpRsize: "rtcp-rsize",
        ext: !info.closed ? headerExtensions.map(function (ext) {
          return {
            uri: ext.uri,
            value: ext.recvId
          };
        }) : [],
        ssrcs: !info.closed && info.ssrc ? [{
          id: info.ssrc,
          attribute: "cname",
          value: info.cname
        }] : [],
        ssrcGroups: []
      };

      if (codecs.rtcpFeedback && codecs.rtcpFeedback.length > 0) {
        codecs.rtcpFeedback.forEach(function (rf) {
          mediaObj.rtcpFb.push({
            payload: codecs.recvPayloadType,
            type: rf.type,
            subtype: rf.parameter
          });
        });
      }

      if (codecs.recvRtxPayloadType) {
        mediaObj.rtp.push({
          payload: codecs.recvRtxPayloadType,
          codec: "rtx",
          rate: codecs.clockRate,
          encoding: codecs.channels > 1 ? codecs.channels : undefined
        });
        mediaObj.fmtp.push({
          payload: codecs.recvRtxPayloadType,
          config: "apt=".concat(codecs.recvPayloadType, ";")
        });
        mediaObj.payloads = "".concat(codecs.recvPayloadType, " ").concat(codecs.recvRtxPayloadType);
      }

      if (info.rtxSsrc && !info.closed) {
        mediaObj.ssrcs = mediaObj.ssrcs.concat([{
          id: info.rtxSsrc,
          attribute: "cname",
          value: info.cname
        }]);
        mediaObj.ssrcGroups.push({
          semantics: "FID",
          ssrcs: "".concat(info.ssrc, " ").concat(info.rtxSsrc)
        });
      }

      sdpObj.media.push(mediaObj);
    };

    for (var _iterator7 = consumerInfos[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
      _loop4();
    }
  } catch (err) {
    _didIteratorError7 = true;
    _iteratorError7 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
        _iterator7.return();
      }
    } finally {
      if (_didIteratorError7) {
        throw _iteratorError7;
      }
    }
  }

  return sdpTransform.write(sdpObj);
}

function createUnifiedPlanAnswerSdp(rtpcaps, data, offer, midRidEncoding, removeMids) {
  var localSdpObj = sdpTransform.parse(offer);
  var sdpObj = {};
  sdpObj.version = 0;
  sdpObj.origin = {
    address: "0.0.0.0",
    ipVer: 4,
    netType: "IN",
    sessionId: "5975129998295344376",
    sessionVersion: 2,
    username: REMOTE_SERVER_NAME
  };
  sdpObj.name = "-";
  sdpObj.timing = {
    start: 0,
    stop: 0
  };
  sdpObj.icelite = data.iceParameters.iceLite ? "ice-lite" : undefined;
  sdpObj.msidSemantic = {
    semantic: "WMS",
    token: "*"
  };
  sdpObj.media = [];
  sdpObj.fingerprint = {
    type: data.dtlsParameters.fingerprints[0].algorithm,
    hash: data.dtlsParameters.fingerprints[0].value
  };
  var _iteratorNormalCompletion8 = true;
  var _didIteratorError8 = false;
  var _iteratorError8 = undefined;

  try {
    var _loop5 = function _loop5() {
      var localMediaObj = _step8.value;
      var closed = localMediaObj.direction === "inactive";
      var kind = localMediaObj.type;
      var codecs = kind === "audio" ? rtpcaps.codecs[0] : rtpcaps.codecs[1];
      var headerExtensions = rtpcaps.headerExtensions.filter(function (h) {
        return h.kind === kind;
      });
      var remoteMediaObj = {
        type: localMediaObj.type,
        port: removeMids && removeMids.has(String(localMediaObj.mid)) ? 0 : 7,
        protocol: "RTP/SAVPF",
        connection: {
          ip: "127.0.0.1",
          version: 4
        },
        mid: localMediaObj.mid,
        iceUfrag: data.iceParameters.usernameFragment,
        icePwd: data.iceParameters.password,
        candidates: iceCandidates2Candidates(data.iceCandidates),
        endOfCandidates: "end-of-candidates",
        iceOptions: "renomination",
        setup: data.dtlsParameters.role === "server" ? "actpass" : "active",
        direction: localMediaObj.direction === "sendonly" || localMediaObj.direction === "sendrecv" ? "recvonly" : "inactive",
        rtp: [{
          payload: codecs.sendPayloadType,
          codec: codecs.name,
          rate: codecs.clockRate,
          encoding: codecs.channels > 1 ? codecs.channels : undefined
        }],
        rtcpFb: [],
        fmtp: [{
          payload: codecs.sendPayloadType,
          config: Object.keys(codecs.parameters).map(function (k) {
            return "".concat(k, "=").concat(codecs.parameters[k], ";");
          }).join("")
        }],
        payloads: codecs.sendPayloadType,
        rtcpMux: "rtcp-mux",
        rtcpRsize: "rtcp-rsize",
        ext: headerExtensions.map(function (ext) {
          return {
            uri: ext.uri,
            value: ext.sendId
          };
        })
      };

      if (codecs.rtcpFeedback && codecs.rtcpFeedback.length > 0) {
        codecs.rtcpFeedback.forEach(function (rf) {
          remoteMediaObj.rtcpFb.push({
            payload: codecs.sendPayloadType,
            type: rf.type,
            subtype: rf.parameter
          });
        });
      }

      if (codecs.sendRtxPayloadType) {
        remoteMediaObj.rtp.push({
          payload: codecs.sendRtxPayloadType,
          codec: "rtx",
          rate: codecs.clockRate,
          encoding: codecs.channels > 1 ? codecs.channels : undefined
        });
        remoteMediaObj.fmtp.push({
          payload: codecs.sendRtxPayloadType,
          config: "apt=".concat(codecs.sendPayloadType, ";")
        });
        remoteMediaObj.payloads = "".concat(codecs.sendPayloadType, " ").concat(codecs.sendRtxPayloadType);
      }

      var profileEncodings = midRidEncoding[remoteMediaObj.mid];

      if (remoteMediaObj.type === 'video' && profileEncodings) {
        remoteMediaObj.rids = [{
          id: "hi",
          direction: "recv"
        }, {
          id: "lo",
          direction: "recv"
        }];
        remoteMediaObj.simulcast = {
          dir1: "recv",
          list1: "hi;lo"
        };
      }

      sdpObj.media.push(remoteMediaObj);
    };

    for (var _iterator8 = localSdpObj.media[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
      _loop5();
    }
  } catch (err) {
    _didIteratorError8 = true;
    _iteratorError8 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
        _iterator8.return();
      }
    } finally {
      if (_didIteratorError8) {
        throw _iteratorError8;
      }
    }
  }

  var bundleMids = (localSdpObj.media || []).filter(function (m) {
    return m.hasOwnProperty("mid") && m.port !== 0;
  }).map(function (m) {
    return String(m.mid);
  });

  if (bundleMids.length > 0) {
    sdpObj.groups = [{
      type: "BUNDLE",
      mids: bundleMids.join(" ")
    }];
  }

  return sdpTransform.write(sdpObj);
}

function createPlanBOfferSdp(kinds, consumerInfos, rtpcaps, data) {
  // 保证 audio 在 video 前
  kinds = ["audio", "video"];
  var sdpObj = {};
  sdpObj.version = 0;
  sdpObj.origin = {
    address: "0.0.0.0",
    ipVer: 4,
    netType: "IN",
    sessionId: "5975129998295344377",
    sessionVersion: 2,
    username: REMOTE_SERVER_NAME
  };
  sdpObj.name = "-";
  sdpObj.timing = {
    start: 0,
    stop: 0
  };
  sdpObj.icelite = data.iceParameters.iceLite ? "ice-lite" : undefined;
  sdpObj.msidSemantic = {
    semantic: "WMS",
    token: "*"
  };
  sdpObj.groups = [{
    type: "BUNDLE",
    mids: kinds.join(" ")
  }];
  sdpObj.media = [];
  sdpObj.fingerprint = {
    type: data.dtlsParameters.fingerprints[0].algorithm,
    hash: data.dtlsParameters.fingerprints[0].value
  };
  var _iteratorNormalCompletion9 = true;
  var _didIteratorError9 = false;
  var _iteratorError9 = undefined;

  try {
    var _loop6 = function _loop6() {
      var kind = _step9.value;
      var kindConsumerInfos = consumerInfos.filter(function (i) {
        return i.kind === kind;
      });
      var codecs = rtpcaps.codecs.find(function (c) {
        return c.kind === kind;
      });
      var headerExtensions = (rtpcaps.headerExtensions || []).filter(function (e) {
        return e.kind === kind;
      });
      if (!codecs) throw ERROR_FATAL("no codec" + kind);
      var mediaObj = {
        type: kind,
        port: 7,
        protocol: "RTP/SAVPF",
        connection: {
          ip: "127.0.0.1",
          version: 4
        },
        mid: kind,
        iceUfrag: data.iceParameters.usernameFragment,
        icePwd: data.iceParameters.password,
        candidates: iceCandidates2Candidates(data.iceCandidates),
        endOfCandidates: "end-of-candidates",
        iceOptions: "renomination",
        setup: data.dtlsParameters.role === "server" ? "actpass" : "active",
        direction: "sendonly",
        rtp: [{
          payload: codecs.recvPayloadType,
          codec: codecs.name,
          rate: codecs.clockRate,
          encoding: codecs.channels > 1 ? codecs.channels : undefined
        }],
        rtcpFb: [],
        fmtp: [{
          payload: codecs.recvPayloadType,
          config: Object.keys(codecs.parameters).map(function (k) {
            return "".concat(k, "=").concat(codecs.parameters[k], ";");
          }).join("")
        }],
        payloads: codecs.recvPayloadType,
        rtcpMux: "rtcp-mux",
        rtcpRsize: "rtcp-rsize",
        ssrcs: [],
        ssrcGroups: [],
        ext: headerExtensions.map(function (ext) {
          return {
            uri: ext.uri,
            value: ext.recvId
          };
        })
      };

      if (codecs.rtcpFeedback && codecs.rtcpFeedback.length > 0) {
        codecs.rtcpFeedback.forEach(function (rf) {
          mediaObj.rtcpFb.push({
            payload: codecs.recvPayloadType,
            type: rf.type,
            subtype: rf.parameter
          });
        });
      }

      if (codecs.recvRtxPayloadType) {
        mediaObj.rtp.push({
          payload: codecs.recvRtxPayloadType,
          codec: "rtx",
          rate: codecs.clockRate,
          encoding: codecs.channels > 1 ? codecs.channels : undefined
        });
        mediaObj.fmtp.push({
          payload: codecs.recvRtxPayloadType,
          config: "apt=".concat(codecs.recvPayloadType, ";")
        });
        mediaObj.payloads = "".concat(codecs.recvPayloadType, " ").concat(codecs.recvRtxPayloadType);
      }

      var _iteratorNormalCompletion10 = true;
      var _didIteratorError10 = false;
      var _iteratorError10 = undefined;

      try {
        for (var _iterator10 = kindConsumerInfos[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
          var info = _step10.value;
          mediaObj.ssrcs.push({
            id: info.ssrc,
            attribute: "msid",
            value: "".concat(info.streamId, " ").concat(info.trackID)
          });
          mediaObj.ssrcs.push({
            id: info.ssrc,
            attribute: "mslabel",
            value: "".concat(info.streamId)
          });
          mediaObj.ssrcs.push({
            id: info.ssrc,
            attribute: "label",
            value: "".concat(info.trackID)
          });
          mediaObj.ssrcs.push({
            id: info.ssrc,
            attribute: "cname",
            value: "".concat(info.cname)
          });

          if (info.rtxSsrc) {
            mediaObj.ssrcGroups.push({
              semantics: "FID",
              ssrcs: "".concat(info.ssrc, " ").concat(info.rtxSsrc)
            });
            mediaObj.ssrcs.push({
              id: info.rtxSsrc,
              attribute: "msid",
              value: "".concat(info.streamId, " ").concat(info.trackID)
            });
            mediaObj.ssrcs.push({
              id: info.rtxSsrc,
              attribute: "mslabel",
              value: "".concat(info.streamId)
            });
            mediaObj.ssrcs.push({
              id: info.rtxSsrc,
              attribute: "label",
              value: "".concat(info.trackID)
            });
            mediaObj.ssrcs.push({
              id: info.rtxSsrc,
              attribute: "cname",
              value: "".concat(info.cname)
            });
          }
        }
      } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion10 && _iterator10.return != null) {
            _iterator10.return();
          }
        } finally {
          if (_didIteratorError10) {
            throw _iteratorError10;
          }
        }
      }

      sdpObj.media.push(mediaObj);
    };

    for (var _iterator9 = kinds[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
      _loop6();
    }
  } catch (err) {
    _didIteratorError9 = true;
    _iteratorError9 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
        _iterator9.return();
      }
    } finally {
      if (_didIteratorError9) {
        throw _iteratorError9;
      }
    }
  }

  return sdpTransform.write(sdpObj);
}

function removeAudioREDLine(sdp) {
  var sdpObj = sdpTransform.parse(sdp);
  if (!('media' in sdpObj)) return sdpTransform.write(sdpObj);
  if (!Array.isArray(sdpObj.media)) return sdpTransform.write(sdpObj);
  var _iteratorNormalCompletion11 = true;
  var _didIteratorError11 = false;
  var _iteratorError11 = undefined;

  try {
    var _loop7 = function _loop7() {
      var media = _step11.value;
      if (!('rtp' in media) || !Array.isArray(media.rtp)) return "continue";
      if (media.type !== "audio") return "continue";
      media.rtp = media.rtp.filter(function (rtp) {
        if (!('codec' in rtp)) return true;

        if (rtp.codec.toLowerCase() === 'red') {
          if ("payload" in rtp && "fmtp" in media && Array.isArray(media.fmtp)) {
            media.fmtp = media.fmtp.filter(function (fmtp) {
              return fmtp.payload !== rtp.payload;
            });
          }

          return false;
        }

        return true;
      });
    };

    for (var _iterator11 = sdpObj.media[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
      var _ret2 = _loop7();

      if (_ret2 === "continue") continue;
    }
  } catch (err) {
    _didIteratorError11 = true;
    _iteratorError11 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion11 && _iterator11.return != null) {
        _iterator11.return();
      }
    } finally {
      if (_didIteratorError11) {
        throw _iteratorError11;
      }
    }
  }

  return sdpTransform.write(sdpObj);
} // 解决手机端合流旋转方向异常问题，删除 urn:3gpp:video-orientation 属性


function removeVideOrientation(sdp) {
  var sdpObj = sdpTransform.parse(sdp);
  if (!('media' in sdpObj)) return sdpTransform.write(sdpObj);
  if (!Array.isArray(sdpObj.media)) return sdpTransform.write(sdpObj);
  var _iteratorNormalCompletion12 = true;
  var _didIteratorError12 = false;
  var _iteratorError12 = undefined;

  try {
    for (var _iterator12 = sdpObj.media[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
      var media = _step12.value;
      if (!('ext' in media) || !Array.isArray(media.ext)) continue;
      if (media.type !== "video") continue;
      media.ext = media.ext.filter(function (ext) {
        return ext.uri !== "urn:3gpp:video-orientation";
      });
    }
  } catch (err) {
    _didIteratorError12 = true;
    _iteratorError12 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion12 && _iterator12.return != null) {
        _iterator12.return();
      }
    } finally {
      if (_didIteratorError12) {
        throw _iteratorError12;
      }
    }
  }

  return sdpTransform.write(sdpObj);
}

function transformOfferSdp(sdp, layers) {
  var sdpObj = sdpTransform.parse(sdp);

  if (layers) {
    if (__chunk_1.browser.name === 'chrome') {
      sdpObj.media = sdpObj.media.map(function (media) {
        if (!media.ssrcGroups || media.ssrcGroups.length === 0 || !media.ssrcs || media.ssrcs.length === 0) {
          return media;
        }

        var fidGroup = media.ssrcGroups.find(function (group) {
          return group.semantics === 'FID';
        });

        if (!fidGroup) {
          return media;
        }

        var _fidGroup$ssrcs$split = fidGroup.ssrcs.split(' ').map(function (ssrc) {
          return parseInt(ssrc, 10);
        }),
            _fidGroup$ssrcs$split2 = _slicedToArray(_fidGroup$ssrcs$split, 2),
            videoSSRC1 = _fidGroup$ssrcs$split2[0],
            rtxSSRC1 = _fidGroup$ssrcs$split2[1];

        var cname, msid;
        media.ssrcs.forEach(function (ssrc) {
          if (ssrc.attribute === 'cname') {
            cname = ssrc.value;
          }

          if (ssrc.attribute === 'msid') {
            msid = ssrc.value;
          }
        });
        var simSsrcs = [];
        simSsrcs.push(videoSSRC1);

        if (layers >= 2) {
          var videoSSRC2 = videoSSRC1 + 1;
          var rtxSSRC2 = rtxSSRC1 + 1;
          media.ssrcs.push({
            id: videoSSRC2,
            attribute: 'cname',
            value: cname
          });
          media.ssrcs.push({
            id: videoSSRC2,
            attribute: 'msid',
            value: msid
          });
          media.ssrcs.push({
            id: rtxSSRC2,
            attribute: 'cname',
            value: cname
          });
          media.ssrcs.push({
            id: rtxSSRC2,
            attribute: 'msid',
            value: msid
          });
          media.ssrcGroups.push({
            semantics: "FID",
            ssrcs: "".concat(videoSSRC2, " ").concat(rtxSSRC2)
          });
          simSsrcs.push(videoSSRC2);
        }

        if (layers >= 3) {
          var videoSSRC3 = videoSSRC1 + 2;
          var rtxSSRC3 = rtxSSRC1 + 2;
          media.ssrcs.push({
            id: videoSSRC3,
            attribute: 'cname',
            value: cname
          });
          media.ssrcs.push({
            id: videoSSRC3,
            attribute: 'msid',
            value: msid
          });
          media.ssrcs.push({
            id: rtxSSRC3,
            attribute: 'cname',
            value: cname
          });
          media.ssrcs.push({
            id: rtxSSRC3,
            attribute: 'msid',
            value: msid
          });
          media.ssrcGroups.push({
            semantics: "FID",
            ssrcs: "".concat(videoSSRC3, " ").concat(rtxSSRC3)
          });
          simSsrcs.push(videoSSRC3);
        }

        media.ssrcGroups.push({
          semantics: "SIM",
          ssrcs: simSsrcs.join(' ')
        });
        return media;
      });
    }
  }

  var newSdp = sdpTransform.write(sdpObj);
  var sdpLines = newSdp.split('\r\n');
  var ssrcGroupsIdx = sdpLines.findIndex(function (line) {
    return line.indexOf('a=ssrc-group:FID') === 0;
  });

  while (ssrcGroupsIdx !== -1 && sdpLines[ssrcGroupsIdx].indexOf('a=ssrc-group:FID') === 0) {
    var rtxSSRC = sdpLines[ssrcGroupsIdx].split(' ')[2];

    for (var i = ssrcGroupsIdx - 1; i >= 0; i--) {
      if (sdpLines[i].indexOf(rtxSSRC) > 0) {
        sdpLines.splice(i + 1, 0, sdpLines[ssrcGroupsIdx]);
        sdpLines.splice(ssrcGroupsIdx + 1, 1);
        break;
      }
    }

    ssrcGroupsIdx++;
  }

  return sdpLines.join('\r\n');
}

function commonjsRequire() {
  throw new Error('Dynamic requires are not currently supported by rollup-plugin-commonjs');
}

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x.default : x;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var adapter_no_edge_no_global = createCommonjsModule(function (module) {
  (function () {
    function r(e, n, t) {
      function o(i, f) {
        if (!n[i]) {
          if (!e[i]) {
            var c = "function" == typeof commonjsRequire && commonjsRequire;
            if (!f && c) return c(i, !0);
            if (u) return u(i, !0);
            var a = new Error("Cannot find module '" + i + "'");
            throw a.code = "MODULE_NOT_FOUND", a;
          }

          var p = n[i] = {
            exports: {}
          };
          e[i][0].call(p.exports, function (r) {
            var n = e[i][1][r];
            return o(n || r);
          }, p, p.exports, r, e, n, t);
        }

        return n[i].exports;
      }

      for (var u = "function" == typeof commonjsRequire && commonjsRequire, i = 0; i < t.length; i++) {
        o(t[i]);
      }

      return o;
    }

    return r;
  })()({
    1: [function (require, module, exports) {
      var _adapter_factory = require('./adapter_factory.js');

      var adapter = (0, _adapter_factory.adapterFactory)({
        window: typeof window === 'undefined' ? undefined : window
      });
      module.exports = adapter; // this is the difference from adapter_core.
    }, {
      "./adapter_factory.js": 2
    }],
    2: [function (require, module, exports) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.adapterFactory = adapterFactory;

      var _utils = require('./utils');

      var utils = _interopRequireWildcard(_utils);

      var _chrome_shim = require('./chrome/chrome_shim');

      var chromeShim = _interopRequireWildcard(_chrome_shim);

      var _edge_shim = require('./edge/edge_shim');

      var edgeShim = _interopRequireWildcard(_edge_shim);

      var _firefox_shim = require('./firefox/firefox_shim');

      var firefoxShim = _interopRequireWildcard(_firefox_shim);

      var _safari_shim = require('./safari/safari_shim');

      var safariShim = _interopRequireWildcard(_safari_shim);

      var _common_shim = require('./common_shim');

      var commonShim = _interopRequireWildcard(_common_shim);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj.default = obj;
          return newObj;
        }
      } // Shimming starts here.

      /*
       *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
       *
       *  Use of this source code is governed by a BSD-style license
       *  that can be found in the LICENSE file in the root of the source
       *  tree.
       */


      function adapterFactory() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            window = _ref.window;

        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
          shimChrome: true,
          shimFirefox: true,
          shimEdge: true,
          shimSafari: true
        }; // Utils.

        var logging = utils.log;
        var browserDetails = utils.detectBrowser(window);
        var adapter = {
          browserDetails: browserDetails,
          commonShim: commonShim,
          extractVersion: utils.extractVersion,
          disableLog: utils.disableLog,
          disableWarnings: utils.disableWarnings
        }; // Shim browser if found.

        switch (browserDetails.browser) {
          case 'chrome':
            if (!chromeShim || !chromeShim.shimPeerConnection || !options.shimChrome) {
              logging('Chrome shim is not included in this adapter release.');
              return adapter;
            }

            if (browserDetails.version === null) {
              logging('Chrome shim can not determine version, not shimming.');
              return adapter;
            }

            logging('adapter.js shimming chrome.'); // Export to the adapter global object visible in the browser.

            adapter.browserShim = chromeShim; // Must be called before shimPeerConnection.

            commonShim.shimAddIceCandidateNullOrEmpty(window, browserDetails);
            chromeShim.shimGetUserMedia(window, browserDetails);
            chromeShim.shimMediaStream(window, browserDetails);
            chromeShim.shimPeerConnection(window, browserDetails);
            chromeShim.shimOnTrack(window, browserDetails);
            chromeShim.shimAddTrackRemoveTrack(window, browserDetails);
            chromeShim.shimGetSendersWithDtmf(window, browserDetails);
            chromeShim.shimGetStats(window, browserDetails);
            chromeShim.shimSenderReceiverGetStats(window, browserDetails);
            chromeShim.fixNegotiationNeeded(window, browserDetails);
            commonShim.shimRTCIceCandidate(window, browserDetails);
            commonShim.shimConnectionState(window, browserDetails);
            commonShim.shimMaxMessageSize(window, browserDetails);
            commonShim.shimSendThrowTypeError(window, browserDetails);
            commonShim.removeExtmapAllowMixed(window, browserDetails);
            break;

          case 'firefox':
            if (!firefoxShim || !firefoxShim.shimPeerConnection || !options.shimFirefox) {
              logging('Firefox shim is not included in this adapter release.');
              return adapter;
            }

            logging('adapter.js shimming firefox.'); // Export to the adapter global object visible in the browser.

            adapter.browserShim = firefoxShim; // Must be called before shimPeerConnection.

            commonShim.shimAddIceCandidateNullOrEmpty(window, browserDetails);
            firefoxShim.shimGetUserMedia(window, browserDetails);
            firefoxShim.shimPeerConnection(window, browserDetails);
            firefoxShim.shimOnTrack(window, browserDetails);
            firefoxShim.shimRemoveStream(window, browserDetails);
            firefoxShim.shimSenderGetStats(window, browserDetails);
            firefoxShim.shimReceiverGetStats(window, browserDetails);
            firefoxShim.shimRTCDataChannel(window, browserDetails);
            firefoxShim.shimAddTransceiver(window, browserDetails);
            firefoxShim.shimGetParameters(window, browserDetails);
            firefoxShim.shimCreateOffer(window, browserDetails);
            firefoxShim.shimCreateAnswer(window, browserDetails);
            commonShim.shimRTCIceCandidate(window, browserDetails);
            commonShim.shimConnectionState(window, browserDetails);
            commonShim.shimMaxMessageSize(window, browserDetails);
            commonShim.shimSendThrowTypeError(window, browserDetails);
            break;

          case 'edge':
            if (!edgeShim || !edgeShim.shimPeerConnection || !options.shimEdge) {
              logging('MS edge shim is not included in this adapter release.');
              return adapter;
            }

            logging('adapter.js shimming edge.'); // Export to the adapter global object visible in the browser.

            adapter.browserShim = edgeShim;
            edgeShim.shimGetUserMedia(window, browserDetails);
            edgeShim.shimGetDisplayMedia(window, browserDetails);
            edgeShim.shimPeerConnection(window, browserDetails);
            edgeShim.shimReplaceTrack(window, browserDetails); // the edge shim implements the full RTCIceCandidate object.

            commonShim.shimMaxMessageSize(window, browserDetails);
            commonShim.shimSendThrowTypeError(window, browserDetails);
            break;

          case 'safari':
            if (!safariShim || !options.shimSafari) {
              logging('Safari shim is not included in this adapter release.');
              return adapter;
            }

            logging('adapter.js shimming safari.'); // Export to the adapter global object visible in the browser.

            adapter.browserShim = safariShim; // Must be called before shimCallbackAPI.

            commonShim.shimAddIceCandidateNullOrEmpty(window, browserDetails);
            safariShim.shimRTCIceServerUrls(window, browserDetails);
            safariShim.shimCreateOfferLegacy(window, browserDetails);
            safariShim.shimCallbacksAPI(window, browserDetails);
            safariShim.shimLocalStreamsAPI(window, browserDetails);
            safariShim.shimRemoteStreamsAPI(window, browserDetails);
            safariShim.shimTrackEventTransceiver(window, browserDetails);
            safariShim.shimGetUserMedia(window, browserDetails);
            safariShim.shimAudioContext(window, browserDetails);
            commonShim.shimRTCIceCandidate(window, browserDetails);
            commonShim.shimMaxMessageSize(window, browserDetails);
            commonShim.shimSendThrowTypeError(window, browserDetails);
            commonShim.removeExtmapAllowMixed(window, browserDetails);
            break;

          default:
            logging('Unsupported browser!');
            break;
        }

        return adapter;
      } // Browser shims.

    }, {
      "./chrome/chrome_shim": 3,
      "./common_shim": 6,
      "./edge/edge_shim": 12,
      "./firefox/firefox_shim": 7,
      "./safari/safari_shim": 10,
      "./utils": 11
    }],
    3: [function (require, module, exports) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.shimGetDisplayMedia = exports.shimGetUserMedia = undefined;

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };

      var _getusermedia = require('./getusermedia');

      Object.defineProperty(exports, 'shimGetUserMedia', {
        enumerable: true,
        get: function get() {
          return _getusermedia.shimGetUserMedia;
        }
      });

      var _getdisplaymedia = require('./getdisplaymedia');

      Object.defineProperty(exports, 'shimGetDisplayMedia', {
        enumerable: true,
        get: function get() {
          return _getdisplaymedia.shimGetDisplayMedia;
        }
      });
      exports.shimMediaStream = shimMediaStream;
      exports.shimOnTrack = shimOnTrack;
      exports.shimGetSendersWithDtmf = shimGetSendersWithDtmf;
      exports.shimGetStats = shimGetStats;
      exports.shimSenderReceiverGetStats = shimSenderReceiverGetStats;
      exports.shimAddTrackRemoveTrackWithNative = shimAddTrackRemoveTrackWithNative;
      exports.shimAddTrackRemoveTrack = shimAddTrackRemoveTrack;
      exports.shimPeerConnection = shimPeerConnection;
      exports.fixNegotiationNeeded = fixNegotiationNeeded;

      var _utils = require('../utils.js');

      var utils = _interopRequireWildcard(_utils);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj.default = obj;
          return newObj;
        }
      }

      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
        } else {
          obj[key] = value;
        }

        return obj;
      }

      function shimMediaStream(window) {
        window.MediaStream = window.MediaStream || window.webkitMediaStream;
      }

      function shimOnTrack(window) {
        if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.RTCPeerConnection && !('ontrack' in window.RTCPeerConnection.prototype)) {
          Object.defineProperty(window.RTCPeerConnection.prototype, 'ontrack', {
            get: function get() {
              return this._ontrack;
            },
            set: function set(f) {
              if (this._ontrack) {
                this.removeEventListener('track', this._ontrack);
              }

              this.addEventListener('track', this._ontrack = f);
            },
            enumerable: true,
            configurable: true
          });
          var origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;

          window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
            var _this = this;

            if (!this._ontrackpoly) {
              this._ontrackpoly = function (e) {
                // onaddstream does not fire when a track is added to an existing
                // stream. But stream.onaddtrack is implemented so we use that.
                e.stream.addEventListener('addtrack', function (te) {
                  var receiver = void 0;

                  if (window.RTCPeerConnection.prototype.getReceivers) {
                    receiver = _this.getReceivers().find(function (r) {
                      return r.track && r.track.id === te.track.id;
                    });
                  } else {
                    receiver = {
                      track: te.track
                    };
                  }

                  var event = new Event('track');
                  event.track = te.track;
                  event.receiver = receiver;
                  event.transceiver = {
                    receiver: receiver
                  };
                  event.streams = [e.stream];

                  _this.dispatchEvent(event);
                });
                e.stream.getTracks().forEach(function (track) {
                  var receiver = void 0;

                  if (window.RTCPeerConnection.prototype.getReceivers) {
                    receiver = _this.getReceivers().find(function (r) {
                      return r.track && r.track.id === track.id;
                    });
                  } else {
                    receiver = {
                      track: track
                    };
                  }

                  var event = new Event('track');
                  event.track = track;
                  event.receiver = receiver;
                  event.transceiver = {
                    receiver: receiver
                  };
                  event.streams = [e.stream];

                  _this.dispatchEvent(event);
                });
              };

              this.addEventListener('addstream', this._ontrackpoly);
            }

            return origSetRemoteDescription.apply(this, arguments);
          };
        } else {
          // even if RTCRtpTransceiver is in window, it is only used and
          // emitted in unified-plan. Unfortunately this means we need
          // to unconditionally wrap the event.
          utils.wrapPeerConnectionEvent(window, 'track', function (e) {
            if (!e.transceiver) {
              Object.defineProperty(e, 'transceiver', {
                value: {
                  receiver: e.receiver
                }
              });
            }

            return e;
          });
        }
      }

      function shimGetSendersWithDtmf(window) {
        // Overrides addTrack/removeTrack, depends on shimAddTrackRemoveTrack.
        if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.RTCPeerConnection && !('getSenders' in window.RTCPeerConnection.prototype) && 'createDTMFSender' in window.RTCPeerConnection.prototype) {
          var shimSenderWithDtmf = function shimSenderWithDtmf(pc, track) {
            return {
              track: track,

              get dtmf() {
                if (this._dtmf === undefined) {
                  if (track.kind === 'audio') {
                    this._dtmf = pc.createDTMFSender(track);
                  } else {
                    this._dtmf = null;
                  }
                }

                return this._dtmf;
              },

              _pc: pc
            };
          }; // augment addTrack when getSenders is not available.


          if (!window.RTCPeerConnection.prototype.getSenders) {
            window.RTCPeerConnection.prototype.getSenders = function getSenders() {
              this._senders = this._senders || [];
              return this._senders.slice(); // return a copy of the internal state.
            };

            var origAddTrack = window.RTCPeerConnection.prototype.addTrack;

            window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
              var sender = origAddTrack.apply(this, arguments);

              if (!sender) {
                sender = shimSenderWithDtmf(this, track);

                this._senders.push(sender);
              }

              return sender;
            };

            var origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;

            window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
              origRemoveTrack.apply(this, arguments);

              var idx = this._senders.indexOf(sender);

              if (idx !== -1) {
                this._senders.splice(idx, 1);
              }
            };
          }

          var origAddStream = window.RTCPeerConnection.prototype.addStream;

          window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
            var _this2 = this;

            this._senders = this._senders || [];
            origAddStream.apply(this, [stream]);
            stream.getTracks().forEach(function (track) {
              _this2._senders.push(shimSenderWithDtmf(_this2, track));
            });
          };

          var origRemoveStream = window.RTCPeerConnection.prototype.removeStream;

          window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
            var _this3 = this;

            this._senders = this._senders || [];
            origRemoveStream.apply(this, [stream]);
            stream.getTracks().forEach(function (track) {
              var sender = _this3._senders.find(function (s) {
                return s.track === track;
              });

              if (sender) {
                // remove sender
                _this3._senders.splice(_this3._senders.indexOf(sender), 1);
              }
            });
          };
        } else if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.RTCPeerConnection && 'getSenders' in window.RTCPeerConnection.prototype && 'createDTMFSender' in window.RTCPeerConnection.prototype && window.RTCRtpSender && !('dtmf' in window.RTCRtpSender.prototype)) {
          var origGetSenders = window.RTCPeerConnection.prototype.getSenders;

          window.RTCPeerConnection.prototype.getSenders = function getSenders() {
            var _this4 = this;

            var senders = origGetSenders.apply(this, []);
            senders.forEach(function (sender) {
              return sender._pc = _this4;
            });
            return senders;
          };

          Object.defineProperty(window.RTCRtpSender.prototype, 'dtmf', {
            get: function get() {
              if (this._dtmf === undefined) {
                if (this.track.kind === 'audio') {
                  this._dtmf = this._pc.createDTMFSender(this.track);
                } else {
                  this._dtmf = null;
                }
              }

              return this._dtmf;
            }
          });
        }
      }

      function shimGetStats(window) {
        if (!window.RTCPeerConnection) {
          return;
        }

        var origGetStats = window.RTCPeerConnection.prototype.getStats;

        window.RTCPeerConnection.prototype.getStats = function getStats() {
          var _this5 = this;

          var _arguments = Array.prototype.slice.call(arguments),
              selector = _arguments[0],
              onSucc = _arguments[1],
              onErr = _arguments[2]; // If selector is a function then we are in the old style stats so just
          // pass back the original getStats format to avoid breaking old users.


          if (arguments.length > 0 && typeof selector === 'function') {
            return origGetStats.apply(this, arguments);
          } // When spec-style getStats is supported, return those when called with
          // either no arguments or the selector argument is null.


          if (origGetStats.length === 0 && (arguments.length === 0 || typeof selector !== 'function')) {
            return origGetStats.apply(this, []);
          }

          var fixChromeStats_ = function fixChromeStats_(response) {
            var standardReport = {};
            var reports = response.result();
            reports.forEach(function (report) {
              var standardStats = {
                id: report.id,
                timestamp: report.timestamp,
                type: {
                  localcandidate: 'local-candidate',
                  remotecandidate: 'remote-candidate'
                }[report.type] || report.type
              };
              report.names().forEach(function (name) {
                standardStats[name] = report.stat(name);
              });
              standardReport[standardStats.id] = standardStats;
            });
            return standardReport;
          }; // shim getStats with maplike support


          var makeMapStats = function makeMapStats(stats) {
            return new Map(Object.keys(stats).map(function (key) {
              return [key, stats[key]];
            }));
          };

          if (arguments.length >= 2) {
            var successCallbackWrapper_ = function successCallbackWrapper_(response) {
              onSucc(makeMapStats(fixChromeStats_(response)));
            };

            return origGetStats.apply(this, [successCallbackWrapper_, selector]);
          } // promise-support


          return new Promise(function (resolve, reject) {
            origGetStats.apply(_this5, [function (response) {
              resolve(makeMapStats(fixChromeStats_(response)));
            }, reject]);
          }).then(onSucc, onErr);
        };
      }

      function shimSenderReceiverGetStats(window) {
        if (!((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.RTCPeerConnection && window.RTCRtpSender && window.RTCRtpReceiver)) {
          return;
        } // shim sender stats.


        if (!('getStats' in window.RTCRtpSender.prototype)) {
          var origGetSenders = window.RTCPeerConnection.prototype.getSenders;

          if (origGetSenders) {
            window.RTCPeerConnection.prototype.getSenders = function getSenders() {
              var _this6 = this;

              var senders = origGetSenders.apply(this, []);
              senders.forEach(function (sender) {
                return sender._pc = _this6;
              });
              return senders;
            };
          }

          var origAddTrack = window.RTCPeerConnection.prototype.addTrack;

          if (origAddTrack) {
            window.RTCPeerConnection.prototype.addTrack = function addTrack() {
              var sender = origAddTrack.apply(this, arguments);
              sender._pc = this;
              return sender;
            };
          }

          window.RTCRtpSender.prototype.getStats = function getStats() {
            var sender = this;
            return this._pc.getStats().then(function (result) {
              return (
                /* Note: this will include stats of all senders that
                 *   send a track with the same id as sender.track as
                 *   it is not possible to identify the RTCRtpSender.
                 */
                utils.filterStats(result, sender.track, true)
              );
            });
          };
        } // shim receiver stats.


        if (!('getStats' in window.RTCRtpReceiver.prototype)) {
          var origGetReceivers = window.RTCPeerConnection.prototype.getReceivers;

          if (origGetReceivers) {
            window.RTCPeerConnection.prototype.getReceivers = function getReceivers() {
              var _this7 = this;

              var receivers = origGetReceivers.apply(this, []);
              receivers.forEach(function (receiver) {
                return receiver._pc = _this7;
              });
              return receivers;
            };
          }

          utils.wrapPeerConnectionEvent(window, 'track', function (e) {
            e.receiver._pc = e.srcElement;
            return e;
          });

          window.RTCRtpReceiver.prototype.getStats = function getStats() {
            var receiver = this;
            return this._pc.getStats().then(function (result) {
              return utils.filterStats(result, receiver.track, false);
            });
          };
        }

        if (!('getStats' in window.RTCRtpSender.prototype && 'getStats' in window.RTCRtpReceiver.prototype)) {
          return;
        } // shim RTCPeerConnection.getStats(track).


        var origGetStats = window.RTCPeerConnection.prototype.getStats;

        window.RTCPeerConnection.prototype.getStats = function getStats() {
          if (arguments.length > 0 && arguments[0] instanceof window.MediaStreamTrack) {
            var track = arguments[0];
            var sender = void 0;
            var receiver = void 0;
            var err = void 0;
            this.getSenders().forEach(function (s) {
              if (s.track === track) {
                if (sender) {
                  err = true;
                } else {
                  sender = s;
                }
              }
            });
            this.getReceivers().forEach(function (r) {
              if (r.track === track) {
                if (receiver) {
                  err = true;
                } else {
                  receiver = r;
                }
              }

              return r.track === track;
            });

            if (err || sender && receiver) {
              return Promise.reject(new DOMException('There are more than one sender or receiver for the track.', 'InvalidAccessError'));
            } else if (sender) {
              return sender.getStats();
            } else if (receiver) {
              return receiver.getStats();
            }

            return Promise.reject(new DOMException('There is no sender or receiver for the track.', 'InvalidAccessError'));
          }

          return origGetStats.apply(this, arguments);
        };
      }

      function shimAddTrackRemoveTrackWithNative(window) {
        // shim addTrack/removeTrack with native variants in order to make
        // the interactions with legacy getLocalStreams behave as in other browsers.
        // Keeps a mapping stream.id => [stream, rtpsenders...]
        window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
          var _this8 = this;

          this._shimmedLocalStreams = this._shimmedLocalStreams || {};
          return Object.keys(this._shimmedLocalStreams).map(function (streamId) {
            return _this8._shimmedLocalStreams[streamId][0];
          });
        };

        var origAddTrack = window.RTCPeerConnection.prototype.addTrack;

        window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
          if (!stream) {
            return origAddTrack.apply(this, arguments);
          }

          this._shimmedLocalStreams = this._shimmedLocalStreams || {};
          var sender = origAddTrack.apply(this, arguments);

          if (!this._shimmedLocalStreams[stream.id]) {
            this._shimmedLocalStreams[stream.id] = [stream, sender];
          } else if (this._shimmedLocalStreams[stream.id].indexOf(sender) === -1) {
            this._shimmedLocalStreams[stream.id].push(sender);
          }

          return sender;
        };

        var origAddStream = window.RTCPeerConnection.prototype.addStream;

        window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
          var _this9 = this;

          this._shimmedLocalStreams = this._shimmedLocalStreams || {};
          stream.getTracks().forEach(function (track) {
            var alreadyExists = _this9.getSenders().find(function (s) {
              return s.track === track;
            });

            if (alreadyExists) {
              throw new DOMException('Track already exists.', 'InvalidAccessError');
            }
          });
          var existingSenders = this.getSenders();
          origAddStream.apply(this, arguments);
          var newSenders = this.getSenders().filter(function (newSender) {
            return existingSenders.indexOf(newSender) === -1;
          });
          this._shimmedLocalStreams[stream.id] = [stream].concat(newSenders);
        };

        var origRemoveStream = window.RTCPeerConnection.prototype.removeStream;

        window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
          this._shimmedLocalStreams = this._shimmedLocalStreams || {};
          delete this._shimmedLocalStreams[stream.id];
          return origRemoveStream.apply(this, arguments);
        };

        var origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;

        window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
          var _this10 = this;

          this._shimmedLocalStreams = this._shimmedLocalStreams || {};

          if (sender) {
            Object.keys(this._shimmedLocalStreams).forEach(function (streamId) {
              var idx = _this10._shimmedLocalStreams[streamId].indexOf(sender);

              if (idx !== -1) {
                _this10._shimmedLocalStreams[streamId].splice(idx, 1);
              }

              if (_this10._shimmedLocalStreams[streamId].length === 1) {
                delete _this10._shimmedLocalStreams[streamId];
              }
            });
          }

          return origRemoveTrack.apply(this, arguments);
        };
      }

      function shimAddTrackRemoveTrack(window, browserDetails) {
        if (!window.RTCPeerConnection) {
          return;
        } // shim addTrack and removeTrack.


        if (window.RTCPeerConnection.prototype.addTrack && browserDetails.version >= 65) {
          return shimAddTrackRemoveTrackWithNative(window);
        } // also shim pc.getLocalStreams when addTrack is shimmed
        // to return the original streams.


        var origGetLocalStreams = window.RTCPeerConnection.prototype.getLocalStreams;

        window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
          var _this11 = this;

          var nativeStreams = origGetLocalStreams.apply(this);
          this._reverseStreams = this._reverseStreams || {};
          return nativeStreams.map(function (stream) {
            return _this11._reverseStreams[stream.id];
          });
        };

        var origAddStream = window.RTCPeerConnection.prototype.addStream;

        window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
          var _this12 = this;

          this._streams = this._streams || {};
          this._reverseStreams = this._reverseStreams || {};
          stream.getTracks().forEach(function (track) {
            var alreadyExists = _this12.getSenders().find(function (s) {
              return s.track === track;
            });

            if (alreadyExists) {
              throw new DOMException('Track already exists.', 'InvalidAccessError');
            }
          }); // Add identity mapping for consistency with addTrack.
          // Unless this is being used with a stream from addTrack.

          if (!this._reverseStreams[stream.id]) {
            var newStream = new window.MediaStream(stream.getTracks());
            this._streams[stream.id] = newStream;
            this._reverseStreams[newStream.id] = stream;
            stream = newStream;
          }

          origAddStream.apply(this, [stream]);
        };

        var origRemoveStream = window.RTCPeerConnection.prototype.removeStream;

        window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
          this._streams = this._streams || {};
          this._reverseStreams = this._reverseStreams || {};
          origRemoveStream.apply(this, [this._streams[stream.id] || stream]);
          delete this._reverseStreams[this._streams[stream.id] ? this._streams[stream.id].id : stream.id];
          delete this._streams[stream.id];
        };

        window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
          var _this13 = this;

          if (this.signalingState === 'closed') {
            throw new DOMException('The RTCPeerConnection\'s signalingState is \'closed\'.', 'InvalidStateError');
          }

          var streams = [].slice.call(arguments, 1);

          if (streams.length !== 1 || !streams[0].getTracks().find(function (t) {
            return t === track;
          })) {
            // this is not fully correct but all we can manage without
            // [[associated MediaStreams]] internal slot.
            throw new DOMException('The adapter.js addTrack polyfill only supports a single ' + ' stream which is associated with the specified track.', 'NotSupportedError');
          }

          var alreadyExists = this.getSenders().find(function (s) {
            return s.track === track;
          });

          if (alreadyExists) {
            throw new DOMException('Track already exists.', 'InvalidAccessError');
          }

          this._streams = this._streams || {};
          this._reverseStreams = this._reverseStreams || {};
          var oldStream = this._streams[stream.id];

          if (oldStream) {
            // this is using odd Chrome behaviour, use with caution:
            // https://bugs.chromium.org/p/webrtc/issues/detail?id=7815
            // Note: we rely on the high-level addTrack/dtmf shim to
            // create the sender with a dtmf sender.
            oldStream.addTrack(track); // Trigger ONN async.

            Promise.resolve().then(function () {
              _this13.dispatchEvent(new Event('negotiationneeded'));
            });
          } else {
            var newStream = new window.MediaStream([track]);
            this._streams[stream.id] = newStream;
            this._reverseStreams[newStream.id] = stream;
            this.addStream(newStream);
          }

          return this.getSenders().find(function (s) {
            return s.track === track;
          });
        }; // replace the internal stream id with the external one and
        // vice versa.


        function replaceInternalStreamId(pc, description) {
          var sdp = description.sdp;
          Object.keys(pc._reverseStreams || []).forEach(function (internalId) {
            var externalStream = pc._reverseStreams[internalId];
            var internalStream = pc._streams[externalStream.id];
            sdp = sdp.replace(new RegExp(internalStream.id, 'g'), externalStream.id);
          });
          return new RTCSessionDescription({
            type: description.type,
            sdp: sdp
          });
        }

        function replaceExternalStreamId(pc, description) {
          var sdp = description.sdp;
          Object.keys(pc._reverseStreams || []).forEach(function (internalId) {
            var externalStream = pc._reverseStreams[internalId];
            var internalStream = pc._streams[externalStream.id];
            sdp = sdp.replace(new RegExp(externalStream.id, 'g'), internalStream.id);
          });
          return new RTCSessionDescription({
            type: description.type,
            sdp: sdp
          });
        }

        ['createOffer', 'createAnswer'].forEach(function (method) {
          var nativeMethod = window.RTCPeerConnection.prototype[method];

          var methodObj = _defineProperty({}, method, function () {
            var _this14 = this;

            var args = arguments;
            var isLegacyCall = arguments.length && typeof arguments[0] === 'function';

            if (isLegacyCall) {
              return nativeMethod.apply(this, [function (description) {
                var desc = replaceInternalStreamId(_this14, description);
                args[0].apply(null, [desc]);
              }, function (err) {
                if (args[1]) {
                  args[1].apply(null, err);
                }
              }, arguments[2]]);
            }

            return nativeMethod.apply(this, arguments).then(function (description) {
              return replaceInternalStreamId(_this14, description);
            });
          });

          window.RTCPeerConnection.prototype[method] = methodObj[method];
        });
        var origSetLocalDescription = window.RTCPeerConnection.prototype.setLocalDescription;

        window.RTCPeerConnection.prototype.setLocalDescription = function setLocalDescription() {
          if (!arguments.length || !arguments[0].type) {
            return origSetLocalDescription.apply(this, arguments);
          }

          arguments[0] = replaceExternalStreamId(this, arguments[0]);
          return origSetLocalDescription.apply(this, arguments);
        }; // TODO: mangle getStats: https://w3c.github.io/webrtc-stats/#dom-rtcmediastreamstats-streamidentifier


        var origLocalDescription = Object.getOwnPropertyDescriptor(window.RTCPeerConnection.prototype, 'localDescription');
        Object.defineProperty(window.RTCPeerConnection.prototype, 'localDescription', {
          get: function get() {
            var description = origLocalDescription.get.apply(this);

            if (description.type === '') {
              return description;
            }

            return replaceInternalStreamId(this, description);
          }
        });

        window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
          var _this15 = this;

          if (this.signalingState === 'closed') {
            throw new DOMException('The RTCPeerConnection\'s signalingState is \'closed\'.', 'InvalidStateError');
          } // We can not yet check for sender instanceof RTCRtpSender
          // since we shim RTPSender. So we check if sender._pc is set.


          if (!sender._pc) {
            throw new DOMException('Argument 1 of RTCPeerConnection.removeTrack ' + 'does not implement interface RTCRtpSender.', 'TypeError');
          }

          var isLocal = sender._pc === this;

          if (!isLocal) {
            throw new DOMException('Sender was not created by this connection.', 'InvalidAccessError');
          } // Search for the native stream the senders track belongs to.


          this._streams = this._streams || {};
          var stream = void 0;
          Object.keys(this._streams).forEach(function (streamid) {
            var hasTrack = _this15._streams[streamid].getTracks().find(function (track) {
              return sender.track === track;
            });

            if (hasTrack) {
              stream = _this15._streams[streamid];
            }
          });

          if (stream) {
            if (stream.getTracks().length === 1) {
              // if this is the last track of the stream, remove the stream. This
              // takes care of any shimmed _senders.
              this.removeStream(this._reverseStreams[stream.id]);
            } else {
              // relying on the same odd chrome behaviour as above.
              stream.removeTrack(sender.track);
            }

            this.dispatchEvent(new Event('negotiationneeded'));
          }
        };
      }

      function shimPeerConnection(window, browserDetails) {
        if (!window.RTCPeerConnection && window.webkitRTCPeerConnection) {
          // very basic support for old versions.
          window.RTCPeerConnection = window.webkitRTCPeerConnection;
        }

        if (!window.RTCPeerConnection) {
          return;
        } // shim implicit creation of RTCSessionDescription/RTCIceCandidate


        if (browserDetails.version < 53) {
          ['setLocalDescription', 'setRemoteDescription', 'addIceCandidate'].forEach(function (method) {
            var nativeMethod = window.RTCPeerConnection.prototype[method];

            var methodObj = _defineProperty({}, method, function () {
              arguments[0] = new (method === 'addIceCandidate' ? window.RTCIceCandidate : window.RTCSessionDescription)(arguments[0]);
              return nativeMethod.apply(this, arguments);
            });

            window.RTCPeerConnection.prototype[method] = methodObj[method];
          });
        }
      } // Attempt to fix ONN in plan-b mode.


      function fixNegotiationNeeded(window, browserDetails) {
        utils.wrapPeerConnectionEvent(window, 'negotiationneeded', function (e) {
          var pc = e.target;

          if (browserDetails.version < 72 || pc.getConfiguration && pc.getConfiguration().sdpSemantics === 'plan-b') {
            if (pc.signalingState !== 'stable') {
              return;
            }
          }

          return e;
        });
      }
    }, {
      "../utils.js": 11,
      "./getdisplaymedia": 4,
      "./getusermedia": 5
    }],
    4: [function (require, module, exports) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.shimGetDisplayMedia = shimGetDisplayMedia;

      function shimGetDisplayMedia(window, getSourceId) {
        if (window.navigator.mediaDevices && 'getDisplayMedia' in window.navigator.mediaDevices) {
          return;
        }

        if (!window.navigator.mediaDevices) {
          return;
        } // getSourceId is a function that returns a promise resolving with
        // the sourceId of the screen/window/tab to be shared.


        if (typeof getSourceId !== 'function') {
          console.error('shimGetDisplayMedia: getSourceId argument is not ' + 'a function');
          return;
        }

        window.navigator.mediaDevices.getDisplayMedia = function getDisplayMedia(constraints) {
          return getSourceId(constraints).then(function (sourceId) {
            var widthSpecified = constraints.video && constraints.video.width;
            var heightSpecified = constraints.video && constraints.video.height;
            var frameRateSpecified = constraints.video && constraints.video.frameRate;
            constraints.video = {
              mandatory: {
                chromeMediaSource: 'desktop',
                chromeMediaSourceId: sourceId,
                maxFrameRate: frameRateSpecified || 3
              }
            };

            if (widthSpecified) {
              constraints.video.mandatory.maxWidth = widthSpecified;
            }

            if (heightSpecified) {
              constraints.video.mandatory.maxHeight = heightSpecified;
            }

            return window.navigator.mediaDevices.getUserMedia(constraints);
          });
        };
      }
    }, {}],
    5: [function (require, module, exports) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };

      exports.shimGetUserMedia = shimGetUserMedia;

      var _utils = require('../utils.js');

      var utils = _interopRequireWildcard(_utils);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj.default = obj;
          return newObj;
        }
      }

      var logging = utils.log;

      function shimGetUserMedia(window, browserDetails) {
        var navigator = window && window.navigator;

        if (!navigator.mediaDevices) {
          return;
        }

        var constraintsToChrome_ = function constraintsToChrome_(c) {
          if ((typeof c === 'undefined' ? 'undefined' : _typeof(c)) !== 'object' || c.mandatory || c.optional) {
            return c;
          }

          var cc = {};
          Object.keys(c).forEach(function (key) {
            if (key === 'require' || key === 'advanced' || key === 'mediaSource') {
              return;
            }

            var r = _typeof(c[key]) === 'object' ? c[key] : {
              ideal: c[key]
            };

            if (r.exact !== undefined && typeof r.exact === 'number') {
              r.min = r.max = r.exact;
            }

            var oldname_ = function oldname_(prefix, name) {
              if (prefix) {
                return prefix + name.charAt(0).toUpperCase() + name.slice(1);
              }

              return name === 'deviceId' ? 'sourceId' : name;
            };

            if (r.ideal !== undefined) {
              cc.optional = cc.optional || [];
              var oc = {};

              if (typeof r.ideal === 'number') {
                oc[oldname_('min', key)] = r.ideal;
                cc.optional.push(oc);
                oc = {};
                oc[oldname_('max', key)] = r.ideal;
                cc.optional.push(oc);
              } else {
                oc[oldname_('', key)] = r.ideal;
                cc.optional.push(oc);
              }
            }

            if (r.exact !== undefined && typeof r.exact !== 'number') {
              cc.mandatory = cc.mandatory || {};
              cc.mandatory[oldname_('', key)] = r.exact;
            } else {
              ['min', 'max'].forEach(function (mix) {
                if (r[mix] !== undefined) {
                  cc.mandatory = cc.mandatory || {};
                  cc.mandatory[oldname_(mix, key)] = r[mix];
                }
              });
            }
          });

          if (c.advanced) {
            cc.optional = (cc.optional || []).concat(c.advanced);
          }

          return cc;
        };

        var shimConstraints_ = function shimConstraints_(constraints, func) {
          if (browserDetails.version >= 61) {
            return func(constraints);
          }

          constraints = JSON.parse(JSON.stringify(constraints));

          if (constraints && _typeof(constraints.audio) === 'object') {
            var remap = function remap(obj, a, b) {
              if (a in obj && !(b in obj)) {
                obj[b] = obj[a];
                delete obj[a];
              }
            };

            constraints = JSON.parse(JSON.stringify(constraints));
            remap(constraints.audio, 'autoGainControl', 'googAutoGainControl');
            remap(constraints.audio, 'noiseSuppression', 'googNoiseSuppression');
            constraints.audio = constraintsToChrome_(constraints.audio);
          }

          if (constraints && _typeof(constraints.video) === 'object') {
            // Shim facingMode for mobile & surface pro.
            var face = constraints.video.facingMode;
            face = face && ((typeof face === 'undefined' ? 'undefined' : _typeof(face)) === 'object' ? face : {
              ideal: face
            });
            var getSupportedFacingModeLies = browserDetails.version < 66;

            if (face && (face.exact === 'user' || face.exact === 'environment' || face.ideal === 'user' || face.ideal === 'environment') && !(navigator.mediaDevices.getSupportedConstraints && navigator.mediaDevices.getSupportedConstraints().facingMode && !getSupportedFacingModeLies)) {
              delete constraints.video.facingMode;
              var matches = void 0;

              if (face.exact === 'environment' || face.ideal === 'environment') {
                matches = ['back', 'rear'];
              } else if (face.exact === 'user' || face.ideal === 'user') {
                matches = ['front'];
              }

              if (matches) {
                // Look for matches in label, or use last cam for back (typical).
                return navigator.mediaDevices.enumerateDevices().then(function (devices) {
                  devices = devices.filter(function (d) {
                    return d.kind === 'videoinput';
                  });
                  var dev = devices.find(function (d) {
                    return matches.some(function (match) {
                      return d.label.toLowerCase().includes(match);
                    });
                  });

                  if (!dev && devices.length && matches.includes('back')) {
                    dev = devices[devices.length - 1]; // more likely the back cam
                  }

                  if (dev) {
                    constraints.video.deviceId = face.exact ? {
                      exact: dev.deviceId
                    } : {
                      ideal: dev.deviceId
                    };
                  }

                  constraints.video = constraintsToChrome_(constraints.video);
                  logging('chrome: ' + JSON.stringify(constraints));
                  return func(constraints);
                });
              }
            }

            constraints.video = constraintsToChrome_(constraints.video);
          }

          logging('chrome: ' + JSON.stringify(constraints));
          return func(constraints);
        };

        var shimError_ = function shimError_(e) {
          if (browserDetails.version >= 64) {
            return e;
          }

          return {
            name: {
              PermissionDeniedError: 'NotAllowedError',
              PermissionDismissedError: 'NotAllowedError',
              InvalidStateError: 'NotAllowedError',
              DevicesNotFoundError: 'NotFoundError',
              ConstraintNotSatisfiedError: 'OverconstrainedError',
              TrackStartError: 'NotReadableError',
              MediaDeviceFailedDueToShutdown: 'NotAllowedError',
              MediaDeviceKillSwitchOn: 'NotAllowedError',
              TabCaptureError: 'AbortError',
              ScreenCaptureError: 'AbortError',
              DeviceCaptureError: 'AbortError'
            }[e.name] || e.name,
            message: e.message,
            constraint: e.constraint || e.constraintName,
            toString: function toString() {
              return this.name + (this.message && ': ') + this.message;
            }
          };
        };

        var getUserMedia_ = function getUserMedia_(constraints, onSuccess, onError) {
          shimConstraints_(constraints, function (c) {
            navigator.webkitGetUserMedia(c, onSuccess, function (e) {
              if (onError) {
                onError(shimError_(e));
              }
            });
          });
        };

        navigator.getUserMedia = getUserMedia_.bind(navigator); // Even though Chrome 45 has navigator.mediaDevices and a getUserMedia
        // function which returns a Promise, it does not accept spec-style
        // constraints.

        if (navigator.mediaDevices.getUserMedia) {
          var origGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);

          navigator.mediaDevices.getUserMedia = function (cs) {
            return shimConstraints_(cs, function (c) {
              return origGetUserMedia(c).then(function (stream) {
                if (c.audio && !stream.getAudioTracks().length || c.video && !stream.getVideoTracks().length) {
                  stream.getTracks().forEach(function (track) {
                    track.stop();
                  });
                  throw new DOMException('', 'NotFoundError');
                }

                return stream;
              }, function (e) {
                return Promise.reject(shimError_(e));
              });
            });
          };
        }
      }
    }, {
      "../utils.js": 11
    }],
    6: [function (require, module, exports) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };

      exports.shimRTCIceCandidate = shimRTCIceCandidate;
      exports.shimMaxMessageSize = shimMaxMessageSize;
      exports.shimSendThrowTypeError = shimSendThrowTypeError;
      exports.shimConnectionState = shimConnectionState;
      exports.removeExtmapAllowMixed = removeExtmapAllowMixed;
      exports.shimAddIceCandidateNullOrEmpty = shimAddIceCandidateNullOrEmpty;

      var _sdp = require('sdp');

      var _sdp2 = _interopRequireDefault(_sdp);

      var _utils = require('./utils');

      var utils = _interopRequireWildcard(_utils);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj.default = obj;
          return newObj;
        }
      }

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function shimRTCIceCandidate(window) {
        // foundation is arbitrarily chosen as an indicator for full support for
        // https://w3c.github.io/webrtc-pc/#rtcicecandidate-interface
        if (!window.RTCIceCandidate || window.RTCIceCandidate && 'foundation' in window.RTCIceCandidate.prototype) {
          return;
        }

        var NativeRTCIceCandidate = window.RTCIceCandidate;

        window.RTCIceCandidate = function RTCIceCandidate(args) {
          // Remove the a= which shouldn't be part of the candidate string.
          if ((typeof args === 'undefined' ? 'undefined' : _typeof(args)) === 'object' && args.candidate && args.candidate.indexOf('a=') === 0) {
            args = JSON.parse(JSON.stringify(args));
            args.candidate = args.candidate.substr(2);
          }

          if (args.candidate && args.candidate.length) {
            // Augment the native candidate with the parsed fields.
            var nativeCandidate = new NativeRTCIceCandidate(args);

            var parsedCandidate = _sdp2.default.parseCandidate(args.candidate);

            var augmentedCandidate = Object.assign(nativeCandidate, parsedCandidate); // Add a serializer that does not serialize the extra attributes.

            augmentedCandidate.toJSON = function toJSON() {
              return {
                candidate: augmentedCandidate.candidate,
                sdpMid: augmentedCandidate.sdpMid,
                sdpMLineIndex: augmentedCandidate.sdpMLineIndex,
                usernameFragment: augmentedCandidate.usernameFragment
              };
            };

            return augmentedCandidate;
          }

          return new NativeRTCIceCandidate(args);
        };

        window.RTCIceCandidate.prototype = NativeRTCIceCandidate.prototype; // Hook up the augmented candidate in onicecandidate and
        // addEventListener('icecandidate', ...)

        utils.wrapPeerConnectionEvent(window, 'icecandidate', function (e) {
          if (e.candidate) {
            Object.defineProperty(e, 'candidate', {
              value: new window.RTCIceCandidate(e.candidate),
              writable: 'false'
            });
          }

          return e;
        });
      }

      function shimMaxMessageSize(window, browserDetails) {
        if (!window.RTCPeerConnection) {
          return;
        }

        if (!('sctp' in window.RTCPeerConnection.prototype)) {
          Object.defineProperty(window.RTCPeerConnection.prototype, 'sctp', {
            get: function get() {
              return typeof this._sctp === 'undefined' ? null : this._sctp;
            }
          });
        }

        var sctpInDescription = function sctpInDescription(description) {
          if (!description || !description.sdp) {
            return false;
          }

          var sections = _sdp2.default.splitSections(description.sdp);

          sections.shift();
          return sections.some(function (mediaSection) {
            var mLine = _sdp2.default.parseMLine(mediaSection);

            return mLine && mLine.kind === 'application' && mLine.protocol.indexOf('SCTP') !== -1;
          });
        };

        var getRemoteFirefoxVersion = function getRemoteFirefoxVersion(description) {
          // TODO: Is there a better solution for detecting Firefox?
          var match = description.sdp.match(/mozilla...THIS_IS_SDPARTA-(\d+)/);

          if (match === null || match.length < 2) {
            return -1;
          }

          var version = parseInt(match[1], 10); // Test for NaN (yes, this is ugly)

          return version !== version ? -1 : version;
        };

        var getCanSendMaxMessageSize = function getCanSendMaxMessageSize(remoteIsFirefox) {
          // Every implementation we know can send at least 64 KiB.
          // Note: Although Chrome is technically able to send up to 256 KiB, the
          //       data does not reach the other peer reliably.
          //       See: https://bugs.chromium.org/p/webrtc/issues/detail?id=8419
          var canSendMaxMessageSize = 65536;

          if (browserDetails.browser === 'firefox') {
            if (browserDetails.version < 57) {
              if (remoteIsFirefox === -1) {
                // FF < 57 will send in 16 KiB chunks using the deprecated PPID
                // fragmentation.
                canSendMaxMessageSize = 16384;
              } else {
                // However, other FF (and RAWRTC) can reassemble PPID-fragmented
                // messages. Thus, supporting ~2 GiB when sending.
                canSendMaxMessageSize = 2147483637;
              }
            } else if (browserDetails.version < 60) {
              // Currently, all FF >= 57 will reset the remote maximum message size
              // to the default value when a data channel is created at a later
              // stage. :(
              // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831
              canSendMaxMessageSize = browserDetails.version === 57 ? 65535 : 65536;
            } else {
              // FF >= 60 supports sending ~2 GiB
              canSendMaxMessageSize = 2147483637;
            }
          }

          return canSendMaxMessageSize;
        };

        var getMaxMessageSize = function getMaxMessageSize(description, remoteIsFirefox) {
          // Note: 65536 bytes is the default value from the SDP spec. Also,
          //       every implementation we know supports receiving 65536 bytes.
          var maxMessageSize = 65536; // FF 57 has a slightly incorrect default remote max message size, so
          // we need to adjust it here to avoid a failure when sending.
          // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1425697

          if (browserDetails.browser === 'firefox' && browserDetails.version === 57) {
            maxMessageSize = 65535;
          }

          var match = _sdp2.default.matchPrefix(description.sdp, 'a=max-message-size:');

          if (match.length > 0) {
            maxMessageSize = parseInt(match[0].substr(19), 10);
          } else if (browserDetails.browser === 'firefox' && remoteIsFirefox !== -1) {
            // If the maximum message size is not present in the remote SDP and
            // both local and remote are Firefox, the remote peer can receive
            // ~2 GiB.
            maxMessageSize = 2147483637;
          }

          return maxMessageSize;
        };

        var origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;

        window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
          this._sctp = null; // Chrome decided to not expose .sctp in plan-b mode.
          // As usual, adapter.js has to do an 'ugly worakaround'
          // to cover up the mess.

          if (browserDetails.browser === 'chrome' && browserDetails.version >= 76) {
            var _getConfiguration = this.getConfiguration(),
                sdpSemantics = _getConfiguration.sdpSemantics;

            if (sdpSemantics === 'plan-b') {
              Object.defineProperty(this, 'sctp', {
                get: function get() {
                  return typeof this._sctp === 'undefined' ? null : this._sctp;
                },
                enumerable: true,
                configurable: true
              });
            }
          }

          if (sctpInDescription(arguments[0])) {
            // Check if the remote is FF.
            var isFirefox = getRemoteFirefoxVersion(arguments[0]); // Get the maximum message size the local peer is capable of sending

            var canSendMMS = getCanSendMaxMessageSize(isFirefox); // Get the maximum message size of the remote peer.

            var remoteMMS = getMaxMessageSize(arguments[0], isFirefox); // Determine final maximum message size

            var maxMessageSize = void 0;

            if (canSendMMS === 0 && remoteMMS === 0) {
              maxMessageSize = Number.POSITIVE_INFINITY;
            } else if (canSendMMS === 0 || remoteMMS === 0) {
              maxMessageSize = Math.max(canSendMMS, remoteMMS);
            } else {
              maxMessageSize = Math.min(canSendMMS, remoteMMS);
            } // Create a dummy RTCSctpTransport object and the 'maxMessageSize'
            // attribute.


            var sctp = {};
            Object.defineProperty(sctp, 'maxMessageSize', {
              get: function get() {
                return maxMessageSize;
              }
            });
            this._sctp = sctp;
          }

          return origSetRemoteDescription.apply(this, arguments);
        };
      }

      function shimSendThrowTypeError(window) {
        if (!(window.RTCPeerConnection && 'createDataChannel' in window.RTCPeerConnection.prototype)) {
          return;
        } // Note: Although Firefox >= 57 has a native implementation, the maximum
        //       message size can be reset for all data channels at a later stage.
        //       See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831


        function wrapDcSend(dc, pc) {
          var origDataChannelSend = dc.send;

          dc.send = function send() {
            var data = arguments[0];
            var length = data.length || data.size || data.byteLength;

            if (dc.readyState === 'open' && pc.sctp && length > pc.sctp.maxMessageSize) {
              throw new TypeError('Message too large (can send a maximum of ' + pc.sctp.maxMessageSize + ' bytes)');
            }

            return origDataChannelSend.apply(dc, arguments);
          };
        }

        var origCreateDataChannel = window.RTCPeerConnection.prototype.createDataChannel;

        window.RTCPeerConnection.prototype.createDataChannel = function createDataChannel() {
          var dataChannel = origCreateDataChannel.apply(this, arguments);
          wrapDcSend(dataChannel, this);
          return dataChannel;
        };

        utils.wrapPeerConnectionEvent(window, 'datachannel', function (e) {
          wrapDcSend(e.channel, e.target);
          return e;
        });
      }
      /* shims RTCConnectionState by pretending it is the same as iceConnectionState.
       * See https://bugs.chromium.org/p/webrtc/issues/detail?id=6145#c12
       * for why this is a valid hack in Chrome. In Firefox it is slightly incorrect
       * since DTLS failures would be hidden. See
       * https://bugzilla.mozilla.org/show_bug.cgi?id=1265827
       * for the Firefox tracking bug.
       */


      function shimConnectionState(window) {
        if (!window.RTCPeerConnection || 'connectionState' in window.RTCPeerConnection.prototype) {
          return;
        }

        var proto = window.RTCPeerConnection.prototype;
        Object.defineProperty(proto, 'connectionState', {
          get: function get() {
            return {
              completed: 'connected',
              checking: 'connecting'
            }[this.iceConnectionState] || this.iceConnectionState;
          },
          enumerable: true,
          configurable: true
        });
        Object.defineProperty(proto, 'onconnectionstatechange', {
          get: function get() {
            return this._onconnectionstatechange || null;
          },
          set: function set(cb) {
            if (this._onconnectionstatechange) {
              this.removeEventListener('connectionstatechange', this._onconnectionstatechange);
              delete this._onconnectionstatechange;
            }

            if (cb) {
              this.addEventListener('connectionstatechange', this._onconnectionstatechange = cb);
            }
          },
          enumerable: true,
          configurable: true
        });
        ['setLocalDescription', 'setRemoteDescription'].forEach(function (method) {
          var origMethod = proto[method];

          proto[method] = function () {
            if (!this._connectionstatechangepoly) {
              this._connectionstatechangepoly = function (e) {
                var pc = e.target;

                if (pc._lastConnectionState !== pc.connectionState) {
                  pc._lastConnectionState = pc.connectionState;
                  var newEvent = new Event('connectionstatechange', e);
                  pc.dispatchEvent(newEvent);
                }

                return e;
              };

              this.addEventListener('iceconnectionstatechange', this._connectionstatechangepoly);
            }

            return origMethod.apply(this, arguments);
          };
        });
      }

      function removeExtmapAllowMixed(window, browserDetails) {
        /* remove a=extmap-allow-mixed for webrtc.org < M71 */
        if (!window.RTCPeerConnection) {
          return;
        }

        if (browserDetails.browser === 'chrome' && browserDetails.version >= 71) {
          return;
        }

        if (browserDetails.browser === 'safari' && browserDetails.version >= 605) {
          return;
        }

        var nativeSRD = window.RTCPeerConnection.prototype.setRemoteDescription;

        window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription(desc) {
          if (desc && desc.sdp && desc.sdp.indexOf('\na=extmap-allow-mixed') !== -1) {
            var sdp = desc.sdp.split('\n').filter(function (line) {
              return line.trim() !== 'a=extmap-allow-mixed';
            }).join('\n'); // Safari enforces read-only-ness of RTCSessionDescription fields.

            if (window.RTCSessionDescription && desc instanceof window.RTCSessionDescription) {
              arguments[0] = new window.RTCSessionDescription({
                type: desc.type,
                sdp: sdp
              });
            } else {
              desc.sdp = sdp;
            }
          }

          return nativeSRD.apply(this, arguments);
        };
      }

      function shimAddIceCandidateNullOrEmpty(window, browserDetails) {
        // Support for addIceCandidate(null or undefined)
        // as well as addIceCandidate({candidate: "", ...})
        // https://bugs.chromium.org/p/chromium/issues/detail?id=978582
        // Note: must be called before other polyfills which change the signature.
        if (!(window.RTCPeerConnection && window.RTCPeerConnection.prototype)) {
          return;
        }

        var nativeAddIceCandidate = window.RTCPeerConnection.prototype.addIceCandidate;

        if (!nativeAddIceCandidate || nativeAddIceCandidate.length === 0) {
          return;
        }

        window.RTCPeerConnection.prototype.addIceCandidate = function addIceCandidate() {
          if (!arguments[0]) {
            if (arguments[1]) {
              arguments[1].apply(null);
            }

            return Promise.resolve();
          } // Firefox 68+ emits and processes {candidate: "", ...}, ignore
          // in older versions.
          // Native support for ignoring exists for Chrome M77+.
          // Safari ignores as well, exact version unknown but works in the same
          // version that also ignores addIceCandidate(null).


          if ((browserDetails.browser === 'chrome' && browserDetails.version < 78 || browserDetails.browser === 'firefox' && browserDetails.version < 68 || browserDetails.browser === 'safari') && arguments[0] && arguments[0].candidate === '') {
            return Promise.resolve();
          }

          return nativeAddIceCandidate.apply(this, arguments);
        };
      }
    }, {
      "./utils": 11,
      "sdp": 13
    }],
    7: [function (require, module, exports) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.shimGetDisplayMedia = exports.shimGetUserMedia = undefined;

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };

      var _getusermedia = require('./getusermedia');

      Object.defineProperty(exports, 'shimGetUserMedia', {
        enumerable: true,
        get: function get() {
          return _getusermedia.shimGetUserMedia;
        }
      });

      var _getdisplaymedia = require('./getdisplaymedia');

      Object.defineProperty(exports, 'shimGetDisplayMedia', {
        enumerable: true,
        get: function get() {
          return _getdisplaymedia.shimGetDisplayMedia;
        }
      });
      exports.shimOnTrack = shimOnTrack;
      exports.shimPeerConnection = shimPeerConnection;
      exports.shimSenderGetStats = shimSenderGetStats;
      exports.shimReceiverGetStats = shimReceiverGetStats;
      exports.shimRemoveStream = shimRemoveStream;
      exports.shimRTCDataChannel = shimRTCDataChannel;
      exports.shimAddTransceiver = shimAddTransceiver;
      exports.shimGetParameters = shimGetParameters;
      exports.shimCreateOffer = shimCreateOffer;
      exports.shimCreateAnswer = shimCreateAnswer;

      var _utils = require('../utils');

      var utils = _interopRequireWildcard(_utils);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj.default = obj;
          return newObj;
        }
      }

      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
        } else {
          obj[key] = value;
        }

        return obj;
      }

      function shimOnTrack(window) {
        if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.RTCTrackEvent && 'receiver' in window.RTCTrackEvent.prototype && !('transceiver' in window.RTCTrackEvent.prototype)) {
          Object.defineProperty(window.RTCTrackEvent.prototype, 'transceiver', {
            get: function get() {
              return {
                receiver: this.receiver
              };
            }
          });
        }
      }

      function shimPeerConnection(window, browserDetails) {
        if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== 'object' || !(window.RTCPeerConnection || window.mozRTCPeerConnection)) {
          return; // probably media.peerconnection.enabled=false in about:config
        }

        if (!window.RTCPeerConnection && window.mozRTCPeerConnection) {
          // very basic support for old versions.
          window.RTCPeerConnection = window.mozRTCPeerConnection;
        }

        if (browserDetails.version < 53) {
          // shim away need for obsolete RTCIceCandidate/RTCSessionDescription.
          ['setLocalDescription', 'setRemoteDescription', 'addIceCandidate'].forEach(function (method) {
            var nativeMethod = window.RTCPeerConnection.prototype[method];

            var methodObj = _defineProperty({}, method, function () {
              arguments[0] = new (method === 'addIceCandidate' ? window.RTCIceCandidate : window.RTCSessionDescription)(arguments[0]);
              return nativeMethod.apply(this, arguments);
            });

            window.RTCPeerConnection.prototype[method] = methodObj[method];
          });
        }

        var modernStatsTypes = {
          inboundrtp: 'inbound-rtp',
          outboundrtp: 'outbound-rtp',
          candidatepair: 'candidate-pair',
          localcandidate: 'local-candidate',
          remotecandidate: 'remote-candidate'
        };
        var nativeGetStats = window.RTCPeerConnection.prototype.getStats;

        window.RTCPeerConnection.prototype.getStats = function getStats() {
          var _arguments = Array.prototype.slice.call(arguments),
              selector = _arguments[0],
              onSucc = _arguments[1],
              onErr = _arguments[2];

          return nativeGetStats.apply(this, [selector || null]).then(function (stats) {
            if (browserDetails.version < 53 && !onSucc) {
              // Shim only promise getStats with spec-hyphens in type names
              // Leave callback version alone; misc old uses of forEach before Map
              try {
                stats.forEach(function (stat) {
                  stat.type = modernStatsTypes[stat.type] || stat.type;
                });
              } catch (e) {
                if (e.name !== 'TypeError') {
                  throw e;
                } // Avoid TypeError: "type" is read-only, in old versions. 34-43ish


                stats.forEach(function (stat, i) {
                  stats.set(i, Object.assign({}, stat, {
                    type: modernStatsTypes[stat.type] || stat.type
                  }));
                });
              }
            }

            return stats;
          }).then(onSucc, onErr);
        };
      }

      function shimSenderGetStats(window) {
        if (!((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.RTCPeerConnection && window.RTCRtpSender)) {
          return;
        }

        if (window.RTCRtpSender && 'getStats' in window.RTCRtpSender.prototype) {
          return;
        }

        var origGetSenders = window.RTCPeerConnection.prototype.getSenders;

        if (origGetSenders) {
          window.RTCPeerConnection.prototype.getSenders = function getSenders() {
            var _this = this;

            var senders = origGetSenders.apply(this, []);
            senders.forEach(function (sender) {
              return sender._pc = _this;
            });
            return senders;
          };
        }

        var origAddTrack = window.RTCPeerConnection.prototype.addTrack;

        if (origAddTrack) {
          window.RTCPeerConnection.prototype.addTrack = function addTrack() {
            var sender = origAddTrack.apply(this, arguments);
            sender._pc = this;
            return sender;
          };
        }

        window.RTCRtpSender.prototype.getStats = function getStats() {
          return this.track ? this._pc.getStats(this.track) : Promise.resolve(new Map());
        };
      }

      function shimReceiverGetStats(window) {
        if (!((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.RTCPeerConnection && window.RTCRtpSender)) {
          return;
        }

        if (window.RTCRtpSender && 'getStats' in window.RTCRtpReceiver.prototype) {
          return;
        }

        var origGetReceivers = window.RTCPeerConnection.prototype.getReceivers;

        if (origGetReceivers) {
          window.RTCPeerConnection.prototype.getReceivers = function getReceivers() {
            var _this2 = this;

            var receivers = origGetReceivers.apply(this, []);
            receivers.forEach(function (receiver) {
              return receiver._pc = _this2;
            });
            return receivers;
          };
        }

        utils.wrapPeerConnectionEvent(window, 'track', function (e) {
          e.receiver._pc = e.srcElement;
          return e;
        });

        window.RTCRtpReceiver.prototype.getStats = function getStats() {
          return this._pc.getStats(this.track);
        };
      }

      function shimRemoveStream(window) {
        if (!window.RTCPeerConnection || 'removeStream' in window.RTCPeerConnection.prototype) {
          return;
        }

        window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
          var _this3 = this;

          utils.deprecated('removeStream', 'removeTrack');
          this.getSenders().forEach(function (sender) {
            if (sender.track && stream.getTracks().includes(sender.track)) {
              _this3.removeTrack(sender);
            }
          });
        };
      }

      function shimRTCDataChannel(window) {
        // rename DataChannel to RTCDataChannel (native fix in FF60):
        // https://bugzilla.mozilla.org/show_bug.cgi?id=1173851
        if (window.DataChannel && !window.RTCDataChannel) {
          window.RTCDataChannel = window.DataChannel;
        }
      }

      function shimAddTransceiver(window) {
        // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
        // Firefox ignores the init sendEncodings options passed to addTransceiver
        // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
        if (!((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.RTCPeerConnection)) {
          return;
        }

        var origAddTransceiver = window.RTCPeerConnection.prototype.addTransceiver;

        if (origAddTransceiver) {
          window.RTCPeerConnection.prototype.addTransceiver = function addTransceiver() {
            this.setParametersPromises = [];
            var initParameters = arguments[1];
            var shouldPerformCheck = initParameters && 'sendEncodings' in initParameters;

            if (shouldPerformCheck) {
              // If sendEncodings params are provided, validate grammar
              initParameters.sendEncodings.forEach(function (encodingParam) {
                if ('rid' in encodingParam) {
                  var ridRegex = /^[a-z0-9]{0,16}$/i;

                  if (!ridRegex.test(encodingParam.rid)) {
                    throw new TypeError('Invalid RID value provided.');
                  }
                }

                if ('scaleResolutionDownBy' in encodingParam) {
                  if (!(parseFloat(encodingParam.scaleResolutionDownBy) >= 1.0)) {
                    throw new RangeError('scale_resolution_down_by must be >= 1.0');
                  }
                }

                if ('maxFramerate' in encodingParam) {
                  if (!(parseFloat(encodingParam.maxFramerate) >= 0)) {
                    throw new RangeError('max_framerate must be >= 0.0');
                  }
                }
              });
            }

            var transceiver = origAddTransceiver.apply(this, arguments);

            if (shouldPerformCheck) {
              // Check if the init options were applied. If not we do this in an
              // asynchronous way and save the promise reference in a global object.
              // This is an ugly hack, but at the same time is way more robust than
              // checking the sender parameters before and after the createOffer
              // Also note that after the createoffer we are not 100% sure that
              // the params were asynchronously applied so we might miss the
              // opportunity to recreate offer.
              var sender = transceiver.sender;
              var params = sender.getParameters();

              if (!('encodings' in params) || // Avoid being fooled by patched getParameters() below.
              params.encodings.length === 1 && Object.keys(params.encodings[0]).length === 0) {
                params.encodings = initParameters.sendEncodings;
                sender.sendEncodings = initParameters.sendEncodings;
                this.setParametersPromises.push(sender.setParameters(params).then(function () {
                  delete sender.sendEncodings;
                }).catch(function () {
                  delete sender.sendEncodings;
                }));
              }
            }

            return transceiver;
          };
        }
      }

      function shimGetParameters(window) {
        if (!((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.RTCRtpSender)) {
          return;
        }

        var origGetParameters = window.RTCRtpSender.prototype.getParameters;

        if (origGetParameters) {
          window.RTCRtpSender.prototype.getParameters = function getParameters() {
            var params = origGetParameters.apply(this, arguments);

            if (!('encodings' in params)) {
              params.encodings = [].concat(this.sendEncodings || [{}]);
            }

            return params;
          };
        }
      }

      function shimCreateOffer(window) {
        // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
        // Firefox ignores the init sendEncodings options passed to addTransceiver
        // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
        if (!((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.RTCPeerConnection)) {
          return;
        }

        var origCreateOffer = window.RTCPeerConnection.prototype.createOffer;

        window.RTCPeerConnection.prototype.createOffer = function createOffer() {
          var _this4 = this,
              _arguments2 = arguments;

          if (this.setParametersPromises && this.setParametersPromises.length) {
            return Promise.all(this.setParametersPromises).then(function () {
              return origCreateOffer.apply(_this4, _arguments2);
            }).finally(function () {
              _this4.setParametersPromises = [];
            });
          }

          return origCreateOffer.apply(this, arguments);
        };
      }

      function shimCreateAnswer(window) {
        // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
        // Firefox ignores the init sendEncodings options passed to addTransceiver
        // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
        if (!((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.RTCPeerConnection)) {
          return;
        }

        var origCreateAnswer = window.RTCPeerConnection.prototype.createAnswer;

        window.RTCPeerConnection.prototype.createAnswer = function createAnswer() {
          var _this5 = this,
              _arguments3 = arguments;

          if (this.setParametersPromises && this.setParametersPromises.length) {
            return Promise.all(this.setParametersPromises).then(function () {
              return origCreateAnswer.apply(_this5, _arguments3);
            }).finally(function () {
              _this5.setParametersPromises = [];
            });
          }

          return origCreateAnswer.apply(this, arguments);
        };
      }
    }, {
      "../utils": 11,
      "./getdisplaymedia": 8,
      "./getusermedia": 9
    }],
    8: [function (require, module, exports) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.shimGetDisplayMedia = shimGetDisplayMedia;

      function shimGetDisplayMedia(window, preferredMediaSource) {
        if (window.navigator.mediaDevices && 'getDisplayMedia' in window.navigator.mediaDevices) {
          return;
        }

        if (!window.navigator.mediaDevices) {
          return;
        }

        window.navigator.mediaDevices.getDisplayMedia = function getDisplayMedia(constraints) {
          if (!(constraints && constraints.video)) {
            var err = new DOMException('getDisplayMedia without video ' + 'constraints is undefined');
            err.name = 'NotFoundError'; // from https://heycam.github.io/webidl/#idl-DOMException-error-names

            err.code = 8;
            return Promise.reject(err);
          }

          if (constraints.video === true) {
            constraints.video = {
              mediaSource: preferredMediaSource
            };
          } else {
            constraints.video.mediaSource = preferredMediaSource;
          }

          return window.navigator.mediaDevices.getUserMedia(constraints);
        };
      }
    }, {}],
    9: [function (require, module, exports) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };

      exports.shimGetUserMedia = shimGetUserMedia;

      var _utils = require('../utils');

      var utils = _interopRequireWildcard(_utils);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj.default = obj;
          return newObj;
        }
      }

      function shimGetUserMedia(window, browserDetails) {
        var navigator = window && window.navigator;
        var MediaStreamTrack = window && window.MediaStreamTrack;

        navigator.getUserMedia = function (constraints, onSuccess, onError) {
          // Replace Firefox 44+'s deprecation warning with unprefixed version.
          utils.deprecated('navigator.getUserMedia', 'navigator.mediaDevices.getUserMedia');
          navigator.mediaDevices.getUserMedia(constraints).then(onSuccess, onError);
        };

        if (!(browserDetails.version > 55 && 'autoGainControl' in navigator.mediaDevices.getSupportedConstraints())) {
          var remap = function remap(obj, a, b) {
            if (a in obj && !(b in obj)) {
              obj[b] = obj[a];
              delete obj[a];
            }
          };

          var nativeGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);

          navigator.mediaDevices.getUserMedia = function (c) {
            if ((typeof c === 'undefined' ? 'undefined' : _typeof(c)) === 'object' && _typeof(c.audio) === 'object') {
              c = JSON.parse(JSON.stringify(c));
              remap(c.audio, 'autoGainControl', 'mozAutoGainControl');
              remap(c.audio, 'noiseSuppression', 'mozNoiseSuppression');
            }

            return nativeGetUserMedia(c);
          };

          if (MediaStreamTrack && MediaStreamTrack.prototype.getSettings) {
            var nativeGetSettings = MediaStreamTrack.prototype.getSettings;

            MediaStreamTrack.prototype.getSettings = function () {
              var obj = nativeGetSettings.apply(this, arguments);
              remap(obj, 'mozAutoGainControl', 'autoGainControl');
              remap(obj, 'mozNoiseSuppression', 'noiseSuppression');
              return obj;
            };
          }

          if (MediaStreamTrack && MediaStreamTrack.prototype.applyConstraints) {
            var nativeApplyConstraints = MediaStreamTrack.prototype.applyConstraints;

            MediaStreamTrack.prototype.applyConstraints = function (c) {
              if (this.kind === 'audio' && (typeof c === 'undefined' ? 'undefined' : _typeof(c)) === 'object') {
                c = JSON.parse(JSON.stringify(c));
                remap(c, 'autoGainControl', 'mozAutoGainControl');
                remap(c, 'noiseSuppression', 'mozNoiseSuppression');
              }

              return nativeApplyConstraints.apply(this, [c]);
            };
          }
        }
      }
    }, {
      "../utils": 11
    }],
    10: [function (require, module, exports) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };

      exports.shimLocalStreamsAPI = shimLocalStreamsAPI;
      exports.shimRemoteStreamsAPI = shimRemoteStreamsAPI;
      exports.shimCallbacksAPI = shimCallbacksAPI;
      exports.shimGetUserMedia = shimGetUserMedia;
      exports.shimConstraints = shimConstraints;
      exports.shimRTCIceServerUrls = shimRTCIceServerUrls;
      exports.shimTrackEventTransceiver = shimTrackEventTransceiver;
      exports.shimCreateOfferLegacy = shimCreateOfferLegacy;
      exports.shimAudioContext = shimAudioContext;

      var _utils = require('../utils');

      var utils = _interopRequireWildcard(_utils);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj.default = obj;
          return newObj;
        }
      }

      function shimLocalStreamsAPI(window) {
        if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== 'object' || !window.RTCPeerConnection) {
          return;
        }

        if (!('getLocalStreams' in window.RTCPeerConnection.prototype)) {
          window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
            if (!this._localStreams) {
              this._localStreams = [];
            }

            return this._localStreams;
          };
        }

        if (!('addStream' in window.RTCPeerConnection.prototype)) {
          var _addTrack = window.RTCPeerConnection.prototype.addTrack;

          window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
            var _this = this;

            if (!this._localStreams) {
              this._localStreams = [];
            }

            if (!this._localStreams.includes(stream)) {
              this._localStreams.push(stream);
            } // Try to emulate Chrome's behaviour of adding in audio-video order.
            // Safari orders by track id.


            stream.getAudioTracks().forEach(function (track) {
              return _addTrack.call(_this, track, stream);
            });
            stream.getVideoTracks().forEach(function (track) {
              return _addTrack.call(_this, track, stream);
            });
          };

          window.RTCPeerConnection.prototype.addTrack = function addTrack(track) {
            var _this2 = this;

            for (var _len = arguments.length, streams = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              streams[_key - 1] = arguments[_key];
            }

            if (streams) {
              streams.forEach(function (stream) {
                if (!_this2._localStreams) {
                  _this2._localStreams = [stream];
                } else if (!_this2._localStreams.includes(stream)) {
                  _this2._localStreams.push(stream);
                }
              });
            }

            return _addTrack.apply(this, arguments);
          };
        }

        if (!('removeStream' in window.RTCPeerConnection.prototype)) {
          window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
            var _this3 = this;

            if (!this._localStreams) {
              this._localStreams = [];
            }

            var index = this._localStreams.indexOf(stream);

            if (index === -1) {
              return;
            }

            this._localStreams.splice(index, 1);

            var tracks = stream.getTracks();
            this.getSenders().forEach(function (sender) {
              if (tracks.includes(sender.track)) {
                _this3.removeTrack(sender);
              }
            });
          };
        }
      }

      function shimRemoteStreamsAPI(window) {
        if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== 'object' || !window.RTCPeerConnection) {
          return;
        }

        if (!('getRemoteStreams' in window.RTCPeerConnection.prototype)) {
          window.RTCPeerConnection.prototype.getRemoteStreams = function getRemoteStreams() {
            return this._remoteStreams ? this._remoteStreams : [];
          };
        }

        if (!('onaddstream' in window.RTCPeerConnection.prototype)) {
          Object.defineProperty(window.RTCPeerConnection.prototype, 'onaddstream', {
            get: function get() {
              return this._onaddstream;
            },
            set: function set(f) {
              var _this4 = this;

              if (this._onaddstream) {
                this.removeEventListener('addstream', this._onaddstream);
                this.removeEventListener('track', this._onaddstreampoly);
              }

              this.addEventListener('addstream', this._onaddstream = f);
              this.addEventListener('track', this._onaddstreampoly = function (e) {
                e.streams.forEach(function (stream) {
                  if (!_this4._remoteStreams) {
                    _this4._remoteStreams = [];
                  }

                  if (_this4._remoteStreams.includes(stream)) {
                    return;
                  }

                  _this4._remoteStreams.push(stream);

                  var event = new Event('addstream');
                  event.stream = stream;

                  _this4.dispatchEvent(event);
                });
              });
            }
          });
          var origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;

          window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
            var pc = this;

            if (!this._onaddstreampoly) {
              this.addEventListener('track', this._onaddstreampoly = function (e) {
                e.streams.forEach(function (stream) {
                  if (!pc._remoteStreams) {
                    pc._remoteStreams = [];
                  }

                  if (pc._remoteStreams.indexOf(stream) >= 0) {
                    return;
                  }

                  pc._remoteStreams.push(stream);

                  var event = new Event('addstream');
                  event.stream = stream;
                  pc.dispatchEvent(event);
                });
              });
            }

            return origSetRemoteDescription.apply(pc, arguments);
          };
        }
      }

      function shimCallbacksAPI(window) {
        if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== 'object' || !window.RTCPeerConnection) {
          return;
        }

        var prototype = window.RTCPeerConnection.prototype;
        var origCreateOffer = prototype.createOffer;
        var origCreateAnswer = prototype.createAnswer;
        var setLocalDescription = prototype.setLocalDescription;
        var setRemoteDescription = prototype.setRemoteDescription;
        var addIceCandidate = prototype.addIceCandidate;

        prototype.createOffer = function createOffer(successCallback, failureCallback) {
          var options = arguments.length >= 2 ? arguments[2] : arguments[0];
          var promise = origCreateOffer.apply(this, [options]);

          if (!failureCallback) {
            return promise;
          }

          promise.then(successCallback, failureCallback);
          return Promise.resolve();
        };

        prototype.createAnswer = function createAnswer(successCallback, failureCallback) {
          var options = arguments.length >= 2 ? arguments[2] : arguments[0];
          var promise = origCreateAnswer.apply(this, [options]);

          if (!failureCallback) {
            return promise;
          }

          promise.then(successCallback, failureCallback);
          return Promise.resolve();
        };

        var withCallback = function withCallback(description, successCallback, failureCallback) {
          var promise = setLocalDescription.apply(this, [description]);

          if (!failureCallback) {
            return promise;
          }

          promise.then(successCallback, failureCallback);
          return Promise.resolve();
        };

        prototype.setLocalDescription = withCallback;

        withCallback = function withCallback(description, successCallback, failureCallback) {
          var promise = setRemoteDescription.apply(this, [description]);

          if (!failureCallback) {
            return promise;
          }

          promise.then(successCallback, failureCallback);
          return Promise.resolve();
        };

        prototype.setRemoteDescription = withCallback;

        withCallback = function withCallback(candidate, successCallback, failureCallback) {
          var promise = addIceCandidate.apply(this, [candidate]);

          if (!failureCallback) {
            return promise;
          }

          promise.then(successCallback, failureCallback);
          return Promise.resolve();
        };

        prototype.addIceCandidate = withCallback;
      }

      function shimGetUserMedia(window) {
        var navigator = window && window.navigator;

        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          // shim not needed in Safari 12.1
          var mediaDevices = navigator.mediaDevices;

          var _getUserMedia = mediaDevices.getUserMedia.bind(mediaDevices);

          navigator.mediaDevices.getUserMedia = function (constraints) {
            return _getUserMedia(shimConstraints(constraints));
          };
        }

        if (!navigator.getUserMedia && navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          navigator.getUserMedia = function getUserMedia(constraints, cb, errcb) {
            navigator.mediaDevices.getUserMedia(constraints).then(cb, errcb);
          }.bind(navigator);
        }
      }

      function shimConstraints(constraints) {
        if (constraints && constraints.video !== undefined) {
          return Object.assign({}, constraints, {
            video: utils.compactObject(constraints.video)
          });
        }

        return constraints;
      }

      function shimRTCIceServerUrls(window) {
        if (!window.RTCPeerConnection) {
          return;
        } // migrate from non-spec RTCIceServer.url to RTCIceServer.urls


        var OrigPeerConnection = window.RTCPeerConnection;

        window.RTCPeerConnection = function RTCPeerConnection(pcConfig, pcConstraints) {
          if (pcConfig && pcConfig.iceServers) {
            var newIceServers = [];

            for (var i = 0; i < pcConfig.iceServers.length; i++) {
              var server = pcConfig.iceServers[i];

              if (!server.hasOwnProperty('urls') && server.hasOwnProperty('url')) {
                utils.deprecated('RTCIceServer.url', 'RTCIceServer.urls');
                server = JSON.parse(JSON.stringify(server));
                server.urls = server.url;
                delete server.url;
                newIceServers.push(server);
              } else {
                newIceServers.push(pcConfig.iceServers[i]);
              }
            }

            pcConfig.iceServers = newIceServers;
          }

          return new OrigPeerConnection(pcConfig, pcConstraints);
        };

        window.RTCPeerConnection.prototype = OrigPeerConnection.prototype; // wrap static methods. Currently just generateCertificate.

        if ('generateCertificate' in OrigPeerConnection) {
          Object.defineProperty(window.RTCPeerConnection, 'generateCertificate', {
            get: function get() {
              return OrigPeerConnection.generateCertificate;
            }
          });
        }
      }

      function shimTrackEventTransceiver(window) {
        // Add event.transceiver member over deprecated event.receiver
        if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.RTCTrackEvent && 'receiver' in window.RTCTrackEvent.prototype && !('transceiver' in window.RTCTrackEvent.prototype)) {
          Object.defineProperty(window.RTCTrackEvent.prototype, 'transceiver', {
            get: function get() {
              return {
                receiver: this.receiver
              };
            }
          });
        }
      }

      function shimCreateOfferLegacy(window) {
        var origCreateOffer = window.RTCPeerConnection.prototype.createOffer;

        window.RTCPeerConnection.prototype.createOffer = function createOffer(offerOptions) {
          if (offerOptions) {
            if (typeof offerOptions.offerToReceiveAudio !== 'undefined') {
              // support bit values
              offerOptions.offerToReceiveAudio = !!offerOptions.offerToReceiveAudio;
            }

            var audioTransceiver = this.getTransceivers().find(function (transceiver) {
              return transceiver.receiver.track.kind === 'audio';
            });

            if (offerOptions.offerToReceiveAudio === false && audioTransceiver) {
              if (audioTransceiver.direction === 'sendrecv') {
                if (audioTransceiver.setDirection) {
                  audioTransceiver.setDirection('sendonly');
                } else {
                  audioTransceiver.direction = 'sendonly';
                }
              } else if (audioTransceiver.direction === 'recvonly') {
                if (audioTransceiver.setDirection) {
                  audioTransceiver.setDirection('inactive');
                } else {
                  audioTransceiver.direction = 'inactive';
                }
              }
            } else if (offerOptions.offerToReceiveAudio === true && !audioTransceiver) {
              this.addTransceiver('audio');
            }

            if (typeof offerOptions.offerToReceiveVideo !== 'undefined') {
              // support bit values
              offerOptions.offerToReceiveVideo = !!offerOptions.offerToReceiveVideo;
            }

            var videoTransceiver = this.getTransceivers().find(function (transceiver) {
              return transceiver.receiver.track.kind === 'video';
            });

            if (offerOptions.offerToReceiveVideo === false && videoTransceiver) {
              if (videoTransceiver.direction === 'sendrecv') {
                if (videoTransceiver.setDirection) {
                  videoTransceiver.setDirection('sendonly');
                } else {
                  videoTransceiver.direction = 'sendonly';
                }
              } else if (videoTransceiver.direction === 'recvonly') {
                if (videoTransceiver.setDirection) {
                  videoTransceiver.setDirection('inactive');
                } else {
                  videoTransceiver.direction = 'inactive';
                }
              }
            } else if (offerOptions.offerToReceiveVideo === true && !videoTransceiver) {
              this.addTransceiver('video');
            }
          }

          return origCreateOffer.apply(this, arguments);
        };
      }

      function shimAudioContext(window) {
        if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== 'object' || window.AudioContext) {
          return;
        }

        window.AudioContext = window.webkitAudioContext;
      }
    }, {
      "../utils": 11
    }],
    11: [function (require, module, exports) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };

      exports.extractVersion = extractVersion;
      exports.wrapPeerConnectionEvent = wrapPeerConnectionEvent;
      exports.disableLog = disableLog;
      exports.disableWarnings = disableWarnings;
      exports.log = log;
      exports.deprecated = deprecated;
      exports.detectBrowser = detectBrowser;
      exports.compactObject = compactObject;
      exports.walkStats = walkStats;
      exports.filterStats = filterStats;

      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
        } else {
          obj[key] = value;
        }

        return obj;
      }

      var logDisabled_ = true;
      var deprecationWarnings_ = true;
      /**
       * Extract browser version out of the provided user agent string.
       *
       * @param {!string} uastring userAgent string.
       * @param {!string} expr Regular expression used as match criteria.
       * @param {!number} pos position in the version string to be returned.
       * @return {!number} browser version.
       */

      function extractVersion(uastring, expr, pos) {
        var match = uastring.match(expr);
        return match && match.length >= pos && parseInt(match[pos], 10);
      } // Wraps the peerconnection event eventNameToWrap in a function
      // which returns the modified event object (or false to prevent
      // the event).


      function wrapPeerConnectionEvent(window, eventNameToWrap, wrapper) {
        if (!window.RTCPeerConnection) {
          return;
        }

        var proto = window.RTCPeerConnection.prototype;
        var nativeAddEventListener = proto.addEventListener;

        proto.addEventListener = function (nativeEventName, cb) {
          if (nativeEventName !== eventNameToWrap) {
            return nativeAddEventListener.apply(this, arguments);
          }

          var wrappedCallback = function wrappedCallback(e) {
            var modifiedEvent = wrapper(e);

            if (modifiedEvent) {
              if (cb.handleEvent) {
                cb.handleEvent(modifiedEvent);
              } else {
                cb(modifiedEvent);
              }
            }
          };

          this._eventMap = this._eventMap || {};

          if (!this._eventMap[eventNameToWrap]) {
            this._eventMap[eventNameToWrap] = new Map();
          }

          this._eventMap[eventNameToWrap].set(cb, wrappedCallback);

          return nativeAddEventListener.apply(this, [nativeEventName, wrappedCallback]);
        };

        var nativeRemoveEventListener = proto.removeEventListener;

        proto.removeEventListener = function (nativeEventName, cb) {
          if (nativeEventName !== eventNameToWrap || !this._eventMap || !this._eventMap[eventNameToWrap]) {
            return nativeRemoveEventListener.apply(this, arguments);
          }

          if (!this._eventMap[eventNameToWrap].has(cb)) {
            return nativeRemoveEventListener.apply(this, arguments);
          }

          var unwrappedCb = this._eventMap[eventNameToWrap].get(cb);

          this._eventMap[eventNameToWrap].delete(cb);

          if (this._eventMap[eventNameToWrap].size === 0) {
            delete this._eventMap[eventNameToWrap];
          }

          if (Object.keys(this._eventMap).length === 0) {
            delete this._eventMap;
          }

          return nativeRemoveEventListener.apply(this, [nativeEventName, unwrappedCb]);
        };

        Object.defineProperty(proto, 'on' + eventNameToWrap, {
          get: function get() {
            return this['_on' + eventNameToWrap];
          },
          set: function set(cb) {
            if (this['_on' + eventNameToWrap]) {
              this.removeEventListener(eventNameToWrap, this['_on' + eventNameToWrap]);
              delete this['_on' + eventNameToWrap];
            }

            if (cb) {
              this.addEventListener(eventNameToWrap, this['_on' + eventNameToWrap] = cb);
            }
          },
          enumerable: true,
          configurable: true
        });
      }

      function disableLog(bool) {
        if (typeof bool !== 'boolean') {
          return new Error('Argument type: ' + (typeof bool === 'undefined' ? 'undefined' : _typeof(bool)) + '. Please use a boolean.');
        }

        logDisabled_ = bool;
        return bool ? 'adapter.js logging disabled' : 'adapter.js logging enabled';
      }
      /**
       * Disable or enable deprecation warnings
       * @param {!boolean} bool set to true to disable warnings.
       */


      function disableWarnings(bool) {
        if (typeof bool !== 'boolean') {
          return new Error('Argument type: ' + (typeof bool === 'undefined' ? 'undefined' : _typeof(bool)) + '. Please use a boolean.');
        }

        deprecationWarnings_ = !bool;
        return 'adapter.js deprecation warnings ' + (bool ? 'disabled' : 'enabled');
      }

      function log() {
        if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object') {
          if (logDisabled_) {
            return;
          }

          if (typeof console !== 'undefined' && typeof console.log === 'function') {
            console.log.apply(console, arguments);
          }
        }
      }
      /**
       * Shows a deprecation warning suggesting the modern and spec-compatible API.
       */


      function deprecated(oldMethod, newMethod) {
        if (!deprecationWarnings_) {
          return;
        }

        console.warn(oldMethod + ' is deprecated, please use ' + newMethod + ' instead.');
      }
      /**
       * Browser detector.
       *
       * @return {object} result containing browser and version
       *     properties.
       */


      function detectBrowser(window) {
        // Returned result object.
        var result = {
          browser: null,
          version: null
        }; // Fail early if it's not a browser

        if (typeof window === 'undefined' || !window.navigator) {
          result.browser = 'Not a browser.';
          return result;
        }

        var navigator = window.navigator;

        if (navigator.mozGetUserMedia) {
          // Firefox.
          result.browser = 'firefox';
          result.version = extractVersion(navigator.userAgent, /Firefox\/(\d+)\./, 1);
        } else if (navigator.webkitGetUserMedia || window.isSecureContext === false && window.webkitRTCPeerConnection && !window.RTCIceGatherer) {
          // Chrome, Chromium, Webview, Opera.
          // Version matches Chrome/WebRTC version.
          // Chrome 74 removed webkitGetUserMedia on http as well so we need the
          // more complicated fallback to webkitRTCPeerConnection.
          result.browser = 'chrome';
          result.version = extractVersion(navigator.userAgent, /Chrom(e|ium)\/(\d+)\./, 2);
        } else if (navigator.mediaDevices && navigator.userAgent.match(/Edge\/(\d+).(\d+)$/)) {
          // Edge.
          result.browser = 'edge';
          result.version = extractVersion(navigator.userAgent, /Edge\/(\d+).(\d+)$/, 2);
        } else if (window.RTCPeerConnection && navigator.userAgent.match(/AppleWebKit\/(\d+)\./)) {
          // Safari.
          result.browser = 'safari';
          result.version = extractVersion(navigator.userAgent, /AppleWebKit\/(\d+)\./, 1);
          result.supportsUnifiedPlan = window.RTCRtpTransceiver && 'currentDirection' in window.RTCRtpTransceiver.prototype;
        } else {
          // Default fallthrough: not supported.
          result.browser = 'Not a supported browser.';
          return result;
        }

        return result;
      }
      /**
       * Checks if something is an object.
       *
       * @param {*} val The something you want to check.
       * @return true if val is an object, false otherwise.
       */


      function isObject(val) {
        return Object.prototype.toString.call(val) === '[object Object]';
      }
      /**
       * Remove all empty objects and undefined values
       * from a nested object -- an enhanced and vanilla version
       * of Lodash's `compact`.
       */


      function compactObject(data) {
        if (!isObject(data)) {
          return data;
        }

        return Object.keys(data).reduce(function (accumulator, key) {
          var isObj = isObject(data[key]);
          var value = isObj ? compactObject(data[key]) : data[key];
          var isEmptyObject = isObj && !Object.keys(value).length;

          if (value === undefined || isEmptyObject) {
            return accumulator;
          }

          return Object.assign(accumulator, _defineProperty({}, key, value));
        }, {});
      }
      /* iterates the stats graph recursively. */


      function walkStats(stats, base, resultSet) {
        if (!base || resultSet.has(base.id)) {
          return;
        }

        resultSet.set(base.id, base);
        Object.keys(base).forEach(function (name) {
          if (name.endsWith('Id')) {
            walkStats(stats, stats.get(base[name]), resultSet);
          } else if (name.endsWith('Ids')) {
            base[name].forEach(function (id) {
              walkStats(stats, stats.get(id), resultSet);
            });
          }
        });
      }
      /* filter getStats for a sender/receiver track. */


      function filterStats(result, track, outbound) {
        var streamStatsType = outbound ? 'outbound-rtp' : 'inbound-rtp';
        var filteredResult = new Map();

        if (track === null) {
          return filteredResult;
        }

        var trackStats = [];
        result.forEach(function (value) {
          if (value.type === 'track' && value.trackIdentifier === track.id) {
            trackStats.push(value);
          }
        });
        trackStats.forEach(function (trackStat) {
          result.forEach(function (stats) {
            if (stats.type === streamStatsType && stats.trackId === trackStat.id) {
              walkStats(result, stats, filteredResult);
            }
          });
        });
        return filteredResult;
      }
    }, {}],
    12: [function (require, module, exports) {}, {}],
    13: [function (require, module, exports) {
      var SDPUtils = {}; // Generate an alphanumeric identifier for cname or mids.
      // TODO: use UUIDs instead? https://gist.github.com/jed/982883

      SDPUtils.generateIdentifier = function () {
        return Math.random().toString(36).substr(2, 10);
      }; // The RTCP CNAME used by all peerconnections from the same JS.


      SDPUtils.localCName = SDPUtils.generateIdentifier(); // Splits SDP into lines, dealing with both CRLF and LF.

      SDPUtils.splitLines = function (blob) {
        return blob.trim().split('\n').map(function (line) {
          return line.trim();
        });
      }; // Splits SDP into sessionpart and mediasections. Ensures CRLF.


      SDPUtils.splitSections = function (blob) {
        var parts = blob.split('\nm=');
        return parts.map(function (part, index) {
          return (index > 0 ? 'm=' + part : part).trim() + '\r\n';
        });
      }; // returns the session description.


      SDPUtils.getDescription = function (blob) {
        var sections = SDPUtils.splitSections(blob);
        return sections && sections[0];
      }; // returns the individual media sections.


      SDPUtils.getMediaSections = function (blob) {
        var sections = SDPUtils.splitSections(blob);
        sections.shift();
        return sections;
      }; // Returns lines that start with a certain prefix.


      SDPUtils.matchPrefix = function (blob, prefix) {
        return SDPUtils.splitLines(blob).filter(function (line) {
          return line.indexOf(prefix) === 0;
        });
      }; // Parses an ICE candidate line. Sample input:
      // candidate:702786350 2 udp 41819902 8.8.8.8 60769 typ relay raddr 8.8.8.8
      // rport 55996"


      SDPUtils.parseCandidate = function (line) {
        var parts; // Parse both variants.

        if (line.indexOf('a=candidate:') === 0) {
          parts = line.substring(12).split(' ');
        } else {
          parts = line.substring(10).split(' ');
        }

        var candidate = {
          foundation: parts[0],
          component: parseInt(parts[1], 10),
          protocol: parts[2].toLowerCase(),
          priority: parseInt(parts[3], 10),
          ip: parts[4],
          address: parts[4],
          // address is an alias for ip.
          port: parseInt(parts[5], 10),
          // skip parts[6] == 'typ'
          type: parts[7]
        };

        for (var i = 8; i < parts.length; i += 2) {
          switch (parts[i]) {
            case 'raddr':
              candidate.relatedAddress = parts[i + 1];
              break;

            case 'rport':
              candidate.relatedPort = parseInt(parts[i + 1], 10);
              break;

            case 'tcptype':
              candidate.tcpType = parts[i + 1];
              break;

            case 'ufrag':
              candidate.ufrag = parts[i + 1]; // for backward compability.

              candidate.usernameFragment = parts[i + 1];
              break;

            default:
              // extension handling, in particular ufrag
              candidate[parts[i]] = parts[i + 1];
              break;
          }
        }

        return candidate;
      }; // Translates a candidate object into SDP candidate attribute.


      SDPUtils.writeCandidate = function (candidate) {
        var sdp = [];
        sdp.push(candidate.foundation);
        sdp.push(candidate.component);
        sdp.push(candidate.protocol.toUpperCase());
        sdp.push(candidate.priority);
        sdp.push(candidate.address || candidate.ip);
        sdp.push(candidate.port);
        var type = candidate.type;
        sdp.push('typ');
        sdp.push(type);

        if (type !== 'host' && candidate.relatedAddress && candidate.relatedPort) {
          sdp.push('raddr');
          sdp.push(candidate.relatedAddress);
          sdp.push('rport');
          sdp.push(candidate.relatedPort);
        }

        if (candidate.tcpType && candidate.protocol.toLowerCase() === 'tcp') {
          sdp.push('tcptype');
          sdp.push(candidate.tcpType);
        }

        if (candidate.usernameFragment || candidate.ufrag) {
          sdp.push('ufrag');
          sdp.push(candidate.usernameFragment || candidate.ufrag);
        }

        return 'candidate:' + sdp.join(' ');
      }; // Parses an ice-options line, returns an array of option tags.
      // a=ice-options:foo bar


      SDPUtils.parseIceOptions = function (line) {
        return line.substr(14).split(' ');
      }; // Parses an rtpmap line, returns RTCRtpCoddecParameters. Sample input:
      // a=rtpmap:111 opus/48000/2


      SDPUtils.parseRtpMap = function (line) {
        var parts = line.substr(9).split(' ');
        var parsed = {
          payloadType: parseInt(parts.shift(), 10) // was: id

        };
        parts = parts[0].split('/');
        parsed.name = parts[0];
        parsed.clockRate = parseInt(parts[1], 10); // was: clockrate

        parsed.channels = parts.length === 3 ? parseInt(parts[2], 10) : 1; // legacy alias, got renamed back to channels in ORTC.

        parsed.numChannels = parsed.channels;
        return parsed;
      }; // Generate an a=rtpmap line from RTCRtpCodecCapability or
      // RTCRtpCodecParameters.


      SDPUtils.writeRtpMap = function (codec) {
        var pt = codec.payloadType;

        if (codec.preferredPayloadType !== undefined) {
          pt = codec.preferredPayloadType;
        }

        var channels = codec.channels || codec.numChannels || 1;
        return 'a=rtpmap:' + pt + ' ' + codec.name + '/' + codec.clockRate + (channels !== 1 ? '/' + channels : '') + '\r\n';
      }; // Parses an a=extmap line (headerextension from RFC 5285). Sample input:
      // a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
      // a=extmap:2/sendonly urn:ietf:params:rtp-hdrext:toffset


      SDPUtils.parseExtmap = function (line) {
        var parts = line.substr(9).split(' ');
        return {
          id: parseInt(parts[0], 10),
          direction: parts[0].indexOf('/') > 0 ? parts[0].split('/')[1] : 'sendrecv',
          uri: parts[1]
        };
      }; // Generates a=extmap line from RTCRtpHeaderExtensionParameters or
      // RTCRtpHeaderExtension.


      SDPUtils.writeExtmap = function (headerExtension) {
        return 'a=extmap:' + (headerExtension.id || headerExtension.preferredId) + (headerExtension.direction && headerExtension.direction !== 'sendrecv' ? '/' + headerExtension.direction : '') + ' ' + headerExtension.uri + '\r\n';
      }; // Parses an ftmp line, returns dictionary. Sample input:
      // a=fmtp:96 vbr=on;cng=on
      // Also deals with vbr=on; cng=on


      SDPUtils.parseFmtp = function (line) {
        var parsed = {};
        var kv;
        var parts = line.substr(line.indexOf(' ') + 1).split(';');

        for (var j = 0; j < parts.length; j++) {
          kv = parts[j].trim().split('=');
          parsed[kv[0].trim()] = kv[1];
        }

        return parsed;
      }; // Generates an a=ftmp line from RTCRtpCodecCapability or RTCRtpCodecParameters.


      SDPUtils.writeFmtp = function (codec) {
        var line = '';
        var pt = codec.payloadType;

        if (codec.preferredPayloadType !== undefined) {
          pt = codec.preferredPayloadType;
        }

        if (codec.parameters && Object.keys(codec.parameters).length) {
          var params = [];
          Object.keys(codec.parameters).forEach(function (param) {
            if (codec.parameters[param]) {
              params.push(param + '=' + codec.parameters[param]);
            } else {
              params.push(param);
            }
          });
          line += 'a=fmtp:' + pt + ' ' + params.join(';') + '\r\n';
        }

        return line;
      }; // Parses an rtcp-fb line, returns RTCPRtcpFeedback object. Sample input:
      // a=rtcp-fb:98 nack rpsi


      SDPUtils.parseRtcpFb = function (line) {
        var parts = line.substr(line.indexOf(' ') + 1).split(' ');
        return {
          type: parts.shift(),
          parameter: parts.join(' ')
        };
      }; // Generate a=rtcp-fb lines from RTCRtpCodecCapability or RTCRtpCodecParameters.


      SDPUtils.writeRtcpFb = function (codec) {
        var lines = '';
        var pt = codec.payloadType;

        if (codec.preferredPayloadType !== undefined) {
          pt = codec.preferredPayloadType;
        }

        if (codec.rtcpFeedback && codec.rtcpFeedback.length) {
          // FIXME: special handling for trr-int?
          codec.rtcpFeedback.forEach(function (fb) {
            lines += 'a=rtcp-fb:' + pt + ' ' + fb.type + (fb.parameter && fb.parameter.length ? ' ' + fb.parameter : '') + '\r\n';
          });
        }

        return lines;
      }; // Parses an RFC 5576 ssrc media attribute. Sample input:
      // a=ssrc:3735928559 cname:something


      SDPUtils.parseSsrcMedia = function (line) {
        var sp = line.indexOf(' ');
        var parts = {
          ssrc: parseInt(line.substr(7, sp - 7), 10)
        };
        var colon = line.indexOf(':', sp);

        if (colon > -1) {
          parts.attribute = line.substr(sp + 1, colon - sp - 1);
          parts.value = line.substr(colon + 1);
        } else {
          parts.attribute = line.substr(sp + 1);
        }

        return parts;
      };

      SDPUtils.parseSsrcGroup = function (line) {
        var parts = line.substr(13).split(' ');
        return {
          semantics: parts.shift(),
          ssrcs: parts.map(function (ssrc) {
            return parseInt(ssrc, 10);
          })
        };
      }; // Extracts the MID (RFC 5888) from a media section.
      // returns the MID or undefined if no mid line was found.


      SDPUtils.getMid = function (mediaSection) {
        var mid = SDPUtils.matchPrefix(mediaSection, 'a=mid:')[0];

        if (mid) {
          return mid.substr(6);
        }
      };

      SDPUtils.parseFingerprint = function (line) {
        var parts = line.substr(14).split(' ');
        return {
          algorithm: parts[0].toLowerCase(),
          // algorithm is case-sensitive in Edge.
          value: parts[1]
        };
      }; // Extracts DTLS parameters from SDP media section or sessionpart.
      // FIXME: for consistency with other functions this should only
      //   get the fingerprint line as input. See also getIceParameters.


      SDPUtils.getDtlsParameters = function (mediaSection, sessionpart) {
        var lines = SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=fingerprint:'); // Note: a=setup line is ignored since we use the 'auto' role.
        // Note2: 'algorithm' is not case sensitive except in Edge.

        return {
          role: 'auto',
          fingerprints: lines.map(SDPUtils.parseFingerprint)
        };
      }; // Serializes DTLS parameters to SDP.


      SDPUtils.writeDtlsParameters = function (params, setupType) {
        var sdp = 'a=setup:' + setupType + '\r\n';
        params.fingerprints.forEach(function (fp) {
          sdp += 'a=fingerprint:' + fp.algorithm + ' ' + fp.value + '\r\n';
        });
        return sdp;
      }; // Parses a=crypto lines into
      //   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#dictionary-rtcsrtpsdesparameters-members


      SDPUtils.parseCryptoLine = function (line) {
        var parts = line.substr(9).split(' ');
        return {
          tag: parseInt(parts[0], 10),
          cryptoSuite: parts[1],
          keyParams: parts[2],
          sessionParams: parts.slice(3)
        };
      };

      SDPUtils.writeCryptoLine = function (parameters) {
        return 'a=crypto:' + parameters.tag + ' ' + parameters.cryptoSuite + ' ' + (typeof parameters.keyParams === 'object' ? SDPUtils.writeCryptoKeyParams(parameters.keyParams) : parameters.keyParams) + (parameters.sessionParams ? ' ' + parameters.sessionParams.join(' ') : '') + '\r\n';
      }; // Parses the crypto key parameters into
      //   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#rtcsrtpkeyparam*


      SDPUtils.parseCryptoKeyParams = function (keyParams) {
        if (keyParams.indexOf('inline:') !== 0) {
          return null;
        }

        var parts = keyParams.substr(7).split('|');
        return {
          keyMethod: 'inline',
          keySalt: parts[0],
          lifeTime: parts[1],
          mkiValue: parts[2] ? parts[2].split(':')[0] : undefined,
          mkiLength: parts[2] ? parts[2].split(':')[1] : undefined
        };
      };

      SDPUtils.writeCryptoKeyParams = function (keyParams) {
        return keyParams.keyMethod + ':' + keyParams.keySalt + (keyParams.lifeTime ? '|' + keyParams.lifeTime : '') + (keyParams.mkiValue && keyParams.mkiLength ? '|' + keyParams.mkiValue + ':' + keyParams.mkiLength : '');
      }; // Extracts all SDES paramters.


      SDPUtils.getCryptoParameters = function (mediaSection, sessionpart) {
        var lines = SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=crypto:');
        return lines.map(SDPUtils.parseCryptoLine);
      }; // Parses ICE information from SDP media section or sessionpart.
      // FIXME: for consistency with other functions this should only
      //   get the ice-ufrag and ice-pwd lines as input.


      SDPUtils.getIceParameters = function (mediaSection, sessionpart) {
        var ufrag = SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=ice-ufrag:')[0];
        var pwd = SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=ice-pwd:')[0];

        if (!(ufrag && pwd)) {
          return null;
        }

        return {
          usernameFragment: ufrag.substr(12),
          password: pwd.substr(10)
        };
      }; // Serializes ICE parameters to SDP.


      SDPUtils.writeIceParameters = function (params) {
        return 'a=ice-ufrag:' + params.usernameFragment + '\r\n' + 'a=ice-pwd:' + params.password + '\r\n';
      }; // Parses the SDP media section and returns RTCRtpParameters.


      SDPUtils.parseRtpParameters = function (mediaSection) {
        var description = {
          codecs: [],
          headerExtensions: [],
          fecMechanisms: [],
          rtcp: []
        };
        var lines = SDPUtils.splitLines(mediaSection);
        var mline = lines[0].split(' ');

        for (var i = 3; i < mline.length; i++) {
          // find all codecs from mline[3..]
          var pt = mline[i];
          var rtpmapline = SDPUtils.matchPrefix(mediaSection, 'a=rtpmap:' + pt + ' ')[0];

          if (rtpmapline) {
            var codec = SDPUtils.parseRtpMap(rtpmapline);
            var fmtps = SDPUtils.matchPrefix(mediaSection, 'a=fmtp:' + pt + ' '); // Only the first a=fmtp:<pt> is considered.

            codec.parameters = fmtps.length ? SDPUtils.parseFmtp(fmtps[0]) : {};
            codec.rtcpFeedback = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-fb:' + pt + ' ').map(SDPUtils.parseRtcpFb);
            description.codecs.push(codec); // parse FEC mechanisms from rtpmap lines.

            switch (codec.name.toUpperCase()) {
              case 'RED':
              case 'ULPFEC':
                description.fecMechanisms.push(codec.name.toUpperCase());
                break;

              default:
                // only RED and ULPFEC are recognized as FEC mechanisms.
                break;
            }
          }
        }

        SDPUtils.matchPrefix(mediaSection, 'a=extmap:').forEach(function (line) {
          description.headerExtensions.push(SDPUtils.parseExtmap(line));
        }); // FIXME: parse rtcp.

        return description;
      }; // Generates parts of the SDP media section describing the capabilities /
      // parameters.


      SDPUtils.writeRtpDescription = function (kind, caps) {
        var sdp = ''; // Build the mline.

        sdp += 'm=' + kind + ' ';
        sdp += caps.codecs.length > 0 ? '9' : '0'; // reject if no codecs.

        sdp += ' UDP/TLS/RTP/SAVPF ';
        sdp += caps.codecs.map(function (codec) {
          if (codec.preferredPayloadType !== undefined) {
            return codec.preferredPayloadType;
          }

          return codec.payloadType;
        }).join(' ') + '\r\n';
        sdp += 'c=IN IP4 0.0.0.0\r\n';
        sdp += 'a=rtcp:9 IN IP4 0.0.0.0\r\n'; // Add a=rtpmap lines for each codec. Also fmtp and rtcp-fb.

        caps.codecs.forEach(function (codec) {
          sdp += SDPUtils.writeRtpMap(codec);
          sdp += SDPUtils.writeFmtp(codec);
          sdp += SDPUtils.writeRtcpFb(codec);
        });
        var maxptime = 0;
        caps.codecs.forEach(function (codec) {
          if (codec.maxptime > maxptime) {
            maxptime = codec.maxptime;
          }
        });

        if (maxptime > 0) {
          sdp += 'a=maxptime:' + maxptime + '\r\n';
        }

        sdp += 'a=rtcp-mux\r\n';

        if (caps.headerExtensions) {
          caps.headerExtensions.forEach(function (extension) {
            sdp += SDPUtils.writeExtmap(extension);
          });
        } // FIXME: write fecMechanisms.


        return sdp;
      }; // Parses the SDP media section and returns an array of
      // RTCRtpEncodingParameters.


      SDPUtils.parseRtpEncodingParameters = function (mediaSection) {
        var encodingParameters = [];
        var description = SDPUtils.parseRtpParameters(mediaSection);
        var hasRed = description.fecMechanisms.indexOf('RED') !== -1;
        var hasUlpfec = description.fecMechanisms.indexOf('ULPFEC') !== -1; // filter a=ssrc:... cname:, ignore PlanB-msid

        var ssrcs = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:').map(function (line) {
          return SDPUtils.parseSsrcMedia(line);
        }).filter(function (parts) {
          return parts.attribute === 'cname';
        });
        var primarySsrc = ssrcs.length > 0 && ssrcs[0].ssrc;
        var secondarySsrc;
        var flows = SDPUtils.matchPrefix(mediaSection, 'a=ssrc-group:FID').map(function (line) {
          var parts = line.substr(17).split(' ');
          return parts.map(function (part) {
            return parseInt(part, 10);
          });
        });

        if (flows.length > 0 && flows[0].length > 1 && flows[0][0] === primarySsrc) {
          secondarySsrc = flows[0][1];
        }

        description.codecs.forEach(function (codec) {
          if (codec.name.toUpperCase() === 'RTX' && codec.parameters.apt) {
            var encParam = {
              ssrc: primarySsrc,
              codecPayloadType: parseInt(codec.parameters.apt, 10)
            };

            if (primarySsrc && secondarySsrc) {
              encParam.rtx = {
                ssrc: secondarySsrc
              };
            }

            encodingParameters.push(encParam);

            if (hasRed) {
              encParam = JSON.parse(JSON.stringify(encParam));
              encParam.fec = {
                ssrc: primarySsrc,
                mechanism: hasUlpfec ? 'red+ulpfec' : 'red'
              };
              encodingParameters.push(encParam);
            }
          }
        });

        if (encodingParameters.length === 0 && primarySsrc) {
          encodingParameters.push({
            ssrc: primarySsrc
          });
        } // we support both b=AS and b=TIAS but interpret AS as TIAS.


        var bandwidth = SDPUtils.matchPrefix(mediaSection, 'b=');

        if (bandwidth.length) {
          if (bandwidth[0].indexOf('b=TIAS:') === 0) {
            bandwidth = parseInt(bandwidth[0].substr(7), 10);
          } else if (bandwidth[0].indexOf('b=AS:') === 0) {
            // use formula from JSEP to convert b=AS to TIAS value.
            bandwidth = parseInt(bandwidth[0].substr(5), 10) * 1000 * 0.95 - 50 * 40 * 8;
          } else {
            bandwidth = undefined;
          }

          encodingParameters.forEach(function (params) {
            params.maxBitrate = bandwidth;
          });
        }

        return encodingParameters;
      }; // parses http://draft.ortc.org/#rtcrtcpparameters*


      SDPUtils.parseRtcpParameters = function (mediaSection) {
        var rtcpParameters = {}; // Gets the first SSRC. Note tha with RTX there might be multiple
        // SSRCs.

        var remoteSsrc = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:').map(function (line) {
          return SDPUtils.parseSsrcMedia(line);
        }).filter(function (obj) {
          return obj.attribute === 'cname';
        })[0];

        if (remoteSsrc) {
          rtcpParameters.cname = remoteSsrc.value;
          rtcpParameters.ssrc = remoteSsrc.ssrc;
        } // Edge uses the compound attribute instead of reducedSize
        // compound is !reducedSize


        var rsize = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-rsize');
        rtcpParameters.reducedSize = rsize.length > 0;
        rtcpParameters.compound = rsize.length === 0; // parses the rtcp-mux attrіbute.
        // Note that Edge does not support unmuxed RTCP.

        var mux = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-mux');
        rtcpParameters.mux = mux.length > 0;
        return rtcpParameters;
      }; // parses either a=msid: or a=ssrc:... msid lines and returns
      // the id of the MediaStream and MediaStreamTrack.


      SDPUtils.parseMsid = function (mediaSection) {
        var parts;
        var spec = SDPUtils.matchPrefix(mediaSection, 'a=msid:');

        if (spec.length === 1) {
          parts = spec[0].substr(7).split(' ');
          return {
            stream: parts[0],
            track: parts[1]
          };
        }

        var planB = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:').map(function (line) {
          return SDPUtils.parseSsrcMedia(line);
        }).filter(function (msidParts) {
          return msidParts.attribute === 'msid';
        });

        if (planB.length > 0) {
          parts = planB[0].value.split(' ');
          return {
            stream: parts[0],
            track: parts[1]
          };
        }
      }; // SCTP
      // parses draft-ietf-mmusic-sctp-sdp-26 first and falls back
      // to draft-ietf-mmusic-sctp-sdp-05


      SDPUtils.parseSctpDescription = function (mediaSection) {
        var mline = SDPUtils.parseMLine(mediaSection);
        var maxSizeLine = SDPUtils.matchPrefix(mediaSection, 'a=max-message-size:');
        var maxMessageSize;

        if (maxSizeLine.length > 0) {
          maxMessageSize = parseInt(maxSizeLine[0].substr(19), 10);
        }

        if (isNaN(maxMessageSize)) {
          maxMessageSize = 65536;
        }

        var sctpPort = SDPUtils.matchPrefix(mediaSection, 'a=sctp-port:');

        if (sctpPort.length > 0) {
          return {
            port: parseInt(sctpPort[0].substr(12), 10),
            protocol: mline.fmt,
            maxMessageSize: maxMessageSize
          };
        }

        var sctpMapLines = SDPUtils.matchPrefix(mediaSection, 'a=sctpmap:');

        if (sctpMapLines.length > 0) {
          var parts = SDPUtils.matchPrefix(mediaSection, 'a=sctpmap:')[0].substr(10).split(' ');
          return {
            port: parseInt(parts[0], 10),
            protocol: parts[1],
            maxMessageSize: maxMessageSize
          };
        }
      }; // SCTP
      // outputs the draft-ietf-mmusic-sctp-sdp-26 version that all browsers
      // support by now receiving in this format, unless we originally parsed
      // as the draft-ietf-mmusic-sctp-sdp-05 format (indicated by the m-line
      // protocol of DTLS/SCTP -- without UDP/ or TCP/)


      SDPUtils.writeSctpDescription = function (media, sctp) {
        var output = [];

        if (media.protocol !== 'DTLS/SCTP') {
          output = ['m=' + media.kind + ' 9 ' + media.protocol + ' ' + sctp.protocol + '\r\n', 'c=IN IP4 0.0.0.0\r\n', 'a=sctp-port:' + sctp.port + '\r\n'];
        } else {
          output = ['m=' + media.kind + ' 9 ' + media.protocol + ' ' + sctp.port + '\r\n', 'c=IN IP4 0.0.0.0\r\n', 'a=sctpmap:' + sctp.port + ' ' + sctp.protocol + ' 65535\r\n'];
        }

        if (sctp.maxMessageSize !== undefined) {
          output.push('a=max-message-size:' + sctp.maxMessageSize + '\r\n');
        }

        return output.join('');
      }; // Generate a session ID for SDP.
      // https://tools.ietf.org/html/draft-ietf-rtcweb-jsep-20#section-5.2.1
      // recommends using a cryptographically random +ve 64-bit value
      // but right now this should be acceptable and within the right range


      SDPUtils.generateSessionId = function () {
        return Math.random().toString().substr(2, 21);
      }; // Write boilder plate for start of SDP
      // sessId argument is optional - if not supplied it will
      // be generated randomly
      // sessVersion is optional and defaults to 2
      // sessUser is optional and defaults to 'thisisadapterortc'


      SDPUtils.writeSessionBoilerplate = function (sessId, sessVer, sessUser) {
        var sessionId;
        var version = sessVer !== undefined ? sessVer : 2;

        if (sessId) {
          sessionId = sessId;
        } else {
          sessionId = SDPUtils.generateSessionId();
        }

        var user = sessUser || 'thisisadapterortc'; // FIXME: sess-id should be an NTP timestamp.

        return 'v=0\r\n' + 'o=' + user + ' ' + sessionId + ' ' + version + ' IN IP4 127.0.0.1\r\n' + 's=-\r\n' + 't=0 0\r\n';
      };

      SDPUtils.writeMediaSection = function (transceiver, caps, type, stream) {
        var sdp = SDPUtils.writeRtpDescription(transceiver.kind, caps); // Map ICE parameters (ufrag, pwd) to SDP.

        sdp += SDPUtils.writeIceParameters(transceiver.iceGatherer.getLocalParameters()); // Map DTLS parameters to SDP.

        sdp += SDPUtils.writeDtlsParameters(transceiver.dtlsTransport.getLocalParameters(), type === 'offer' ? 'actpass' : 'active');
        sdp += 'a=mid:' + transceiver.mid + '\r\n';

        if (transceiver.direction) {
          sdp += 'a=' + transceiver.direction + '\r\n';
        } else if (transceiver.rtpSender && transceiver.rtpReceiver) {
          sdp += 'a=sendrecv\r\n';
        } else if (transceiver.rtpSender) {
          sdp += 'a=sendonly\r\n';
        } else if (transceiver.rtpReceiver) {
          sdp += 'a=recvonly\r\n';
        } else {
          sdp += 'a=inactive\r\n';
        }

        if (transceiver.rtpSender) {
          // spec.
          var msid = 'msid:' + stream.id + ' ' + transceiver.rtpSender.track.id + '\r\n';
          sdp += 'a=' + msid; // for Chrome.

          sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc + ' ' + msid;

          if (transceiver.sendEncodingParameters[0].rtx) {
            sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc + ' ' + msid;
            sdp += 'a=ssrc-group:FID ' + transceiver.sendEncodingParameters[0].ssrc + ' ' + transceiver.sendEncodingParameters[0].rtx.ssrc + '\r\n';
          }
        } // FIXME: this should be written by writeRtpDescription.


        sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc + ' cname:' + SDPUtils.localCName + '\r\n';

        if (transceiver.rtpSender && transceiver.sendEncodingParameters[0].rtx) {
          sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc + ' cname:' + SDPUtils.localCName + '\r\n';
        }

        return sdp;
      }; // Gets the direction from the mediaSection or the sessionpart.


      SDPUtils.getDirection = function (mediaSection, sessionpart) {
        // Look for sendrecv, sendonly, recvonly, inactive, default to sendrecv.
        var lines = SDPUtils.splitLines(mediaSection);

        for (var i = 0; i < lines.length; i++) {
          switch (lines[i]) {
            case 'a=sendrecv':
            case 'a=sendonly':
            case 'a=recvonly':
            case 'a=inactive':
              return lines[i].substr(2);

            default: // FIXME: What should happen here?

          }
        }

        if (sessionpart) {
          return SDPUtils.getDirection(sessionpart);
        }

        return 'sendrecv';
      };

      SDPUtils.getKind = function (mediaSection) {
        var lines = SDPUtils.splitLines(mediaSection);
        var mline = lines[0].split(' ');
        return mline[0].substr(2);
      };

      SDPUtils.isRejected = function (mediaSection) {
        return mediaSection.split(' ', 2)[1] === '0';
      };

      SDPUtils.parseMLine = function (mediaSection) {
        var lines = SDPUtils.splitLines(mediaSection);
        var parts = lines[0].substr(2).split(' ');
        return {
          kind: parts[0],
          port: parseInt(parts[1], 10),
          protocol: parts[2],
          fmt: parts.slice(3).join(' ')
        };
      };

      SDPUtils.parseOLine = function (mediaSection) {
        var line = SDPUtils.matchPrefix(mediaSection, 'o=')[0];
        var parts = line.substr(2).split(' ');
        return {
          username: parts[0],
          sessionId: parts[1],
          sessionVersion: parseInt(parts[2], 10),
          netType: parts[3],
          addressType: parts[4],
          address: parts[5]
        };
      }; // a very naive interpretation of a valid SDP.


      SDPUtils.isValidSDP = function (blob) {
        if (typeof blob !== 'string' || blob.length === 0) {
          return false;
        }

        var lines = SDPUtils.splitLines(blob);

        for (var i = 0; i < lines.length; i++) {
          if (lines[i].length < 2 || lines[i].charAt(1) !== '=') {
            return false;
          } // TODO: check the modifier a bit more.

        }

        return true;
      }; // Expose public methods.


      if (typeof module === 'object') {
        module.exports = SDPUtils;
      }
    }, {}]
  }, {}, [1]);
});
unwrapExports(adapter_no_edge_no_global);
var RTC_HOST = "https://rtcv3-test.qiniuapi.com";

function getAccessToken(_x26, _x27, _x28) {
  return _getAccessToken.apply(this, arguments);
}

function _getAccessToken() {
  _getAccessToken = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee129(roomAccess, roomToken, requestTimeout) {
    var appId, roomName, userId, url, qosItem, res;
    return _regeneratorRuntime.wrap(function _callee129$(_context129) {
      while (1) {
        switch (_context129.prev = _context129.next) {
          case 0:
            appId = roomAccess.appId, roomName = roomAccess.roomName, userId = roomAccess.userId;
            url = "".concat(RTC_HOST, "/v3/apps/").concat(appId, "/rooms/").concat(roomName, "/auth?user=").concat(userId, "&token=").concat(roomToken);

          case 2:
            if (!true) {
              _context129.next = 22;
              break;
            }

            qosItem = {
              auth_start_time: Date.now(),
              auth_dns_time: 0,
              auth_server_ip: "",
              room_token: roomToken
            };
            _context129.prev = 4;
            _context129.next = 7;
            return request(url, requestTimeout);

          case 7:
            res = _context129.sent;
            qos.addEvent("MCSAuth", __chunk_1._objectSpread({}, qosItem, {
              auth_take_time: Date.now() - qosItem.auth_start_time,
              auth_error_code: 0,
              auth_error_message: "",
              access_token: res.accessToken
            }));
            return _context129.abrupt("return", res);

          case 12:
            _context129.prev = 12;
            _context129.t0 = _context129["catch"](4);
            qos.addEvent("MCSAuth", __chunk_1._objectSpread({}, qosItem, {
              auth_take_time: Date.now() - qosItem.auth_start_time,
              auth_error_code: _context129.t0.retry === undefined ? -1 : Number(_context129.t0.message),
              auth_error_message: _context129.t0.retry === undefined ? _context129.t0.toString() : _context129.t0.message,
              access_token: ""
            }));

            if (!(_context129.t0.retry === false)) {
              _context129.next = 17;
              break;
            }

            throw ERROR_AUTH_FAILED(_context129.t0.message);

          case 17:
            _context129.next = 19;
            return timeout(1000);

          case 19:
            log.warning("can not get accessToken, retry.", ERROR_AUTH_FAILED(_context129.t0));

          case 20:
            _context129.next = 2;
            break;

          case 22:
          case "end":
            return _context129.stop();
        }
      }
    }, _callee129, this, [[4, 12]]);
  }));
  return _getAccessToken.apply(this, arguments);
}

function getRelayToken(_x29, _x30, _x31) {
  return _getRelayToken.apply(this, arguments);
}
/*
 * ws.ts
 * Copyright (C) 2018 disoul <disoul@DiSouldeMacBook-Pro.local>
 *
 * Distributed under terms of the MIT license.
*/


function _getRelayToken() {
  _getRelayToken = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee130(roomAccess, roomToken, requestTimeout) {
    var appId, roomName, userId, url, qosItem, res;
    return _regeneratorRuntime.wrap(function _callee130$(_context130) {
      while (1) {
        switch (_context130.prev = _context130.next) {
          case 0:
            appId = roomAccess.appId, roomName = roomAccess.roomName, userId = roomAccess.userId;
            url = "".concat(RTC_HOST, "/V3/Apps/").concat(appId, "/rooms/").concat(roomName, "/relay/token?user=").concat(userId, "&token=").concat(roomToken);

          case 2:
            if (!true) {
              _context130.next = 22;
              break;
            }

            qosItem = {
              auth_start_time: Date.now(),
              auth_dns_time: 0,
              auth_server_ip: "",
              room_token: roomToken
            };
            _context130.prev = 4;
            _context130.next = 7;
            return request(url, requestTimeout);

          case 7:
            res = _context130.sent;
            qos.addEvent("MCURelayAuth", __chunk_1._objectSpread({}, qosItem, {
              auth_take_time: Date.now() - qosItem.auth_start_time,
              auth_error_code: 0,
              auth_error_message: "",
              access_token: res.relayToken || "no relay token"
            }));
            return _context130.abrupt("return", res);

          case 12:
            _context130.prev = 12;
            _context130.t0 = _context130["catch"](4);
            qos.addEvent("MCURelayAuth", __chunk_1._objectSpread({}, qosItem, {
              auth_take_time: Date.now() - qosItem.auth_start_time,
              auth_error_code: _context130.t0.retry === undefined ? -1 : Number(_context130.t0.message),
              auth_error_message: _context130.t0.retry === undefined ? _context130.t0.toString() : _context130.t0.message,
              access_token: ""
            }));

            if (!(_context130.t0.retry === false)) {
              _context130.next = 17;
              break;
            }

            throw ERROR_RELAY_TOKEN(_context130.t0.message);

          case 17:
            _context130.next = 19;
            return timeout(1000);

          case 19:
            log.warning("can not get relayToken, retry.", ERROR_RELAY_TOKEN(_context130.t0));

          case 20:
            _context130.next = 2;
            break;

          case 22:
          case "end":
            return _context130.stop();
        }
      }
    }, _callee130, this, [[4, 12]]);
  }));
  return _getRelayToken.apply(this, arguments);
}

var SignalingState;

(function (SignalingState) {
  SignalingState[SignalingState["CONNECTING"] = 0] = "CONNECTING";
  SignalingState[SignalingState["OPEN"] = 1] = "OPEN";
  SignalingState[SignalingState["CLOSING"] = 2] = "CLOSING";
  SignalingState[SignalingState["CLOSED"] = 3] = "CLOSED";
})(SignalingState || (SignalingState = {}));

var JOIN_ROOM_ERROR$1 = error.JOIN_ROOM_ERROR,
    ERROR_RECONNECT_FAILED$1 = error.ERROR_RECONNECT_FAILED;

var SignalingWS =
/*#__PURE__*/
function (_EnhancedEventEmitter2) {
  _inherits(SignalingWS, _EnhancedEventEmitter2);

  function SignalingWS(token, capsdp, reconnectTimes, timeout, playerdata) {
    var _this30;

    var privileges = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : ["subscribe", "publish"];

    _classCallCheck(this, SignalingWS);

    _this30 = _possibleConstructorReturn(this, _getPrototypeOf(SignalingWS).call(this));
    _this30.privileges = [];
    /**
     * websocket 连接地址后加上 query
     * wss://bc1178-roomd.cloudvdn.com/v2/signaling => wss://bc1178-roomd.cloudvdn.com/v2/signaling?rpcid=XXXXXXXX
     */

    _this30.rpcid = randomStringGen(16);
    /**
     * 初始化 ws 开始时间
     */

    _this30.startInitTime = -1;
    /**
     * 如果为 0 说明鉴权完成，或者还没有开始鉴权
     */

    _this30.startAuthTime = 0;

    _this30.initWs = function () {
      var isUserAction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var ws = arguments.length > 1 ? arguments[1] : undefined;
      var url = arguments.length > 2 ? arguments[2] : undefined;
      return new Promise(function (resolve, reject) {
        if (_this30.ws && _this30.ws.readyState === WebSocket.OPEN) {
          _this30.ws.close();

          _this30.ws.onclose = null;
        }

        if (isUserAction) {
          _this30.ws = ws;

          _this30.setUrl(url);
        } else {
          _this30.startInitTime = Date.now();

          try {
            _this30.wsConnectTimeoutID = setTimeout(function () {
              if (_this30.ws) {
                _this30.ws.onopen = null;
                _this30.ws.onclose = null;
                _this30.ws.onerror = null;

                _this30.ws.close();
              }

              var errorMsg = _this30.wsConnectTimeout / 1000 + "s timeout";
              qos.addEvent("WebsocketConnect", {
                happy_dns_resolve_time: 0,
                happy_dns_take_effect: false,
                socket_node_info: _this30.url,
                socket_connect_time: Date.now() - _this30.startInitTime,
                socket_connect_success: false,
                socket_connect_error_message: errorMsg
              });
              _this30.startInitTime = -1;

              _this30.reconnect().catch(function (e) {
                log.warning("signaling: reconnect timeout error", e);
              });
            }, _this30.wsConnectTimeout);
            _this30.ws = new WebSocket(_this30.url);
            _this30._state = SignalingState.CONNECTING;
          } catch (e) {
            throw ERROR_FATAL("init signaling websocket faild!\nError: ".concat(e));
          }
        }

        _this30.ws.onerror = _this30.onWsError;
        _this30.ws.onclose = _this30.onWsClose.bind(_assertThisInitialized(_assertThisInitialized(_this30)), resolve, reject);

        var onWsOpen = function onWsOpen() {
          if (_this30.wsConnectTimeoutID) {
            clearTimeout(_this30.wsConnectTimeoutID);
          }

          _this30.emit("ws:onopen");

          log.log("signaling: websocket open", _this30.url);

          if (!isUserAction) {
            qos.addEvent("WebsocketConnect", {
              happy_dns_resolve_time: 0,
              happy_dns_take_effect: false,
              socket_node_info: _this30.url,
              socket_connect_time: Date.now() - _this30.startInitTime,
              socket_connect_success: true
            });
            _this30.startInitTime = -1;
          }

          _this30.ws.onmessage = _this30.onWsMsg;
          var authData = {
            token: _this30.accessToken,
            reconntoken: _this30.reconnectToken,
            agent: "".concat(__chunk_1.browser.name).concat(__chunk_1.browser.version),
            sdkversion: version,
            capsdp: _this30.capsdp,
            msgsn: _this30.customMsgNumber,
            supportdomain: true,
            privileges: _this30.privileges
          };

          if (_this30.playerdata) {
            authData.playerdata = _this30.playerdata;
          }

          _this30.startAuthTime = Date.now();

          _this30.request("auth", authData).then(function (msgData) {
            if (msgData.code !== 0) {
              qos.addEvent("SignalAuth", {
                auth_start_time: _this30.startAuthTime,
                auth_dns_time: 0,
                auth_server_ip: _this30.url,
                auth_error_code: msgData.code,
                auth_error_message: msgData.error,
                auth_take_time: Date.now() - _this30.startAuthTime,
                access_token: _this30.accessToken
              });
              _this30.startAuthTime = 0;
            }

            switch (msgData.code) {
              case 0:
                {
                  _this30.ws.onclose = _this30.onWsClose.bind(_assertThisInitialized(_assertThisInitialized(_this30)), null, null);
                  _this30.reconnectToken = msgData.reconntoken;
                  log.log("signaling: websocket authed");
                  _this30._state = SignalingState.OPEN;
                  qos.addEvent("SignalAuth", {
                    auth_start_time: _this30.startAuthTime,
                    auth_dns_time: 0,
                    auth_server_ip: _this30.url,
                    auth_error_code: 0,
                    auth_error_message: "",
                    auth_take_time: Date.now() - _this30.startAuthTime,
                    access_token: _this30.accessToken
                  });

                  _this30.emit("@signalingauth", msgData);

                  _this30.startAuthTime = 0;
                  resolve(msgData);
                  break;
                }

              case 10001: // 用户 token 错误

              case 10002: // 用户 token 过期

              case 10011: // 房间人数已满

              case 10022: // 房间已关闭

              case 10012: // 已经在其他设备登陆

              case 10004:
                {
                  // 重连失败，重连超时
                  _this30.emit("@error", msgData);

                  reject(ERROR_RECONNECT_FAILED$1(msgData.error));
                  break;
                }

              case 10005:
                {
                  // 重连失败，房间已被销毁
                  _this30.emit("@error", msgData);

                  reject(ERROR_RECONNECT_FAILED$1(msgData.error));
                }

              case 10052:
                {
                  log.debug("10052 auth, retry", isUserAction); // 媒体服务器宕机或者重启

                  _this30.reconnectToken = undefined;

                  if (isUserAction) {
                    reject(JOIN_ROOM_ERROR$1(msgData.code, msgData.error));
                    break;
                  } else {
                    _this30.emit("@error", msgData);

                    return;
                  }
                }

              case 10054:
                {
                  // 客户端与服务端编码能力不匹配
                  reject(UNSUPPORT_FMT(10054, msgData.error));
                  break;
                }

              default:
                reject(ERROR_FATAL(msgData.error));
                break;
            }

            if (msgData.code !== 0) {
              _this30.reconnectToken = undefined;
              _this30._state = SignalingState.CLOSED;

              _this30.release();
            }
          });
        };

        _this30.ws.onopen = function () {
          onWsOpen();
        };

        if (isUserAction) {
          onWsOpen();
        }
      });
    };

    _this30.onWsMsg = function (e) {
      // data 格式为 'xxx={ "a": 1, "b": 2 }'
      var data = e.data;

      _this30.emit("ws:onmessage", data);

      var index = data.indexOf("=");

      if (index > 0) {
        var msgType = data.substring(0, index);
        var payload = JSON.parse(data.substring(index + 1));

        _this30.receiveWsMsg(msgType, payload);
      } else {
        throw ERROR_FATAL("signaling model can not parse message: ".concat(data));
      }
    };

    _this30.onWsError = function (e) {
      if (_this30.wsConnectTimeoutID) {
        clearTimeout(_this30.wsConnectTimeoutID);
      }

      log.warning("signaling: websocket error", e);

      _this30.emit("@ws:error", e); // 只有当新建 ws 连接后，没有 open 成功的情况下，才打这个错误的点，仅仅用于表示建连时出错
      // 过程中出错的情况在 onClose 事件中打点


      if (_this30.startInitTime !== -1) {
        qos.addEvent("WebsocketConnect", {
          happy_dns_resolve_time: 0,
          happy_dns_take_effect: false,
          socket_node_info: _this30.url,
          socket_connect_time: Date.now() - _this30.startInitTime,
          socket_connect_success: false
        });
        _this30.startInitTime = -1;
      }
    };

    _this30.sendWsMsg = function (msgType, msgData) {
      if (_this30.ws.readyState !== WebSocket.OPEN) {
        throw WS_ABORT();
      }

      var jsonString = JSON.stringify(msgData);

      try {
        _this30.ws.send("".concat(msgType, "=").concat(jsonString));

        _this30.emit("send", msgType, msgData);
      } catch (e) {
        log.warning("signaling: websocket send error", e);

        _this30.reconnect().catch(function (e) {
          log.warning("signaling: reconnect error", e);
        });

        throw WS_ABORT();
      }
    };

    _this30.handlePing = function () {
      _this30.sendWsMsg("pong", {});

      if (_this30.reconnectTimeoutID) {
        clearTimeout(_this30.reconnectTimeoutID);
      }

      _this30.reconnectTimeoutID = setTimeout(function () {
        log.debug("signaling: websocket heartbeat timeout");

        _this30.reconnect().catch(function (e) {
          log.warning("signaling: reconnect error", e);
        });
      }, 9000);
    };

    _this30.receiveWsMsg = function (msgType, msgData) {
      _this30.emit("receive", msgType, msgData);

      switch (msgType) {
        case "ping":
          _this30.handlePing();

          break;

        case "auth-res":
          _this30.emit("@auth-res", msgData);

        case "pubpc-res":
        case "subpc-res":
        case "pub-tracks":
        case "webrtc-candidate":
        case "on-player-in":
        case "on-player-out":
        case "disconnect":
        case "mute-tracks":
        case "on-add-tracks":
        case "on-remove-tracks":
        case "on-player-reconnect":
        case "on-player-reconnect-in":
          _this30.emit(msgType, msgData);

          break;

        case "sub-res":
        case "unsub-res":
          _this30.emit(msgType, msgData);

          _this30.emit("".concat(msgType, "-").concat(msgData.streamid), msgData);

          break;

        case "control-res":
          _this30.emit(msgType, msgData);

          _this30.emit("".concat(msgType, "-").concat(msgData.command, "-").concat(msgData.playerid), msgData);

          break;

        case "on-pubpc-connected":
        case "on-pubpc-disconnected":
          _this30.emit("on-pubpc-state", {
            pcid: msgData.pcid,
            connected: msgType === "on-pubpc-connected"
          });

          _this30.emit("".concat(msgType, "-").concat(msgData.pcid), msgData);

          break;

        case "on-subpc-disconnected":
        case "on-subpc-connected":
          _this30.emit("on-subpc-state", {
            pcid: msgData.pcid,
            connected: msgType === "on-subpc-connected"
          });

          _this30.emit(msgType, msgData);

          break;

        case "pub-tracks-res":
          _this30.emit(msgType, msgData);

          break;

        case "on-messages":
        case "on-qos-messages":
          // 按照 msgsn 从小到大排序
          msgData.messages = msgData.messages.sort(function (a, b) {
            return a.msgsn - b.msgsn;
          });
          _this30.customMsgNumber = msgData.messages[msgData.messages.length - 1].msgsn;

          _this30.emit(msgType, msgData);

          break;

        case "unpub-tracks-res":
        case "sub-tracks-res":
        case "unsub-tracks-res":
        case "on-pubpc-restart-notify":
        case "on-subpc-restart-notify":
        case "set-sub-profile-res":
        case "on-sub-profile-changed":
        case "pubpc-restart-res":
        case "subpc-restart-res":
        case "create-merge-job-res":
        case "create-forward-job-res":
        case "stop-forward-res":
        case "on-job-connected":
        case "on-job-disconnected":
        case "on-merge-job-connected":
        case "on-merge-job-disconnected":
        case "update-merge-tracks-res":
        case "set-privileges-res":
        case "start-media-relay-res":
        case "update-media-relay-res":
        case "stop-media-relay-res":
        case "on-media-relay-state":
          _this30.emit(msgType, msgData);

          break;

        default:
          break;
      }
    };

    _this30.accessToken = token;
    _this30.capsdp = capsdp;
    _this30.reconnectTimes = reconnectTimes;
    _this30.wsConnectTimeout = timeout;
    _this30.playerdata = playerdata;
    _this30.privileges = privileges;
    _this30._state = SignalingState.CONNECTING;
    return _this30;
  }

  _createClass(SignalingWS, [{
    key: "setUrl",
    value: function setUrl(url) {
      this.url = url + "?rpcid=".concat(this.rpcid);
    }
  }, {
    key: "onWsClose",
    value: function onWsClose(resolve, reject, e) {
      if (this.wsConnectTimeoutID) {
        clearTimeout(this.wsConnectTimeoutID);
      }

      this._state = SignalingState.CLOSED;
      log.warning("signaling: websocket onclose", e);

      if (this.startAuthTime) {
        qos.addEvent("SignalAuth", {
          auth_start_time: this.startAuthTime,
          auth_dns_time: 0,
          auth_server_ip: this.url,
          auth_error_code: e.code,
          auth_error_message: e.toString(),
          auth_take_time: Date.now() - this.startAuthTime,
          access_token: this.accessToken
        });
      }

      var reconnectPromise = this.reconnectPromise; // See http://tools.ietf.org/html/rfc6455#section-7.4.1

      switch (e.code) {
        case 1000:
          {
            // Normal closure, meaning that the purpose for which the connection was established has been fulfilled.
            this.emit("@closed");
            break;
          }

        case 1001:
          {
            // An endpoint is "going away", such as a server going down or a browser having navigated away from a page.
            reconnectPromise = this.reconnect();
            break;
          }

        case 1005:
          {
            // No status code was actually present.
            reconnectPromise = this.reconnect();
            break;
          }

        case 1006:
          {
            // The connection was closed abnormally, e.g., without sending or receiving a Close control frame
            reconnectPromise = this.reconnect();
            break;
          }

        case 1007:
          {
            // An endpoint is terminating the connection because it has received data within a message that was not consistent with the type of the message (e.g., non-UTF-8 [http://tools.ietf.org/html/rfc3629] data within a text message).
            break;
          }

        case 1008:
          {
            // An endpoint is terminating the connection because it has received a message that "violates its policy". This reason is given either if there is no other sutible reason, or if there is a need to hide specific details about the policy.
            break;
          }

        case 1009:
          {
            // An endpoint is terminating the connection because it has received a message that is too big for it to process.
            break;
          }

        case 1010:
          {
            // Note that this status code is not used by the server, because it can fail the WebSocket handshake instead.
            // An endpoint (client) is terminating the connection because it has expected the server to negotiate one or more extension, but the server didn't return them in the response message of the WebSocket handshake.
            // Specifically, the extensions that are needed are: " + e.reason
            break;
          }

        case 1011:
          {
            // A server is terminating the connection because it encountered an unexpected condition that prevented it from fulfilling the request.
            reconnectPromise = this.reconnect();
            break;
          }
        // https://www.ietf.org/mail-archive/web/hybi/current/msg09670.html

        case 1012:
          {
            // the service is restarted. a client may reconnect,
            // and if it choses to do, should reconnect using a randomized delay of 5 - 30s.
            reconnectPromise = this.reconnect(5000);
            break;
          }

        case 1013:
          {
            // The server is terminating the connection due to a temporary condition,
            // e.g. it is overloaded and is casting off some of its clients.
            reconnectPromise = this.reconnect();
            break;
          }

        case 1014:
          {
            // The server was acting as a gateway or proxy and received an invalid response from the upstream server.
            // This is similar to 502 HTTP Status Code.
            reconnectPromise = this.reconnect(5000);
            break;
          }

        case 1015:
          {
            // The connection was closed due to a failure to perform a TLS handshake (e.g., the server certificate can't be verified).
            break;
          }

        default:
          {
            // Others
            break;
          }
      }

      if (resolve && reject) {
        // 重连成功，则返回继续后续逻辑，重连失败不再抛出错误，通过事件错误码通知客户
        if (reconnectPromise) {
          reconnectPromise.then(resolve).catch(function (e) {
            log.warning("signaling: reconnect error", e);
          });
        } else {
          // 这里表示原生 ws 错误，且不主动重连的情况，直接抛出
          reject(e);
        }
      }
    }
  }, {
    key: "sendDisconnect",
    value: function sendDisconnect() {
      if (this.state !== SignalingState.OPEN) {
        return;
      }

      try {
        this.sendWsMsg("disconnect", {});
      } catch (error) {// abort error
      }
    }
  }, {
    key: "reconnect",
    value: function reconnect() {
      var _this31 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;

      // 每次连接已经确认断开后，本地 heartbeat 都需要删除
      if (this.reconnectTimeoutID) {
        clearTimeout(this.reconnectTimeoutID);
      }

      if (this.wsConnectTimeoutID) {
        clearTimeout(this.wsConnectTimeoutID);
      }

      if (this.reconnectPromise && this._state === SignalingState.CONNECTING) {
        return this.reconnectPromise;
      }

      if (this.currentLeftReconnectTimes <= 0) {
        /**
         * 注意这里的 10007 为自定义的 code，用于表示重连次数用完仍然无法成功建立 ws 连接
         * 与 server 返回的 code 不相通
         * 注意 10007 与 server 返回的 10004 的区别，10004 表示 reconnect token 过期
         */
        this.emit("@error", {
          code: 10007
        });
        return Promise.reject("websocket reconnectTimes run out, reconnect stops.");
      }

      this.currentLeftReconnectTimes -= 1;
      this._state = SignalingState.CONNECTING;
      log.debug("signaling: websocket reconnecting, currentLeftReconnectTimes remaining: ", this.currentLeftReconnectTimes);
      this.reconnectPromise = timeout(time).then(function () {
        return _this31.initWs();
      }).then(function (res) {
        _this31.reconnectPromise = undefined;
        _this31.currentLeftReconnectTimes = _this31.reconnectTimes;
        return res;
      }).catch(function (e) {
        _this31._state = SignalingState.CLOSED;

        _this31.emit("error", e);

        return Promise.reject(e);
      });
      return this.reconnectPromise;
    }
    /**
     * request
     */

  }, {
    key: "request",
    value: function request(method, data) {
      var _this32 = this;

      var rpcid = randomStringGen(8);
      data.rpcid = rpcid;
      log.log("ws request", rpcid, method, data);
      this.sendWsMsg(method, data);
      return new Promise(function (resolve) {
        var onres = function onres(data) {
          if (data.rpcid === rpcid) {
            log.log("ws response", rpcid, method, data);

            _this32.off("".concat(method, "-res"), onres);

            resolve(data);
          }
        };

        _this32.on("".concat(method, "-res"), onres);
      });
    }
  }, {
    key: "release",
    value: function release() {
      if (this.reconnectTimeoutID) {
        clearTimeout(this.reconnectTimeoutID);
      }

      if (this.wsConnectTimeoutID) {
        clearTimeout(this.wsConnectTimeoutID);
      }

      this.removeEvent();

      if (this.ws) {
        this.ws.onopen = null;
        this.ws.onclose = null;
        this.ws.onerror = null;
        this.ws.close();
      }
    }
  }, {
    key: "_state",
    set: function set(state) {
      this.emit("@ws-state-change", this.__state, state);
      this.__state = state;
    }
  }, {
    key: "state",
    get: function get() {
      return this.__state;
    }
  }, {
    key: "reconnectTimes",
    set: function set(n) {
      this._reconnectTimes = n;
      this.currentLeftReconnectTimes = n;
    },
    get: function get() {
      return this._reconnectTimes;
    }
  }]);

  return SignalingWS;
}(EnhancedEventEmitter);
/*
 * merger.ts
 * Copyright (C) 2018 disoul <disoul@DiSouldeMacBook-Pro.local>
 *
 * Distributed under terms of the MIT license.
*/


var MergerSessionController = function MergerSessionController() {
  _classCallCheck(this, MergerSessionController);
};

var Merger =
/*#__PURE__*/
function () {
  function Merger(width, height, controller, jobID) {
    var _this33 = this;

    _classCallCheck(this, Merger);

    this.videoTrackInfo = [];
    this.audioTrackInfo = [];
    this.layoutLevel = 0;
    this.width = width;
    this.height = height;
    this.jobID = jobID;
    this.controller = controller;
    this.controller.getCurrentTracks().forEach(function (track) {
      if (track.kind === "audio") {
        _this33.audioTrackInfo.push(track);
      } else {
        _this33.videoTrackInfo.push(track);
      }
    });
    this.controller.addMergeTrack(this.audioTrackInfo.map(function (t) {
      return {
        trackID: t.trackID
      };
    }), this.jobID);
    this.initLayout();

    this.controller.onAddTracks = function (tracks) {
      var audioTracks = tracks.filter(function (t) {
        return t.kind === "audio";
      });
      var videoTracks = tracks.filter(function (t) {
        return t.kind === "video";
      });

      _this33.controller.addMergeTrack(audioTracks.map(function (t) {
        return {
          trackID: t.trackID
        };
      }), _this33.jobID);

      videoTracks.forEach(_this33.handleAddVideoTrack.bind(_this33));
    };

    this.controller.onRemoveTracks = function (tracks) {
      var videoTracks = tracks.filter(function (t) {
        return t.kind === "video";
      });
      videoTracks.forEach(_this33.handleRemoveVideoTrack.bind(_this33));
    };

    log.log("init default merger, init layout: ", this.layout);
  }

  _createClass(Merger, [{
    key: "initLayout",
    value: function initLayout() {
      var streamCount = this.videoTrackInfo.length;
      this.layoutLevel = 0;
      this.layout = {
        "level-0": {
          items: {
            "item-0": {
              x: 0,
              y: 0,
              isExpand: false,
              isExpanded: false,
              index: 0
            }
          },
          itemWidth: this.width,
          itemHeight: this.height,
          maxItems: 1,
          currentItems: 0,
          splitWidthFlag: this.width < this.height
        }
      };
      var splitWidthFlag = this.width >= this.height;

      if (streamCount === 0) {
        return;
      }

      while (Math.pow(2, this.layoutLevel) < streamCount) {
        this.updateLayoutLevel(splitWidthFlag);
        splitWidthFlag = !splitWidthFlag;
      }

      this.setLevelLayoutStream();
    }
  }, {
    key: "updateLayoutLevel",
    value: function updateLayoutLevel(splitWidthFlag) {
      var _this34 = this;

      var currentLayout = this.layout["level-".concat(this.layoutLevel)];
      var currentWidth = currentLayout.itemWidth;
      var currentHeight = currentLayout.itemHeight;
      this.layoutLevel += 1;
      var maxItems = Math.pow(2, this.layoutLevel);
      var itemWidth = splitWidthFlag ? currentWidth / 2.0 : currentWidth;
      var itemHeight = splitWidthFlag ? currentHeight : currentHeight / 2.0;

      if (this.layoutLevel === 1) {
        this.layout["level-".concat(this.layoutLevel)] = {
          items: {
            "item-0": {
              x: 0,
              y: 0,
              isExpand: false,
              isExpanded: false,
              index: 0
            },
            "item-1": {
              x: this.width >= this.height ? itemWidth : 0,
              y: this.width < this.height ? itemHeight : 0,
              isExpand: false,
              isExpanded: false,
              index: 1
            }
          },
          maxItems: maxItems,
          currentItems: 0,
          itemWidth: itemWidth,
          itemHeight: itemHeight,
          splitWidthFlag: splitWidthFlag
        };
      } else {
        this.layout["level-".concat(this.layoutLevel)] = {
          items: {},
          maxItems: maxItems,
          currentItems: 0,
          itemWidth: itemWidth,
          itemHeight: itemHeight,
          splitWidthFlag: splitWidthFlag
        };
        var levelItems = this.layout["level-".concat(this.layoutLevel)].items;
        Object.keys(this.layout["level-".concat(this.layoutLevel - 1)].items).forEach(function (itemIndex) {
          var item = _this34.layout["level-".concat(_this34.layoutLevel - 1)].items[itemIndex];

          var newIndex = 2 * item.index;
          levelItems["item-".concat(newIndex)] = {
            x: item.x,
            y: item.y,
            isExpand: false,
            isExpanded: false,
            index: newIndex
          };

          if (splitWidthFlag) {
            levelItems["item-".concat(newIndex + 1)] = {
              x: item.x + itemWidth,
              y: item.y,
              isExpand: false,
              isExpanded: false,
              index: newIndex + 1
            };
          } else {
            levelItems["item-".concat(newIndex + 1)] = {
              x: item.x,
              y: item.y + itemHeight,
              isExpand: false,
              isExpanded: false,
              index: newIndex + 1
            };
          }
        });
      }

      log.log("merger: increase layout level, current level: ".concat(this.layoutLevel), this.layout);
    }
  }, {
    key: "setLevelLayoutStream",
    value: function setLevelLayoutStream() {
      var streamCount = this.videoTrackInfo.length;
      var currentLevelLayout = this.layout["level-".concat(this.layoutLevel)];
      var expandCount = currentLevelLayout.maxItems - streamCount;
      var streamIndex = 0;

      for (var i = 0; i < currentLevelLayout.maxItems; i += 1) {
        if (expandCount > 0) {
          if (i % 2 === 0) {
            currentLevelLayout.items["item-".concat(i)].isExpand = true;
            currentLevelLayout.items["item-".concat(i)].trackID = this.videoTrackInfo[streamIndex].trackID;
            this.sendMergeOpt(this.layoutLevel, i);
            streamIndex += 1;
          } else {
            currentLevelLayout.items["item-".concat(i)].isExpanded = true;
            expandCount -= 1;
          }
        } else {
          currentLevelLayout.items["item-".concat(i)].trackID = this.videoTrackInfo[streamIndex].trackID;
          this.sendMergeOpt(this.layoutLevel, i);
          streamIndex += 1;
        }
      }

      currentLevelLayout.currentItems = streamCount;
    }
  }, {
    key: "sendMergeOpt",
    value: function sendMergeOpt(level, index) {
      var levelLayout = this.layout["level-".concat(level)];
      var item = levelLayout.items["item-".concat(index)];

      if (!item.trackID || item.isExpanded) {
        return;
      }

      var width = levelLayout.itemWidth;
      var height = levelLayout.itemHeight;

      if (item.isExpand) {
        if (levelLayout.splitWidthFlag) {
          width = width * 2;
        } else {
          height = height * 2;
        }
      }

      var option = {
        x: item.x,
        y: item.y,
        w: width,
        h: height,
        z: 0,
        trackID: item.trackID
      };
      this.controller.addMergeTrack([option], this.jobID);
    }
  }, {
    key: "handleRemoveVideoTrack",
    value: function handleRemoveVideoTrack(track) {
      remove(this.videoTrackInfo, function (t) {
        return t.trackID === track.trackID;
      });
      var levelLayout = this.layout["level-".concat(this.layoutLevel)];

      if (this.layoutLevel > 0 && this.videoTrackInfo.length <= this.layout["level-".concat(this.layoutLevel - 1)].maxItems) {
        this.layoutLevel -= 1;
        log.log("merger: reduce layout level, current level: ".concat(this.layoutLevel), this.layout);
        this.setLevelLayoutStream();
      } else {
        for (var itemKey in levelLayout.items) {
          var item = levelLayout.items[itemKey];

          if (item.trackID === track.trackID) {
            if (item.index % 2 === 0) {
              if (levelLayout.items["item-".concat(item.index + 1)]) {
                item.isExpand = true;
                item.trackID = levelLayout.items["item-".concat(item.index + 1)].trackID;
                levelLayout.items["item-".concat(item.index + 1)].isExpanded = true;
                levelLayout.items["item-".concat(item.index + 1)].trackID = undefined;
              } else {
                item.trackID = undefined;
              }

              this.sendMergeOpt(this.layoutLevel, item.index);
            } else {
              item.isExpanded = true;
              item.trackID = undefined;
              levelLayout.items["item-".concat(item.index - 1)].isExpand = true;
              this.sendMergeOpt(this.layoutLevel, item.index - 1);
            }

            break;
          }
        }
      }
    }
  }, {
    key: "handleAddVideoTrack",
    value: function handleAddVideoTrack(track) {
      var lastLength = this.videoTrackInfo.length;
      this.videoTrackInfo.push(track);
      this.videoTrackInfo = uniqBy(this.videoTrackInfo, "trackID"); // 如果重复添加了 trackID 就忽略

      if (this.videoTrackInfo.length === lastLength) {
        log.log("handle add video track ignore", track);
        return;
      }

      var levelLayout = this.layout["level-".concat(this.layoutLevel)];

      if (this.videoTrackInfo.length <= levelLayout.maxItems) {
        for (var itemKey in levelLayout.items) {
          var item = levelLayout.items[itemKey];

          if (!item.trackID) {
            item.trackID = track.trackID;

            if (item.isExpanded) {
              item.isExpanded = false;
              levelLayout.items["item-".concat(item.index - 1)].isExpand = false;
              this.sendMergeOpt(this.layoutLevel, item.index - 1);
            }

            this.sendMergeOpt(this.layoutLevel, item.index);
            break;
          }
        }

        levelLayout.currentItems = this.videoTrackInfo.length;
      } else {
        // 需要提升 level
        this.updateLayoutLevel(!levelLayout.splitWidthFlag);
        this.setLevelLayoutStream();
      }
    }
  }, {
    key: "release",
    value: function release() {
      this.controller.release();
    }
  }]);

  return Merger;
}();
/**
 * @public
 * 房间连接状态
 */


(function (QNConnectionState) {
  /**
   * 初始状态
   */
  QNConnectionState["DISCONNECTED"] = "DISCONNECTED";
  /**
   * 正在连接
   */

  QNConnectionState["CONNECTING"] = "CONNECTING";
  /**
   * 连接成功
   */

  QNConnectionState["CONNECTED"] = "CONNECTED";
  /**
   * 正在重连
   */

  QNConnectionState["RECONNECTING"] = "RECONNECTING";
  /**
   * 重连成功
   */

  QNConnectionState["RECONNECTED"] = "RECONNECTED";
})(exports.QNConnectionState || (exports.QNConnectionState = {}));

(function (QNDeviceState) {
  /**
   * 设备插入
   */
  QNDeviceState["ACTIVE"] = "ACTIVE";
  /**
   * 设备拔出
   */

  QNDeviceState["INACTIVE"] = "INACTIVE";
})(exports.QNDeviceState || (exports.QNDeviceState = {}));
/**
 * @public
 * 视频采集编码预设值数组
 */


var SUPPORT_VIDEO_ENCODER_CONFIG_LIST = {
  "360p": {
    width: 640,
    height: 360,
    frameRate: 15,
    bitrate: 400
  },
  "480p": {
    width: 640,
    height: 480,
    frameRate: 15,
    bitrate: 500
  },
  "720p": {
    width: 1280,
    height: 720,
    frameRate: 30,
    bitrate: 1130
  },
  "1080p": {
    width: 1920,
    height: 1080,
    frameRate: 30,
    bitrate: 2080
  },
  "1440p": {
    width: 2560,
    height: 1440,
    frameRate: 30,
    bitrate: 4850
  },
  "4k": {
    width: 3840,
    height: 2160,
    frameRate: 30,
    bitrate: 8910
  }
};
/**
 * @internal
 */

var defaultVideoEncoderConfiguration = SUPPORT_VIDEO_ENCODER_CONFIG_LIST["480p"];
/**
 * @public
 * 音频采集编码预设值数组
 */

var AUDIO_ENCODER_CONFIG_SETTINGS = {
  LOW: {
    sampleRate: 16000,
    stereo: false,
    bitrate: 24,
    sampleSize: 16
  },
  STANDARD: {
    sampleRate: 48000,
    stereo: false,
    bitrate: 64,
    sampleSize: 16
  },
  STANDARD_STEREO: {
    sampleRate: 48000,
    stereo: true,
    bitrate: 80,
    sampleSize: 16
  },
  HIGH: {
    sampleRate: 48000,
    stereo: false,
    bitrate: 96,
    sampleSize: 16
  },
  HIGH_STEREO: {
    sampleRate: 48000,
    stereo: true,
    bitrate: 128,
    sampleSize: 16
  }
};
/**
 * @internal
 */

var defaultAudioEncoderConfiguration = AUDIO_ENCODER_CONFIG_SETTINGS["STANDARD"];
/**
 * @public
 * 屏幕分享采集编码预设值数组
 */

var SUPPORT_SCREEN_ENCODER_CONFIG_LIST = {
  "480p": {
    width: 640,
    height: 480,
    frameRate: 5
  },
  "720p": {
    width: 1280,
    height: 720,
    frameRate: 5
  },
  "1080p": {
    width: 1920,
    height: 1080,
    frameRate: 5
  }
};
/**
 * @internal
 */

var defaultScreenEncoderConfiguration = SUPPORT_SCREEN_ENCODER_CONFIG_LIST["720p"];

(function (QNChromeExtensionSourceType) {
  /**
   * 窗口采集
   */
  QNChromeExtensionSourceType["WINDOW"] = "window";
  /**
   * 屏幕采集
   */

  QNChromeExtensionSourceType["SCREEN"] = "screen";
  /**
   * 全部数据源
   */

  QNChromeExtensionSourceType["ALL"] = "all";
})(exports.QNChromeExtensionSourceType || (exports.QNChromeExtensionSourceType = {}));

(function (QNAudioSourceState) {
  /**
   * 播放中
   */
  QNAudioSourceState["PlAYING"] = "PlAYING";
  /**
   * 暂停
   */

  QNAudioSourceState["PAUSED"] = "PAUSED";
  /**
   * 停止
   */

  QNAudioSourceState["STOPPED"] = "STOPPED";
})(exports.QNAudioSourceState || (exports.QNAudioSourceState = {}));

(function (QNRenderMode) {
  /**
   * 视频被拉伸以填充视图的大小，而不需要保持长宽比
   */
  QNRenderMode["FILL"] = "scaleToFit";
  /**
   * 默认值, 视频通过保持长宽比来填充视图的大小。视频的某些部分可能被剪切
   */

  QNRenderMode["ASPECT_FILL"] = "aspectFill";
  /**
   * 通过保持宽高比(可能显示黑色边框)，视频被缩放以适应视图的大小
   */

  QNRenderMode["ASPECT_FIT"] = "aspectFit";
})(exports.QNRenderMode || (exports.QNRenderMode = {}));

(function (QNLiveStreamingState) {
  /**
   * 已开始
   */
  QNLiveStreamingState["STARTED"] = "STARTED";
  /**
   * 已停止
   */

  QNLiveStreamingState["STOPPED"] = "STOPPED";
})(exports.QNLiveStreamingState || (exports.QNLiveStreamingState = {}));

(function (QNNetworkQuality) {
  /**
   * 网络质量未知
   */
  QNNetworkQuality["UNKNOWN"] = "UNKNOWN";
  /**
   * 质量极好
   */

  QNNetworkQuality["EXCELLENT"] = "EXCELLENT";
  /**
   * 用户主观感觉和极好差不多，但码率可能略低于极好
   */

  QNNetworkQuality["GOOD"] = "GOOD";
  /**
   * 网络一般
   */

  QNNetworkQuality["FAIR"] = "FAIR";
  /**
   * 网络质量差，影响正常通信
   */

  QNNetworkQuality["POOR"] = "POOR";
})(exports.QNNetworkQuality || (exports.QNNetworkQuality = {}));

(function (QNTrackProfile) {
  /**
   * 低分辨率
   */
  QNTrackProfile["LOW"] = "LOW";
  /**
   * 中分辨率
   */

  QNTrackProfile["MEDIUM"] = "MEDIUM";
  /**
   * 高分辨率
   */

  QNTrackProfile["HIGH"] = "HIGH";
})(exports.QNTrackProfile || (exports.QNTrackProfile = {}));

(function (QNConnectionDisconnectedReason) {
  /**
   * 主动退出
   */
  QNConnectionDisconnectedReason["LEAVE"] = "LEAVE";
  /**
   * 被踢出房间
   */

  QNConnectionDisconnectedReason["KICKED_OUT"] = "KICKED_OUT";
  /**
   * 发生错误，异常断开
   */

  QNConnectionDisconnectedReason["ERROR"] = "ERROR";
})(exports.QNConnectionDisconnectedReason || (exports.QNConnectionDisconnectedReason = {}));

(function (QNLogLevel) {
  /**
   * VERBOSE 级别日志打印
   */
  QNLogLevel["VERBOSE"] = "VERBOSE";
  /**
   * INFO 级别日志打印
   */

  QNLogLevel["INFO"] = "INFO";
  /**
   * WARNING 级别日志打印
   */

  QNLogLevel["WARNING"] = "WARNING";
  /**
   * ERROR 级别日志打印
   */

  QNLogLevel["ERROR"] = "ERROR";
  /**
   * 关闭日志打印
   */

  QNLogLevel["NONE"] = "NONE";
})(exports.QNLogLevel || (exports.QNLogLevel = {}));

(function (QNTransportPolicy) {
  /**
   * 强制使用 UDP
   */
  QNTransportPolicy["FORCE_UDP"] = "FORCE_UDP";
  /**
   * 强制使用 TCP
   */

  QNTransportPolicy["FORCE_TCP"] = "FORCE_TCP";
  /**
   * 优先使用 UDP
   */

  QNTransportPolicy["PREFER_UDP"] = "PREFER_UDP";
})(exports.QNTransportPolicy || (exports.QNTransportPolicy = {}));

(function (QNVideoOptimizationMode) {
  /**
   * 流畅优先
   */
  QNVideoOptimizationMode["MOTION"] = "motion";
  /**
   * 清晰度优先
   */

  QNVideoOptimizationMode["DETAIL"] = "detail";
  /**
   * 由 SDK 自动判断
   */

  QNVideoOptimizationMode["DEFAULT"] = "";
})(exports.QNVideoOptimizationMode || (exports.QNVideoOptimizationMode = {}));

(function (QNElectronScreenSourceType) {
  /**
   * 分享整个屏幕
   */
  QNElectronScreenSourceType["SCREEN"] = "screen";
  /**
   * 分享应用窗口
   */

  QNElectronScreenSourceType["WINDOW"] = "window";
  /**
   * 所有数据源
   */

  QNElectronScreenSourceType["ALL"] = "all";
})(exports.QNElectronScreenSourceType || (exports.QNElectronScreenSourceType = {}));

(function (QNClientMode) {
  /**
   * 通信场景
   */
  QNClientMode["RTC"] = "RTC";
  /**
   * 互动直播场景
   */

  QNClientMode["LIVE"] = "LIVE";
})(exports.QNClientMode || (exports.QNClientMode = {}));

(function (QNClientRole) {
  /**
   * 主播
   */
  QNClientRole["BROADCASTER"] = "BROADCASTER";
  /**
   * 观众
   */

  QNClientRole["AUDIENCE"] = "AUDIENCE";
})(exports.QNClientRole || (exports.QNClientRole = {}));

(function (QNMediaRelayState) {
  /**
   * 成功
   */
  QNMediaRelayState[QNMediaRelayState["SUCCESS"] = 0] = "SUCCESS";
  /**
   * 主动退出
   */

  QNMediaRelayState[QNMediaRelayState["STOPPED"] = 1] = "STOPPED";
  /**
   * 无效 token
   */

  QNMediaRelayState[QNMediaRelayState["INVALID_TOKEN"] = 2] = "INVALID_TOKEN";
  /**
   * 目标房间不存在
   */

  QNMediaRelayState[QNMediaRelayState["NO_ROOM"] = 3] = "NO_ROOM";
  /**
   * 目标房间已关闭
   */

  QNMediaRelayState[QNMediaRelayState["ROOM_CLOSED"] = 4] = "ROOM_CLOSED";
  /**
   * 目标房间存在相同用户名的用户
   */

  QNMediaRelayState[QNMediaRelayState["PLAYER_EXISTED"] = 5] = "PLAYER_EXISTED";
})(exports.QNMediaRelayState || (exports.QNMediaRelayState = {}));

var ImageUtils =
/*#__PURE__*/
function () {
  function ImageUtils() {
    _classCallCheck(this, ImageUtils);
  }

  _createClass(ImageUtils, null, [{
    key: "loadImage",
    value: function loadImage(source) {
      if (source instanceof File) {
        return ImageUtils.loadImageFromFile(source);
      } else if (source instanceof ArrayBuffer) {
        return ImageUtils.loadImageFromArrayBuffer(source);
      } else if (typeof source === "string") {
        return ImageUtils.loadImageFromUrl(source);
      } else {
        throw ERROR_NOT_SUPPORT("unsupported image source");
      }
    }
  }, {
    key: "loadImageFromUrl",
    value: function loadImageFromUrl(url) {
      return new Promise(function (resolve, reject) {
        var img = new Image();
        img.crossOrigin = "Anonymous";
        img.src = url;

        img.onload = function () {
          resolve(img);
        };

        img.onerror = function (error) {
          reject(error);
        };
      });
    }
  }, {
    key: "loadImageFromFile",
    value: function loadImageFromFile(file) {
      return new Promise(function (resolve, reject) {
        var fileReader = new FileReader();

        fileReader.onload = function (e) {
          if (fileReader.result) {
            resolve(ImageUtils.loadImageFromUrl(fileReader.result));
          }
        };

        fileReader.onerror = function (e) {
          reject(e);
        };

        fileReader.readAsDataURL(file);
      });
    }
  }, {
    key: "loadImageFromArrayBuffer",
    value: function loadImageFromArrayBuffer(arrayBuffer) {
      return new Promise(function (resolve, reject) {
        var blob = new Blob([arrayBuffer]);
        var url = URL.createObjectURL(blob);
        resolve(ImageUtils.loadImageFromUrl(url));
      });
    }
  }]);

  return ImageUtils;
}();

var ImageStreamTrack =
/*#__PURE__*/
function () {
  function ImageStreamTrack() {
    _classCallCheck(this, ImageStreamTrack);

    this.canvas = document.createElement("canvas");
    this.ctx = this.canvas.getContext("2d");
  }

  _createClass(ImageStreamTrack, [{
    key: "setSource",
    value: function () {
      var _setSource = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10(source) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!(source === this.source)) {
                  _context10.next = 2;
                  break;
                }

                return _context10.abrupt("return");

              case 2:
                this.source = source;
                _context10.next = 5;
                return this.createImageStreamTrack(source);

              case 5:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function setSource(_x32) {
        return _setSource.apply(this, arguments);
      }

      return setSource;
    }()
  }, {
    key: "createImageStreamTrack",
    value: function () {
      var _createImageStreamTrack = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11(source) {
        var _this35 = this;

        var image, stream;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (!(source instanceof File)) {
                  _context11.next = 6;
                  break;
                }

                _context11.next = 3;
                return ImageUtils.loadImageFromFile(source);

              case 3:
                image = _context11.sent;
                _context11.next = 15;
                break;

              case 6:
                if (!(source instanceof ArrayBuffer)) {
                  _context11.next = 12;
                  break;
                }

                _context11.next = 9;
                return ImageUtils.loadImageFromArrayBuffer(source);

              case 9:
                image = _context11.sent;
                _context11.next = 15;
                break;

              case 12:
                _context11.next = 14;
                return ImageUtils.loadImageFromUrl(source);

              case 14:
                image = _context11.sent;

              case 15:
                this.canvas.width = image.width;
                this.canvas.height = image.height;

                if (this.drawIntervalId) {
                  clearInterval(this.drawIntervalId);
                }

                this.drawIntervalId = setInterval(function () {
                  _this35.ctx.drawImage(image, 0, 0);
                }, 900);
                stream = this.canvas.captureStream(1);
                this.mediaTrack = stream.getTracks()[0];

              case 21:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function createImageStreamTrack(_x33) {
        return _createImageStreamTrack.apply(this, arguments);
      }

      return createImageStreamTrack;
    }()
  }, {
    key: "release",
    value: function release() {
      if (this.drawIntervalId) {
        clearInterval(this.drawIntervalId);
      }
    }
  }, {
    key: "id",
    get: function get() {
      if (this.mediaTrack) {
        return this.mediaTrack.id;
      }
    }
  }]);

  return ImageStreamTrack;
}();

var QNMediaRecorder =
/*#__PURE__*/
function () {
  function QNMediaRecorder() {
    _classCallCheck(this, QNMediaRecorder);

    this.recordedChunks = [];
  }

  _createClass(QNMediaRecorder, [{
    key: "releaseMediaElement",
    value: function releaseMediaElement() {
      log.log("Recorder release Media Element", this.mediaElement);

      if (this.mediaElement && this.mediaElement.parentElement) {
        this.mediaElement.parentElement.removeChild(this.mediaElement);
      }
    }
  }, {
    key: "release",
    value: function release() {
      if (this.recorder && this.recorder.state !== "inactive") {
        this.recorder.stop();
      }

      this.recorder = undefined;
      this.recordedChunks = [];
      this.recordedBlob = undefined;

      if (this.recordedUrl) {
        window.URL.revokeObjectURL(this.recordedUrl);
        this.recordedUrl = undefined;
      }

      this.releaseMediaElement();
    }
  }, {
    key: "setMimeType",
    value: function setMimeType(mimeType) {
      log.log("Recorder setMimeType, ", mimeType);
      if (!("MediaRecorder" in window)) throw ERROR_NOT_SUPPORT("MediaRecorder is not supported.");
      var w = window;

      if (w.MediaRecorder.isTypeSupported(mimeType)) {
        this.mimeType = mimeType;
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "start",
    value: function start(tracks) {
      var _this36 = this;

      log.log("Recorder start, ", tracks);
      if (!("MediaRecorder" in window)) throw ERROR_NOT_SUPPORT("MediaRecorder is not supported.");
      if (tracks === undefined || tracks.length === 0 || tracks.length > 2) throw ERROR_FATAL("Invalid parameters.");

      if (this.recorder && this.recorder.state !== "inactive") {
        throw ERROR_FATAL("MediaRecorder is active, cannot start again.");
      }

      var isTrackKindInvalid = tracks.reduce(function (pre, cur) {
        if (cur.mediaTrack.kind === "video") {
          pre[0] += 1;
        }

        if (cur.mediaTrack.kind === "audio") {
          pre[1] += 1;
        }

        return pre;
      }, [0, 0]).some(function (n) {
        return n > 1;
      });

      if (isTrackKindInvalid) {
        throw ERROR_FATAL("Invalid parameters.");
      }

      this.release();

      try {
        var stream = new MediaStream(tracks.map(function (t) {
          return t.mediaTrack;
        }));
        var w = window;

        if (this.mimeType) {
          var options = {
            mimeType: this.mimeType
          };
          this.recorder = new w.MediaRecorder(stream, options);
        } else {
          this.recorder = new w.MediaRecorder(stream);
        }

        this.recorder.ondataavailable = function (e) {
          log.debug("Recorder data, ", e.data);

          _this36.recordedChunks.push(e.data);
        };

        this.recorder.start(QNMediaRecorder.recorderTimeslice);
      } catch (error) {
        throw ERROR_FATAL("MediaRecoder start error: " + error.message);
      }
    }
  }, {
    key: "pause",
    value: function pause() {
      log.log("Recorder pause");
      if (!this.recorder) throw ERROR_FATAL("No MediaRecorder, please try to start first.");
      if (this.recorder.state !== "recording") throw ERROR_FATAL("MediaRecorder is not in recording state, cannot do pause.");
      this.recorder.pause();
    }
  }, {
    key: "resume",
    value: function resume() {
      log.log("Recorder resume");
      if (!this.recorder) throw ERROR_FATAL("No MediaRecorder, please try to start first.");
      if (this.recorder.state !== "paused") throw ERROR_FATAL("MediaRecorder is not in paused state, cannot do resume.");
      this.recorder.resume();
    }
  }, {
    key: "stop",
    value: function stop() {
      log.log("Recorder stop, ", this.recordedChunks);
      if (!this.recorder) throw ERROR_FATAL("No MediaRecorder, please try to start first.");

      if (this.recorder.state === "inactive") {
        throw ERROR_FATAL("MediaRecorder is in inactive state, cannot do stop.");
      }

      try {
        this.recorder.stop();

        if (this.mimeType) {
          var options = {
            type: this.mimeType
          };
          this.recordedBlob = new Blob(this.recordedChunks, options);
        } else {
          this.recordedBlob = new Blob(this.recordedChunks);
        }

        this.recordedUrl = window.URL.createObjectURL(this.recordedBlob);
        return this.recordedBlob;
      } catch (error) {
        throw ERROR_FATAL("MediaRecorder stop error: " + error.message);
      }
    }
  }, {
    key: "play",
    value: function play(container) {
      var muted = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      log.log("Recorder play, ", container, muted);

      if (!this.recordedUrl) {
        throw ERROR_FATAL("No recorded data, please start record first.");
      }

      this.releaseMediaElement();
      var video = document.createElement("video");
      video.style.width = "100%";
      video.style.height = "100%";
      video.style.objectFit = "contain";
      video.controls = true;
      video.muted = muted;
      video.className = "qnrtc-recorder-video-player";
      video.setAttribute("playsinline", true);
      video.autoplay = true;
      video.src = this.recordedUrl;
      container.appendChild(video);
      this.mediaElement = video;
      return new Promise(function (resolve, reject) {
        var promise;

        try {
          promise = video.play();
        } catch (error) {
          reject(error);
        }

        if (promise) {
          promise.then(resolve).catch(function (error) {
            reject(error);

            try {
              throw ERROR_FATAL("MediaRecoder play error: " + error.message);
            } catch (_unused) {}
          });
        } else {
          resolve();
        }
      });
    }
  }, {
    key: "download",
    value: function download(filename) {
      log.log("Recorder download, " + filename);

      if (!this.recordedUrl) {
        throw ERROR_FATAL("No recorded data, please start record first.");
      }

      var a = document.createElement('a');
      a.style.display = 'none';
      a.href = this.recordedUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      setTimeout(function () {
        document.body.removeChild(a);
      }, 100);
    }
  }]);

  return QNMediaRecorder;
}();

QNMediaRecorder.recorderTimeslice = 1000;

var Consumer = function Consumer(id, mid, kind, rtpParameters) {
  _classCallCheck(this, Consumer);

  this.id = id;
  this.mid = mid; // this._closed = false;

  this.kind = kind;
  this.rtpParameters = rtpParameters; // this._peer = peer;
  // this._supported = false;

  this.track = null;
};

var PCTrack =
/*#__PURE__*/
function () {
  function PCTrack(transport, direction, track, trackID, mid) {
    _classCallCheck(this, PCTrack);

    this._connectStatus = TrackConnectStatus.Idle;
    this.track = track;
    this.trackID = trackID;
    this.mid = mid;
    this.transport = transport;
    this.direction = direction;
  }

  _createClass(PCTrack, [{
    key: "startConnect",
    value: function startConnect() {
      var _this37 = this;

      this.connectStatus = TrackConnectStatus.Connecting;
      return new Promise(function (resolve, reject) {
        _this37.onConnectStatusChange = function (_, curr) {
          if (curr === TrackConnectStatus.Connect) {
            resolve();
          }

          if (curr === TrackConnectStatus.Idle) {
            reject();
          }
        };
      });
    }
  }, {
    key: "appendConsumner",
    value: function appendConsumner(rtpparms, kind) {
      this.consumer = new Consumer(this.trackID, this.mid, kind, rtpparms);
      this.transport.appendConsumer(this.consumer);
    }
  }, {
    key: "setMute",
    value: function setMute(muted) {
      if (!this.track) return;
      this.track.setMute(muted);
    }
  }, {
    key: "addTrackId",
    value: function addTrackId(trackid) {
      if (!this.track) return;
      this.trackID = trackid;
      this.track.setInfo({
        trackID: trackid
      });
    }
  }, {
    key: "release",
    value: function release() {
      if (this.consumer && this.transport) {
        // 如果释放这个 Track 时发现 pc 已经断开，就跳过
        if (this.transport.recvHandler.isPcReady) {
          this.transport.removeConsumers([this.consumer]);
        } // 只有订阅的 Track 才会自动释放


        if (this.track) {
          this.track.release();
        }
      } else {
        if (this.track) {
          this.track.reset();
        }
      }
    }
  }, {
    key: "connectStatus",
    get: function get() {
      return this._connectStatus;
    },
    set: function set(v) {
      var _this38 = this;

      if (v !== this._connectStatus) {
        var prev = this._connectStatus;
        this._connectStatus = v;
        nextTick(function () {
          if (_this38.onConnectStatusChange) {
            _this38.onConnectStatusChange(prev, _this38._connectStatus);
          }
        });
      }
    }
  }]);

  return PCTrack;
}();
/*
 * audio.ts
 * Copyright (C) 2018 disoul <disoul@DiSouldeMacBook-Pro.local>
 *
 * Distributed under terms of the MIT license.
*/


var AudioContext = window.AudioContext || window.webkitAudioContext || window.Object;
var audioContext = __chunk_1.browserReport.audioContextOptions ? new AudioContext({
  // 控制音频延迟，默认为 interactive，在 Chrome 下为 0.01s
  latencyHint: "interactive"
}) : new AudioContext();
window.audioContext = audioContext;

if (window.Promise) {
  var unlockWebAudio = function unlockWebAudio() {
    webAudioUnlock(audioContext).then(function (unlocked) {
      log.debug("web audio context unlocked", unlocked);
    }).catch(function (e) {
      log.warning("can not unlock web audio context", e);
    });
    window.removeEventListener("load", unlockWebAudio);
  };

  if (!document.body) {
    window.addEventListener("load", unlockWebAudio);
  } else {
    unlockWebAudio();
  }

  audioContext.onstatechange = function () {
    unlockWebAudio();
  };
}

var FFT_SIZE = 2048;
var BUFFER_SIZE = 4096;
var MediaElementEventList = ["play", "playing", "pause", "ended", "waiting", "seeking"];

var AudioManager =
/*#__PURE__*/
function (_EnhancedEventEmitter3) {
  _inherits(AudioManager, _EnhancedEventEmitter3);

  function AudioManager() {
    var _this39;

    _classCallCheck(this, AudioManager);

    _this39 = _possibleConstructorReturn(this, _getPrototypeOf(AudioManager).call(this)); // 麦克风音频源 或者 PCM音频源

    _this39.audioSource = null;
    _this39._audioSourceState = AudioSourceState.IDLE;
    _this39.bufferSourceDuration = {
      startTime: 0,
      pauseTime: 0,
      lastPauseTime: 0,
      offsetTime: 0,
      stopTime: 0
    };

    _this39.handleMediaElementEvents = function (e) {
      switch (e.type) {
        case "playing":
        case "play":
          {
            _this39.audioSourceState = AudioSourceState.PLAY;
            break;
          }

        case "pause":
          {
            if (_this39.audioSourceState === AudioSourceState.END) break;
            _this39.audioSourceState = AudioSourceState.PAUSE;
            break;
          }

        case "waiting":
        case "seeking":
          {
            _this39.audioSourceState = AudioSourceState.LOADING;
            break;
          }

        case "ended":
          {
            _this39.audioSourceState = AudioSourceState.END;
            break;
          }
      }
    };

    return _this39;
  }

  _createClass(AudioManager, [{
    key: "initAudioContext",
    value: function initAudioContext() {
      log.log("init audio context", audioContext.state); // in chrome, audioContext maybe in suspended state after initialization

      if (audioContext.state === "suspended") {
        log.log("audio context suspended");
        audioContext.resume().catch(function (e) {
          log.warning("resume audiocontext failed! see: http://s.qnsdk.com/s/Txsdz", e);
        });
      }

      log.log("init audio finish", audioContext.state);
      this.analyserNode = audioContext.createAnalyser();
      this.analyserNode.fftSize = FFT_SIZE;
      this.gainNode = audioContext.createGain();
      polyfillAudioNode(this.gainNode);

      if (__chunk_1.browserReport.mediaStreamDest) {
        this.audioStream = audioContext.createMediaStreamDestination();
      }
    }
  }, {
    key: "setMediaStreamSource",
    value: function setMediaStreamSource(originMediaStream) {
      this.audioSource = audioContext.createMediaStreamSource(originMediaStream);
      this.connect();
    }
  }, {
    key: "setAudioBufferSource",
    value: function setAudioBufferSource() {
      var _this40 = this;

      this.audioSource = audioContext.createBufferSource(); // 播放结束后清空节点

      this.audioSource.onended = function () {
        return _this40.stopAudioSource();
      };

      this.connect();
    }
  }, {
    key: "setMediaElementSource",
    value: function setMediaElementSource(mediaElement) {
      this.audioSource = audioContext.createMediaElementSource(mediaElement);
      this.audioSourceElement = mediaElement;

      for (var _i = 0; _i < MediaElementEventList.length; _i++) {
        var eventItem = MediaElementEventList[_i];
        this.audioSourceElement.addEventListener(eventItem, this.handleMediaElementEvents);
      }

      this.connect();
    }
  }, {
    key: "setAudioSourceLoop",
    value: function setAudioSourceLoop(isLoop) {
      this.audioSourceLoop = isLoop;

      if (this.audioSource instanceof AudioBufferSourceNode) {
        this.audioSource.loop = !!isLoop;
      } else if (this.audioSourceElement) {
        this.audioSourceElement.loop = !!isLoop;
      }
    }
  }, {
    key: "setAudioBuffer",
    value: function setAudioBuffer(data) {
      if (!(this.audioSource instanceof AudioBufferSourceNode)) {
        return;
      }

      this.audioSource.buffer = data;
      this.audioSourceBuffer = data;
    }
  }, {
    key: "playAudioSource",
    value: function playAudioSource() {
      var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.audioSource instanceof AudioBufferSourceNode) {
        this.resetBufferSourceDuration();

        try {
          this.audioSource.start(0, offset);
          this.bufferSourceDuration.startTime = audioContext.currentTime;
          this.bufferSourceDuration.offsetTime = offset;
          this.audioSourceState = AudioSourceState.PLAY;
        } catch (e) {
          // 说明已经 start
          this.stopAudioSource();
          this.playAudioSource(offset);
        }
      } else if (this.audioSourceElement) {
        this.audioSourceElement.currentTime = 0;
        this.audioSourceElement.play().catch(showPlayWarn);
      } else if (this.audioSource === null && this.audioSourceBuffer) {
        this.resetBufferSourceDuration(); // 说明原来的 AudioBufferSourceNode 被删掉了，重新创建

        this.setAudioBufferSource();
        this.setAudioBuffer(this.audioSourceBuffer);
        this.setAudioSourceLoop(!!this.audioSourceLoop); // fix ts error

        this.audioSource.start(0, offset);
        this.bufferSourceDuration.startTime = audioContext.currentTime;
        this.bufferSourceDuration.offsetTime = offset;
        this.audioSourceState = AudioSourceState.PLAY;
      }
    }
  }, {
    key: "resumeAudioSource",
    value: function resumeAudioSource() {
      if (this.audioSource instanceof AudioBufferSourceNode) {
        if (this.audioSourceState !== AudioSourceState.PAUSE) return;
        this.audioSource.playbackRate.value = 1;
        this.bufferSourceDuration.pauseTime += audioContext.currentTime - this.bufferSourceDuration.lastPauseTime;
        this.bufferSourceDuration.lastPauseTime = 0;
        this.audioSourceState = AudioSourceState.PLAY;
      } else if (this.audioSourceElement) {
        this.audioSourceElement.play().catch(showPlayWarn);
      }
    }
  }, {
    key: "pauseAudioSource",
    value: function pauseAudioSource() {
      if (this.audioSource instanceof AudioBufferSourceNode) {
        // hack to pause, but firefox does not support MIN_VALUE
        if (__chunk_1.isFirefox) {
          this.audioSource.playbackRate.value = 10e-8;
        } else {
          this.audioSource.playbackRate.value = Number.MIN_VALUE;
        }

        if (!this.bufferSourceDuration.lastPauseTime) {
          this.bufferSourceDuration.lastPauseTime = audioContext.currentTime;
        }

        this.audioSourceState = AudioSourceState.PAUSE;
      } else if (this.audioSourceElement) {
        this.audioSourceElement.pause();
      }
    }
  }, {
    key: "stopAudioSource",
    value: function stopAudioSource() {
      var useToSeek = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.audioSource instanceof AudioBufferSourceNode) {
        /**
         * 一个 AudioBufferSourceNode 节点在其生命周期只允许开始一次
         * 所以这里停止了之后是无法再次开始的
         * 我们就直接删掉这个 Node，等待下次开始的时候重新创建
         */
        this.audioSource.onended = null;
        this.audioSource.stop();
        this.audioSource.disconnect();
        this.audioSource = null;
        this.bufferSourceDuration.stopTime = audioContext.currentTime;

        if (!useToSeek) {
          this.audioSourceState = AudioSourceState.END;
        }
      } else if (this.audioSourceElement) {
        this.audioSourceState = AudioSourceState.END;
        this.audioSourceElement.pause();
        this.audioSourceElement.currentTime = 0;
      }
    }
  }, {
    key: "getAudioSourceCurrentTime",
    value: function getAudioSourceCurrentTime() {
      if (this.audioSourceElement) {
        return this.audioSourceElement.currentTime;
      } else if (this.audioSource instanceof AudioBufferSourceNode) {
        var baseTime = audioContext.currentTime;
        var duration = this.getAudioSourceDuration();

        if (this.bufferSourceDuration.lastPauseTime) {
          baseTime = this.bufferSourceDuration.lastPauseTime;
        }

        if (this.bufferSourceDuration.stopTime) {
          baseTime = this.bufferSourceDuration.stopTime;
        }

        var currentTime = this.bufferSourceDuration.offsetTime + baseTime - this.bufferSourceDuration.startTime - this.bufferSourceDuration.pauseTime;
        return Math.max(0, currentTime % duration);
      }

      return 0;
    }
  }, {
    key: "setAudioSourceCurrentTime",
    value: function setAudioSourceCurrentTime(val) {
      if (this.audioSourceElement) {
        this.audioSourceElement.currentTime = val;
      } else if (this.audioSource instanceof AudioBufferSourceNode) {
        /**
         * audioBufferSource 的 seek 分 2 步
         * stop audioBuffer
         * 在指定位置 start
         */
        this.stopAudioSource(true);
        this.playAudioSource(val);
      }
    }
  }, {
    key: "getAudioSourceDuration",
    value: function getAudioSourceDuration() {
      if (this.audioSourceElement) return this.audioSourceElement.duration;
      if (this.audioSourceBuffer) return this.audioSourceBuffer.duration;
      return 0;
    }
  }, {
    key: "release",
    value: function release() {
      if (this.audioSource instanceof MediaStreamAudioSourceNode) {
        if (this.audioSource.mediaStream) this.audioSource.mediaStream.getTracks().map(function (t) {
          return t.stop();
        });
      }

      if (this.audioSource) {
        this.audioSource.disconnect();
      }

      this.gainNode.disconnect();

      if (this.audioSourceElement) {
        for (var _i2 = 0; _i2 < MediaElementEventList.length; _i2++) {
          var eventItem = MediaElementEventList[_i2];
          this.audioSourceElement.removeEventListener(eventItem, this.handleMediaElementEvents);
        }

        this.audioSourceElement.src = "";
        this.audioSourceElement.load();
        this.audioSourceElement.remove();
        this.audioSourceElement = undefined;
      }

      if (this.scriptNode) {
        this.scriptNode.disconnect();
      }
    }
  }, {
    key: "connect",
    value: function connect() {
      if (!this.audioSource) {
        log.warning("no audio source, can not connect");
        return;
      }

      this.audioSource.connect(this.analyserNode);
      this.audioSource.connect(this.gainNode);

      if (this.audioStream) {
        this.gainNode.connect(this.audioStream);
        this.onAudioBuffer();
      }
    }
  }, {
    key: "handleAudioBuffer",
    value: function handleAudioBuffer(audioEvent) {
      var input = audioEvent.inputBuffer;
      this.emit("audioBuffer", input);

      if (this.audioBufferCallback) {
        this.audioBufferCallback(input);
      }
    }
  }, {
    key: "onAudioBuffer",
    value: function onAudioBuffer(audioBufferCallback) {
      var bufferSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : BUFFER_SIZE;
      this.audioBufferCallback = audioBufferCallback;
      this.audioBufferSize = bufferSize;
      if (!this.audioStream || !this.audioSource) return;

      if (!this.scriptNode) {
        this.scriptNode = audioContext.createScriptProcessor(bufferSize);
        this.audioSource.connect(this.scriptNode);
        this.scriptNode.connect(this.audioStream);
        this.scriptNode.onaudioprocess = this.handleAudioBuffer.bind(this);
      }
    }
  }, {
    key: "resetBufferSourceDuration",
    value: function resetBufferSourceDuration() {
      this.bufferSourceDuration = {
        offsetTime: 0,
        startTime: 0,
        lastPauseTime: 0,
        pauseTime: 0,
        stopTime: 0
      };
    }
  }, {
    key: "audioSourceState",
    get: function get() {
      return this._audioSourceState;
    },
    set: function set(newState) {
      if (newState === this._audioSourceState) return;
      this.emit("@audio-source-state-change", newState, this._audioSourceState);
      this._audioSourceState = newState;
    }
  }]);

  return AudioManager;
}(EnhancedEventEmitter);
/**
 * Safari 的 AudioNode.disconnect 不支持 disconnect 指定节点，只能操作全部节点
 * 这里的 polyfill 是通过 _inputNodes 保存全部已经 connect 的节点
 * 然后在 disconnect 后，将那些预期不应该被 disconnect 的节点重新 connect
 */


function polyfillAudioNode(node) {
  if (__chunk_1.browserReport.disconnectAudioNode) return;
  var nativeConnect = node.connect;
  var nativeDisconnect = node.disconnect;

  node.connect = function (destination, outputIndex, inputIndex) {
    if (!node._inputNodes) {
      node._inputNodes = [];
    }

    if (destination instanceof AudioNode) {
      node._inputNodes.push(destination);

      node._inputNodes = uniqBy(node._inputNodes, function (s) {
        return s;
      });
      nativeConnect.call(node, destination, outputIndex, inputIndex);
    } else {
      nativeConnect.call(node, destination, outputIndex);
    }

    return node;
  };

  node.disconnect = function (destination, output, input) {
    if (!destination) {
      nativeDisconnect.call(node);
      node._inputNodes = [];
      return;
    }

    nativeDisconnect.call(node, destination, output, input);
    remove(node._inputNodes, function (node) {
      return node === destination;
    });
    var _iteratorNormalCompletion13 = true;
    var _didIteratorError13 = false;
    var _iteratorError13 = undefined;

    try {
      for (var _iterator13 = node._inputNodes[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
        var _n = _step13.value;
        node.connect(_n);
      }
    } catch (err) {
      _didIteratorError13 = true;
      _iteratorError13 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion13 && _iterator13.return != null) {
          _iterator13.return();
        }
      } finally {
        if (_didIteratorError13) {
          throw _iteratorError13;
        }
      }
    }
  };
}

function aWeight(f) {
  var f2 = f * f;
  return 1.2588966 * 148840000 * f2 * f2 / ((f2 + 424.36) * Math.sqrt((f2 + 11599.29) * (f2 + 544496.41)) * (f2 + 148840000));
}

var AUDIO_WEIGHT_LIMIT = 0;

var AudioTrack =
/*#__PURE__*/
function (_Track) {
  _inherits(AudioTrack, _Track);

  function AudioTrack(track, userID, direction) {
    var _this41;

    _classCallCheck(this, AudioTrack);

    if (track.kind !== "audio") {
      throw new Error("audio track only!");
    }

    _this41 = _possibleConstructorReturn(this, _getPrototypeOf(AudioTrack).call(this, track, userID, direction));
    _this41.mediaStream = new MediaStream();

    _this41.mediaStream.addTrack(track);

    return _this41;
  }
  /**
   * @inernal
   */


  _createClass(AudioTrack, [{
    key: "resume",
    value: function resume(track) {
      this.mediaTrack = track;
      this.removeEvent("@get-stats");
      this.resetStats();
      var stream = new MediaStream([track]);
      this.mediaStream = stream;

      if (this.mediaElement) {
        this.mediaElement.dataset.localid = track.id;
        this.mediaElement.srcObject = stream;
      }

      if (this.audioManager) {
        this.audioManager.release();
        this.initAudioManager();
      }
    }
    /**
     * @internal
     * @param replaceOriginStream 是否使用 WebAudio 替换原来的输入
     * safari 不支持 webaudio 替换输入
     */

  }, {
    key: "initAudioManager",
    value: function initAudioManager(replaceOriginStream) {
      var _this42 = this;

      this.audioManager = new AudioManager();
      this.audioManager.initAudioContext();
      this.audioManager.setMediaStreamSource(this.mediaStream);
      this.audioManager.on("audioBuffer", function (buffer) {
        _this42.emit("audioBuffer", buffer);
      });

      if (replaceOriginStream && __chunk_1.browserReport.mediaStreamDest) {
        this.mediaStream = this.audioManager.audioStream.stream;
        this.mediaTrack = this.mediaStream.getTracks()[0];
      }
    }
    /**
     * 设置音量，目前仅对采集到的 Track 有效（订阅 Track 无效）
     * @param value 增益值，0 静音，2，当前声音的 2 倍
     */

  }, {
    key: "setVolume",
    value: function setVolume(value) {
      this.audioManager.gainNode.gain.setValueAtTime(value, audioContext.currentTime);
    }
    /**
     * 获取当前 2048 位的时域数据
     */

  }, {
    key: "getCurrentTimeDomainData",
    value: function getCurrentTimeDomainData() {
      var data = new Uint8Array(FFT_SIZE);
      this.audioManager.analyserNode.getByteTimeDomainData(data);
      return data;
    }
    /**
     * 获取当前 2048 位的频域数据
     */

  }, {
    key: "getCurrentFrequencyData",
    value: function getCurrentFrequencyData() {
      var data = new Uint8Array(this.audioManager.analyserNode.frequencyBinCount);
      this.audioManager.analyserNode.getByteFrequencyData(data);
      return data;
    }
    /**
     * 获取这个 Track 的音量设置，默认为 1，也就是原始音量
     */

  }, {
    key: "getVolume",
    value: function getVolume() {
      return this.audioManager.gainNode.gain.value;
    }
    /**
     * 获取当前实时的音量等级，一般用来展示可视化音量数据
     */

  }, {
    key: "getCurrentVolumeLevel",
    value: function getCurrentVolumeLevel() {
      var data = this.getCurrentFrequencyData();
      var sum = 0;
      var length = data.length;
      data.forEach(function (d, i) {
        var frequency = i * (audioContext.sampleRate || 44100) / data.length;

        if (frequency > 22050) {
          length -= 1;
          return;
        }

        var weight = aWeight(frequency) * d / 255.0;

        if (weight <= AUDIO_WEIGHT_LIMIT) {
          length -= 1;
          return;
        }

        sum += weight * weight;
      });
      return length === 0 ? 0 : Math.sqrt(sum / length);
    }
  }, {
    key: "release",
    value: function release() {
      this.emit("release");
      this.removeEvent();

      if (this.statsInterval) {
        window.clearInterval(this.statsInterval);
      }

      if (this.audioManager) {
        this.audioManager.release();
      }

      this.removeMediaElement();
      this.mediaTrack.stop();
    }
  }]);

  return AudioTrack;
}(Track);

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var objectWithoutProperties = _objectWithoutProperties;

var Handler =
/*#__PURE__*/
function (_EnhancedEventEmitter4) {
  _inherits(Handler, _EnhancedEventEmitter4);

  function Handler(direction, extendedRtpCapabilities, settings) {
    var _this43;

    _classCallCheck(this, Handler);

    _this43 = _possibleConstructorReturn(this, _getPrototypeOf(Handler).call(this));
    _this43._isRestartingICE = false;
    _this43.isPcReady = false;
    _this43.midRidEncoding = {};
    _this43.removeMids = new Set(); // last qos media statistic list

    _this43.lastMediaStatistics = []; // qos media statistic report interval

    _this43.intervalId = -1; // play quality interval

    _this43.playQualityIntervalId = -1; //   private qualityStats

    _this43.qualityStats = new Map();
    _this43._direction = direction; // RTCPeerConnection instance.

    _this43._pc = createPC(); // Generic sending RTP parameters for audio and video.

    _this43._extendedRtpCapabilities = extendedRtpCapabilities;
    _this43._remoteSdp = new RemoteSdp(direction, extendedRtpCapabilities);
    _this43._simulcast = !!settings && settings.simulcast;
    _this43.coreInstance = settings && settings.core; // Handle RTCPeerConnection connection status.

    _this43._pc.addEventListener("iceconnectionstatechange", function () {
      switch (_this43._pc.iceConnectionState) {
        case "checking":
          _this43.emit("@connectionstatechange", "connecting");

          break;

        case "connected":
        case "completed":
          _this43.emit("@connectionstatechange", "connected");

          _this43.registerMediaStatisticStatsReport();

          _this43.registerPlayQualityReport();

          break;

        case "failed":
          _this43.emit("@connectionstatechange", "failed");

          _this43.unregisterMediaStatisticStatsReport();

          _this43.unregisterPlayQualityReport();

          break;

        case "disconnected":
          _this43.emit("@connectionstatechange", "disconnected");

          _this43.unregisterMediaStatisticStatsReport();

          _this43.unregisterPlayQualityReport();

          break;

        case "closed":
          _this43.emit("@connectionstatechange", "closed");

          _this43.unregisterMediaStatisticStatsReport();

          _this43.unregisterPlayQualityReport();

          break;
      }
    });

    return _this43;
  }

  _createClass(Handler, [{
    key: "getStats",
    value: function () {
      var _getStats2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12(track, lastReportList) {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return getPCStats(this._pc, track, this._direction, lastReportList);

              case 2:
                return _context12.abrupt("return", _context12.sent);

              case 3:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getStats(_x34, _x35) {
        return _getStats2.apply(this, arguments);
      }

      return getStats;
    }()
  }, {
    key: "registerPlayQualityReport",
    value: function registerPlayQualityReport() {
      var _this44 = this;

      if (this._direction === "send") return;
      this.unregisterPlayQualityReport();
      this.playQualityIntervalId = window.setInterval(
      /*#__PURE__*/
      _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee13() {
        var stats, _iteratorNormalCompletion14, _didIteratorError14, _iteratorError14, _iterator14, _step14, stat, trackStats;

        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return getQualityStats(_this44._pc, _this44.coreInstance);

              case 2:
                stats = _context13.sent;
                _iteratorNormalCompletion14 = true;
                _didIteratorError14 = false;
                _iteratorError14 = undefined;
                _context13.prev = 6;

                for (_iterator14 = stats[Symbol.iterator](); !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
                  stat = _step14.value;
                  trackStats = _this44.qualityStats.get(stat.trackID);

                  if (trackStats) {
                    trackStats.push(stat);
                  } else {
                    _this44.qualityStats.set(stat.trackID, [stat]);
                  }
                }

                _context13.next = 14;
                break;

              case 10:
                _context13.prev = 10;
                _context13.t0 = _context13["catch"](6);
                _didIteratorError14 = true;
                _iteratorError14 = _context13.t0;

              case 14:
                _context13.prev = 14;
                _context13.prev = 15;

                if (!_iteratorNormalCompletion14 && _iterator14.return != null) {
                  _iterator14.return();
                }

              case 17:
                _context13.prev = 17;

                if (!_didIteratorError14) {
                  _context13.next = 20;
                  break;
                }

                throw _iteratorError14;

              case 20:
                return _context13.finish(17);

              case 21:
                return _context13.finish(14);

              case 22:
                _this44.addQualityStats();

              case 23:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this, [[6, 10, 14, 22], [15,, 17, 21]]);
      })), 2000);
    }
  }, {
    key: "unregisterPlayQualityReport",
    value: function unregisterPlayQualityReport() {
      if (this._direction === "send") return;

      if (this.playQualityIntervalId !== -1) {
        window.clearInterval(this.playQualityIntervalId);
        this.addQualityStats(true);
        this.playQualityIntervalId = -1;
      }
    }
  }, {
    key: "addQualityStats",
    value: function addQualityStats() {
      var isForce = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var statsList = _toConsumableArray(this.qualityStats.values());

      var isAddNeeded = statsList.some(function (v) {
        return v.length >= 30;
      }); // 30 * 2, 1min

      if (isAddNeeded || isForce) {
        log.log("quality stats", this.qualityStats);
        var _iteratorNormalCompletion15 = true;
        var _didIteratorError15 = false;
        var _iteratorError15 = undefined;

        try {
          var _loop8 = function _loop8() {
            var stats = _step15.value;
            if (stats.length === 0) return "continue";
            var track_id = stats[0].trackID;
            var total_duration = stats.length * 2 * 1000;

            if (stats[0].kind === "video") {
              var freeze_duration = stats.reduce(function (pre, _, idx) {
                if (idx >= 1 && stats[idx].framesDecoded === stats[idx - 1].framesDecoded) {
                  return pre + 2;
                } else {
                  return pre;
                }
              }, 0) * 1000;
              qos.addEvent("VideoPlayQuality", {
                track_id: track_id,
                freeze_duration: freeze_duration,
                total_duration: total_duration
              });
            } else {
              var _freeze_duration = stats.reduce(function (pre, _, idx) {
                if (idx >= 1 && stats[idx].totalSamplesReceived === stats[idx - 1].totalSamplesReceived) {
                  return pre + 2;
                } else {
                  return pre;
                }
              }, 0) * 1000;

              qos.addEvent("AudioPlayQuality", {
                track_id: track_id,
                freeze_duration: _freeze_duration,
                total_duration: total_duration
              });
            }
          };

          for (var _iterator15 = statsList[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
            var _ret3 = _loop8();

            if (_ret3 === "continue") continue;
          }
        } catch (err) {
          _didIteratorError15 = true;
          _iteratorError15 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion15 && _iterator15.return != null) {
              _iterator15.return();
            }
          } finally {
            if (_didIteratorError15) {
              throw _iteratorError15;
            }
          }
        }

        this.qualityStats = new Map();
      }
    }
  }, {
    key: "registerMediaStatisticStatsReport",
    value: function registerMediaStatisticStatsReport() {
      var _this45 = this;

      this.unregisterMediaStatisticStatsReport();
      this.intervalId = window.setInterval(
      /*#__PURE__*/
      _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee14() {
        var mediaStatistics;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return getMediaStatisticStats(_this45._pc, _this45.coreInstance);

              case 2:
                mediaStatistics = _context14.sent;

                if (mediaStatistics && mediaStatistics.length > 0) {
                  _this45.addMediaStatistics(mediaStatistics, _this45.lastMediaStatistics);

                  _this45.lastMediaStatistics = mediaStatistics;
                }

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      })), 3000);
    }
  }, {
    key: "unregisterMediaStatisticStatsReport",
    value: function unregisterMediaStatisticStatsReport() {
      if (this.intervalId !== -1) {
        window.clearInterval(this.intervalId);
        this.lastMediaStatistics = [];
        this.intervalId = -1;
      }
    }
  }, {
    key: "addMediaStatistics",
    value: function addMediaStatistics(reports, lastReports) {
      var statistics = reports.map(function (report) {
        var expFilter = getStatisticExpFilter(report.id, report.kind);
        var lastReport = lastReports.find(function (lastReport) {
          return lastReport.id === report.id;
        });
        if (!lastReport) return report;
        var lastCalculationStats = lastReport.calculation_stats;
        var calculation_stats = report.calculation_stats,
            otherStats = objectWithoutProperties(report, ["calculation_stats"]);
        return __chunk_1._objectSpread({}, otherStats, calculationMediaStatisticReport(calculation_stats, lastCalculationStats, expFilter));
      });
      log.log("media statistics", statistics);
      qos.addEvent("MediaStatistics", {
        cpu_loading: 0,
        track_stats: statistics
      });
      var maxLostRate = statistics.sort(function (a, b) {
        return b.packet_lost_rate - a.packet_lost_rate;
      })[0].packet_lost_rate;
      var maxRtt = statistics.sort(function (a, b) {
        return b.rtt - a.rtt;
      })[0].rtt;
      var networkGrade = getNetworkGrade(maxLostRate, maxRtt);
      qnCheckNetworkChangeQos(networkGrade);
      var tracks_qos = statistics.map(function (s) {
        return {
          kind: s.kind,
          lostRate: s.packet_lost_rate,
          rtt: s.rtt,
          track: s.track_id
        };
      });
      this.emit("@send-qos-message", {
        qos: JSON.stringify({
          networkGrade: networkGrade,
          tracks_qos: tracks_qos
        })
      });
    }
  }, {
    key: "getCurrentIceConnectionState",
    value: function getCurrentIceConnectionState() {
      return this._pc.iceConnectionState;
    }
  }, {
    key: "close",
    value: function close() {
      log.log("handle", this._direction, "close");
      this.removeEvent();
      this.unregisterMediaStatisticStatsReport();
      this.unregisterPlayQualityReport();

      this._pc.close();

      this.isPcReady = false;
    }
  }]);

  return Handler;
}(EnhancedEventEmitter);

var SendHandler =
/*#__PURE__*/
function (_Handler) {
  _inherits(SendHandler, _Handler);

  function SendHandler(extendedRtpCapabilities, signaling, settings) {
    var _this46;

    _classCallCheck(this, SendHandler);

    _this46 = _possibleConstructorReturn(this, _getPrototypeOf(SendHandler).call(this, "send", extendedRtpCapabilities, settings));
    log.log("init send handler"); // Got transport local and remote parameters.

    _this46._transportReady = false; // Local stream.

    _this46._stream = new MediaStream();
    _this46._signaling = signaling;
    signaling.on("on-pubpc-state", function (res) {
      if (_this46._remoteSdp.transportRemoteParameters && res.pcid === _this46._remoteSdp.transportRemoteParameters.pcid) {
        if (!res.connected) {
          _this46.emit("@connectionstatechange", "remote-disconnected");
        }
      }
    });
    return _this46;
  }

  _createClass(SendHandler, [{
    key: "getReady",
    value: function getReady(transportRemoteParameters) {
      var _this47 = this;

      return new Promise(function (resolve, reject) {
        var callback = function callback(res) {
          if (res.pcid === transportRemoteParameters.pcid) {
            _this47._signaling.off("on-pubpc-state", callback);

            if (res.connected) {
              _this47.isPcReady = true;
              resolve();
            } else {
              // 此时会被 constructor 中的时间监听捕获，触发重连，所以这里既不 reject 也不 resolve
              return;
            }
          }
        };

        _this47._signaling.on("on-pubpc-state", callback);
      });
    }
  }, {
    key: "addProducerTracks",
    value: function addProducerTracks(producerTracks) {
      var _this48 = this;

      log.debug("add producer", producerTracks);
      var tracks = producerTracks.filter(function (track) {
        return !_this48._stream.getTrackById(track.mediaTrack.id);
      });

      if (tracks.length === 0) {
        return Promise.reject(new Error("track already added"));
      }

      var rtpSenders;
      var transceivers = [];
      var localSdp;
      var shouldSendPubTracks = true;
      return Promise.resolve().then(
      /*#__PURE__*/
      _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee15() {
        var _iteratorNormalCompletion16, _didIteratorError16, _iteratorError16, _iterator16, _step16, _track, _iteratorNormalCompletion17, _didIteratorError17, _iteratorError17, _iterator17, _step17, track, transceiver;

        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _iteratorNormalCompletion16 = true;
                _didIteratorError16 = false;
                _iteratorError16 = undefined;
                _context15.prev = 3;

                for (_iterator16 = tracks[Symbol.iterator](); !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
                  _track = _step16.value;

                  _this48._stream.addTrack(_track.mediaTrack);
                }

                _context15.next = 11;
                break;

              case 7:
                _context15.prev = 7;
                _context15.t0 = _context15["catch"](3);
                _didIteratorError16 = true;
                _iteratorError16 = _context15.t0;

              case 11:
                _context15.prev = 11;
                _context15.prev = 12;

                if (!_iteratorNormalCompletion16 && _iterator16.return != null) {
                  _iterator16.return();
                }

              case 14:
                _context15.prev = 14;

                if (!_didIteratorError16) {
                  _context15.next = 17;
                  break;
                }

                throw _iteratorError16;

              case 17:
                return _context15.finish(14);

              case 18:
                return _context15.finish(11);

              case 19:
                if (!(__chunk_1.browserReport.unifiedPlan && __chunk_1.browserReport.supportTransceivers)) {
                  _context15.next = 51;
                  break;
                }

                _iteratorNormalCompletion17 = true;
                _didIteratorError17 = false;
                _iteratorError17 = undefined;
                _context15.prev = 23;
                _iterator17 = tracks[Symbol.iterator]();

              case 25:
                if (_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done) {
                  _context15.next = 35;
                  break;
                }

                track = _step17.value;
                _context15.next = 29;
                return addTransceiver(track.mediaTrack, _this48._pc, track.lowStreamConfig, track.info.kbps);

              case 29:
                transceiver = _context15.sent;
                log.debug("add transceiver", transceiver, transceiver.mid);
                transceivers.push(transceiver);

              case 32:
                _iteratorNormalCompletion17 = true;
                _context15.next = 25;
                break;

              case 35:
                _context15.next = 41;
                break;

              case 37:
                _context15.prev = 37;
                _context15.t1 = _context15["catch"](23);
                _didIteratorError17 = true;
                _iteratorError17 = _context15.t1;

              case 41:
                _context15.prev = 41;
                _context15.prev = 42;

                if (!_iteratorNormalCompletion17 && _iterator17.return != null) {
                  _iterator17.return();
                }

              case 44:
                _context15.prev = 44;

                if (!_didIteratorError17) {
                  _context15.next = 47;
                  break;
                }

                throw _iteratorError17;

              case 47:
                return _context15.finish(44);

              case 48:
                return _context15.finish(41);

              case 49:
                _context15.next = 53;
                break;

              case 51:
                log.debug("add tracks", tracks);
                rtpSenders = tracks.map(function (track) {
                  return _this48._pc.addTrack(track.mediaTrack, _this48._stream);
                });

              case 53:
                return _context15.abrupt("return", createPcOffer(_this48._pc, _this48._simulcast));

              case 54:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this, [[3, 7, 11, 19], [12,, 14, 18], [23, 37, 41, 49], [42,, 44, 48]]);
      }))).then(function (offer) {
        var _offer;

        if (__chunk_1.browserReport.needH264FmtpLine) {
          offer.sdp += "a=fmtp:107 level-asymmetry-allowed=1;packetization-mode=1;profile-level-id=42e01f".concat(NEW_LINE);
        }

        _offer = {
          type: "offer",
          sdp: offer.sdp
        };
        localSdp = _offer.sdp;
        log.log("publish: set local offer", _offer);
        return _this48._pc.setLocalDescription(_offer);
      }).then(function () {
        var _loop9 = function _loop9() {
          var transceiver = transceivers[_i3];
          if (!transceiver.sender.track) return "continue";
          var targetProducerTrack = producerTracks.find(function (t) {
            return t.mediaTrack === transceiver.sender.track;
          });

          if (!targetProducerTrack || !transceiver.mid) {
            throw ERROR_FATAL("can not get transceiver mid!");
          }

          targetProducerTrack.setInfo({
            mid: transceiver.mid
          });
          _this48.midRidEncoding[transceiver.mid] = targetProducerTrack.lowStreamConfig;
        };

        for (var _i3 = 0; _i3 < transceivers.length; _i3++) {
          var _ret4 = _loop9();

          if (_ret4 === "continue") continue;
        }

        if (!_this48._transportReady) {
          shouldSendPubTracks = false;
          return _this48._setupTransport(producerTracks);
        }
      }).then(function () {
        // localSdpObj = sdpTransform.parse((this._pc.localDescription as RTCSessionDescription).sdp);
        // genPubAnswer
        return _this48._remoteSdp.createRemoteAnswer(localSdp, _this48.midRidEncoding, _this48.removeMids);
      }).then(function (remoteSdp) {
        var answer = {
          type: "answer",
          sdp: remoteSdp
        };
        log.debug("addProducer answer", answer); // logger.debug(
        //   'addProducer() | calling pc.setRemoteDescription() [answer:%o]',
        //   answer);

        return _this48._pc.setRemoteDescription(answer);
      }).then(function () {
        return _this48._pcReady;
      }).then(function () {
        if (shouldSendPubTracks) {
          return _this48.safeEmitAsPromise("@needpubtracks", producerTracks, localSdp);
        } else {
          return Promise.resolve(_this48._remoteSdp.transportRemoteParameters);
        }
      }).catch(function (error) {
        // Panic here. Try to undo things.
        log.log("add producer error", error);

        try {
          var _iteratorNormalCompletion18 = true;
          var _didIteratorError18 = false;
          var _iteratorError18 = undefined;

          try {
            for (var _iterator18 = rtpSenders[Symbol.iterator](), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
              var rtpSender = _step18.value;

              _this48._pc.removeTrack(rtpSender);
            }
          } catch (err) {
            _didIteratorError18 = true;
            _iteratorError18 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion18 && _iterator18.return != null) {
                _iterator18.return();
              }
            } finally {
              if (_didIteratorError18) {
                throw _iteratorError18;
              }
            }
          }

          for (var _i4 = 0; _i4 < transceivers.length; _i4++) {
            var transceiver = transceivers[_i4];
            transceiver.direction = "inactive";
          }
        } catch (error2) {}

        var _iteratorNormalCompletion19 = true;
        var _didIteratorError19 = false;
        var _iteratorError19 = undefined;

        try {
          for (var _iterator19 = tracks[Symbol.iterator](), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
            var track = _step19.value;

            _this48._stream.removeTrack(track.mediaTrack);
          }
        } catch (err) {
          _didIteratorError19 = true;
          _iteratorError19 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion19 && _iterator19.return != null) {
              _iterator19.return();
            }
          } finally {
            if (_didIteratorError19) {
              throw _iteratorError19;
            }
          }
        }

        if (error instanceof QNRTCError) {
          throw error;
        } else {
          throw ERROR_FATAL(error);
        }
      });
    }
  }, {
    key: "removeProducerTracks",
    value: function removeProducerTracks(producerTracks) {
      var _this49 = this;

      log.debug("removeProducerTracks", producerTracks);
      var tracks = producerTracks.filter(function (pcTrack) {
        if (pcTrack.track === undefined) return false;

        if (!_this49._stream.getTrackById(pcTrack.track.mediaTrack.id)) {
          return false;
        }

        return true;
      }).map(function (pcTrack) {
        return pcTrack.track.isReplacedByImageTrack ? pcTrack.track.imageStreamTrack.mediaTrack : pcTrack.track.mediaTrack;
      });
      var localSdp;
      return Promise.resolve().then(function () {
        if (__chunk_1.browserReport.unifiedPlan && __chunk_1.browserReport.supportTransceivers) {
          _this49._pc.getTransceivers().forEach(function (transceiver) {
            if (transceiver.sender.track && transceiver.mid && tracks.includes(transceiver.sender.track)) {
              _this49.removeMids.add(transceiver.mid);
            } // use answer reject, no need stop
            // transceiver.stop();

          });
        }

        var rtpSenders = _this49._pc.getSenders().filter(function (s) {
          return s.track && tracks.includes(s.track);
        });

        if (rtpSenders.length === 0) {
          log.warning("removeProducerTracks [nothing to remove]");
          return Promise.reject("removeProducerTracks: nothing to remote");
        } // Remove the associated RtpSender.


        var _iteratorNormalCompletion20 = true;
        var _didIteratorError20 = false;
        var _iteratorError20 = undefined;

        try {
          for (var _iterator20 = rtpSenders[Symbol.iterator](), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
            var rtpSender = _step20.value;

            _this49._pc.removeTrack(rtpSender);
          } // Remove the track from the local stream.

        } catch (err) {
          _didIteratorError20 = true;
          _iteratorError20 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion20 && _iterator20.return != null) {
              _iterator20.return();
            }
          } finally {
            if (_didIteratorError20) {
              throw _iteratorError20;
            }
          }
        }

        var _iteratorNormalCompletion21 = true;
        var _didIteratorError21 = false;
        var _iteratorError21 = undefined;

        try {
          for (var _iterator21 = tracks[Symbol.iterator](), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
            var track = _step21.value;

            _this49._stream.removeTrack(track);
          }
        } catch (err) {
          _didIteratorError21 = true;
          _iteratorError21 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion21 && _iterator21.return != null) {
              _iterator21.return();
            }
          } finally {
            if (_didIteratorError21) {
              throw _iteratorError21;
            }
          }
        }

        return createPcOffer(_this49._pc, _this49._simulcast);
      }).then(function (offer) {
        var description = new RTCSessionDescription(offer);
        localSdp = description.sdp;
        log.log("unpublish: set local offer", description);
        return _this49._pc.setLocalDescription(description);
      }).then(function () {
        var remoteSdp = _this49._remoteSdp.createRemoteAnswer(localSdp, _this49.midRidEncoding, _this49.removeMids);

        var answer = {
          type: "answer",
          sdp: remoteSdp
        };
        log.log("unpublish: set remote answer", answer);
        return _this49._pc.setRemoteDescription(answer);
      }).catch(function (error) {
        // NOTE: If there are no sending tracks, setLocalDescription() will fail with
        // "Failed to create channels". If so, ignore it.
        if (_this49._stream.getTracks().length === 0) {
          log.debug("removeProducer() | ignoring expected error due no sending tracks: %s", error.toString());
          return;
        }

        if (error instanceof QNRTCError) {
          throw error;
        } else {
          throw ERROR_FATAL(error);
        }
      }).then(function () {
        // no need to wait response
        _this49.safeEmitAsPromise("@needunpubtracks", producerTracks);
      });
    }
  }, {
    key: "replaceTrack",
    value: function () {
      var _replaceTrack = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee16(producerTrack, newTrack) {
        var sender, oldTrack;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                if (this._pc.getSenders) {
                  _context16.next = 2;
                  break;
                }

                throw ERROR_FATAL("getSenders is not supported.");

              case 2:
                sender = this._pc.getSenders().find(function (sender) {
                  if (!sender.track) return false;
                  if (!producerTrack.track) return false;
                  var sendTrackId = sender.track.id;

                  if (producerTrack.track.mediaTrack && sendTrackId === producerTrack.track.mediaTrack.id) {
                    return true;
                  }

                  if (producerTrack.track.imageStreamTrack && sendTrackId === producerTrack.track.imageStreamTrack.id) {
                    return true;
                  }

                  return false;
                });

                if (sender) {
                  _context16.next = 5;
                  break;
                }

                throw ERROR_FATAL("sender not found when replaceTrack: ".concat(producerTrack.trackID));

              case 5:
                if (sender.replaceTrack) {
                  _context16.next = 7;
                  break;
                }

                throw ERROR_FATAL("replaceTrack is not supported.");

              case 7:
                if (producerTrack.track) {
                  producerTrack.track.mediaTrack = newTrack;
                  producerTrack.track.removeMediaElement();
                }

                oldTrack = sender.track;
                _context16.next = 11;
                return sender.replaceTrack(newTrack);

              case 11:
                this._stream.removeTrack(oldTrack);

                this._stream.addTrack(newTrack);

              case 13:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function replaceTrack(_x36, _x37) {
        return _replaceTrack.apply(this, arguments);
      }

      return replaceTrack;
    }()
  }, {
    key: "replaceProducerTrack",
    value: function () {
      var _replaceProducerTrack = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee17(producerTrack, target) {
        var sender;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                if (this._pc.getSenders) {
                  _context17.next = 2;
                  break;
                }

                throw ERROR_FATAL("getSenders is not supported.");

              case 2:
                // find the sender corresponding to producerTrack 
                sender = this._pc.getSenders().find(function (sender) {
                  if (!sender.track) return false;
                  if (!producerTrack.track) return false;
                  var sendTrackId = sender.track.id;

                  if (producerTrack.track.mediaTrack && sendTrackId === producerTrack.track.mediaTrack.id) {
                    return true;
                  }

                  if (producerTrack.track.imageStreamTrack && sendTrackId === producerTrack.track.imageStreamTrack.id) {
                    return true;
                  }

                  return false;
                });

                if (sender) {
                  _context17.next = 5;
                  break;
                }

                throw ERROR_FATAL("sender not found when replaceProducerTrack: ".concat(producerTrack.trackID));

              case 5:
                if (sender.replaceTrack) {
                  _context17.next = 7;
                  break;
                }

                throw ERROR_FATAL("replaceTrack is not supported.");

              case 7:
                if (!(target === "image")) {
                  _context17.next = 13;
                  break;
                }

                log.debug("replaceTrack", producerTrack.track.imageStreamTrack.mediaTrack);
                _context17.next = 11;
                return sender.replaceTrack(producerTrack.track.imageStreamTrack.mediaTrack);

              case 11:
                _context17.next = 17;
                break;

              case 13:
                if (!(target === "video")) {
                  _context17.next = 17;
                  break;
                }

                log.debug("replaceTrack", producerTrack.track.mediaTrack);
                _context17.next = 17;
                return sender.replaceTrack(producerTrack.track.mediaTrack);

              case 17:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function replaceProducerTrack(_x38, _x39) {
        return _replaceProducerTrack.apply(this, arguments);
      }

      return replaceProducerTrack;
    }()
  }, {
    key: "restartICE",
    value: function restartICE(iceParameters, iceCandidates) {
      var _this50 = this;

      log.log("restart send ice");
      this._isRestartingICE = true;
      return Promise.resolve().then(function () {
        return _this50._remoteSdp.updateICEData(iceParameters, iceCandidates);
      }).then(function () {
        return createPcOffer(_this50._pc, _this50._simulcast, {
          iceRestart: true
        });
      }).then(function (offer) {
        return _this50._pc.setLocalDescription(offer);
      }).then(function () {
        var remoteSdp = _this50._remoteSdp.createRemoteAnswer(_this50._pc.localDescription.sdp, _this50.midRidEncoding, _this50.removeMids);

        var answer = {
          type: "answer",
          sdp: remoteSdp
        };
        return _this50._pc.setRemoteDescription(answer);
      });
    } // needpubpc

  }, {
    key: "_setupTransport",
    value: function _setupTransport(tracks) {
      var _this51 = this;

      var startTime = Date.now();
      return Promise.resolve().then(function () {
        if (!_this51._pc.localDescription) {
          return createPcOffer(_this51._pc, _this51._simulcast);
        }

        return _this51._pc.localDescription;
      }).then(function (localDescription) {
        // We need transport remote parameters.
        return _this51.safeEmitAsPromise("@needpubpc", localDescription.sdp, tracks);
      }).then(function (transportRemoteParameters) {
        qos.addEvent("PublisherPC", {
          signal_take_time: Date.now() - startTime,
          result_code: transportRemoteParameters.code,
          up_stream_ip: (transportRemoteParameters.iceCandidates || []).map(function (_ref10) {
            var ip = _ref10.ip;
            return ip;
          }).join(","),
          tracks: transportRemoteParameters.tracks.map(function (t) {
            var targetTrack = tracks.find(function (track) {
              return track.mediaTrack.id === t.localid;
            });
            if (!targetTrack) return undefined;
            return {
              local_id: t.localid,
              track_id: t.trackid,
              source_type: targetTrack.sourceType,
              kind: targetTrack.info.kind,
              tag: targetTrack.info.tag || "",
              muted: !!targetTrack.info.muted,
              master: !!targetTrack.master,
              kbps: targetTrack.info.kbps || -1,
              encode_video_width: 0,
              encode_video_height: 0
            };
          }).filter(function (t) {
            return t !== undefined;
          })
        });
        _this51.pcid = transportRemoteParameters.pcid;
        _this51._transportReady = true;
        _this51._pcReady = _this51.getReady(transportRemoteParameters); // Provide the remote SDP handler with transport remote parameters.

        return _this51._remoteSdp.setTransportRemoteParameters(transportRemoteParameters);
      });
    }
  }]);

  return SendHandler;
}(Handler);

var RecvHandler =
/*#__PURE__*/
function (_Handler2) {
  _inherits(RecvHandler, _Handler2);

  function RecvHandler(extendedRtpCapabilities, signaling, settings) {
    var _this52;

    _classCallCheck(this, RecvHandler);

    _this52 = _possibleConstructorReturn(this, _getPrototypeOf(RecvHandler).call(this, "recv", extendedRtpCapabilities, settings));
    _this52._transportCreated = false;
    _this52._consumerInfos = new Map();
    _this52._signaling = signaling;
    signaling.on("on-subpc-state", function (res) {
      if (_this52._remoteSdp.transportRemoteParameters && res.pcid === _this52._remoteSdp.transportRemoteParameters.pcid) {
        if (!res.connected) {
          _this52.emit("@connectionstatechange", "remote-disconnected");
        }
      }
    });
    log.log("init recvhandler", _assertThisInitialized(_assertThisInitialized(_this52)));
    return _this52;
  }

  _createClass(RecvHandler, [{
    key: "getReady",
    value: function getReady(transportRemoteParameters) {
      var _this53 = this;

      return new Promise(function (resolve, reject) {
        var callback = function callback(res) {
          if (res.pcid === transportRemoteParameters.pcid) {
            _this53._signaling.off("on-subpc-state", callback);

            if (res.connected) {
              _this53.isPcReady = true;
              resolve();
            } else {
              // 此时会被 constructor 中的时间监听捕获，触发重连，所以这里既不 reject 也不 resolve
              return;
            }
          }
        };

        _this53._signaling.on("on-subpc-state", callback);
      });
    }
    /**
     * 如果发生了重复订阅的情况，策略是直接返回已经保存的 track 信息
     * 也就是无论传入的 consumer 是否重复，都返回和传入数量一致的 MediaStreamTrack
     */

  }, {
    key: "addConsumerTracks",
    value: function () {
      var _addConsumerTracks = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee18(consumers) {
        var _this54 = this;

        var tracks, _iteratorNormalCompletion22, _didIteratorError22, _iteratorError22, _iterator22, _step22, consumer, track, consumerInfoList, _consumerInfoArray, _iteratorNormalCompletion23, _didIteratorError23, _iteratorError23, _loop11, _iterator23, _step23;

        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                if (!(__chunk_1.browserReport.unifiedPlan && __chunk_1.isFirefox)) {
                  _context18.next = 31;
                  break;
                }

                tracks = [];
                _iteratorNormalCompletion22 = true;
                _didIteratorError22 = false;
                _iteratorError22 = undefined;
                _context18.prev = 5;
                _iterator22 = consumers[Symbol.iterator]();

              case 7:
                if (_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done) {
                  _context18.next = 16;
                  break;
                }

                consumer = _step22.value;
                _context18.next = 11;
                return this.addConsumerTrack(consumer);

              case 11:
                track = _context18.sent;
                tracks.push(track);

              case 13:
                _iteratorNormalCompletion22 = true;
                _context18.next = 7;
                break;

              case 16:
                _context18.next = 22;
                break;

              case 18:
                _context18.prev = 18;
                _context18.t0 = _context18["catch"](5);
                _didIteratorError22 = true;
                _iteratorError22 = _context18.t0;

              case 22:
                _context18.prev = 22;
                _context18.prev = 23;

                if (!_iteratorNormalCompletion22 && _iterator22.return != null) {
                  _iterator22.return();
                }

              case 25:
                _context18.prev = 25;

                if (!_didIteratorError22) {
                  _context18.next = 28;
                  break;
                }

                throw _iteratorError22;

              case 28:
                return _context18.finish(25);

              case 29:
                return _context18.finish(22);

              case 30:
                return _context18.abrupt("return", tracks);

              case 31:
                log.log("add consumers", consumers);
                consumerInfoList = [];
                _consumerInfoArray = Array.from(this._consumerInfos.values());
                _iteratorNormalCompletion23 = true;
                _didIteratorError23 = false;
                _iteratorError23 = undefined;
                _context18.prev = 37;

                _loop11 = function _loop11() {
                  var consumer = _step23.value;

                  var info = _consumerInfoArray.find(function (i) {
                    return i.consumerId === consumer.id;
                  });

                  if (info && !info.closed) {
                    consumerInfoList.push(info);
                  } else {
                    var newInfo = _this54.genNewConsumerInfo(consumer);

                    if (__chunk_1.browserReport.unifiedPlan) {
                      // 递增 mid, plan-b 模式下不会使用到这个参数
                      var mid = consumer.mid;
                      newInfo.mid = mid;

                      _this54._consumerInfos.set(mid, newInfo);
                    } else {
                      _this54._consumerInfos.set(consumer.id, newInfo);
                    }

                    consumerInfoList.push(newInfo);
                  }
                };

                for (_iterator23 = consumers[Symbol.iterator](); !(_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done); _iteratorNormalCompletion23 = true) {
                  _loop11();
                }

                _context18.next = 46;
                break;

              case 42:
                _context18.prev = 42;
                _context18.t1 = _context18["catch"](37);
                _didIteratorError23 = true;
                _iteratorError23 = _context18.t1;

              case 46:
                _context18.prev = 46;
                _context18.prev = 47;

                if (!_iteratorNormalCompletion23 && _iterator23.return != null) {
                  _iterator23.return();
                }

              case 49:
                _context18.prev = 49;

                if (!_didIteratorError23) {
                  _context18.next = 52;
                  break;
                }

                throw _iteratorError23;

              case 52:
                return _context18.finish(49);

              case 53:
                return _context18.finish(46);

              case 54:
                return _context18.abrupt("return", Promise.resolve().then(function () {
                  // createremoteSdp
                  var remoteSdp = _this54._remoteSdp.createRemoteOffer(Array.from(_this54._consumerInfos.values()));

                  var offer = {
                    type: "offer",
                    sdp: remoteSdp
                  };
                  log.debug("subscribe: set remote offer", offer);
                  return _this54._pc.setRemoteDescription(offer);
                }).then(function () {
                  if (__chunk_1.browserReport.unifiedPlan) {
                    return _this54._pc.createAnswer();
                  }

                  return _this54._pc.createAnswer();
                }).then(function (answer) {
                  log.debug("subscribe, set local answer", answer);
                  return _this54._pc.setLocalDescription(answer);
                }) // .then(() => {
                //   if (!this._transportUpdated) { return this._updateTransport(); }
                // })
                .then(function () {
                  return _this54._pcReady;
                }).then(function () {
                  var _loop10 = function _loop10(i) {
                    var consumerInfo = consumerInfoList[i];
                    var consumer = consumers[i];
                    if (consumer.track) return "continue";

                    if (__chunk_1.browserReport.unifiedPlan) {
                      var transceiver = _this54._pc.getTransceivers().find(function (transceiver) {
                        if (!transceiver.receiver.track) {
                          return false;
                        }

                        if (transceiver.receiver.track.id === consumerInfo.trackID || transceiver.mid === consumerInfo.mid) {
                          return true;
                        }

                        return false;
                      });

                      if (transceiver) {
                        consumer.track = transceiver.receiver.track;
                      }
                    } else {
                      // chrome 55 以下不支持 getReceivers，使用 getRemoteStreams
                      if (__chunk_1.browserReport.getReceivers) {
                        var receiver = _this54._pc.getReceivers().find(function (rtpReceiver) {
                          var track = rtpReceiver.track;

                          if (!track) {
                            return false;
                          }

                          if (consumerInfo.trackID === track.id) {
                            return true;
                          }

                          return false;
                        });

                        if (receiver) {
                          consumer.track = receiver.track;
                        }
                      } else {
                        var stream = _this54._pc.getRemoteStreams().find(function (s) {
                          return s.id === consumerInfo.streamId;
                        });

                        if (stream) {
                          consumer.track = stream.getTrackById(consumerInfo.trackID);
                        }
                      }
                    }

                    if (!consumer.track) {
                      throw ERROR_FATAL("remote track not found");
                    }

                    log.log("subscribe: get new track", consumer.track);
                  };

                  for (var i = 0; i < consumerInfoList.length; i += 1) {
                    var _ret5 = _loop10(i);

                    if (_ret5 === "continue") continue;
                  }

                  return consumers.map(function (c) {
                    return c.track;
                  });
                }));

              case 55:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this, [[5, 18, 22, 30], [23,, 25, 29], [37, 42, 46, 54], [47,, 49, 53]]);
      }));

      function addConsumerTracks(_x40) {
        return _addConsumerTracks.apply(this, arguments);
      }

      return addConsumerTracks;
    }()
  }, {
    key: "genNewConsumerInfo",
    value: function genNewConsumerInfo(consumer) {
      var encoding = consumer.rtpParameters.encodings[0];
      var cname = consumer.rtpParameters.rtcp.cname;
      var mid = consumer.mid;
      var newInfo = {
        kind: consumer.kind,
        streamId: __chunk_1.browserReport.unifiedPlan ? "recv-stream-".concat(mid) : "recv-stream-".concat(encoding.ssrc),
        trackID: __chunk_1.browserReport.unifiedPlan ? "consumer-".concat(consumer.kind, "-").concat(mid) : "consumer-".concat(consumer.kind, "-").concat(encoding.ssrc),
        ssrc: encoding.ssrc,
        rtxSsrc: encoding.rtx ? encoding.rtx.ssrc : undefined,
        cname: cname,
        consumerId: consumer.id,
        closed: false
      };
      return newInfo;
    }
  }, {
    key: "addConsumerTrack",
    value: function () {
      var _addConsumerTrack = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee19(consumer) {
        var _this55 = this;

        var consumerInfo, _consumerInfoArray, info, newInfo, mid;

        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                log.log("add consumer", consumer);
                consumerInfo = null;
                _consumerInfoArray = Array.from(this._consumerInfos.values());
                info = _consumerInfoArray.find(function (i) {
                  return i.consumerId === consumer.id;
                });

                if (info && !info.closed) {
                  consumerInfo = info;
                } else {
                  newInfo = this.genNewConsumerInfo(consumer);

                  if (__chunk_1.browserReport.unifiedPlan) {
                    // plan-b 模式下不会使用到这个参数
                    mid = consumer.mid;
                    newInfo.mid = mid;

                    this._consumerInfos.set(mid, newInfo);
                  } else {
                    this._consumerInfos.set(consumer.id, newInfo);
                  }

                  consumerInfo = newInfo;
                }

                return _context19.abrupt("return", Promise.resolve().then(function () {
                  // createremoteSdp
                  var remoteSdp = _this55._remoteSdp.createRemoteOffer(Array.from(_this55._consumerInfos.values()));

                  var offer = {
                    type: "offer",
                    sdp: remoteSdp
                  };
                  log.log("set ontrack");

                  _this55._pc.ontrack = function (e) {
                    log.log("ontrack", e.receiver.track);
                  };

                  log.debug("subscribe: set remote offer", offer);
                  return _this55._pc.setRemoteDescription(offer);
                }).then(function () {
                  return _this55._pc.createAnswer();
                }).then(function (answer) {
                  log.debug("subscribe, set local answer", answer);
                  return _this55._pc.setLocalDescription(answer);
                }) // .then(() => {
                //   if (!this._transportUpdated) { return this._updateTransport(); }
                // })
                .then(function () {
                  return _this55._pcReady;
                }).then(function () {
                  var newTrack = null;

                  if (__chunk_1.browserReport.unifiedPlan && __chunk_1.browserReport.supportTransceivers && !!consumer && !!consumerInfo) {
                    var transceiver = _this55._pc.getTransceivers().find(function (transceiver) {
                      if (!transceiver.receiver.track) {
                        return false;
                      }

                      if (transceiver.receiver.track.id === consumerInfo.trackID || transceiver.mid === consumerInfo.mid) {
                        consumer.track = transceiver.receiver.track;
                        return true;
                      }

                      return false;
                    });

                    if (transceiver) {
                      newTrack = transceiver.receiver.track;
                    }
                  } else if (!!consumer && !!consumerInfo) {
                    var receiver = _this55._pc.getReceivers().find(function (rtpReceiver) {
                      var track = rtpReceiver.track;

                      if (!track) {
                        return false;
                      }

                      if (consumerInfo.trackID === track.id) {
                        consumer.track = track;
                        return true;
                      }

                      return false;
                    });

                    if (receiver) {
                      newTrack = receiver.track;
                    }
                  }

                  if (!newTrack && !!consumer) {
                    throw ERROR_FATAL("remote track not found");
                  }

                  log.log("subscribe: get new track", newTrack, newTrack.readyState);
                  return newTrack;
                }));

              case 6:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function addConsumerTrack(_x41) {
        return _addConsumerTrack.apply(this, arguments);
      }

      return addConsumerTrack;
    }()
  }, {
    key: "removeConsumerTracks",
    value: function removeConsumerTracks(consumers) {
      var _this56 = this;

      log.log("remove consumer", consumers);
      var needToUpdateOffer = false;
      var _iteratorNormalCompletion24 = true;
      var _didIteratorError24 = false;
      var _iteratorError24 = undefined;

      try {
        var _loop12 = function _loop12() {
          var consumer = _step24.value;
          var info = Array.from(_this56._consumerInfos.values()).find(function (i) {
            return i.consumerId === consumer.id && !i.closed;
          });

          if (!info) {
            log.log("can not find unpublish track target, ignore");
            return "continue";
          }

          needToUpdateOffer = true;
          /**
           * 对于 unified-plan 不能直接删除 consumer
           * 因为重协商必须保证前后 mid 只增不减，这里将 consumer 置为 closed
           * 使得生成 sdp 的时候改 mid 不会带上 ssrc 和 ext，也就不会产生订阅
           */

          if (__chunk_1.browserReport.unifiedPlan) {
            consumer.track = null;
            info.closed = true;
          } else {
            _this56._consumerInfos.delete(consumer.id);
          }
        };

        for (var _iterator24 = consumers[Symbol.iterator](), _step24; !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
          var _ret6 = _loop12();

          if (_ret6 === "continue") continue;
        }
      } catch (err) {
        _didIteratorError24 = true;
        _iteratorError24 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion24 && _iterator24.return != null) {
            _iterator24.return();
          }
        } finally {
          if (_didIteratorError24) {
            throw _iteratorError24;
          }
        }
      }

      if (!needToUpdateOffer) return Promise.resolve();
      return Promise.resolve().then(function () {
        var remoteSdp = _this56._remoteSdp.createRemoteOffer(Array.from(_this56._consumerInfos.values()));

        var offer = {
          type: "offer",
          sdp: remoteSdp
        };
        log.log("unsubscribe set remote offer", offer);
        return _this56._pc.setRemoteDescription(offer);
      }).then(function () {
        return _this56._pc.createAnswer();
      }).then(function (answer) {
        log.log("unsubscribe set local answer", answer);
        return _this56._pc.setLocalDescription(answer);
      });
    }
  }, {
    key: "restartICE",
    value: function restartICE(iceParameters, iceCandidates) {
      var _this57 = this;

      log.log("recv restart ice");
      this._isRestartingICE = true;
      return Promise.resolve().then(function () {
        return _this57._remoteSdp.updateICEData(iceParameters, iceCandidates);
      }).then(function () {
        var remoteSdp = _this57._remoteSdp.createRemoteOffer(Array.from(_this57._consumerInfos.values()));

        var offer = {
          type: "offer",
          sdp: remoteSdp
        };
        return _this57._pc.setRemoteDescription(offer);
      }).then(function () {
        return _this57._pc.createAnswer();
      }).then(function (answer) {
        _this57._pc.setLocalDescription(answer);
      });
    }
  }, {
    key: "setupTransport",
    value: function () {
      var _setupTransport2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee20(trackIDs) {
        var startTime, transportRemoteParameters;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                if (!this._transportCreated) {
                  _context20.next = 4;
                  break;
                }

                _context20.next = 3;
                return this._pcReady;

              case 3:
                return _context20.abrupt("return", _context20.sent);

              case 4:
                startTime = Date.now();
                _context20.next = 7;
                return this.safeEmitAsPromise("@needsubpc", trackIDs);

              case 7:
                transportRemoteParameters = _context20.sent;
                qos.addEvent("SubscriberPC", {
                  signal_take_time: Date.now() - startTime,
                  result_code: transportRemoteParameters.code,
                  down_stream_ip: (transportRemoteParameters.iceCandidates || []).map(function (_ref11) {
                    var ip = _ref11.ip;
                    return ip;
                  }).join(","),
                  tracks: transportRemoteParameters.tracks.map(function (t) {
                    return {
                      track_id: t.trackid,
                      status: t.status
                    };
                  })
                });
                this.pcid = transportRemoteParameters.pcid;
                this._transportCreated = true;
                this._pcReady = this.getReady(transportRemoteParameters);
                log.log("init subscribe, get transport remote", transportRemoteParameters);
                _context20.next = 15;
                return this._remoteSdp.setTransportRemoteParameters(transportRemoteParameters);

              case 15:
                return _context20.abrupt("return", transportRemoteParameters);

              case 16:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function setupTransport(_x42) {
        return _setupTransport2.apply(this, arguments);
      }

      return setupTransport;
    }()
  }]);

  return RecvHandler;
}(Handler);

function createPcOffer(pc, simulcast, offerOptions) {
  return pc.createOffer(offerOptions).then(function (offer) {
    var type = offer.type,
        sdp = offer.sdp;

    if (!sdp) {
      return offer;
    }

    sdp = removeAudioREDLine(sdp);
    sdp = removeVideOrientation(sdp);

    if (__chunk_1.browser.name === 'chrome' && simulcast) {
      sdp = transformOfferSdp(sdp, 3);
    }

    return {
      type: type,
      sdp: sdp
    };
  });
}

function getHandler(direction, extendedRtpCapabilities, signaling, settings) {
  // let rtpParametersByKind;
  switch (direction) {
    case "send":
      {
        return new SendHandler(extendedRtpCapabilities, signaling, settings);
      }

    case "recv":
      {
        return new RecvHandler(extendedRtpCapabilities, signaling, settings);
      }
  }
}

var TaskCommandEnum;

(function (TaskCommandEnum) {
  TaskCommandEnum["SEND_TRACKS"] = "@transport:send-tracks";
  TaskCommandEnum["RESTART_SEND_ICE"] = "@transport:send-restart-ice";
  TaskCommandEnum["REMOVE_TRACKS"] = "@transport:remove-tracks";
  TaskCommandEnum["INIT_RECV"] = "@transport:init-recv";
  TaskCommandEnum["RESTART_RECV_ICE"] = "@transport:recv-restart-ice";
  TaskCommandEnum["ADD_CONUMERS"] = "@transport:add-consumers";
  TaskCommandEnum["REMOVE_CONSUMERS"] = "@transport:remove-consumers";
})(TaskCommandEnum || (TaskCommandEnum = {}));

var ConnectionTransport =
/*#__PURE__*/
function (_EnhancedEventEmitter5) {
  _inherits(ConnectionTransport, _EnhancedEventEmitter5);

  function ConnectionTransport(rtpcap, signaling, core, simulcast) {
    var _this58;

    _classCallCheck(this, ConnectionTransport);

    _this58 = _possibleConstructorReturn(this, _getPrototypeOf(ConnectionTransport).call(this));
    _this58.sendCommandQueue = new TaskQueue("SendQueue");
    _this58.recvCommandQueue = new TaskQueue("RecvQueue");
    _this58.simulcast = false;
    /**
     * sub-pc 创建单独走一个 queue
     */

    _this58.recvInitCommandQueue = new TaskQueue("RecvInitQueue");
    _this58.sendTrackQueue = [];
    _this58.consumerQueue = [];
    _this58._publishTracks = new Map();
    _this58.extendedRtpCapabilities = rtpcap;
    _this58.signaling = signaling;
    _this58.simulcast = !!simulcast;
    _this58.coreInstance = core;
    _this58.sendHandler = getHandler("send", rtpcap, signaling, {
      simulcast: _this58.simulcast,
      core: _this58.coreInstance
    });
    _this58.recvHandler = getHandler("recv", rtpcap, signaling, {
      simulcast: _this58.simulcast,
      core: _this58.coreInstance
    });

    _this58.handleSendHandler();

    _this58.handleRecvHandler();

    _this58.sendCommandQueue.on("exec", _this58.handleSendCommandTask.bind(_assertThisInitialized(_assertThisInitialized(_this58))));

    _this58.recvCommandQueue.on("exec", _this58.handleRecvCommandTask.bind(_assertThisInitialized(_assertThisInitialized(_this58))));

    _this58.recvInitCommandQueue.on("exec", _this58.handleRecvInitCommandTask.bind(_assertThisInitialized(_assertThisInitialized(_this58))));

    _this58.initSubPcPromise = new Promise(function (resolve) {
      _this58.initSubPcPromiseResolve = resolve;
    });
    return _this58;
  }

  _createClass(ConnectionTransport, [{
    key: "resolveInitSubPcPromise",
    value: function resolveInitSubPcPromise() {
      if (!this.initSubPcPromiseResolve) return;
      this.initSubPcPromiseResolve();
      this.initSubPcPromiseResolve = undefined;
    }
  }, {
    key: "handleSendHandler",
    value: function handleSendHandler() {
      var _this59 = this;

      this.sendHandler.on("@needpubpc", function (sdp, tracks, cb, errcb) {
        _this59.safeEmitAsPromise("@needpubpc", sdp, tracks).then(cb).catch(errcb);
      }).on("@connectionstatechange", function (state) {
        log.log("pubpc connectionstatechange", state);
        qos.addEvent("ICEConnectionState", {
          pc_type: 0,
          state: state,
          id: _this59.sendHandler.pcid
        });

        switch (state) {
          case "remote-disconnected":
          case "closed":
          case "failed":
            {
              if (_this59.signaling.state === SignalingState.OPEN) {
                _this59.reconnectProducer();
              } else {
                _this59.sendHandler.close();
              }

              break;
            }

          case "disconnected":
            {
              if (_this59.sendHandler._isRestartingICE || !_this59.sendHandler.pcid) return;

              if (_this59.signaling.state === SignalingState.OPEN) {
                _this59.restartSendICE(_this59.sendHandler.pcid);
              } else {
                _this59.signaling.once("@signalingauth", function (data) {
                  if (_this59.sendHandler.getCurrentIceConnectionState() !== "disconnected") return;
                  _this59.extendedRtpCapabilities = data.rtpcaps;

                  _this59.restartSendICE(_this59.sendHandler.pcid);
                });
              }

              break;
            }

          default:
            break;
        }
      }).on("@needpubtracks", function (targetTracks, sdp, cb, errcb) {
        var publishTrackData = targetTracks.map(transferTrackToPublishTrack);
        var startTime = Date.now();

        _this59.signaling.request("pub-tracks", {
          tracks: publishTrackData,
          sdp: sdp
        }).then(function (data) {
          qos.addEvent("PublishTracks", {
            signal_take_time: Date.now() - startTime,
            result_code: data.code,
            tracks: data.tracks.map(function (t) {
              var targetTrack = targetTracks.find(function (track) {
                return track.mediaTrack.id === t.localid;
              });
              if (!targetTrack) return undefined;
              return {
                local_id: t.localid,
                track_id: t.trackid,
                source_type: targetTrack.sourceType,
                kind: targetTrack.info.kind,
                tag: targetTrack.info.tag || "",
                muted: !!targetTrack.info.muted,
                master: !!targetTrack.master,
                kbps: targetTrack.info.kbps || -1,
                encode_video_width: 0,
                encode_video_height: 0
              };
            }).filter(function (t) {
              return t !== undefined;
            })
          });

          switch (data.code) {
            case 0:
              break;

            case 10052:
              return errcb(SERVER_UNAVAILABLE());
            // pc 断开，重新走 pub-pc 的过程

            case 10061:
              _this59.reconnectProducer();

              return errcb(PUBLISH_ERROR(10061, data.error));

            default:
              return errcb(PUBLISH_ERROR(data.code, data.error));
          }

          var _iteratorNormalCompletion25 = true;
          var _didIteratorError25 = false;
          var _iteratorError25 = undefined;

          try {
            for (var _iterator25 = data.tracks[Symbol.iterator](), _step25; !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
              var track = _step25.value;

              if (!track.status) {
                errcb(PUBLISH_ERROR(data.code, data.error));
                return;
              }
            }
          } catch (err) {
            _didIteratorError25 = true;
            _iteratorError25 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion25 && _iterator25.return != null) {
                _iterator25.return();
              }
            } finally {
              if (_didIteratorError25) {
                throw _iteratorError25;
              }
            }
          }

          cb(data);
        }, errcb);
      }).on("@needunpubtracks", function (targetPCTracks, cb, errcb) {
        qos.addEvent("UnPublishTracks", {
          tracks: targetPCTracks.map(function (p) {
            return {
              track_id: p.trackID
            };
          })
        });

        _this59.signaling.request("unpub-tracks", {
          tracks: targetPCTracks.map(function (t) {
            return {
              trackid: t.trackID
            };
          })
        }).then(function (data) {
          cb(data);
        });
      }).on("@send-qos-message", function (qos) {
        _this59.signaling.request("send-qos-message", qos);
      });
    }
  }, {
    key: "sendTracks",
    value: function () {
      var _sendTracks = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee21(tracks) {
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                if (!(tracks.length === 0)) {
                  _context21.next = 2;
                  break;
                }

                return _context21.abrupt("return", Promise.resolve());

              case 2:
                return _context21.abrupt("return", this.sendCommandQueue.push(TaskCommandEnum.SEND_TRACKS, tracks));

              case 3:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function sendTracks(_x43) {
        return _sendTracks.apply(this, arguments);
      }

      return sendTracks;
    }()
  }, {
    key: "removeTracks",
    value: function removeTracks(tracks) {
      if (tracks.length === 0) return Promise.resolve();
      return this.sendCommandQueue.push(TaskCommandEnum.REMOVE_TRACKS, tracks);
    }
  }, {
    key: "restartSendICE",
    value: function () {
      var _restartSendICE = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee22(pcid) {
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                if (__chunk_1.browserReport.supportRestartICE) {
                  _context22.next = 2;
                  break;
                }

                return _context22.abrupt("return", Promise.resolve(this.reconnectProducer()));

              case 2:
                return _context22.abrupt("return", this.sendCommandQueue.push(TaskCommandEnum.RESTART_SEND_ICE, pcid));

              case 3:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function restartSendICE(_x44) {
        return _restartSendICE.apply(this, arguments);
      }

      return restartSendICE;
    }()
  }, {
    key: "handleSendCommandTask",
    value: function handleSendCommandTask(command, ph) {
      switch (command.method) {
        case TaskCommandEnum.SEND_TRACKS:
          {
            ph.promise = this._execAddProducerTracks(command.data);
            return;
          }

        case TaskCommandEnum.REMOVE_TRACKS:
          {
            ph.promise = this._execRemoveTracks(command.data);
            return;
          }

        case TaskCommandEnum.RESTART_SEND_ICE:
          {
            ph.promise = this._execRestartSendICE(command.data);
            return;
          }
      }
    }
    /**
     * 将 Track 添加到 transport 的 PCTrack 列表中
     * 将这一步抽成同步方法是为了保证多个 publish 操作同时触发时
     * 上层能够正确监测到非法订阅操作并及时抛出错误
     */

  }, {
    key: "addTrackToPublishTracks",
    value: function addTrackToPublishTracks(tracks) {
      var _this60 = this;

      var pcTracks = tracks.map(function (t) {
        return new PCTrack(_this60, "send", t);
      });
      var _iteratorNormalCompletion26 = true;
      var _didIteratorError26 = false;
      var _iteratorError26 = undefined;

      try {
        for (var _iterator26 = pcTracks[Symbol.iterator](), _step26; !(_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done); _iteratorNormalCompletion26 = true) {
          var pcTrack = _step26.value;

          this._publishTracks.set(pcTrack.track.mediaTrack.id, pcTrack);
        }
      } catch (err) {
        _didIteratorError26 = true;
        _iteratorError26 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion26 && _iterator26.return != null) {
            _iterator26.return();
          }
        } finally {
          if (_didIteratorError26) {
            throw _iteratorError26;
          }
        }
      }

      return pcTracks;
    }
    /**
     * 当发布任务遇到无法重试的失败时清理添加的 Tracks
     */

  }, {
    key: "removeTrackFromPublishTracks",
    value: function removeTrackFromPublishTracks(tracks) {
      var _iteratorNormalCompletion27 = true;
      var _didIteratorError27 = false;
      var _iteratorError27 = undefined;

      try {
        for (var _iterator27 = tracks[Symbol.iterator](), _step27; !(_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done); _iteratorNormalCompletion27 = true) {
          var track = _step27.value;

          this._publishTracks.delete(track.mediaTrack.id);
        }
      } catch (err) {
        _didIteratorError27 = true;
        _iteratorError27 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion27 && _iterator27.return != null) {
            _iterator27.return();
          }
        } finally {
          if (_didIteratorError27) {
            throw _iteratorError27;
          }
        }
      }
    }
  }, {
    key: "_execAddProducerTracks",
    value: function () {
      var _execAddProducerTracks2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee23(pcTracks) {
        var data, _iteratorNormalCompletion28, _didIteratorError28, _iteratorError28, _iterator28, _step28, pcTrack, trackData;

        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.next = 2;
                return this.sendHandler.addProducerTracks(pcTracks.map(function (t) {
                  return t.track;
                }));

              case 2:
                data = _context23.sent;
                _iteratorNormalCompletion28 = true;
                _didIteratorError28 = false;
                _iteratorError28 = undefined;
                _context23.prev = 6;

                for (_iterator28 = pcTracks[Symbol.iterator](); !(_iteratorNormalCompletion28 = (_step28 = _iterator28.next()).done); _iteratorNormalCompletion28 = true) {
                  pcTrack = _step28.value;
                  trackData = getElementFromArray(data.tracks, "localid", pcTrack.track.mediaTrack.id);

                  if (trackData) {
                    pcTrack.addTrackId(trackData.trackid);
                    pcTrack.track.setInfo({
                      versionid: trackData.versionid
                    });
                    pcTrack.track.resetStats();
                  }
                }

                _context23.next = 14;
                break;

              case 10:
                _context23.prev = 10;
                _context23.t0 = _context23["catch"](6);
                _didIteratorError28 = true;
                _iteratorError28 = _context23.t0;

              case 14:
                _context23.prev = 14;
                _context23.prev = 15;

                if (!_iteratorNormalCompletion28 && _iterator28.return != null) {
                  _iterator28.return();
                }

              case 17:
                _context23.prev = 17;

                if (!_didIteratorError28) {
                  _context23.next = 20;
                  break;
                }

                throw _iteratorError28;

              case 20:
                return _context23.finish(17);

              case 21:
                return _context23.finish(14);

              case 22:
                pcTracks.map(function (p) {
                  return p.connectStatus = TrackConnectStatus.Connect;
                });
                return _context23.abrupt("return", data);

              case 24:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this, [[6, 10, 14, 22], [15,, 17, 21]]);
      }));

      function _execAddProducerTracks(_x45) {
        return _execAddProducerTracks2.apply(this, arguments);
      }

      return _execAddProducerTracks;
    }()
  }, {
    key: "_execRemoveTracks",
    value: function _execRemoveTracks(pcTracks) {
      this.removeTrackFromPublishTracks(pcTracks.map(function (p) {
        return p.track;
      }));
      pcTracks.map(function (p) {
        return p.release();
      });
      return this.sendHandler.removeProducerTracks(pcTracks);
    }
  }, {
    key: "_execRestartSendICE",
    value: function () {
      var _execRestartSendICE2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee24(pcid) {
        var res;
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                this.sendHandler._isRestartingICE = true;
                _context24.next = 3;
                return this.signaling.request("pubpc-restart", {
                  pcid: pcid
                });

              case 3:
                res = _context24.sent;

                if (!(res.code !== 0)) {
                  _context24.next = 9;
                  break;
                }

                this.sendHandler._isRestartingICE = false;
                log.debug("restart ice faild", res.code, res.error);
                this.reconnectProducer();
                return _context24.abrupt("return");

              case 9:
                _context24.prev = 9;
                _context24.next = 12;
                return this.sendHandler.restartICE(res.iceParameters, res.iceCandidates);

              case 12:
                this.sendHandler._isRestartingICE = false;
                _context24.next = 20;
                break;

              case 15:
                _context24.prev = 15;
                _context24.t0 = _context24["catch"](9);
                log.debug("restart ice faild", res.code, res.error);
                this.sendHandler._isRestartingICE = false;
                this.reconnectProducer();

              case 20:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this, [[9, 15]]);
      }));

      function _execRestartSendICE(_x46) {
        return _execRestartSendICE2.apply(this, arguments);
      }

      return _execRestartSendICE;
    }()
  }, {
    key: "reconnectProducer",
    value: function reconnectProducer() {
      this.resetSendCommandQueue();
      this.sendHandler.close();
      var targetPCTracks = this.publishTracks;
      this.sendHandler = getHandler("send", this.extendedRtpCapabilities, this.signaling, {
        simulcast: this.simulcast,
        core: this.coreInstance
      });
      this.handleSendHandler();
      targetPCTracks.forEach(function (t) {
        t.connectStatus = TrackConnectStatus.Connecting;
      });
      this.emit("@needrepub", targetPCTracks);
    }
  }, {
    key: "handleRecvHandler",
    value: function handleRecvHandler() {
      var _this61 = this;

      this.recvHandler.on("@needsubpc", function (d, cb, errcb) {
        _this61.safeEmitAsPromise("@needsubpc", d).then(cb, errcb);
      }).on("@connectionstatechange", function (state) {
        log.log("sub pc connection state change", state);
        qos.addEvent("ICEConnectionState", {
          pc_type: 1,
          state: state,
          id: _this61.recvHandler.pcid
        });

        switch (state) {
          case "remote-disconnected":
          case "closed":
          case "failed":
            {
              if (_this61.signaling.state === SignalingState.OPEN) {
                _this61.resetRecvHandler();
              } else {
                // 置为 close，等待信令重连完成后统一重新创建
                _this61.recvHandler.close();
              }

              break;
            }

          case "disconnected":
            {
              if (_this61.recvHandler._isRestartingICE || !_this61.recvHandler.pcid) return;

              if (_this61.signaling.state === SignalingState.OPEN) {
                _this61.restartRecvICE(_this61.recvHandler.pcid);
              } else {
                _this61.signaling.once("@signalingauth", function (data) {
                  if (_this61.recvHandler.getCurrentIceConnectionState() !== "disconnected") return;
                  _this61.extendedRtpCapabilities = data.rtpcaps;

                  _this61.restartRecvICE(_this61.recvHandler.pcid);
                });
              }

              break;
            }

          default:
            {
              break;
            }
        }
      });
    }
  }, {
    key: "appendConsumer",
    value: function appendConsumer(consumer) {
      this.consumerQueue.push(consumer);
    }
  }, {
    key: "addConsumers",
    value: function () {
      var _addConsumers2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee25() {
        var consumers;
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                consumers = this.consumerQueue;
                this.consumerQueue = [];
                return _context25.abrupt("return", this.recvCommandQueue.push(TaskCommandEnum.ADD_CONUMERS, consumers));

              case 3:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function addConsumers() {
        return _addConsumers2.apply(this, arguments);
      }

      return addConsumers;
    }()
  }, {
    key: "initRecvHandler",
    value: function initRecvHandler(trackIDs) {
      return this.recvInitCommandQueue.push(TaskCommandEnum.INIT_RECV, trackIDs);
    }
  }, {
    key: "removeConsumers",
    value: function () {
      var _removeConsumers2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee26(consumers) {
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _context26.next = 2;
                return this.recvCommandQueue.push(TaskCommandEnum.REMOVE_CONSUMERS, consumers);

              case 2:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function removeConsumers(_x47) {
        return _removeConsumers2.apply(this, arguments);
      }

      return removeConsumers;
    }()
  }, {
    key: "restartRecvICE",
    value: function () {
      var _restartRecvICE = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee27(pcid) {
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                if (__chunk_1.browserReport.supportRestartICE) {
                  _context27.next = 2;
                  break;
                }

                return _context27.abrupt("return", this.resetRecvHandler());

              case 2:
                return _context27.abrupt("return", this.recvCommandQueue.push(TaskCommandEnum.RESTART_RECV_ICE, pcid));

              case 3:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function restartRecvICE(_x48) {
        return _restartRecvICE.apply(this, arguments);
      }

      return restartRecvICE;
    }()
  }, {
    key: "_removeConsumers",
    value: function () {
      var _removeConsumers3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee28(consumers) {
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                _context28.next = 2;
                return this.recvHandler.removeConsumerTracks(consumers);

              case 2:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function _removeConsumers(_x49) {
        return _removeConsumers3.apply(this, arguments);
      }

      return _removeConsumers;
    }()
  }, {
    key: "_initRecvHandler",
    value: function () {
      var _initRecvHandler2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee29(trackIDs) {
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                if (this.recvHandler.isPcReady) {
                  _context29.next = 4;
                  break;
                }

                _context29.next = 3;
                return this.recvHandler.setupTransport(trackIDs);

              case 3:
                return _context29.abrupt("return", _context29.sent);

              case 4:
                _context29.next = 6;
                return this.initSubPcPromise;

              case 6:
                return _context29.abrupt("return", null);

              case 7:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function _initRecvHandler(_x50) {
        return _initRecvHandler2.apply(this, arguments);
      }

      return _initRecvHandler;
    }()
  }, {
    key: "_addConsumers",
    value: function () {
      var _addConsumers3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee30(consumers) {
        var tracks;
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                if (!(consumers.length === 0)) {
                  _context30.next = 2;
                  break;
                }

                return _context30.abrupt("return", Promise.resolve([]));

              case 2:
                _context30.next = 4;
                return this.recvHandler.addConsumerTracks(consumers);

              case 4:
                tracks = _context30.sent;
                return _context30.abrupt("return", tracks);

              case 6:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function _addConsumers(_x51) {
        return _addConsumers3.apply(this, arguments);
      }

      return _addConsumers;
    }()
  }, {
    key: "_execRestartRecvICE",
    value: function () {
      var _execRestartRecvICE2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee31(pcid) {
        var res;
        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                this.recvHandler._isRestartingICE = true;
                _context31.next = 3;
                return this.signaling.request("subpc-restart", {
                  pcid: pcid
                });

              case 3:
                res = _context31.sent;

                if (!(res.code !== 0)) {
                  _context31.next = 9;
                  break;
                }

                this.recvHandler._isRestartingICE = false;
                log.debug("restart ice faild", res.code, res.error);
                this.resetRecvHandler();
                return _context31.abrupt("return");

              case 9:
                _context31.prev = 9;
                _context31.next = 12;
                return this.recvHandler.restartICE(res.iceParameters, res.iceCandidates);

              case 12:
                this.recvHandler._isRestartingICE = false;
                _context31.next = 20;
                break;

              case 15:
                _context31.prev = 15;
                _context31.t0 = _context31["catch"](9);
                this.recvHandler._isRestartingICE = false;
                log.debug("restart ice faild", res.code, res.error);
                this.resetRecvHandler();

              case 20:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this, [[9, 15]]);
      }));

      function _execRestartRecvICE(_x52) {
        return _execRestartRecvICE2.apply(this, arguments);
      }

      return _execRestartRecvICE;
    }()
  }, {
    key: "handleRecvCommandTask",
    value: function handleRecvCommandTask(command, ph) {
      switch (command.method) {
        case TaskCommandEnum.ADD_CONUMERS:
          {
            ph.promise = this._addConsumers(command.data);
            return;
          }

        case TaskCommandEnum.REMOVE_CONSUMERS:
          {
            ph.promise = this._removeConsumers(command.data);
            return;
          }

        case TaskCommandEnum.RESTART_RECV_ICE:
          {
            ph.promise = this._execRestartRecvICE(command.data);
            return;
          }
      }
    }
  }, {
    key: "handleRecvInitCommandTask",
    value: function handleRecvInitCommandTask(command, ph) {
      switch (command.method) {
        case TaskCommandEnum.INIT_RECV:
          {
            ph.promise = this._initRecvHandler(command.data);
            return;
          }
      }
    }
  }, {
    key: "resetSendCommandQueue",
    value: function resetSendCommandQueue() {
      log.log("reset send queue");
      this.sendCommandQueue = new TaskQueue("SendQueue");
      this.sendCommandQueue.on("exec", this.handleSendCommandTask.bind(this));
    }
  }, {
    key: "resetRecvCommandQueue",
    value: function resetRecvCommandQueue() {
      log.log("reset recv queue");
      this.recvCommandQueue = new TaskQueue("RecvQueue");
      this.recvInitCommandQueue = new TaskQueue("RecvInitQueue");
      this.recvCommandQueue.on("exec", this.handleRecvCommandTask.bind(this));
      this.recvInitCommandQueue.on("exec", this.handleRecvInitCommandTask.bind(this));
    }
  }, {
    key: "resetRecvHandler",
    value: function resetRecvHandler() {
      var _this62 = this;

      this.resetRecvCommandQueue(); // 重置 RecvHandler 时外层 track 需要做一些操作

      this.emit("@needresetrecv");
      this.recvHandler.close();
      this.recvHandler = getHandler("recv", this.extendedRtpCapabilities, this.signaling, {
        simulcast: this.simulcast,
        core: this.coreInstance
      });
      this.initSubPcPromise = new Promise(function (resolve) {
        _this62.initSubPcPromiseResolve = resolve;
      });
      this.handleRecvHandler(); // 重连Consumer需要对比服务端的变化，抛出事件

      this.emit("@needresub");
    }
  }, {
    key: "release",
    value: function release() {
      this.recvHandler.close();
      this.sendHandler.close();
      this.publishTracks.forEach(function (t) {
        return t.release();
      });
    }
  }, {
    key: "publishTracks",
    get: function get() {
      return Array.from(this._publishTracks.values());
    }
  }]);

  return ConnectionTransport;
}(EnhancedEventEmitter);

var qnevents = new EnhancedEventEmitter();
/**
 * ws 连接 url，返回结果
 */

function wsConnect(url, timeout) {
  return new Promise(function (resolve) {
    var timeoutID;
    var startTime = Date.now();
    var ws = new WebSocket(url);

    ws.onopen = function () {
      if (timeoutID) {
        clearTimeout(timeoutID);
      }

      var connectTime = Date.now() - startTime;
      resolve({
        ws: ws,
        url: url,
        status: true,
        reason: "ok",
        connectTime: connectTime
      });
    };

    ws.onerror = function () {
      if (timeoutID) {
        clearTimeout(timeoutID);
      }

      var connectTime = Date.now() - startTime;
      resolve({
        ws: ws,
        url: url,
        status: false,
        reason: 'onerror',
        connectTime: connectTime
      });
    };

    timeoutID = setTimeout(function () {
      var connectTime = Date.now() - startTime;
      resolve({
        ws: ws,
        url: url,
        status: false,
        reason: 'timeout',
        connectTime: connectTime
      });
      ws.close();
    }, timeout);
  });
}
/**
 * 并发连接 urls，返回第一个成功建立连接的 ws 对象，所有结果做打点
 * 后返回的 ws，不管是否连接成功（默认几秒内不发 auth，服务端会自动关闭），直接忽略。
 */


function wsCreate(urls, timeout) {
  var results = [];
  var isSucess = false;
  return new Promise(function (resolve, reject) {
    var _iteratorNormalCompletion29 = true;
    var _didIteratorError29 = false;
    var _iteratorError29 = undefined;

    try {
      for (var _iterator29 = urls[Symbol.iterator](), _step29; !(_iteratorNormalCompletion29 = (_step29 = _iterator29.next()).done); _iteratorNormalCompletion29 = true) {
        var url = _step29.value;
        wsConnect(url, timeout).then(function (res) {
          results.push(res);

          if (res.status) {
            resolve({
              ws: res.ws,
              url: res.url
            });
            isSucess = true;
          }

          qos.addEvent("WebsocketConnect", {
            happy_dns_resolve_time: 0,
            happy_dns_take_effect: false,
            socket_node_info: res.url,
            socket_connect_time: res.connectTime,
            socket_connect_success: res.status,
            socket_connect_error_message: res.reason
          });

          if (results.length === urls.length && !isSucess) {
            reject(ERROR_AUTH_FAILED("websocket connect failed."));
          }
        });
      }
    } catch (err) {
      _didIteratorError29 = true;
      _iteratorError29 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion29 && _iterator29.return != null) {
          _iterator29.return();
        }
      } finally {
        if (_didIteratorError29) {
          throw _iteratorError29;
        }
      }
    }
  });
}

var RoomState;

(function (RoomState) {
  RoomState[RoomState["Idle"] = 0] = "Idle";
  RoomState[RoomState["Connecting"] = 1] = "Connecting";
  RoomState[RoomState["Connected"] = 2] = "Connected";
  RoomState[RoomState["Reconnecting"] = 3] = "Reconnecting";
})(RoomState || (RoomState = {}));

var DEFAULT_CONFIG = {
  transportPolicy: "preferUdp",
  simulcast: false,
  reconnectTimes: 3,
  requestTimeout: 5 * 1000
};

var QNRTCCore =
/*#__PURE__*/
function (_EventEmitter3) {
  _inherits(QNRTCCore, _EventEmitter3);

  function QNRTCCore() {
    var _this63;

    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_CONFIG;

    _classCallCheck(this, QNRTCCore);

    _this63 = _possibleConstructorReturn(this, _getPrototypeOf(QNRTCCore).call(this));
    _this63.profiles = new Map();
    _this63._trackInfo = [];
    _this63.recorder = new QNMediaRecorder();
    _this63.volumeIndicatorHistory = [];
    /**
     * 所有订阅的 PCTrack，需要注意的是这些 PCTrack 可能有 2 种状态
     * 1. Connecting 表示正在进行连接过程
     * 2. Conncted 表示连接已经建立（subscribe 已经 resolve）
     */

    _this63.subscribeTracks = []; // userid -> User

    _this63._users = new Map();
    _this63._roomState = RoomState.Idle;
    _this63.mergeJobMerger = {};
    _this63.defaultMergeJobTracks = [];
    _this63.mergeJobTracks = {};
    _this63.forwardJobTracks = {};
    _this63._mode = exports.QNClientMode.RTC;
    _this63._role = exports.QNClientRole.AUDIENCE;
    _this63._privileges = ["subscribe", "publish"];

    _this63._publish = function (tracks, isReconnect) {
      return new Promise(
      /*#__PURE__*/
      function () {
        var _ref12 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee32(resolve, reject) {
          var transport, signaling, pcTracks, localIds, currentLocalIds, targetTracks, connectPromise, user;
          return _regeneratorRuntime.wrap(function _callee32$(_context32) {
            while (1) {
              switch (_context32.prev = _context32.next) {
                case 0:
                  if (!(_this63.roomState !== RoomState.Connected)) {
                    _context32.next = 3;
                    break;
                  }

                  reject(ERROR_FATAL("not connected to the room, please run joinRoom first"));
                  return _context32.abrupt("return");

                case 3:
                  if (tracks.length === 0) {
                    resolve();
                  }

                  if (!(_this63._mode === exports.QNClientMode.LIVE && _this63._role === exports.QNClientRole.AUDIENCE)) {
                    _context32.next = 7;
                    break;
                  }

                  reject(ERROR_FATAL("no permission. Audience in Live mode has no permission to publish."));
                  return _context32.abrupt("return");

                case 7:
                  tracks.forEach(function (t) {
                    return t.userID = _this63.userID;
                  });
                  tracks.forEach(function (t) {
                    return t.selfEndedCallback = _this63.unpublish.bind(_assertThisInitialized(_assertThisInitialized(_this63)));
                  });
                  transport = _this63.connectionTransport;
                  signaling = _this63.signaling;

                  if (!isReconnect) {
                    _context32.next = 16;
                    break;
                  }

                  localIds = tracks.map(function (t) {
                    return t.mediaTrack.id;
                  });
                  pcTracks = transport.publishTracks.filter(function (t) {
                    return localIds.indexOf(t.track.mediaTrack.id) !== -1;
                  });
                  _context32.next = 22;
                  break;

                case 16:
                  currentLocalIds = transport.publishTracks.map(function (t) {
                    return t.track.mediaTrack.id;
                  });
                  targetTracks = tracks.filter(function (t) {
                    return currentLocalIds.indexOf(t.mediaTrack.id) === -1;
                  }); // 这里表示传入的 track 包含已经发布过的 track，直接抛出错误，简化逻辑

                  if (!(targetTracks.length !== tracks.length)) {
                    _context32.next = 21;
                    break;
                  }

                  reject(ERROR_FATAL("there are already published tracks in the provided tracks"));
                  return _context32.abrupt("return");

                case 21:
                  pcTracks = transport.addTrackToPublishTracks(tracks);

                case 22:
                  log.debug("start publish", pcTracks, isReconnect);

                  if (!isReconnect) {
                    connectPromise = pcTracks.map(function (p) {
                      return p.startConnect();
                    });
                    Promise.all(connectPromise).then(function () {
                      return resolve();
                    }).catch(function () {
                      // 表示调用了 unpublish 中止了发布
                      reject(SUB_PUB_ABORT());
                    });
                  }

                  _context32.prev = 24;
                  _context32.next = 27;
                  return transport.sendTracks(pcTracks);

                case 27:
                  signaling.sendWsMsg("mute-tracks", {
                    tracks: pcTracks.map(function (track) {
                      return {
                        trackid: track.trackID,
                        muted: !!track.track.info.muted
                      };
                    })
                  });
                  user = getElementFromArray(_this63.users, "userID", _this63.userID);

                  if (user) {
                    user.addTracks(pcTracks.map(function (p) {
                      return p.track;
                    }));
                    user.addPublishedTrackInfo(pcTracks.map(function (t) {
                      return {
                        trackID: t.trackID,
                        muted: !!t.track.info.muted,
                        kind: t.track.info.kind,
                        tag: t.track.info.tag,
                        userID: _this63.userID,
                        versionid: t.track.info.versionid,
                        profiles: t.track.info.profiles
                      };
                    }));
                  }

                  tracks.forEach(function (t) {
                    t.on("@get-stats", function (lastReportList, cb, errorcb) {
                      if (!_this63.connectionTransport) return cb([]);
                      var targetTrack = t.isReplacedByImageTrack ? t.imageStreamTrack.mediaTrack : t.mediaTrack;

                      _this63.connectionTransport.sendHandler.getStats(targetTrack, lastReportList).then(cb, errorcb);
                    });
                  });

                  _this63.getAllMerger().forEach(function (m) {
                    return m.controller.onAddTracks(tracks.map(function (t) {
                      return t.info;
                    }));
                  });

                  _context32.next = 50;
                  break;

                case 34:
                  _context32.prev = 34;
                  _context32.t0 = _context32["catch"](24);

                  if (!(_context32.t0 instanceof QNRTCError)) {
                    _context32.next = 48;
                    break;
                  }

                  _context32.t1 = _context32.t0.code;
                  _context32.next = _context32.t1 === 10061 ? 40 : _context32.t1 === 30001 ? 40 : _context32.t1 === 10052 ? 41 : 44;
                  break;

                case 40:
                  return _context32.abrupt("return");

                case 41:
                  log.warning(_context32.t0, "republish");
                  setTimeout(function () {
                    return _this63._publish(tracks, true);
                  }, 1000);
                  return _context32.abrupt("return");

                case 44:
                  transport.removeTrackFromPublishTracks(tracks);
                  reject(_context32.t0);

                case 46:
                  _context32.next = 50;
                  break;

                case 48:
                  log.warning(_context32.t0, "republish");
                  setTimeout(function () {
                    return _this63._publish(tracks, true);
                  }, 1000);

                case 50:
                case "end":
                  return _context32.stop();
              }
            }
          }, _callee32, this, [[24, 34]]);
        }));

        return function (_x53, _x54) {
          return _ref12.apply(this, arguments);
        };
      }());
    };

    _this63._subscribe = function (trackIDs, isReconnect) {
      var strictMode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var trackProfiles = arguments.length > 3 ? arguments[3] : undefined;
      return new Promise(
      /*#__PURE__*/
      function () {
        var _ref13 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee34(resolve, reject) {
          var availableTrackInfo, pcTracks, transport, signaling, currentTrackIds, targetTrackInfo, connectPromise, data, startTime, successTracks, faildTrackIds, removedPcTracks, _iteratorNormalCompletion30, _didIteratorError30, _iteratorError30, _loop13, _iterator30, _step30, _ret7, _iteratorNormalCompletion31, _didIteratorError31, _iteratorError31, _loop14, _iterator31, _step31, _ret8, tracks, consumers;

          return _regeneratorRuntime.wrap(function _callee34$(_context34) {
            while (1) {
              switch (_context34.prev = _context34.next) {
                case 0:
                  if (!(_this63.roomState !== RoomState.Connected)) {
                    _context34.next = 3;
                    break;
                  }

                  reject(ERROR_FATAL("can not connected to the room, please joinRoom first"));
                  return _context34.abrupt("return");

                case 3:
                  if (!(trackIDs.length === 0)) {
                    _context34.next = 6;
                    break;
                  }

                  resolve([]);
                  return _context34.abrupt("return");

                case 6:
                  log.debug("subscribe", trackIDs, isReconnect);
                  availableTrackInfo = _this63._trackInfo.filter(function (info) {
                    return trackIDs.includes(info.trackid);
                  });

                  if (!(availableTrackInfo.length !== trackIDs.length)) {
                    _context34.next = 11;
                    break;
                  }

                  reject(SUB_ERROR(10041, "can not find track in room ".concat(trackIDs)));
                  return _context34.abrupt("return");

                case 11:
                  transport = _this63.connectionTransport;
                  signaling = _this63.signaling;

                  if (isReconnect) {
                    pcTracks = _this63.subscribeTracks.filter(function (t) {
                      return trackIDs.indexOf(t.trackID) !== -1;
                    });
                  } else {
                    currentTrackIds = _this63.subscribeTracks.map(function (t) {
                      return t.trackID;
                    });
                    targetTrackInfo = availableTrackInfo.filter(function (t) {
                      return !currentTrackIds.includes(t.trackid);
                    });
                    pcTracks = targetTrackInfo.map(function (t) {
                      return new PCTrack(transport, "recv", undefined, t.trackid, t.mid);
                    });
                    _this63.subscribeTracks = _this63.subscribeTracks.concat(pcTracks);
                  }

                  if (trackProfiles) {
                    Object.entries(trackProfiles).forEach(function (_ref14) {
                      var _ref15 = _slicedToArray(_ref14, 2),
                          key = _ref15[0],
                          value = _ref15[1];

                      _this63.profiles.set(key, value);
                    });
                  }

                  log.log("sub tracks", pcTracks, trackProfiles);
                  _context34.prev = 16;

                  if (!isReconnect) {
                    connectPromise = pcTracks.map(function (t) {
                      return t.startConnect();
                    });
                    Promise.all(connectPromise).then(function () {
                      return resolve(pcTracks.map(function (p) {
                        return p.track;
                      }));
                    }).catch(function () {
                      // 表示调用 unsubscribe 中止了订阅
                      reject(SUB_PUB_ABORT());
                    });
                  }

                  _context34.next = 20;
                  return transport.initRecvHandler(pcTracks.map(function (t) {
                    return t.trackID;
                  }));

                case 20:
                  data = _context34.sent;

                  if (data) {
                    _context34.next = 27;
                    break;
                  }

                  startTime = Date.now();
                  _context34.next = 25;
                  return signaling.request("sub-tracks", {
                    tracks: pcTracks.map(function (track) {
                      var trackId = track.trackID;
                      return _this63.profiles.get(trackId) ? {
                        trackid: trackId,
                        profile: _this63.profiles.get(trackId)
                      } : {
                        trackid: trackId
                      };
                    })
                  });

                case 25:
                  data = _context34.sent;
                  qos.addEvent("SubscribeTracks", {
                    result_code: data.code,
                    signal_take_time: Date.now() - startTime,
                    tracks: data.tracks.map(function (t) {
                      return {
                        track_id: t.trackid,
                        status: t.status
                      };
                    })
                  });

                case 27:
                  log.log("get sub res data", data);
                  _context34.t0 = data.code;
                  _context34.next = _context34.t0 === 0 ? 31 : _context34.t0 === 10052 ? 32 : _context34.t0 === 10062 ? 33 : 35;
                  break;

                case 31:
                  return _context34.abrupt("break", 36);

                case 32:
                  throw SERVER_UNAVAILABLE();

                case 33:
                  transport.resetRecvHandler();
                  throw SUB_ERROR(10062, data.error);

                case 35:
                  throw SUB_ERROR(data.code, data.error);

                case 36:
                  successTracks = data.tracks.filter(function (t) {
                    return !!t.status;
                  });
                  faildTrackIds = data.tracks.filter(function (t) {
                    return !t.status;
                  }).map(function (t) {
                    return t.trackid;
                  }); // 在严格模式下，直接抛出错误，取消之后的订阅流程

                  if (!(successTracks.length < data.tracks.length && strictMode)) {
                    _context34.next = 40;
                    break;
                  }

                  throw SUB_ERROR(10041, "can not find target track id: ".concat(faildTrackIds.join(" ")));

                case 40:
                  if (successTracks && !strictMode) {
                    log.debug("can not find target track id: ".concat(faildTrackIds.join(""), ", continue"));
                    removedPcTracks = remove(pcTracks, function (t) {
                      return faildTrackIds.indexOf(t.trackID) !== -1;
                    });
                    remove(_this63.subscribeTracks, function (t) {
                      return faildTrackIds.indexOf(t.trackID) !== -1;
                    });
                    removedPcTracks.map(function (t) {
                      return t.release();
                    });
                  }

                  data.tracks = successTracks; // 先检查后设置

                  _iteratorNormalCompletion30 = true;
                  _didIteratorError30 = false;
                  _iteratorError30 = undefined;
                  _context34.prev = 45;

                  _loop13 = function _loop13() {
                    var track = _step30.value;
                    var pcTrack = pcTracks.find(function (t) {
                      return t.trackID === track.trackid;
                    });
                    var info = availableTrackInfo.find(function (t) {
                      return t.trackid === track.trackid;
                    });
                    if (!pcTrack || !info) return "continue";
                    var rtpparams = track.rtpparams;
                    pcTrack.appendConsumner(rtpparams, info.kind);
                  };

                  _iterator30 = (data.tracks || [])[Symbol.iterator]();

                case 48:
                  if (_iteratorNormalCompletion30 = (_step30 = _iterator30.next()).done) {
                    _context34.next = 55;
                    break;
                  }

                  _ret7 = _loop13();

                  if (!(_ret7 === "continue")) {
                    _context34.next = 52;
                    break;
                  }

                  return _context34.abrupt("continue", 52);

                case 52:
                  _iteratorNormalCompletion30 = true;
                  _context34.next = 48;
                  break;

                case 55:
                  _context34.next = 61;
                  break;

                case 57:
                  _context34.prev = 57;
                  _context34.t1 = _context34["catch"](45);
                  _didIteratorError30 = true;
                  _iteratorError30 = _context34.t1;

                case 61:
                  _context34.prev = 61;
                  _context34.prev = 62;

                  if (!_iteratorNormalCompletion30 && _iterator30.return != null) {
                    _iterator30.return();
                  }

                case 64:
                  _context34.prev = 64;

                  if (!_didIteratorError30) {
                    _context34.next = 67;
                    break;
                  }

                  throw _iteratorError30;

                case 67:
                  return _context34.finish(64);

                case 68:
                  return _context34.finish(61);

                case 69:
                  _context34.next = 71;
                  return transport.addConsumers();

                case 71:
                  transport.resolveInitSubPcPromise();
                  _iteratorNormalCompletion31 = true;
                  _didIteratorError31 = false;
                  _iteratorError31 = undefined;
                  _context34.prev = 75;

                  _loop14 = function _loop14() {
                    var pcTrack = _step31.value;
                    var consumer = pcTrack.consumer;
                    if (!consumer || !consumer.track) return "continue";
                    var t = consumer.track;
                    var track = pcTrack.track;
                    var info = availableTrackInfo.find(function (t) {
                      return t.trackid === consumer.id;
                    });
                    if (!info) return "continue";

                    if (!track) {
                      if (t.kind === "audio") {
                        track = new AudioTrack(t, info.playerid, "remote");
                        track.initAudioManager();
                      } else {
                        track = new Track(t, info.playerid, "remote", info.profiles || []);
                      }
                    } else {
                      track.resume(t);
                    }

                    track.setInfo({
                      trackID: info.trackid,
                      userID: info.playerid,
                      tag: info.tag,
                      kind: info.kind,
                      muted: info.muted,
                      versionid: info.versionid
                    });
                    track.setMaster(info.master);
                    track.removeAllListeners("@get-stats");
                    track.removeAllListeners("@ended");
                    track.on("@get-stats", function (lastReportList, cb, errcb) {
                      if (!_this63.connectionTransport) return cb([]);

                      _this63.connectionTransport.recvHandler.getStats(track.mediaTrack, lastReportList).then(cb, errcb);
                    }); // 如果远端 track ended，重新订阅

                    track.once("@ended",
                    /*#__PURE__*/
                    _asyncToGenerator(
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee33() {
                      return _regeneratorRuntime.wrap(function _callee33$(_context33) {
                        while (1) {
                          switch (_context33.prev = _context33.next) {
                            case 0:
                              if (!(!track || !track.info.trackID)) {
                                _context33.next = 2;
                                break;
                              }

                              return _context33.abrupt("return");

                            case 2:
                              log.warning("remote track ended, try to resubscribe");
                              _context33.prev = 3;
                              _context33.next = 6;
                              return _this63._unsubscribe([track.info.trackID], true);

                            case 6:
                              _context33.next = 10;
                              break;

                            case 8:
                              _context33.prev = 8;
                              _context33.t0 = _context33["catch"](3);

                            case 10:
                              _context33.next = 12;
                              return _this63._subscribe([track.info.trackID], true);

                            case 12:
                            case "end":
                              return _context33.stop();
                          }
                        }
                      }, _callee33, this, [[3, 8]]);
                    })));
                    pcTrack.track = track;

                    var user = _this63.users.find(function (u) {
                      return u.userID === info.playerid;
                    });

                    if (user) {
                      user.addTracks([track]);
                    }
                  };

                  _iterator31 = pcTracks[Symbol.iterator]();

                case 78:
                  if (_iteratorNormalCompletion31 = (_step31 = _iterator31.next()).done) {
                    _context34.next = 85;
                    break;
                  }

                  _ret8 = _loop14();

                  if (!(_ret8 === "continue")) {
                    _context34.next = 82;
                    break;
                  }

                  return _context34.abrupt("continue", 82);

                case 82:
                  _iteratorNormalCompletion31 = true;
                  _context34.next = 78;
                  break;

                case 85:
                  _context34.next = 91;
                  break;

                case 87:
                  _context34.prev = 87;
                  _context34.t2 = _context34["catch"](75);
                  _didIteratorError31 = true;
                  _iteratorError31 = _context34.t2;

                case 91:
                  _context34.prev = 91;
                  _context34.prev = 92;

                  if (!_iteratorNormalCompletion31 && _iterator31.return != null) {
                    _iterator31.return();
                  }

                case 94:
                  _context34.prev = 94;

                  if (!_didIteratorError31) {
                    _context34.next = 97;
                    break;
                  }

                  throw _iteratorError31;

                case 97:
                  return _context34.finish(94);

                case 98:
                  return _context34.finish(91);

                case 99:
                  pcTracks.forEach(function (t) {
                    return t.connectStatus = TrackConnectStatus.Connect;
                  }); // sub 数据中，缺少 muted 属性，此时手动通过 trackid 使用 this._trackInfo 赋值，
                  // 防止在 handleMute 中将 muted 属性设置为了 undefined

                  tracks = data.tracks.map(function (subTrack) {
                    if (subTrack.muted === undefined) {
                      for (var i = 0; i < _this63._trackInfo.length; i++) {
                        if (subTrack.trackid === _this63._trackInfo[i].trackid) {
                          subTrack.muted = _this63._trackInfo[i].muted;
                        }
                      }
                    }

                    return subTrack;
                  });

                  _this63.handleMute({
                    tracks: tracks
                  });

                  _context34.next = 126;
                  break;

                case 104:
                  _context34.prev = 104;
                  _context34.t3 = _context34["catch"](16);
                  log.log(_context34.t3);
                  consumers = [];
                  pcTracks.forEach(function (t) {
                    if (t.consumer) {
                      consumers.push(t.consumer);
                    }
                  });
                  _context34.next = 111;
                  return transport.removeConsumers(consumers);

                case 111:
                  if (!(_context34.t3 instanceof QNRTCError)) {
                    _context34.next = 123;
                    break;
                  }

                  _context34.t4 = _context34.t3.code;
                  _context34.next = _context34.t4 === 10062 ? 115 : _context34.t4 === 30001 ? 115 : _context34.t4 === 10052 ? 116 : 119;
                  break;

                case 115:
                  return _context34.abrupt("return");

                case 116:
                  log.warning(_context34.t3, "resubscribe");
                  setTimeout(function () {
                    return _this63._subscribe(trackIDs, true);
                  }, 1000);
                  return _context34.abrupt("return");

                case 119:
                  remove(_this63.subscribeTracks, function (t) {
                    return trackIDs.indexOf(t.trackID) !== -1;
                  });
                  reject(_context34.t3);

                case 121:
                  _context34.next = 126;
                  break;

                case 123:
                  log.warning(_context34.t3, "resubscribe");
                  setTimeout(function () {
                    return _this63._subscribe(trackIDs, true);
                  }, 1000);
                  return _context34.abrupt("return");

                case 126:
                  resolve(pcTracks.map(function (p) {
                    return p.track;
                  }));

                case 127:
                case "end":
                  return _context34.stop();
              }
            }
          }, _callee34, this, [[16, 104], [45, 57, 61, 69], [62,, 64, 68], [75, 87, 91, 99], [92,, 94, 98]]);
        }));

        return function (_x55, _x56) {
          return _ref13.apply(this, arguments);
        };
      }());
    }; // update config for potential missing property


    config = __chunk_1._objectSpread({}, DEFAULT_CONFIG, config);
    _this63.config = config;
    log.log("config", config);
    log.log("version", version);
    log.log("browser report", __chunk_1.browserReport, __chunk_1.browser);
    return _this63;
  }

  _createClass(QNRTCCore, [{
    key: "_setReconnectTimes",
    value: function _setReconnectTimes(reconnectTimes) {
      this.config.reconnectTimes = reconnectTimes;

      if (this.signaling) {
        this.signaling.reconnectTimes = reconnectTimes;
      }
    }
  }, {
    key: "_getReconnectTimes",
    value: function _getReconnectTimes() {
      return this.config.reconnectTimes || DEFAULT_CONFIG.reconnectTimes;
    }
  }, {
    key: "setRequestTimeout",
    value: function setRequestTimeout(timeout) {
      this.config.requestTimeout = timeout;
    }
  }, {
    key: "_setProfile",
    value: function _setProfile(trackID, profile) {
      this.profile = profile;
      this.profiles.set(trackID, profile);
      if (!this.subscribeTracks.some(function (track) {
        return track.trackID === trackID;
      })) return;
      var signaling = this.signaling;
      signaling.sendWsMsg('set-sub-profile', {
        tracks: [{
          trackid: trackID,
          profile: this.profile
        }]
      });
    }
    /**
     * 获取当前用户单路转推 Job 信息
     */

  }, {
    key: "getForwardJobTracks",
    value: function getForwardJobTracks() {
      return this.forwardJobTracks;
    }
    /**
     * 房间中已经发布的 Track 列表
     */

  }, {
    key: "setClientMode",
    value: function () {
      var _setClientMode = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee35(mode) {
        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                if (!(this.roomState !== RoomState.Idle)) {
                  _context35.next = 2;
                  break;
                }

                throw ERROR_FATAL("can not setClientMode, room state is not idle");

              case 2:
                this._mode = mode;

                this._setPrivileges();

              case 4:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, this);
      }));

      function setClientMode(_x57) {
        return _setClientMode.apply(this, arguments);
      }

      return setClientMode;
    }()
  }, {
    key: "_setPrivileges",
    value: function _setPrivileges() {
      if (this._mode === exports.QNClientMode.RTC || this._mode === exports.QNClientMode.LIVE && this._role === exports.QNClientRole.BROADCASTER) {
        this._privileges = ["subscribe", "publish"];
      } else {
        this._privileges = ["subscribe"];
      }
    }
  }, {
    key: "setClientRole",
    value: function () {
      var _setClientRole = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee36(role) {
        var res;
        return _regeneratorRuntime.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                if (!(this._mode === exports.QNClientMode.RTC)) {
                  _context36.next = 2;
                  break;
                }

                throw ERROR_FATAL("client role can only be set in client mode LIVE.");

              case 2:
                if (!(role === exports.QNClientRole.AUDIENCE)) {
                  _context36.next = 5;
                  break;
                }

                if (!(this.publishedTracks.length > 0 && role === exports.QNClientRole.AUDIENCE)) {
                  _context36.next = 5;
                  break;
                }

                throw ERROR_FATAL("cannot change to audience, please unpublish all tracks first.");

              case 5:
                this._role = role;

                this._setPrivileges();

                if (!(this.roomState !== RoomState.Connected)) {
                  _context36.next = 9;
                  break;
                }

                return _context36.abrupt("return");

              case 9:
                _context36.next = 11;
                return this.signaling.request("set-privileges", {
                  privileges: this._privileges
                });

              case 11:
                res = _context36.sent;
                qos.addEvent("SetClientRole", {
                  "result_code": res.code,
                  "user_role": role === exports.QNClientRole.BROADCASTER ? 0 : 1,
                  "audience_latency_level": 0
                });

                if (!(res.code !== 0)) {
                  _context36.next = 15;
                  break;
                }

                throw SERVER_ERROR(res.code, res.error);

              case 15:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, this);
      }));

      function setClientRole(_x58) {
        return _setClientRole.apply(this, arguments);
      }

      return setClientRole;
    }()
  }, {
    key: "joinRoomWithToken",
    value: function () {
      var _joinRoomWithToken = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee37(roomToken, userData) {
        var joinRoomStartTime, roomAccess, authRes, res, e;
        return _regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                joinRoomStartTime = Date.now();
                qos.addEvent("JoinRoom", {
                  room_token: roomToken,
                  user_data: userData
                });

                if (!(this.roomState !== RoomState.Idle)) {
                  _context37.next = 4;
                  break;
                }

                throw ERROR_FATAL("roomState is not idle! Do not repeat join room, please run leaveRoom first");

              case 4:
                this.roomState = RoomState.Connecting;
                _context37.prev = 5;
                this.roomToken = roomToken;
                this.userData = userData;
                roomAccess = getRoomAccessFromToken(roomToken);
                this.userID = roomAccess.userId;
                this.roomName = roomAccess.roomName;
                this.appId = roomAccess.appId;
                qos.setUserBase(this.userID, this.roomName, this.appId);
                log.log("join room, token:", roomToken);
                log.debug("join room, roomName: ".concat(this.roomName, ", userID: ").concat(this.userID));

                if (this.roomName.match(/^[a-zA-Z0-9_-]{3,64}$/)) {
                  _context37.next = 18;
                  break;
                }

                this.roomState = RoomState.Idle;
                throw ERROR_FATAL("invalid roomname. roomname must match /^[a-zA-Z0-9_-]{3,64}$/");

              case 18:
                if (this.userID.match(/^[a-zA-Z0-9_-]{3,50}$/)) {
                  _context37.next = 21;
                  break;
                }

                this.roomState = RoomState.Idle;
                throw ERROR_FATAL("invalid userID. userID must match /^[a-zA-Z0-9_-]{3,50}$/");

              case 21:
                _context37.prev = 21;
                _context37.next = 24;
                return getAccessToken(roomAccess, roomToken, this.config.requestTimeout);

              case 24:
                authRes = _context37.sent;
                this.accessToken = authRes.accessToken;
                qos.setSessionId(authRes.sessionId);
                qos.setUserBase(this.userID, this.roomName, this.appId);
                _context37.next = 33;
                break;

              case 30:
                _context37.prev = 30;
                _context37.t0 = _context37["catch"](21);
                throw _context37.t0;

              case 33:
                _context37.next = 35;
                return this.joinRoomWithAccess(this.accessToken);

              case 35:
                res = _context37.sent;
                qos.addEvent("JoinRoomResult", {
                  join_start_time: joinRoomStartTime,
                  join_take_time: Date.now() - joinRoomStartTime,
                  join_result_code: 0,
                  join_node_info: this.signaling.url,
                  join_error_message: ""
                });

                if (!(this._mode === exports.QNClientMode.LIVE)) {
                  _context37.next = 40;
                  break;
                }

                _context37.next = 40;
                return this.setClientRole(this._role);

              case 40:
                return _context37.abrupt("return", res);

              case 43:
                _context37.prev = 43;
                _context37.t1 = _context37["catch"](5);
                e = _context37.t1;
                this.roomState = RoomState.Idle;
                log.debug("joinRoomWithToken fail: " + e.message);
                qos.addEvent("JoinRoomResult", {
                  join_start_time: joinRoomStartTime,
                  join_take_time: Date.now() - joinRoomStartTime,
                  join_result_code: e.code ? e.code : -1,
                  join_node_info: this.signaling ? this.signaling.url : "",
                  join_error_message: e.message || e.error || ""
                });
                throw e;

              case 50:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37, this, [[5, 43], [21, 30]]);
      }));

      function joinRoomWithToken(_x59, _x60) {
        return _joinRoomWithToken.apply(this, arguments);
      }

      return joinRoomWithToken;
    }()
  }, {
    key: "joinRoomWithAccess",
    value: function () {
      var _joinRoomWithAccess = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee38(accessToken) {
        var _this64 = this;

        var accessPayload, _ref17, capsdp, signaling, urls, _ref18, ws, url, authResData, _iteratorNormalCompletion32, _didIteratorError32, _iteratorError32, _iterator32, _step32, user;

        return _regeneratorRuntime.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                accessPayload = getPayloadFromJwt(accessToken);
                _context38.next = 3;
                return getClientCapabilitiesSdp();

              case 3:
                _ref17 = _context38.sent;
                capsdp = _ref17.capsdp;

                if (!(this._roomState === RoomState.Idle)) {
                  _context38.next = 7;
                  break;
                }

                throw ERROR_FATAL("roomState is idle, maybe because you left the room.");

              case 7:
                signaling = new SignalingWS(accessToken, capsdp, this._getReconnectTimes(), this.config.requestTimeout, this.userData, this._privileges);
                signaling.on("@error", this.handleDisconnect.bind(this)).on("@ws-state-change", function (prev, curr) {
                  switch (curr) {
                    case SignalingState.CONNECTING:
                      if (_this64.roomState === RoomState.Connected) {
                        _this64.roomState = RoomState.Reconnecting;
                      } else if (_this64.roomState !== RoomState.Reconnecting) {
                        _this64.roomState = RoomState.Connecting;
                      }

                      break;

                    default:
                      break;
                  }
                }).on("@needupdateaccesstoken", function (cb, errcb) {
                  _this64.updateAccessToken().then(cb).catch(errcb);
                }).on("on-player-in", this.handlePlayerIn.bind(this)).on("on-player-out", this.handlePlayerOut.bind(this)).on("on-add-tracks", function (d) {
                  _this64.filterSignalTracks(d);

                  _this64.handleAddTracks(d);
                }).on("on-remove-tracks", function (d) {
                  _this64.filterSignalTracks(d);

                  _this64.handleRemoveTracks(d);
                }).on("mute-tracks", function (d) {
                  _this64.filterSignalTracks(d);

                  _this64.handleMute(d);
                }).on("on-messages", this.handleCustomMessages.bind(this)).on("on-qos-messages", this.handleQosMessages.bind(this)).on("on-pubpc-restart-notify", function (d) {
                  var transport = _this64.connectionTransport;
                  qos.addEvent("AbnormalDisconnect", {
                    event_reason: "on-pubpc-restart-notify",
                    event_description: d.error
                  });
                  if (!transport || !__chunk_1.browserReport.supportRestartICE) return;
                  transport.restartSendICE(d.pcid).catch(log.debug);
                }).on("on-subpc-restart-notify", function (d) {
                  var transport = _this64.connectionTransport;
                  qos.addEvent("AbnormalDisconnect", {
                    event_reason: "on-subpc-restart-notify",
                    event_description: d.error
                  });
                  if (!transport || !__chunk_1.browserReport.supportRestartICE) return;
                  transport.restartRecvICE(d.pcid).catch(log.debug);
                }).on("on-sub-profile-changed", function (d) {
                  _this64.emit("on-sub-profile-changed", d);
                }).on("on-job-connected", function (d) {
                  _this64.emit('forward-job-connected', {
                    jobId: d.id
                  });
                }).on("on-job-disconnected", function (d) {
                  _this64.emit('forward-job-disconnected', {
                    jobId: d.id
                  });
                }).on("on-merge-job-connected", function (d) {
                  _this64.emit('merge-job-connected', {
                    jobId: d.id
                  });
                }).on("on-merge-job-disconnected", function (d) {
                  _this64.emit('merge-job-disconnected', {
                    jobId: d.id
                  });
                }).on("on-media-relay-state", function (d) {
                  var roomName = d.roomid.slice(d.roomid.indexOf(":") + 1);

                  _this64.emit("media-relay-state-changed", roomName, d.state);
                }).on("disconnect", this.handleDisconnect.bind(this)).on("on-player-reconnect", this.handleRemoteUserReconnecting.bind(this)).on("on-player-reconnect-in", this.handleRemoteUserReconnected.bind(this));
                log.log("init signaling websocket");
                this.signaling = signaling;
                _context38.prev = 11;

                if (accessPayload.roomServers && accessPayload.roomServers.length > 0) {
                  urls = accessPayload.roomServers.sort(function (a, b) {
                    return b.score - a.score;
                  }).map(function (x) {
                    return x.url;
                  });
                } else {
                  urls = [accessPayload.signalingurl2];
                }

                _context38.next = 15;
                return wsCreate(urls, this.config.requestTimeout);

              case 15:
                _ref18 = _context38.sent;
                ws = _ref18.ws;
                url = _ref18.url;
                _context38.next = 20;
                return signaling.initWs(true, ws, url);

              case 20:
                authResData = _context38.sent;
                signaling.on("@signalingauth", this.handleAuth.bind(this));
                _context38.next = 24;
                return this.handleAuth(authResData);

              case 24:
                _context38.next = 34;
                break;

              case 26:
                _context38.prev = 26;
                _context38.t0 = _context38["catch"](11);

                if (this.signaling) {
                  this.signaling.release();
                  this.signaling = undefined;
                }

                if (!(_context38.t0.code === 10052)) {
                  _context38.next = 33;
                  break;
                }

                _context38.next = 32;
                return timeout(1000);

              case 32:
                return _context38.abrupt("return", this.joinRoomWithToken(this.roomToken, this.userData));

              case 33:
                throw _context38.t0;

              case 34:
                // 成功加入房间，emit 当前房间已有的 users
                _iteratorNormalCompletion32 = true;
                _didIteratorError32 = false;
                _iteratorError32 = undefined;
                _context38.prev = 37;

                for (_iterator32 = this.users[Symbol.iterator](); !(_iteratorNormalCompletion32 = (_step32 = _iterator32.next()).done); _iteratorNormalCompletion32 = true) {
                  user = _step32.value;

                  if (user.userID !== this.userID) {
                    this.emit("user-join", user);
                  }
                } // 成功加入房间，emit 当前房间已有的 trackInfoList


                _context38.next = 45;
                break;

              case 41:
                _context38.prev = 41;
                _context38.t1 = _context38["catch"](37);
                _didIteratorError32 = true;
                _iteratorError32 = _context38.t1;

              case 45:
                _context38.prev = 45;
                _context38.prev = 46;

                if (!_iteratorNormalCompletion32 && _iterator32.return != null) {
                  _iterator32.return();
                }

              case 48:
                _context38.prev = 48;

                if (!_didIteratorError32) {
                  _context38.next = 51;
                  break;
                }

                throw _iteratorError32;

              case 51:
                return _context38.finish(48);

              case 52:
                return _context38.finish(45);

              case 53:
                if (this.trackInfoList.length > 0) {
                  this.emit("track-add", this.trackInfoList);
                }

                return _context38.abrupt("return", this.users);

              case 55:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38, this, [[11, 26], [37, 41, 45, 53], [46,, 48, 52]]);
      }));

      function joinRoomWithAccess(_x61) {
        return _joinRoomWithAccess.apply(this, arguments);
      }

      return joinRoomWithAccess;
    }()
  }, {
    key: "_unpublish",
    value: function () {
      var _unpublish2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee39(trackIDs) {
        var transport, targetTracks, user;
        return _regeneratorRuntime.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                if (!(this.roomState !== RoomState.Connected)) {
                  _context39.next = 2;
                  break;
                }

                throw ERROR_FATAL("not connected to the room");

              case 2:
                if (!(trackIDs.length === 0)) {
                  _context39.next = 4;
                  break;
                }

                return _context39.abrupt("return");

              case 4:
                log.debug("unpublish", trackIDs);
                transport = this.connectionTransport;
                targetTracks = transport.publishTracks.filter(function (t) {
                  return trackIDs.indexOf(t.trackID) !== -1;
                });

                if (!(targetTracks.length !== trackIDs.length)) {
                  _context39.next = 9;
                  break;
                }

                throw ERROR_FATAL("can not find target trackid to unpublish");

              case 9:
                _context39.next = 11;
                return transport.removeTracks(targetTracks);

              case 11:
                this.getAllMerger().forEach(function (m) {
                  return m.controller.onRemoveTracks(targetTracks.map(function (t) {
                    return t.track.info;
                  }));
                });
                user = getElementFromArray(this.users, "userID", this.userID);

                if (user) {
                  user.removeTracksByTrackId(trackIDs);
                  user.removePublishedTrackInfo(trackIDs);
                }

                this.cleanTrackIdsFromMergeJobs(trackIDs);

              case 15:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39, this);
      }));

      function _unpublish(_x62) {
        return _unpublish2.apply(this, arguments);
      }

      return _unpublish;
    }()
  }, {
    key: "createMergeJob",
    value: function () {
      var _createMergeJob = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee40(id, option) {
        var mergeJob, startTime, data;
        return _regeneratorRuntime.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                if (!(this.roomState !== RoomState.Connected)) {
                  _context40.next = 2;
                  break;
                }

                throw ERROR_FATAL("can not createMergeJob, room state is not connected");

              case 2:
                mergeJob = __chunk_1._objectSpread({}, defaultMergeJob, option, {
                  id: id
                });
                log.debug("send create merge job", mergeJob, id);
                startTime = Date.now();
                _context40.next = 7;
                return this.signaling.request("create-merge-job", mergeJob);

              case 7:
                data = _context40.sent;
                qos.addEvent("CreateMergeJob", {
                  signal_take_time: Date.now() - startTime,
                  id: id,
                  result_code: data.code
                });

                if (!(data.code !== 0)) {
                  _context40.next = 11;
                  break;
                }

                throw CREATE_MERGE_JOB_ERROR(data.code, data.error);

              case 11:
                if (this.mergeJobTracks[id]) {
                  log.warning("merge job id already exist", id);
                } else {
                  this.mergeJobTracks[id] = [];
                }

              case 12:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40, this);
      }));

      function createMergeJob(_x63, _x64) {
        return _createMergeJob.apply(this, arguments);
      }

      return createMergeJob;
    }()
  }, {
    key: "createForwardJob",
    value: function () {
      var _createForwardJob = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee41(option) {
        var audioOnly, tracks, forwardJob, startTime, data;
        return _regeneratorRuntime.wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                if (!(this.roomState !== RoomState.Connected)) {
                  _context41.next = 2;
                  break;
                }

                throw ERROR_FATAL("can not createForwardJob, room state is not connected");

              case 2:
                audioOnly = !!option.audioTrackId && !option.videoTrackId;
                tracks = [option.audioTrackId, option.videoTrackId].filter(Boolean).map(function (t) {
                  return {
                    trackid: t
                  };
                });
                forwardJob = {
                  id: option.jobId,
                  publishUrl: option.publishUrl,
                  audioOnly: audioOnly,
                  tracks: tracks
                };

                if (!(option && option.userConfigExtraInfo)) {
                  _context41.next = 11;
                  break;
                }

                if (!(calcCharacterLength(option.userConfigExtraInfo) <= 1000)) {
                  _context41.next = 10;
                  break;
                }

                forwardJob.seiTemplate = {
                  value: option.userConfigExtraInfo
                };
                _context41.next = 11;
                break;

              case 10:
                throw ERROR_FATAL("userConfigExtraInfo Up to 1000 Bytes");

              case 11:
                startTime = Date.now();
                _context41.next = 14;
                return this.signaling.request("create-forward-job", forwardJob);

              case 14:
                data = _context41.sent;
                qos.addEvent("CreateForwardJob", {
                  signal_take_time: Date.now() - startTime,
                  id: option.jobId,
                  result_code: data.code
                });

                if (!(data.code !== 0)) {
                  _context41.next = 18;
                  break;
                }

                throw CREATE_FORWARD_JOB_ERROR(data.code, data.error);

              case 18:
                if (this.forwardJobTracks[option.jobId]) {
                  log.warning("forward job id already exist", option.jobId);
                } else {
                  this.forwardJobTracks[option.jobId] = [];
                  if (option.audioTrackId) this.forwardJobTracks[option.jobId].push(option.audioTrackId);
                  if (option.videoTrackId) this.forwardJobTracks[option.jobId].push(option.videoTrackId);
                }

              case 19:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41, this);
      }));

      function createForwardJob(_x65) {
        return _createForwardJob.apply(this, arguments);
      }

      return createForwardJob;
    }()
  }, {
    key: "stopForwardJob",
    value: function () {
      var _stopForwardJob = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee42(jobId) {
        return _regeneratorRuntime.wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                if (!(this.roomState !== RoomState.Connected)) {
                  _context42.next = 2;
                  break;
                }

                throw ERROR_FATAL("can not stopForwardJob, room state is not connected");

              case 2:
                if (!(jobId && !this.forwardJobTracks[jobId])) {
                  _context42.next = 4;
                  break;
                }

                throw ERROR_FATAL("no forward job id ".concat(jobId));

              case 4:
                qos.addEvent("StopForwardJob", {
                  id: jobId || ""
                });
                _context42.next = 7;
                return this.signaling.request("stop-forward", {
                  id: jobId,
                  delayMillisecond: 0
                });

              case 7:
                delete this.forwardJobTracks[jobId];

              case 8:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42, this);
      }));

      function stopForwardJob(_x66) {
        return _stopForwardJob.apply(this, arguments);
      }

      return stopForwardJob;
    }()
  }, {
    key: "setDefaultMergeStream",
    value: function setDefaultMergeStream(width, height, jobID) {
      if (jobID && !this.mergeJobTracks[jobID]) {
        throw NO_MERGE_JOB(jobID);
      }

      if (this.merger && !jobID) {
        this.merger.release();
        this.merger = undefined;
      }

      if (jobID && this.mergeJobMerger[jobID]) {
        this.mergeJobMerger[jobID].release();
        delete this.mergeJobMerger[jobID];
      }

      var controller = this.CreateMergerSessionController();

      if (!jobID) {
        this.merger = new Merger(width, height, controller, jobID);
      } else {
        this.mergeJobMerger[jobID] = new Merger(width, height, controller, jobID);
      }
    }
  }, {
    key: "_stopMerge",
    value: function _stopMerge(jobID) {
      if (this.roomState !== RoomState.Connected) {
        throw ERROR_FATAL("can not addMergeTracks, room state is not connected");
      }

      if (jobID && !this.mergeJobTracks[jobID]) {
        throw NO_MERGE_JOB(jobID);
      }

      qos.addEvent("StopMerge", {
        id: jobID || ""
      });
      this.signaling.sendWsMsg("stop-merge", {
        id: jobID
      });

      if (jobID) {
        delete this.mergeJobTracks[jobID];

        if (this.mergeJobMerger[jobID]) {
          this.mergeJobMerger[jobID].release();
          delete this.mergeJobMerger[jobID];
        }
      } else {
        this.defaultMergeJobTracks = [];

        if (this.merger) {
          this.merger.release();
          this.merger = undefined;
        }
      }
    }
  }, {
    key: "_addMergeTracks",
    value: function () {
      var _addMergeTracks2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee43(mergeOpts, jobID) {
        var addTraget, config, res;
        return _regeneratorRuntime.wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                if (!(this.roomState !== RoomState.Connected)) {
                  _context43.next = 2;
                  break;
                }

                throw ERROR_FATAL("can not addMergeTracks, room state is not connected");

              case 2:
                if (!(jobID && !this.mergeJobTracks[jobID])) {
                  _context43.next = 4;
                  break;
                }

                throw NO_MERGE_JOB(jobID);

              case 4:
                addTraget = mergeOpts.map(function (opt) {
                  return {
                    trackid: opt.trackID,
                    x: opt.x,
                    y: opt.y,
                    w: opt.w,
                    h: opt.h,
                    z: opt.z,
                    stretchMode: opt.stretchMode
                  };
                });
                config = {
                  id: jobID,
                  add: addTraget
                };
                log.debug("addMergeTracks", config);

                if (jobID) {
                  this.mergeJobTracks[jobID] = this.mergeJobTracks[jobID].concat(mergeOpts.map(function (t) {
                    return t.trackID;
                  }));
                  this.mergeJobTracks[jobID] = uniqBy(this.mergeJobTracks[jobID], function (s) {
                    return s;
                  });
                } else {
                  this.defaultMergeJobTracks = this.defaultMergeJobTracks.concat(mergeOpts.map(function (t) {
                    return t.trackID;
                  }));
                  this.defaultMergeJobTracks = uniqBy(this.defaultMergeJobTracks, function (s) {
                    return s;
                  });
                }

                _context43.next = 10;
                return this.signaling.request("update-merge-tracks", config);

              case 10:
                res = _context43.sent;
                qos.addEvent("UpdateMergeTracks", {
                  id: jobID || "",
                  add: addTraget.map(function (t) {
                    return {
                      track_id: t.trackid,
                      x: t.x || 0,
                      y: t.y || 0,
                      w: t.w || 0,
                      h: t.h || 0,
                      z: t.z || 0,
                      stretchMode: t.stretchMode || ""
                    };
                  }),
                  result_code: res.code
                });

                if (!(res.code !== 0)) {
                  _context43.next = 14;
                  break;
                }

                throw SERVER_ERROR(res.code, res.error);

              case 14:
              case "end":
                return _context43.stop();
            }
          }
        }, _callee43, this);
      }));

      function _addMergeTracks(_x67, _x68) {
        return _addMergeTracks2.apply(this, arguments);
      }

      return _addMergeTracks;
    }()
  }, {
    key: "_removeMergeTracks",
    value: function () {
      var _removeMergeTracks2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee44(trackIDs, jobID) {
        var config, res;
        return _regeneratorRuntime.wrap(function _callee44$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                if (!(this.roomState !== RoomState.Connected)) {
                  _context44.next = 2;
                  break;
                }

                throw ERROR_FATAL("can not addMergeTracks, room state is not connected");

              case 2:
                if (!(jobID && !this.mergeJobTracks[jobID])) {
                  _context44.next = 4;
                  break;
                }

                throw NO_MERGE_JOB(jobID);

              case 4:
                config = {
                  id: jobID,
                  remove: trackIDs.map(function (t) {
                    return {
                      trackid: t
                    };
                  })
                };
                log.debug("removeMergeTracks", config);

                if (jobID) {
                  remove(this.mergeJobTracks[jobID], function (t) {
                    return trackIDs.indexOf(t) !== -1;
                  });
                } else {
                  remove(this.defaultMergeJobTracks, function (t) {
                    return trackIDs.indexOf(t) !== -1;
                  });
                }

                _context44.next = 9;
                return this.signaling.request("update-merge-tracks", config);

              case 9:
                res = _context44.sent;
                qos.addEvent("UpdateMergeTracks", {
                  id: jobID || "",
                  remove: config.remove.map(function (t) {
                    return {
                      track_id: t.trackid
                    };
                  }),
                  result_code: res.code
                });

                if (!(res.code !== 0)) {
                  _context44.next = 13;
                  break;
                }

                throw SERVER_ERROR(res.code, res.error);

              case 13:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee44, this);
      }));

      function _removeMergeTracks(_x69, _x70) {
        return _removeMergeTracks2.apply(this, arguments);
      }

      return _removeMergeTracks;
    }() // 这里走全量更新的逻辑
    // 后端后修改为暂不支持，暂时废弃

  }, {
    key: "updateMergeTracks",
    value: function () {
      var _updateMergeTracks = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee45(mergeOpts, jobID) {
        var target, config;
        return _regeneratorRuntime.wrap(function _callee45$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                if (!(this.roomState !== RoomState.Connected)) {
                  _context45.next = 2;
                  break;
                }

                throw ERROR_FATAL("can not addMergeTracks, room state is not connected");

              case 2:
                if (!(jobID && !this.mergeJobTracks[jobID])) {
                  _context45.next = 4;
                  break;
                }

                throw NO_MERGE_JOB(jobID);

              case 4:
                target = mergeOpts.map(function (opt) {
                  return {
                    trackid: opt.trackID,
                    x: opt.x,
                    y: opt.y,
                    w: opt.w,
                    h: opt.h,
                    z: opt.z,
                    stretchMode: opt.stretchMode
                  };
                });
                config = {
                  id: jobID,
                  all: target,
                  mode: 1
                };
                log.debug("updateMergeTracks", config);

                if (jobID) {
                  this.mergeJobTracks[jobID] = this.mergeJobTracks[jobID].concat(mergeOpts.map(function (t) {
                    return t.trackID;
                  }));
                  this.mergeJobTracks[jobID] = uniqBy(this.mergeJobTracks[jobID], function (s) {
                    return s;
                  });
                } else {
                  this.defaultMergeJobTracks = this.defaultMergeJobTracks.concat(mergeOpts.map(function (t) {
                    return t.trackID;
                  }));
                  this.defaultMergeJobTracks = uniqBy(this.defaultMergeJobTracks, function (s) {
                    return s;
                  });
                }

                qos.addEvent("UpdateMergeTracks", {
                  id: jobID || "",
                  all: target.map(function (t) {
                    return {
                      track_id: t.trackid,
                      x: t.x || 0,
                      y: t.y || 0,
                      w: t.w || 0,
                      h: t.h || 0,
                      z: t.z || 0,
                      stretchMode: t.stretchMode || ""
                    };
                  })
                });
                _context45.next = 11;
                return this.signaling.request("update-merge-tracks", config);

              case 11:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee45, this);
      }));

      function updateMergeTracks(_x71, _x72) {
        return _updateMergeTracks.apply(this, arguments);
      }

      return updateMergeTracks;
    }()
    /**
     * @param isReconnect 代表这次 unsub 是否是为了重新订阅，如果是 pcTrack 不需要释放
     */

  }, {
    key: "_unsubscribe",
    value: function () {
      var _unsubscribe2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee46(trackIDs, isReconnect) {
        var targetTracks;
        return _regeneratorRuntime.wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                if (!(this.roomState !== RoomState.Connected)) {
                  _context46.next = 2;
                  break;
                }

                throw ERROR_FATAL("no signaling model, please run joinRoomWithToken first");

              case 2:
                targetTracks = this.subscribeTracks.filter(function (t) {
                  return trackIDs.indexOf(t.trackID) !== -1;
                });
                log.debug("unsubscribe", targetTracks);

                if (!(targetTracks.length === 0)) {
                  _context46.next = 6;
                  break;
                }

                return _context46.abrupt("return");

              case 6:
                qos.addEvent("UnSubscribeTracks", {
                  tracks: trackIDs.map(function (t) {
                    return {
                      track_id: t
                    };
                  })
                });
                this.signaling.request("unsub-tracks", {
                  tracks: targetTracks.map(function (t) {
                    return {
                      trackid: t.trackID
                    };
                  })
                });

                if (!isReconnect) {
                  targetTracks.forEach(function (t) {
                    return t.release();
                  });
                  remove(this.subscribeTracks, function (t) {
                    return trackIDs.indexOf(t.trackID) !== -1;
                  });
                }

                _context46.next = 11;
                return this.connectionTransport.removeConsumers(targetTracks.map(function (p) {
                  return p.consumer;
                }));

              case 11:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee46, this);
      }));

      function _unsubscribe(_x73, _x74) {
        return _unsubscribe2.apply(this, arguments);
      }

      return _unsubscribe;
    }()
  }, {
    key: "_muteTracks",
    value: function _muteTracks(tracks) {
      if (this.roomState !== RoomState.Connected) {
        throw ERROR_FATAL("no signaling model, please run joinRoomWithToken first");
      }

      var transport = this.connectionTransport;
      var trackMuteMap = {};
      tracks.forEach(function (t) {
        trackMuteMap[t.trackID] = t.muted;
      });
      var targetTracks = transport.publishTracks.filter(function (t) {
        return trackMuteMap[t.trackID] !== undefined;
      });
      targetTracks.forEach(function (t) {
        t.setMute(trackMuteMap[t.trackID]);
      });
      qos.addEvent("MuteTracks", {
        tracks: targetTracks.map(function (t) {
          return {
            track_id: t.trackID,
            muted: t.track.info.muted,
            kind: t.track.info.kind
          };
        })
      });
      this.signaling.sendWsMsg("mute-tracks", {
        tracks: tracks.map(function (t) {
          return {
            trackid: t.trackID,
            muted: t.muted
          };
        })
      });
    }
  }, {
    key: "kickoutUser",
    value: function () {
      var _kickoutUser = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee47(userID) {
        return _regeneratorRuntime.wrap(function _callee47$(_context47) {
          while (1) {
            switch (_context47.prev = _context47.next) {
              case 0:
                log.log("kickoutUser", userID);
                _context47.next = 3;
                return this.control("kickplayer", userID);

              case 3:
              case "end":
                return _context47.stop();
            }
          }
        }, _callee47, this);
      }));

      function kickoutUser(_x75) {
        return _kickoutUser.apply(this, arguments);
      }

      return kickoutUser;
    }()
    /**
     * 向房间中指定目标发送自定义消息
     * @param message string 自定义消息内容
     * @param userIDs Array<string> 目标用户名列表，如果为空，则在全房间广播
     * @param messageID string 消息ID
     */

  }, {
    key: "sendCustomMessage",
    value: function sendCustomMessage(message, userIDs, messageID) {
      if (this.roomState !== RoomState.Connected) {
        throw ERROR_FATAL("room state is not connected, can not send message");
      }

      var msgid = messageID || randomStringGen(8);
      var target = !userIDs || userIDs.length === 0 ? undefined : userIDs;
      this.signaling.sendWsMsg("send-message", {
        msgid: msgid,
        target: target,
        type: "normal",
        text: message
      });
      log.debug("send custom message", message, target, msgid);
    }
  }, {
    key: "replaceTrack",
    value: function () {
      var _replaceTrack2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee48(trackID, newTrack) {
        var targetPCTrack;
        return _regeneratorRuntime.wrap(function _callee48$(_context48) {
          while (1) {
            switch (_context48.prev = _context48.next) {
              case 0:
                if (!(this.roomState !== RoomState.Connected)) {
                  _context48.next = 2;
                  break;
                }

                throw ERROR_FATAL("no signaling model, please run joinRoomWithToken first");

              case 2:
                log.log("replaceTrack", trackID, newTrack);
                targetPCTrack = this.connectionTransport.publishTracks.find(function (pcTrack) {
                  return pcTrack.trackID === trackID;
                });

                if (!(targetPCTrack === undefined || targetPCTrack.track === undefined)) {
                  _context48.next = 6;
                  break;
                }

                throw ERROR_FATAL("track not exist: ".concat(trackID));

              case 6:
                return _context48.abrupt("return", this.connectionTransport.sendHandler.replaceTrack(targetPCTrack, newTrack));

              case 7:
              case "end":
                return _context48.stop();
            }
          }
        }, _callee48, this);
      }));

      function replaceTrack(_x76, _x77) {
        return _replaceTrack2.apply(this, arguments);
      }

      return replaceTrack;
    }()
    /**
     * @description 使用图片 track 替换 video track，如果 source 为空，表示切换回来
     * @param trackID 要替换的 trackID
     * @param source 图片来源
     */

  }, {
    key: "pushCameraTrackWithImage",
    value: function () {
      var _pushCameraTrackWithImage = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee49(trackID, source) {
        var targetPCTrack;
        return _regeneratorRuntime.wrap(function _callee49$(_context49) {
          while (1) {
            switch (_context49.prev = _context49.next) {
              case 0:
                if (!(this.roomState !== RoomState.Connected)) {
                  _context49.next = 2;
                  break;
                }

                throw ERROR_FATAL("no signaling model, please run joinRoomWithToken first");

              case 2:
                log.log("pushCameraTrackWithImage", {
                  trackID: trackID,
                  source: source
                });
                targetPCTrack = this.connectionTransport.publishTracks.find(function (pcTrack) {
                  return pcTrack.trackID === trackID;
                });

                if (!(targetPCTrack === undefined || targetPCTrack.track === undefined)) {
                  _context49.next = 6;
                  break;
                }

                throw ERROR_FATAL("track not exist: ".concat(trackID));

              case 6:
                if (!(targetPCTrack.track.info.kind !== 'video')) {
                  _context49.next = 8;
                  break;
                }

                throw ERROR_FATAL("track kind is not video: ".concat(trackID));

              case 8:
                if (!targetPCTrack.track.imageStreamTrack) {
                  targetPCTrack.track.imageStreamTrack = new ImageStreamTrack();
                } // source 为空，切换回来


                if (!(source === undefined && targetPCTrack.track.isReplacedByImageTrack)) {
                  _context49.next = 15;
                  break;
                }

                _context49.next = 12;
                return this.connectionTransport.sendHandler.replaceProducerTrack(targetPCTrack, "video");

              case 12:
                targetPCTrack.track.isReplacedByImageTrack = false;
                targetPCTrack.track.switchPlayingTrack();
                return _context49.abrupt("return");

              case 15:
                if (!(source !== undefined && targetPCTrack.track && !targetPCTrack.track.isReplacedByImageTrack)) {
                  _context49.next = 23;
                  break;
                }

                _context49.next = 18;
                return targetPCTrack.track.imageStreamTrack.setSource(source);

              case 18:
                _context49.next = 20;
                return this.connectionTransport.sendHandler.replaceProducerTrack(targetPCTrack, "image");

              case 20:
                targetPCTrack.track.isReplacedByImageTrack = true;
                targetPCTrack.track.switchPlayingTrack();
                return _context49.abrupt("return");

              case 23:
              case "end":
                return _context49.stop();
            }
          }
        }, _callee49, this);
      }));

      function pushCameraTrackWithImage(_x78, _x79) {
        return _pushCameraTrackWithImage.apply(this, arguments);
      }

      return pushCameraTrackWithImage;
    }()
    /**
     * leaveRoom 将不会本地的发布流，如果想清除本地的发布流
     * 或者手动调用 Track 对象的 release 方法
     */

  }, {
    key: "leaveRoom",
    value: function leaveRoom() {
      var _this65 = this;

      if (this.roomState === RoomState.Idle) {
        log.log("can not leave room, please join room first");
        return;
      }

      log.log("leave room");
      qos.addEvent("LeaveRoom", {
        leave_reason_code: 0
      });

      if (this.signaling) {
        Object.keys(this.forwardJobTracks).forEach(function (jobId) {
          return _this65.stopForwardJob(jobId);
        });
        this.signaling.sendDisconnect();
      }

      this.releaseRoom();
    }
  }, {
    key: "_releasePublishTracks",
    value: function _releasePublishTracks() {}
  }, {
    key: "control",
    value: function () {
      var _control = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee50(command, userID) {
        var startTime, data;
        return _regeneratorRuntime.wrap(function _callee50$(_context50) {
          while (1) {
            switch (_context50.prev = _context50.next) {
              case 0:
                if (!(this.roomState !== RoomState.Connected)) {
                  _context50.next = 2;
                  break;
                }

                throw ERROR_FATAL("can not connected to the room, please run joinRoom first");

              case 2:
                startTime = Date.now();
                _context50.next = 5;
                return this.signaling.request("control", {
                  command: command,
                  playerid: userID
                });

              case 5:
                data = _context50.sent;

                if (command === "kickplayer") {
                  qos.addEvent("KickoutUser", {
                    signal_take_time: Date.now() - startTime,
                    user_id: userID,
                    result_code: data.code
                  });
                }

                if (!data.error) {
                  _context50.next = 9;
                  break;
                }

                throw CONTROL_ERROR(data.code, data.error);

              case 9:
              case "end":
                return _context50.stop();
            }
          }
        }, _callee50, this);
      }));

      function control(_x80, _x81) {
        return _control.apply(this, arguments);
      }

      return control;
    }()
  }, {
    key: "handlePlayerOut",
    value: function handlePlayerOut(data) {
      var _this66 = this;

      var removeElement = this._users.get(data.playerid);

      if (removeElement) {
        this._users.delete(data.playerid);

        remove(this._trackInfo, function (info) {
          return info.playerid === data.playerid;
        });
        var targetTracks = remove(this.subscribeTracks, function (t) {
          return t.track.userID === removeElement.userID;
        });
        targetTracks.forEach(function (t) {
          return t.release();
        });
        nextTick(function () {
          log.debug("user-leave", removeElement);

          _this66.emit("user-leave", removeElement);
        });
      }
    }
  }, {
    key: "handlePlayerIn",
    value: function handlePlayerIn(signalUser) {
      var _this67 = this;

      var user = transferSignalingUserToUser(signalUser);

      this._users.set(user.userID, user);

      nextTick(function () {
        log.debug("user-join", user);

        _this67.emit("user-join", user);
      });
    }
  }, {
    key: "handleAddTracks",
    value: function handleAddTracks(_ref19) {
      var _this68 = this;

      var tracks = _ref19.tracks;
      log.log("receive track-add", tracks, __chunk_1._objectSpread({}, this._trackInfo));
      var publishedUsers = new Set();
      var _iteratorNormalCompletion33 = true;
      var _didIteratorError33 = false;
      var _iteratorError33 = undefined;

      try {
        for (var _iterator33 = tracks[Symbol.iterator](), _step33; !(_iteratorNormalCompletion33 = (_step33 = _iterator33.next()).done); _iteratorNormalCompletion33 = true) {
          var track = _step33.value;
          var user = getElementFromArray(this.users, "userID", track.playerid);
          if (!user) continue; // 如果在收到这个 master track 之前已经有了 master track
          // 就翻译为 unpublish 后再 publish

          if (user.published && !publishedUsers.has(user.userID) && this.sessionMode === "stream") {
            var publishedTracks = user.publishedTrackInfo.map(function (t) {
              return transferTrackBaseInfoToSignalingTrack(t, true);
            });
            this.handleRemoveTracks({
              tracks: publishedTracks
            });
            publishedTracks.push(track);
            this.handleAddTracks({
              tracks: publishedTracks
            });
          } else {
            this._trackInfo.push(track);

            user.addPublishedTrackInfo([transferSignalingTrackToTrackBaseInfo(track)]);
            publishedUsers.add(user.userID);
          }
        }
      } catch (err) {
        _didIteratorError33 = true;
        _iteratorError33 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion33 && _iterator33.return != null) {
            _iterator33.return();
          }
        } finally {
          if (_didIteratorError33) {
            throw _iteratorError33;
          }
        }
      }

      if (this.sessionMode === "stream") {
        var _arr = Array.from(publishedUsers);

        var _loop15 = function _loop15() {
          var userID = _arr[_i5];
          nextTick(function () {
            log.debug("user-publish", _this68._users.get(userID));

            _this68.emit("user-publish", _this68._users.get(userID));
          });
        };

        for (var _i5 = 0; _i5 < _arr.length; _i5++) {
          _loop15();
        }
      }

      nextTick(function () {
        log.debug("track-add", tracks.map(transferSignalingTrackToTrackBaseInfo));

        _this68.emit("track-add", tracks.map(transferSignalingTrackToTrackBaseInfo));
      });
    }
  }, {
    key: "handleRemoveTracks",
    value: function handleRemoveTracks(_ref20) {
      var _this69 = this;

      var tracks = _ref20.tracks;
      log.log("receive track-remove", tracks, __chunk_1._objectSpread({}, this._trackInfo));
      var targetTracks = remove(this._trackInfo, function (t) {
        return tracks.map(function (t) {
          return t.trackid;
        }).includes(t.trackid);
      });
      var unpublishedUsers = new Set();
      var _iteratorNormalCompletion34 = true;
      var _didIteratorError34 = false;
      var _iteratorError34 = undefined;

      try {
        var _loop17 = function _loop17() {
          var track = _step34.value;

          var user = _this69._users.get(track.playerid);

          if (!user) return "continue";
          user.removePublishedTrackInfo([track.trackid]);
          user.removeTracksByTrackId([track.trackid]);
          unpublishedUsers.add(user.userID);
          var subscribeTrack = remove(_this69.subscribeTracks, function (t) {
            return t.trackID === track.trackid;
          })[0];

          if (subscribeTrack) {
            subscribeTrack.release();
          }
        };

        for (var _iterator34 = targetTracks[Symbol.iterator](), _step34; !(_iteratorNormalCompletion34 = (_step34 = _iterator34.next()).done); _iteratorNormalCompletion34 = true) {
          var _ret9 = _loop17();

          if (_ret9 === "continue") continue;
        }
      } catch (err) {
        _didIteratorError34 = true;
        _iteratorError34 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion34 && _iterator34.return != null) {
            _iterator34.return();
          }
        } finally {
          if (_didIteratorError34) {
            throw _iteratorError34;
          }
        }
      }

      this.cleanTrackIdsFromMergeJobs(tracks.map(function (t) {
        return t.trackid;
      }));

      if (this.sessionMode === "stream") {
        var _arr2 = Array.from(unpublishedUsers);

        var _loop16 = function _loop16() {
          var userID = _arr2[_i6];

          var user = _this69._users.get(userID); // 如果收到 master track remove 后还留有 master track
          // 翻译为先取消发布再重新发布


          if (user.published) {
            var publishedTracks = user.publishedTrackInfo.map(function (t) {
              return transferTrackBaseInfoToSignalingTrack(t, true);
            });

            _this69.handleRemoveTracks({
              tracks: publishedTracks
            });

            _this69.handleAddTracks({
              tracks: publishedTracks
            });
          } else {
            nextTick(function () {
              log.debug("user-unpublish", user);

              _this69.emit("user-unpublish", user);
            });
          }
        };

        for (var _i6 = 0; _i6 < _arr2.length; _i6++) {
          _loop16();
        }
      }

      nextTick(function () {
        log.debug("track-remove", targetTracks.map(transferSignalingTrackToTrackBaseInfo));

        _this69.emit("track-remove", targetTracks.map(transferSignalingTrackToTrackBaseInfo));
      });
    }
  }, {
    key: "handleMute",
    value: function handleMute(_ref21) {
      var _this70 = this;

      var tracks = _ref21.tracks;
      var _iteratorNormalCompletion35 = true;
      var _didIteratorError35 = false;
      var _iteratorError35 = undefined;

      try {
        var _loop18 = function _loop18() {
          var sigTrack = _step35.value;
          var trackid = sigTrack.trackid;
          var muted = sigTrack.muted;
          var trackInfo = getElementFromArray(_this70._trackInfo, "trackid", trackid);

          if (!trackInfo) {
            return {
              v: void 0
            };
          }

          var user = _this70._users.get(trackInfo.playerid);

          if (!user) {
            return {
              v: void 0
            };
          }

          var info = user.publishedTrackInfo.find(function (t) {
            return t.trackID === trackid;
          });

          if (info) {
            info.muted = muted;
          }

          var track = user.tracks.find(function (t) {
            return t.info.trackID === trackid;
          });

          if (track) {
            track.info.muted = muted;
            track.setMute(muted);
          }

          trackInfo.muted = muted;

          var pcTrack = _this70.subscribeTracks.filter(function (t) {
            return t.trackID === trackid;
          })[0];

          if (pcTrack) {
            pcTrack.setMute(muted);
          }

          var anotherTrackInfo = undefined;

          for (var i = 0; i < _this70._trackInfo.length; i += 1) {
            if (_this70._trackInfo[i].playerid === trackInfo.playerid && _this70._trackInfo[i].kind !== trackInfo.kind) {
              anotherTrackInfo = _this70._trackInfo[i];
            }
          }

          var data = {
            userID: trackInfo.playerid,
            muteAudio: false,
            muteVideo: false
          };

          if (trackInfo.kind === "audio") {
            data.muteAudio = muted;
            data.muteVideo = anotherTrackInfo ? anotherTrackInfo.muted : false;
          } else {
            data.muteVideo = muted;
            data.muteAudio = anotherTrackInfo ? anotherTrackInfo.muted : false;
          }

          if (_this70.sessionMode === "stream") {
            nextTick(function () {
              log.log("user-mute", data);

              _this70.emit("user-mute", data);
            });
          }
        };

        for (var _iterator35 = tracks[Symbol.iterator](), _step35; !(_iteratorNormalCompletion35 = (_step35 = _iterator35.next()).done); _iteratorNormalCompletion35 = true) {
          var _ret10 = _loop18();

          if (typeof _ret10 === "object") return _ret10.v;
        }
      } catch (err) {
        _didIteratorError35 = true;
        _iteratorError35 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion35 && _iterator35.return != null) {
            _iterator35.return();
          }
        } finally {
          if (_didIteratorError35) {
            throw _iteratorError35;
          }
        }
      }

      nextTick(function () {
        log.log("mute-tracks", tracks.map(function (t) {
          return {
            trackID: t.trackid,
            muted: t.muted
          };
        }));

        _this70.emit("mute-tracks", tracks.map(function (t) {
          return {
            trackID: t.trackid,
            muted: t.muted
          };
        }));
      });
    }
  }, {
    key: "handleCustomMessages",
    value: function handleCustomMessages(_ref22) {
      var messages = _ref22.messages;
      this.emit("messages-received", messages.map(transferSignalingCustomMessageToCustomMessage));
    }
  }, {
    key: "handleQosMessages",
    value: function handleQosMessages(_ref23) {
      var messages = _ref23.messages;
      var remoteTrackStats = [];
      messages.forEach(function (msg) {
        try {
          var _qos = JSON.parse(msg.qos);

          _qos.tracks_qos.forEach(function (track_qos) {
            remoteTrackStats.push({
              userID: msg.playerid,
              networkGrade: _qos.networkGrade,
              kind: track_qos.kind,
              trackID: track_qos.track,
              packetLossRate: track_qos.lostRate,
              rtt: track_qos.rtt
            });
          });
        } catch (error) {
          log.warning("parse SignalingQosMessage error: ", error);
        }
      });
      qnevents.emit("remote-track-stats", remoteTrackStats);
      this.emit("remote-track-stats", remoteTrackStats);
    }
  }, {
    key: "handleDisconnect",
    value: function handleDisconnect(data) {
      var _this71 = this;

      log.log("handle disconnect", data.code, data); // 0, 10005, 10006 是正常的断开 code

      if ([0, 10005, 10006].indexOf(data.code) === -1) {
        qos.addEvent("AbnormalDisconnect", {
          event_reason: "websocket_error",
          event_description: data.error
        });
      }

      qos.addEvent("LeaveRoom", {
        leave_reason_code: data.code
      });

      if (data.code === 10052 && this.roomToken) {
        this.roomState = RoomState.Reconnecting;
        setTimeout(function () {
          return _this71.signaling.initWs();
        }, 1000);
        return;
      }

      switch (data.code) {
        case 10006:
          {
            this.emit("disconnect", {
              code: data.code,
              data: {
                userID: data.kickedid
              }
            });
            break;
          }

        default:
          {
            this.emit("disconnect", {
              code: data.code
            });
            break;
          }
      }

      this.releaseRoom();
    }
  }, {
    key: "handleRemoteUserReconnecting",
    value: function handleRemoteUserReconnecting(data) {
      var user = this.users.find(function (user) {
        return user.userID === data.playerid;
      });

      if (user) {
        log.debug("remote-user-reconnecting", user);
        this.emit("remote-user-reconnecting", user);
      }
    }
  }, {
    key: "handleRemoteUserReconnected",
    value: function handleRemoteUserReconnected(data) {
      var user = this.users.find(function (user) {
        return user.userID === data.playerid;
      });

      if (user) {
        log.debug("remote-user-reconnected", user);
        this.emit("remote-user-reconnected", user);
      }
    }
    /** 更新 AccessToken  */

  }, {
    key: "updateAccessToken",
    value: function () {
      var _updateAccessToken = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee51() {
        var roomAccess, authRes, accessPayload;
        return _regeneratorRuntime.wrap(function _callee51$(_context51) {
          while (1) {
            switch (_context51.prev = _context51.next) {
              case 0:
                roomAccess = getRoomAccessFromToken(this.roomToken);
                _context51.next = 3;
                return getAccessToken(roomAccess, this.roomToken, this.config.requestTimeout);

              case 3:
                authRes = _context51.sent;
                qos.setSessionId(authRes.sessionId);
                this.accessToken = authRes.accessToken;
                accessPayload = getPayloadFromJwt(authRes.accessToken);

                if (!this.signaling) {
                  _context51.next = 12;
                  break;
                }

                this.signaling.accessToken = this.accessToken;
                this.signaling.setUrl(accessPayload.signalingurl2);
                _context51.next = 13;
                break;

              case 12:
                throw ERROR_FATAL("room state is idle when updateAccessToken");

              case 13:
              case "end":
                return _context51.stop();
            }
          }
        }, _callee51, this);
      }));

      function updateAccessToken() {
        return _updateAccessToken.apply(this, arguments);
      }

      return updateAccessToken;
    }()
  }, {
    key: "handleAuth",
    value: function () {
      var _handleAuth = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee52(authData) {
        var _this72 = this;

        var isGetMissingEvent, missingEvents, lastUsers, currentUsers, _iteratorNormalCompletion36, _didIteratorError36, _iteratorError36, _loop19, _iterator36, _step36, publishingTracks, subscribingTracks;

        return _regeneratorRuntime.wrap(function _callee52$(_context52) {
          while (1) {
            switch (_context52.prev = _context52.next) {
              case 0:
                this.filterSignalTracks(authData); // auth 鉴权失败，一般是 token 过期，或者长时间断线导致房间被关闭，
                // 直接重新走加入房间的流程

                log.debug("handleAuth", authData);

                if (!authData.error) {
                  _context52.next = 6;
                  break;
                }

                _context52.next = 5;
                return this.joinRoomWithToken(this.roomToken, this.userData);

              case 5:
                return _context52.abrupt("return");

              case 6:
                authData.tracks = authData.tracks || []; // 只保留除自己以外的 trackInfo，防止补事件出错

                authData.tracks = authData.tracks.filter(function (t) {
                  return t.playerid !== _this72.userID;
                });
                authData.players = authData.players || [];
                isGetMissingEvent = this.roomState === RoomState.Reconnecting;
                missingEvents = {
                  join: [],
                  leave: [],
                  add: [],
                  remove: [],
                  mute: []
                };
                lastUsers = Array.from(this._users.keys());
                currentUsers = authData.players.map(function (player) {
                  return player.playerid;
                });
                missingEvents = getMissingUserEvent(this.userID, this._trackInfo, authData.tracks, lastUsers, currentUsers); // connected 的唯一标准是收到 error 为 0 的 auth-res

                this.roomState = RoomState.Connected; // 仅在第一次处理的时候设置用户和 TrackInfo, 其余通过补事件来更新

                if (isGetMissingEvent) {
                  _context52.next = 40;
                  break;
                }

                this._trackInfo = authData.tracks;

                this._users.clear();

                _iteratorNormalCompletion36 = true;
                _didIteratorError36 = false;
                _iteratorError36 = undefined;
                _context52.prev = 21;

                _loop19 = function _loop19() {
                  var player = _step36.value;
                  var user = transferSignalingUserToUser(player);

                  var userTracks = _this72._trackInfo.filter(function (trackInfo) {
                    return trackInfo.playerid === user.userID;
                  });

                  user.addPublishedTrackInfo(userTracks.map(transferSignalingTrackToTrackBaseInfo));

                  _this72._users.set(user.userID, user);
                };

                for (_iterator36 = (authData.players || [])[Symbol.iterator](); !(_iteratorNormalCompletion36 = (_step36 = _iterator36.next()).done); _iteratorNormalCompletion36 = true) {
                  _loop19();
                }

                _context52.next = 30;
                break;

              case 26:
                _context52.prev = 26;
                _context52.t0 = _context52["catch"](21);
                _didIteratorError36 = true;
                _iteratorError36 = _context52.t0;

              case 30:
                _context52.prev = 30;
                _context52.prev = 31;

                if (!_iteratorNormalCompletion36 && _iterator36.return != null) {
                  _iterator36.return();
                }

              case 33:
                _context52.prev = 33;

                if (!_didIteratorError36) {
                  _context52.next = 36;
                  break;
                }

                throw _iteratorError36;

              case 36:
                return _context52.finish(33);

              case 37:
                return _context52.finish(30);

              case 38:
                _context52.next = 46;
                break;

              case 40:
                log.debug("get missing events", missingEvents);

                if (missingEvents.remove.length > 0) {
                  this.handleRemoveTracks({
                    tracks: missingEvents.remove
                  });
                }

                if (missingEvents.leave.length > 0) {
                  missingEvents.leave.forEach(this.handlePlayerOut.bind(this));
                }

                if (missingEvents.join.length > 0) {
                  missingEvents.join.forEach(this.handlePlayerIn.bind(this));
                }

                if (missingEvents.add.length > 0) {
                  this.handleAddTracks({
                    tracks: missingEvents.add
                  });
                }

                if (missingEvents.mute.length > 0) {
                  this.handleMute({
                    tracks: missingEvents.mute
                  });
                }

              case 46:
                if (!this.connectionTransport) {
                  this.connectionTransport = this.createConnectionTransport(authData.rtpcaps);
                } else {
                  publishingTracks = this.connectionTransport.publishTracks.filter(function (p) {
                    return p.connectStatus === TrackConnectStatus.Connecting;
                  });
                  subscribingTracks = this.subscribeTracks.filter(function (p) {
                    return p.connectStatus === TrackConnectStatus.Connecting;
                  });
                  this.connectionTransport.extendedRtpCapabilities = authData.rtpcaps;

                  if (!this.connectionTransport.sendHandler.isPcReady || this.connectionTransport.sendHandler._isRestartingICE || publishingTracks.length > 0) {
                    this.connectionTransport.reconnectProducer();
                  }

                  if (!this.connectionTransport.recvHandler.isPcReady || this.connectionTransport.recvHandler._isRestartingICE || subscribingTracks.length > 0) {
                    this.connectionTransport.resetRecvHandler();
                  }
                }

              case 47:
              case "end":
                return _context52.stop();
            }
          }
        }, _callee52, this, [[21, 26, 30, 38], [31,, 33, 37]]);
      }));

      function handleAuth(_x82) {
        return _handleAuth.apply(this, arguments);
      }

      return handleAuth;
    }()
  }, {
    key: "createConnectionTransport",
    value: function createConnectionTransport(rtpcaps) {
      var _this73 = this;

      var coreInstance = this;
      var signaling = this.signaling;
      var transport = new ConnectionTransport(rtpcaps, signaling, coreInstance, this.config.simulcast);
      transport.on("@needpubpc", function (sdp, tracks, cb, errcb) {
        signaling.request("pubpc", {
          sdp: sdp,
          tracks: tracks.map(transferTrackToPublishTrack),
          policy: _this73.config.transportPolicy
        }).then(function (d) {
          switch (d.code) {
            case 0:
              {
                cb(d);
                return;
              }

            case 10052:
              {
                throw SERVER_UNAVAILABLE();
              }

            default:
              {
                throw ERROR_FATAL(d.error);
              }
          }
        }).catch(errcb);
      });
      transport.on("@needsubpc", function (trackIDs, cb, errcb) {
        signaling.request("subpc", {
          tracks: trackIDs.map(function (t) {
            return _this73.profiles.get(t) ? {
              trackid: t,
              profile: _this73.profiles.get(t)
            } : {
              trackid: t
            };
          }),
          policy: _this73.config.transportPolicy
        }).then(function (d) {
          switch (d.code) {
            case 0:
              {
                cb(d);
                return;
              }

            case 10052:
              {
                throw SERVER_UNAVAILABLE();
              }

            default:
              {
                throw ERROR_FATAL(d.error);
              }
          }
        }).catch(errcb);
      }).on("@needresub", function () {
        var allTrackIds = _this73.subscribeTracks.map(function (t) {
          return t.trackID;
        });

        _this73.subscribeTracks.forEach(function (t) {
          return t.connectStatus = TrackConnectStatus.Connecting;
        });

        _this73._subscribe(allTrackIds, true);
      }).on("@needrepub", function (tracks) {
        _this73._publish(tracks.map(function (t) {
          return t.track;
        }), true);
      }).on("@needresetrecv", function () {
        _this73.subscribeTracks.filter(function (p) {
          return !!p.track;
        }).forEach(function (p) {
          p.track.removeAllListeners("@ended");
        });
      });
      return transport;
    }
  }, {
    key: "cleanTrackIdsFromMergeJobs",
    value: function cleanTrackIdsFromMergeJobs(trackIDs) {
      remove(this.defaultMergeJobTracks, function (t) {
        return trackIDs.indexOf(t) !== -1;
      });

      for (var tracks in this.mergeJobTracks) {
        remove(tracks, function (t) {
          return trackIDs.indexOf(t) !== -1;
        });
      }
    }
  }, {
    key: "CreateMergerSessionController",
    value: function CreateMergerSessionController() {
      var _this74 = this;

      var controller = new MergerSessionController();

      var handleTrackAdd = function handleTrackAdd(tracks) {
        controller.onAddTracks(tracks);
      };

      var handleTrackRemove = function handleTrackRemove(tracks) {
        controller.onRemoveTracks(tracks);
      };

      this.on("track-add", handleTrackAdd);
      this.on("track-remove", handleTrackRemove);

      controller.getCurrentTracks = function () {
        if (!_this74.connectionTransport) return [];

        var tracks = _this74._trackInfo.map(transferSignalingTrackToTrackBaseInfo);

        var selfPublishedTracks = _this74.connectionTransport.publishTracks.map(function (t) {
          return t.track.info;
        });

        return tracks.concat(selfPublishedTracks);
      };

      controller.addMergeTrack = function (mergeOpt, jobID) {
        _this74._addMergeTracks(mergeOpt, jobID);
      };

      controller.release = function () {
        _this74.off("track-add", handleTrackAdd);

        _this74.off("track-remove", handleTrackRemove);
      };

      return controller;
    }
  }, {
    key: "getAllMerger",
    value: function getAllMerger() {
      var mergers = [];

      if (this.merger) {
        mergers.push(this.merger);
      }

      for (var jobID in this.mergeJobMerger) {
        mergers.push(this.mergeJobMerger[jobID]);
      }

      return mergers;
    } // 退出房间后清空房间状态

  }, {
    key: "releaseRoom",
    value: function releaseRoom() {
      this.releaseSession();

      if (this.signaling) {
        this.signaling.release();
        this.signaling = undefined;
      }

      qos.addEvent("UnInit", {
        id: "".concat(this.sessionMode, "_").concat(Date.now())
      }, true);

      if (this.connectionTransport) {
        this.connectionTransport.release();
        this.connectionTransport = undefined;
      }

      this.getAllMerger().map(function (merger) {
        merger.release();
      });
      this.defaultMergeJobTracks = [];
      this.mergeJobTracks = {};
      this.forwardJobTracks = {};
      this.merger = undefined;
      this.mergeJobMerger = {};
      this.roomState = RoomState.Idle;
      this._trackInfo = [];

      this._users.clear();

      this.userID = undefined;
      this.subscribeTracks.forEach(function (t) {
        t.release();
      });
      this.subscribeTracks = [];
      this.profile = undefined;
      this.profiles.clear();
      clearInterval(this.volumeIndicatorTimer);
      this._mode = exports.QNClientMode.RTC;
      this._role = exports.QNClientRole.AUDIENCE;
      this._privileges = ["subscribe", "publish"];
    }
    /**
     * @internal
     * 报告频道内正在说话的远端用户及其音量的回调。
     */

  }, {
    key: "registerVolumeIndicatorEvent",
    value: function registerVolumeIndicatorEvent() {
      var _this75 = this;

      var _minVolume = 0.1;

      var _time = 2000 / 4;

      clearInterval(this.volumeIndicatorTimer);
      this.volumeIndicatorTimer = setInterval(function () {
        if (!_this75.connectionTransport) {
          return false;
        } // 遍历过滤符合条件的数组数据


        var nowAudioVolumeIndicator = _toConsumableArray(_this75.subscribedTracks).concat(_toConsumableArray(_this75.publishedTracks)).filter(function (item) {
          return item.info.kind === "audio" && !item.info.muted;
        }).map(function (item) {
          return {
            trackID: item.info.trackID,
            userID: item.userID,
            level: item.getCurrentVolumeLevel() || 0,
            muted: item.info.muted
          };
        }); // 将本次采集传入 volumeIndicatorHistory


        if (_this75.volumeIndicatorHistory.length === 0) {
          // 第一次采集直接传入 volumeIndicatorHistory 数组
          _this75.volumeIndicatorHistory.push(nowAudioVolumeIndicator.filter(function (item) {
            return item.level >= _minVolume;
          }));
        } else {
          var lastAudioVolumeIndicator = _this75.volumeIndicatorHistory[_this75.volumeIndicatorHistory.length - 1];
          var volumeHashmap = {}; // 将上一次采集的数据生成 hashmap

          lastAudioVolumeIndicator.forEach(function (item) {
            return volumeHashmap[item.trackID] = item.level;
          });
          var filterAudioVolumeIndicator = [];
          var _iteratorNormalCompletion37 = true;
          var _didIteratorError37 = false;
          var _iteratorError37 = undefined;

          try {
            for (var _iterator37 = nowAudioVolumeIndicator[Symbol.iterator](), _step37; !(_iteratorNormalCompletion37 = (_step37 = _iterator37.next()).done); _iteratorNormalCompletion37 = true) {
              var i = _step37.value;

              if (i.level >= _minVolume) {
                if (volumeHashmap[i.trackID]) {
                  i.level > volumeHashmap[i.trackID] ? filterAudioVolumeIndicator.push(i) : filterAudioVolumeIndicator.push(__chunk_1._objectSpread({}, i, {
                    level: volumeHashmap[i.trackID]
                  }));
                } else {
                  filterAudioVolumeIndicator.push(i);
                }
              } else {
                volumeHashmap[i.trackID] && filterAudioVolumeIndicator.push(__chunk_1._objectSpread({}, i, {
                  level: volumeHashmap[i.trackID]
                }));
              }
            }
          } catch (err) {
            _didIteratorError37 = true;
            _iteratorError37 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion37 && _iterator37.return != null) {
                _iterator37.return();
              }
            } finally {
              if (_didIteratorError37) {
                throw _iteratorError37;
              }
            }
          }

          _this75.volumeIndicatorHistory.push(filterAudioVolumeIndicator); // 采集了四次数据后，清空采集记录，重新采集


          if (_this75.volumeIndicatorHistory.length === 4) {
            _this75.emit("volume-indicator", filterAudioVolumeIndicator.filter(function (item) {
              return !item.muted;
            }).map(function (item) {
              return {
                trackID: item.trackID,
                userID: item.userID,
                level: item.level
              };
            }));

            _this75.volumeIndicatorHistory = [];
          }
        }
      }, _time);
    }
  }, {
    key: "startMediaRelay",
    value: function () {
      var _startMediaRelay = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee54(config) {
        var _this76 = this;

        var destinationInfos, res, status, result;
        return _regeneratorRuntime.wrap(function _callee54$(_context54) {
          while (1) {
            switch (_context54.prev = _context54.next) {
              case 0:
                if (!(this.roomState !== RoomState.Connected)) {
                  _context54.next = 2;
                  break;
                }

                throw ERROR_FATAL("no signaling model, please run joinRoomWithToken first");

              case 2:
                if (!(this._mode === exports.QNClientMode.RTC)) {
                  _context54.next = 4;
                  break;
                }

                throw ERROR_INVALID_CLIENT_MODE("no permission. only BROADCASTER in LIVE mode has permission to media relay");

              case 4:
                if (!(this._role === exports.QNClientRole.AUDIENCE)) {
                  _context54.next = 6;
                  break;
                }

                throw ERROR_INVALID_CLIENT_ROLE("no permission. only BROADCASTER in LIVE mode has permission to media relay");

              case 6:
                _context54.prev = 6;
                _context54.next = 9;
                return Promise.all(config.destRoomInfos.map(
                /*#__PURE__*/
                function () {
                  var _ref24 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee53(dest) {
                    var roomAccess, relayRes;
                    return _regeneratorRuntime.wrap(function _callee53$(_context53) {
                      while (1) {
                        switch (_context53.prev = _context53.next) {
                          case 0:
                            roomAccess = getRoomAccessFromToken(dest.roomToken);
                            _context53.next = 3;
                            return getRelayToken(roomAccess, dest.roomToken, _this76.config.requestTimeout);

                          case 3:
                            relayRes = _context53.sent;
                            return _context53.abrupt("return", {
                              roomName: dest.roomName,
                              playerId: roomAccess.userId,
                              token: relayRes.relayToken
                            });

                          case 5:
                          case "end":
                            return _context53.stop();
                        }
                      }
                    }, _callee53, this);
                  }));

                  return function (_x84) {
                    return _ref24.apply(this, arguments);
                  };
                }()));

              case 9:
                destinationInfos = _context54.sent;
                _context54.next = 12;
                return this.signaling.request("start-media-relay", {
                  destinationInfos: destinationInfos.reduce(function (pre, cur) {
                    return __chunk_1._objectSpread({}, pre, _defineProperty2({}, cur.roomName, __chunk_1._objectSpread({}, cur)));
                  }, {})
                });

              case 12:
                res = _context54.sent;
                qos.addEvent("StartMediaRelay", {
                  "result_code": res.code,
                  "destination_infos": destinationInfos.map(function (dest) {
                    return {
                      room_name: dest.roomName,
                      room_token: dest.token,
                      uid: dest.playerId
                    };
                  })
                });

                if (!(res.code !== 0)) {
                  _context54.next = 16;
                  break;
                }

                throw SERVER_ERROR(res.code, res.error);

              case 16:
                status = res.status;
                result = Object.keys(status).reduce(function (pre, roomName) {
                  return __chunk_1._objectSpread({}, pre, _defineProperty2({}, roomName, status[roomName].state));
                }, {});
                return _context54.abrupt("return", result);

              case 21:
                _context54.prev = 21;
                _context54.t0 = _context54["catch"](6);

                if (!(_context54.t0 instanceof QNRTCError)) {
                  _context54.next = 27;
                  break;
                }

                throw _context54.t0;

              case 27:
                throw ERROR_FATAL(_context54.t0 instanceof Error ? _context54.t0.message : String(_context54.t0));

              case 28:
              case "end":
                return _context54.stop();
            }
          }
        }, _callee54, this, [[6, 21]]);
      }));

      function startMediaRelay(_x83) {
        return _startMediaRelay.apply(this, arguments);
      }

      return startMediaRelay;
    }()
  }, {
    key: "updateMediaRelay",
    value: function () {
      var _updateMediaRelay = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee56(config) {
        var _this77 = this;

        var destinationInfos, res, status, result;
        return _regeneratorRuntime.wrap(function _callee56$(_context56) {
          while (1) {
            switch (_context56.prev = _context56.next) {
              case 0:
                if (!(this.roomState !== RoomState.Connected)) {
                  _context56.next = 2;
                  break;
                }

                throw ERROR_FATAL("no signaling model, please run joinRoomWithToken first");

              case 2:
                if (!(this._mode === exports.QNClientMode.RTC)) {
                  _context56.next = 4;
                  break;
                }

                throw ERROR_INVALID_CLIENT_MODE("no permission. only BROADCASTER in LIVE mode has permission to media relay");

              case 4:
                if (!(this._role === exports.QNClientRole.AUDIENCE)) {
                  _context56.next = 6;
                  break;
                }

                throw ERROR_INVALID_CLIENT_ROLE("no permission. only BROADCASTER in LIVE mode has permission to media relay");

              case 6:
                _context56.prev = 6;
                _context56.next = 9;
                return Promise.all(config.destRoomInfos.map(
                /*#__PURE__*/
                function () {
                  var _ref25 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee55(dest) {
                    var roomAccess, relayRes;
                    return _regeneratorRuntime.wrap(function _callee55$(_context55) {
                      while (1) {
                        switch (_context55.prev = _context55.next) {
                          case 0:
                            roomAccess = getRoomAccessFromToken(dest.roomToken);
                            _context55.next = 3;
                            return getRelayToken(roomAccess, dest.roomToken, _this77.config.requestTimeout);

                          case 3:
                            relayRes = _context55.sent;
                            return _context55.abrupt("return", {
                              roomName: dest.roomName,
                              playerId: roomAccess.userId,
                              token: relayRes.relayToken
                            });

                          case 5:
                          case "end":
                            return _context55.stop();
                        }
                      }
                    }, _callee55, this);
                  }));

                  return function (_x86) {
                    return _ref25.apply(this, arguments);
                  };
                }()));

              case 9:
                destinationInfos = _context56.sent;
                _context56.next = 12;
                return this.signaling.request("update-media-relay", {
                  destinationInfos: destinationInfos.reduce(function (pre, cur) {
                    return __chunk_1._objectSpread({}, pre, _defineProperty2({}, cur.roomName, __chunk_1._objectSpread({}, cur)));
                  }, {})
                });

              case 12:
                res = _context56.sent;
                qos.addEvent("UpdateMediaRelay", {
                  "result_code": res.code,
                  "destination_infos": destinationInfos.map(function (dest) {
                    return {
                      room_name: dest.roomName,
                      room_token: dest.token,
                      uid: dest.playerId
                    };
                  })
                });

                if (!(res.code !== 0)) {
                  _context56.next = 16;
                  break;
                }

                throw SERVER_ERROR(res.code, res.error);

              case 16:
                status = res.status;
                result = Object.keys(status).reduce(function (pre, roomName) {
                  return __chunk_1._objectSpread({}, pre, _defineProperty2({}, roomName, status[roomName].state));
                }, {});
                return _context56.abrupt("return", result);

              case 21:
                _context56.prev = 21;
                _context56.t0 = _context56["catch"](6);

                if (!(_context56.t0 instanceof QNRTCError)) {
                  _context56.next = 27;
                  break;
                }

                throw _context56.t0;

              case 27:
                throw ERROR_FATAL(_context56.t0 instanceof Error ? _context56.t0.message : String(_context56.t0));

              case 28:
              case "end":
                return _context56.stop();
            }
          }
        }, _callee56, this, [[6, 21]]);
      }));

      function updateMediaRelay(_x85) {
        return _updateMediaRelay.apply(this, arguments);
      }

      return updateMediaRelay;
    }()
  }, {
    key: "stopMediaRelay",
    value: function () {
      var _stopMediaRelay = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee57() {
        var res, status, result;
        return _regeneratorRuntime.wrap(function _callee57$(_context57) {
          while (1) {
            switch (_context57.prev = _context57.next) {
              case 0:
                if (!(this.roomState !== RoomState.Connected)) {
                  _context57.next = 2;
                  break;
                }

                throw ERROR_FATAL("no signaling model, please run joinRoomWithToken first");

              case 2:
                if (!(this._mode === exports.QNClientMode.RTC)) {
                  _context57.next = 4;
                  break;
                }

                throw ERROR_INVALID_CLIENT_MODE("no permission. only BROADCASTER in LIVE mode has permission to media relay");

              case 4:
                if (!(this._role === exports.QNClientRole.AUDIENCE)) {
                  _context57.next = 6;
                  break;
                }

                throw ERROR_INVALID_CLIENT_ROLE("no permission. only BROADCASTER in LIVE mode has permission to media relay");

              case 6:
                _context57.prev = 6;
                _context57.next = 9;
                return this.signaling.request("stop-media-relay", {});

              case 9:
                res = _context57.sent;
                qos.addEvent("StopMediaRelay", {
                  "result_code": res.code
                });

                if (!(res.code !== 0)) {
                  _context57.next = 13;
                  break;
                }

                throw SERVER_ERROR(res.code, res.error);

              case 13:
                status = res.status;
                result = Object.keys(status).reduce(function (pre, roomName) {
                  return __chunk_1._objectSpread({}, pre, _defineProperty2({}, roomName, status[roomName].state));
                }, {});
                return _context57.abrupt("return", result);

              case 18:
                _context57.prev = 18;
                _context57.t0 = _context57["catch"](6);

                if (!(_context57.t0 instanceof QNRTCError)) {
                  _context57.next = 24;
                  break;
                }

                throw _context57.t0;

              case 24:
                throw ERROR_FATAL(_context57.t0 instanceof Error ? _context57.t0.message : String(_context57.t0));

              case 25:
              case "end":
                return _context57.stop();
            }
          }
        }, _callee57, this, [[6, 18]]);
      }));

      function stopMediaRelay() {
        return _stopMediaRelay.apply(this, arguments);
      }

      return stopMediaRelay;
    }()
  }, {
    key: "users",
    get: function get() {
      return Array.from(this._users.values());
    }
    /**
     * 房间内所有 Track 的信息列表，包括未订阅的，用 TrackBaseInfo 表示
     */

  }, {
    key: "trackInfoList",
    get: function get() {
      return this._trackInfo.map(transferSignalingTrackToTrackBaseInfo);
    }
  }, {
    key: "roomState",
    get: function get() {
      return this._roomState;
    },
    set: function set(state) {
      if (this._roomState !== state) {
        this._roomState = state;
        log.debug("roomState change", this._roomState);
        this.emit("room-state-change", this._roomState);
        qos.addEvent("RoomStateChanged", {
          room_state: state
        });
      }
    }
  }, {
    key: "simulcast",
    set: function set(simulcast) {
      this.config.simulcast = simulcast;

      if (this.connectionTransport) {
        this.connectionTransport.simulcast = simulcast;
        this.connectionTransport.sendHandler._simulcast = simulcast;
        this.connectionTransport.recvHandler._simulcast = simulcast;
      }
    }
  }, {
    key: "publishedTracks",
    get: function get() {
      if (!this.connectionTransport) return [];
      return this.connectionTransport.publishTracks.filter(function (p) {
        return p.connectStatus === TrackConnectStatus.Connect;
      }).map(function (p) {
        return p.track;
      });
    }
    /**
     * 房间中已经订阅的 Track 列表
     */

  }, {
    key: "subscribedTracks",
    get: function get() {
      return this.subscribeTracks.filter(function (p) {
        return p.connectStatus === TrackConnectStatus.Connect;
      }).map(function (t) {
        return t.track;
      });
    }
  }]);

  return QNRTCCore;
}(EventEmitter);

var TrackModeSession =
/*#__PURE__*/
function (_QNRTCCore) {
  _inherits(TrackModeSession, _QNRTCCore);

  function TrackModeSession(config) {
    var _this78;

    _classCallCheck(this, TrackModeSession);

    _this78 = _possibleConstructorReturn(this, _getPrototypeOf(TrackModeSession).call(this, config)); // 是否已发布 master audio track

    _this78.isAudioMastered = false; // 是否已发布 master video track

    _this78.isVideoMastered = false;
    _this78.sessionMode = "track";
    qos.addEvent("Init", {
      id: "".concat(_this78.sessionMode, "_").concat(Date.now())
    });
    return _this78;
  }
  /**
   * 已经添加进合流的 Track 列表（只有 trackid 信息）
   */


  _createClass(TrackModeSession, [{
    key: "join",

    /**
     * 加入房间
     * @param roomToken 房间 token
     * @param userData 用户自定义数据
     */
    value: function () {
      var _join = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee58(roomToken, userData) {
        return _regeneratorRuntime.wrap(function _callee58$(_context58) {
          while (1) {
            switch (_context58.prev = _context58.next) {
              case 0:
                _context58.next = 2;
                return this.joinRoomWithToken(roomToken, userData);

              case 2:
                return _context58.abrupt("return", _context58.sent);

              case 3:
              case "end":
                return _context58.stop();
            }
          }
        }, _callee58, this);
      }));

      function join(_x87, _x88) {
        return _join.apply(this, arguments);
      }

      return join;
    }()
    /**
     * 离开房间
     */

  }, {
    key: "leave",
    value: function leave() {
      this.leaveRoom();
      this.isAudioMastered = false;
      this.isVideoMastered = false;
    }
  }, {
    key: "publish",
    value: function () {
      var _publish = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee59(tracks) {
        var isAudioMastered, isVideoMastered, _iteratorNormalCompletion38, _didIteratorError38, _iteratorError38, _iterator38, _step38, track;

        return _regeneratorRuntime.wrap(function _callee59$(_context59) {
          while (1) {
            switch (_context59.prev = _context59.next) {
              case 0:
                isAudioMastered = this.isAudioMastered;
                isVideoMastered = this.isVideoMastered;
                _iteratorNormalCompletion38 = true;
                _didIteratorError38 = false;
                _iteratorError38 = undefined;
                _context59.prev = 5;

                for (_iterator38 = tracks[Symbol.iterator](); !(_iteratorNormalCompletion38 = (_step38 = _iterator38.next()).done); _iteratorNormalCompletion38 = true) {
                  track = _step38.value;

                  if (track.info.kind === "audio") {
                    if (this.isAudioMastered) {
                      track.setMaster(false);
                    } else {
                      track.setMaster(true);
                      this.isAudioMastered = true;
                    }
                  }

                  if (track.info.kind === "video") {
                    if (this.isVideoMastered) {
                      track.setMaster(false);
                    } else {
                      track.setMaster(true);
                      this.isVideoMastered = true;
                    }
                  }
                }

                _context59.next = 13;
                break;

              case 9:
                _context59.prev = 9;
                _context59.t0 = _context59["catch"](5);
                _didIteratorError38 = true;
                _iteratorError38 = _context59.t0;

              case 13:
                _context59.prev = 13;
                _context59.prev = 14;

                if (!_iteratorNormalCompletion38 && _iterator38.return != null) {
                  _iterator38.return();
                }

              case 16:
                _context59.prev = 16;

                if (!_didIteratorError38) {
                  _context59.next = 19;
                  break;
                }

                throw _iteratorError38;

              case 19:
                return _context59.finish(16);

              case 20:
                return _context59.finish(13);

              case 21:
                _context59.prev = 21;
                _context59.next = 24;
                return this._publish(tracks);

              case 24:
                return _context59.abrupt("return", _context59.sent);

              case 27:
                _context59.prev = 27;
                _context59.t1 = _context59["catch"](21);
                // publish error, restore master state
                this.isAudioMastered = isAudioMastered;
                this.isVideoMastered = isVideoMastered;
                throw _context59.t1;

              case 32:
              case "end":
                return _context59.stop();
            }
          }
        }, _callee59, this, [[5, 9, 13, 21], [14,, 16, 20], [21, 27]]);
      }));

      function publish(_x89) {
        return _publish.apply(this, arguments);
      }

      return publish;
    }()
  }, {
    key: "unpublish",
    value: function () {
      var _unpublish3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee60(trackIDs) {
        var res;
        return _regeneratorRuntime.wrap(function _callee60$(_context60) {
          while (1) {
            switch (_context60.prev = _context60.next) {
              case 0:
                _context60.next = 2;
                return this._unpublish(trackIDs);

              case 2:
                res = _context60.sent;
                this.isAudioMastered = this.publishedTracks.some(function (t) {
                  return !!(t.info.kind === "audio" && t.master);
                });
                this.isVideoMastered = this.publishedTracks.some(function (t) {
                  return !!(t.info.kind === "video" && t.master);
                });
                return _context60.abrupt("return", res);

              case 6:
              case "end":
                return _context60.stop();
            }
          }
        }, _callee60, this);
      }));

      function unpublish(_x90) {
        return _unpublish3.apply(this, arguments);
      }

      return unpublish;
    }()
    /**
     * 传入 trackID 列表订阅指定 Track
     * @param trackIDs trackID 列表
     * @param strictMode 是否开启严格模式
     * @param profiles 指定每路 track 的 profile
     * 如果开启严格模式，订阅过程中只要有一个 Track 出现错误就会导致整个订阅失败
     * 默认不开启严格模式
     */

  }, {
    key: "subscribe",
    value: function () {
      var _subscribe = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee61(trackIDs) {
        var strictMode,
            trackProfiles,
            _args61 = arguments;
        return _regeneratorRuntime.wrap(function _callee61$(_context61) {
          while (1) {
            switch (_context61.prev = _context61.next) {
              case 0:
                strictMode = _args61.length > 1 && _args61[1] !== undefined ? _args61[1] : false;
                trackProfiles = _args61.length > 2 ? _args61[2] : undefined;
                _context61.next = 4;
                return this._subscribe(trackIDs, false, strictMode, trackProfiles);

              case 4:
                return _context61.abrupt("return", _context61.sent);

              case 5:
              case "end":
                return _context61.stop();
            }
          }
        }, _callee61, this);
      }));

      function subscribe(_x91) {
        return _subscribe.apply(this, arguments);
      }

      return subscribe;
    }()
  }, {
    key: "unsubscribe",
    value: function () {
      var _unsubscribe3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee62(trackIDs) {
        return _regeneratorRuntime.wrap(function _callee62$(_context62) {
          while (1) {
            switch (_context62.prev = _context62.next) {
              case 0:
                _context62.next = 2;
                return this._unsubscribe(trackIDs);

              case 2:
                return _context62.abrupt("return", _context62.sent);

              case 3:
              case "end":
                return _context62.stop();
            }
          }
        }, _callee62, this);
      }));

      function unsubscribe(_x92) {
        return _unsubscribe3.apply(this, arguments);
      }

      return unsubscribe;
    }()
  }, {
    key: "setProfile",
    value: function setProfile(trackID, profile) {
      this._setProfile(trackID, profile);
    }
  }, {
    key: "setReconnectTimes",
    value: function setReconnectTimes(reconnectTimes) {
      this._setReconnectTimes(reconnectTimes);
    }
  }, {
    key: "getReconnectTimes",
    value: function getReconnectTimes() {
      return this._getReconnectTimes();
    }
  }, {
    key: "muteTracks",
    value: function muteTracks(tracks) {
      this._muteTracks(tracks);
    }
  }, {
    key: "addMergeStreamTracks",
    value: function () {
      var _addMergeStreamTracks = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee63(mergeOpts, jobID) {
        return _regeneratorRuntime.wrap(function _callee63$(_context63) {
          while (1) {
            switch (_context63.prev = _context63.next) {
              case 0:
                _context63.next = 2;
                return this._addMergeTracks(mergeOpts, jobID);

              case 2:
              case "end":
                return _context63.stop();
            }
          }
        }, _callee63, this);
      }));

      function addMergeStreamTracks(_x93, _x94) {
        return _addMergeStreamTracks.apply(this, arguments);
      }

      return addMergeStreamTracks;
    }()
  }, {
    key: "removeMergeStreamTracks",
    value: function () {
      var _removeMergeStreamTracks = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee64(trackIDs, jobID) {
        return _regeneratorRuntime.wrap(function _callee64$(_context64) {
          while (1) {
            switch (_context64.prev = _context64.next) {
              case 0:
                _context64.next = 2;
                return this._removeMergeTracks(trackIDs, jobID);

              case 2:
              case "end":
                return _context64.stop();
            }
          }
        }, _callee64, this);
      }));

      function removeMergeStreamTracks(_x95, _x96) {
        return _removeMergeStreamTracks.apply(this, arguments);
      }

      return removeMergeStreamTracks;
    }()
  }, {
    key: "stopMergeStream",
    value: function stopMergeStream(id) {
      this._stopMerge(id);
    }
  }, {
    key: "filterSignalTracks",
    value: function filterSignalTracks() {}
  }, {
    key: "releaseSession",
    value: function releaseSession() {}
  }, {
    key: "mergeStreamTracks",
    get: function get() {
      return this.defaultMergeJobTracks;
    }
    /**
     * 除了默认合流 job 之外的其他 job 的 合流 Track 列表
     */

  }, {
    key: "mergeStreamJobTracks",
    get: function get() {
      return this.mergeJobTracks;
    }
  }]);

  return TrackModeSession;
}(QNRTCCore);

var appId = "fk6fk2rnb";
var HOST = 'https://api-demo.qnsdk.com';
var PREFIX = '/v1';

var PATH = function PATH(roomName, user, appId) {
  return "/rtc/token/app/".concat(appId, "/room/").concat(roomName, "/user/").concat(user);
};

function getTestRoomName() {
  return _getTestRoomName.apply(this, arguments);
}

function _getTestRoomName() {
  _getTestRoomName = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee131() {
    var deviceId, rpcid;
    return _regeneratorRuntime.wrap(function _callee131$(_context131) {
      while (1) {
        switch (_context131.prev = _context131.next) {
          case 0:
            deviceId = "unknow";
            _context131.prev = 1;
            _context131.next = 4;
            return getDeviceId();

          case 4:
            deviceId = _context131.sent;
            _context131.next = 9;
            break;

          case 7:
            _context131.prev = 7;
            _context131.t0 = _context131["catch"](1);

          case 9:
            rpcid = randomStringGen(8);
            return _context131.abrupt("return", deviceId + "_" + rpcid);

          case 11:
          case "end":
            return _context131.stop();
        }
      }
    }, _callee131, this, [[1, 7]]);
  }));
  return _getTestRoomName.apply(this, arguments);
}

function getTestUserAId() {
  return "userA";
}

function getTestUserBId() {
  return "userB";
}

function getRoomToken(_x97, _x98) {
  return _getRoomToken.apply(this, arguments);
}

function _getRoomToken() {
  _getRoomToken = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee132(roomName, userID) {
    var requestURL, res, abortController;
    return _regeneratorRuntime.wrap(function _callee132$(_context132) {
      while (1) {
        switch (_context132.prev = _context132.next) {
          case 0:
            requestURL = "".concat(HOST).concat(PREFIX).concat(PATH(roomName, userID, appId));
            _context132.prev = 1;

            if (!("AbortController" in window)) {
              _context132.next = 10;
              break;
            }

            abortController = new AbortController();
            setTimeout(function () {
              return abortController.abort();
            }, 5 * 1000);
            _context132.next = 7;
            return fetch(requestURL, {
              signal: abortController.signal,
              headers: {
                'Content-Type': 'application/json'
              }
            });

          case 7:
            res = _context132.sent;
            _context132.next = 13;
            break;

          case 10:
            _context132.next = 12;
            return fetch(requestURL, {
              headers: {
                'Content-Type': 'application/json'
              }
            });

          case 12:
            res = _context132.sent;

          case 13:
            if (res.ok) {
              _context132.next = 15;
              break;
            }

            throw new Error(res.statusText);

          case 15:
            return _context132.abrupt("return", res.text());

          case 18:
            _context132.prev = 18;
            _context132.t0 = _context132["catch"](1);
            throw _context132.t0;

          case 21:
          case "end":
            return _context132.stop();
        }
      }
    }, _callee132, this, [[1, 18]]);
  }));
  return _getRoomToken.apply(this, arguments);
}

function _checkSystemRequirements2() {
  return _checkSystemRequirements.apply(this, arguments);
}
/*
 * index.ts
 * Copyright (C) 2018 disoul <disoul@DiSouldeMacBook-Pro.local>
 *
 * Distributed under terms of the MIT license.
*/

/**
 * 如果音频来源不是麦克风，而是通过在线音频或者自定义 buffer，将会使用这个类
 */


function _checkSystemRequirements() {
  _checkSystemRequirements = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee133() {
    var startTestTime, ok, reason, testRoomA, userA, testRoomB, userB, roomName, timeoutId, statsId, audioTrack, videoTrack, avgRTT, avgPacketLossRate, avgAudioBitrate, avgVideoBitrate, avgVolumnLevel, tracks, joinRoom, subTrack, rtts, packetLossRates, audioBitrates, videoBitrates, volumnLevels, maxStatsIntervalTime, statsIntervalTime;
    return _regeneratorRuntime.wrap(function _callee133$(_context133) {
      while (1) {
        switch (_context133.prev = _context133.next) {
          case 0:
            log.log("start checkSystemRequirements");
            startTestTime = Date.now();
            ok = false;
            reason = "";
            testRoomA = new TrackModeSession();
            userA = getTestUserAId();
            testRoomB = new TrackModeSession();
            userB = getTestUserBId();
            _context133.next = 10;
            return getTestRoomName();

          case 10:
            roomName = _context133.sent;
            avgRTT = -1;
            avgPacketLossRate = -1;
            avgAudioBitrate = -1;
            avgVideoBitrate = -1;
            avgVolumnLevel = -1;
            _context133.prev = 16;
            _context133.next = 19;
            return deviceManager.getLocalTracks({
              video: {
                enabled: true
              },
              audio: {
                enabled: true
              }
            });

          case 19:
            tracks = _context133.sent;
            videoTrack = tracks.find(function (t) {
              return t.info.kind === "video";
            });
            audioTrack = tracks.find(function (t) {
              return t.info.kind === "audio";
            });

            if (!(videoTrack === undefined || audioTrack === undefined)) {
              _context133.next = 24;
              break;
            }

            throw ERROR_FATAL("getLocalTracks failed.");

          case 24:
            joinRoom = function joinRoom(userID, testRoom) {
              return new Promise(function (resolve, reject) {
                getRoomToken(roomName, userID).then(function (token) {
                  return testRoom.joinRoomWithToken(token);
                }).then(resolve).catch(reject);
              });
            };

            _context133.next = 27;
            return Promise.all([joinRoom(userA, testRoomA), joinRoom(userB, testRoomB)]);

          case 27:
            subTrack = function subTrack(room) {
              return new Promise(function (resolve, reject) {
                if (room.trackInfoList.length > 0) {
                  room.subscribe(room.trackInfoList.map(function (info) {
                    return info.trackID;
                  })).then(resolve).catch(reject);
                } else {
                  room.on("track-add", function (trackInfoList) {
                    room.subscribe(trackInfoList.map(function (info) {
                      return info.trackID;
                    })).then(resolve).catch(reject);
                  });
                }
              });
            };

            _context133.next = 30;
            return Promise.all([testRoomA.publish([videoTrack]), testRoomB.publish([audioTrack]), subTrack(testRoomA), subTrack(testRoomB)]);

          case 30:
            // 采集 15 条有效流状态数据
            rtts = [];
            packetLossRates = [];
            audioBitrates = [];
            videoBitrates = [];
            volumnLevels = [];
            maxStatsIntervalTime = 30;
            statsIntervalTime = 0;
            _context133.next = 39;
            return new Promise(function (resolve) {
              statsId = setInterval(function () {
                var testRoomAPubs = testRoomA.publishedTracks[0].getStats();
                var testRoomBPubs = testRoomB.publishedTracks[0].getStats();

                if (testRoomAPubs.length > 0 && testRoomBPubs.length > 0 && audioTrack) {
                  rtts.push(testRoomAPubs[0].rtt);
                  packetLossRates.push(testRoomAPubs[0].packetLossRate);
                  audioBitrates.push(testRoomBPubs[0].bitrate);
                  videoBitrates.push(testRoomAPubs[0].bitrate);
                  volumnLevels.push(audioTrack.getCurrentVolumeLevel());
                } // TODO: 检测视频：1、是否有数据；2、是否正常渲染


                if (rtts.length > 15) {
                  clearInterval(statsId);
                  resolve();
                }

                if (statsIntervalTime > maxStatsIntervalTime) {
                  log.warning("abnormal track stats: less than 15 valid stats in 30s");
                  clearInterval(statsId);
                  resolve();
                }

                statsIntervalTime += 1;
              }, 1000);
            });

          case 39:
            log.log(JSON.stringify({
              detailTestResult: {
                rtts: rtts,
                packetLossRates: packetLossRates,
                audioBitrates: audioBitrates,
                videoBitrates: videoBitrates,
                volumnLevels: volumnLevels
              }
            }));

            if (rtts.length > 0) {
              avgRTT = Math.ceil(rtts.reduce(function (pre, cur) {
                return pre + cur;
              }, 0) / rtts.length);
              avgPacketLossRate = packetLossRates.reduce(function (pre, cur) {
                return pre + cur;
              }, 0) / packetLossRates.length;
              avgAudioBitrate = audioBitrates.reduce(function (pre, cur) {
                return pre + cur;
              }, 0) / audioBitrates.length;
              avgVideoBitrate = videoBitrates.reduce(function (pre, cur) {
                return pre + cur;
              }, 0) / videoBitrates.length;
              avgVolumnLevel = volumnLevels.reduce(function (pre, cur) {
                return pre + cur;
              }, 0) / volumnLevels.length;
            }

            ok = true;
            _context133.next = 48;
            break;

          case 44:
            _context133.prev = 44;
            _context133.t0 = _context133["catch"](16);
            ok = false;

            if (typeof _context133.t0 === "string") {
              reason = _context133.t0;
            } else if (_context133.t0 instanceof QNRTCError) {
              reason = JSON.stringify(_context133.t0);
            } else {
              reason = _context133.t0.message;
            }

          case 48:
            _context133.prev = 48;

            if (!(testRoomA.roomState === RoomState.Connected)) {
              _context133.next = 53;
              break;
            }

            _context133.next = 52;
            return testRoomA.unpublish(testRoomA.publishedTracks.map(function (t) {
              return t.info.trackID;
            }));

          case 52:
            testRoomA.leaveRoom();

          case 53:
            if (!(testRoomB.roomState === RoomState.Connected)) {
              _context133.next = 57;
              break;
            }

            _context133.next = 56;
            return testRoomB.unpublish(testRoomB.publishedTracks.map(function (t) {
              return t.info.trackID;
            }));

          case 56:
            testRoomB.leaveRoom();

          case 57:
            if (videoTrack) {
              videoTrack.release();
            }

            if (audioTrack) {
              audioTrack.release();
            }

            clearTimeout(timeoutId);
            clearInterval(statsId);
            qos.addEvent("SystemRequirementsTest", {
              room_name: roomName,
              ok: ok,
              reason: reason,
              avg_rtt: avgRTT,
              avg_packet_loss_rate: avgPacketLossRate,
              avg_volumn_level: avgVolumnLevel,
              avg_audio_bitrate: avgAudioBitrate,
              avg_video_bitrate: avgVideoBitrate,
              test_take_time: Date.now() - startTestTime
            }, true);
            return _context133.abrupt("return", {
              roomName: roomName,
              ok: ok,
              reason: reason,
              avgRTT: avgRTT,
              avgPacketLossRate: avgPacketLossRate,
              avgVolumnLevel: avgVolumnLevel,
              avgAudioBitrate: avgAudioBitrate,
              avgVideoBitrate: avgVideoBitrate
            });

          case 64:
          case "end":
            return _context133.stop();
        }
      }
    }, _callee133, this, [[16, 44, 48, 64]]);
  }));
  return _checkSystemRequirements.apply(this, arguments);
}

var AudioSourceTrack =
/*#__PURE__*/
function (_AudioTrack) {
  _inherits(AudioSourceTrack, _AudioTrack);

  function AudioSourceTrack(source, userID) {
    var _this79;

    _classCallCheck(this, AudioSourceTrack);

    if (!__chunk_1.browserReport.mediaStreamDest) {
      throw ERROR_NOT_SUPPORT("your browser does not support audio buffer input!");
    }

    var audioManager = new AudioManager();
    audioManager.initAudioContext();

    if (source instanceof AudioBuffer) {
      audioManager.setAudioBufferSource();
      audioManager.setAudioBuffer(source);
    } else if (source instanceof HTMLAudioElement) {
      audioManager.setMediaElementSource(source);
    }

    var mediaStream = audioManager.audioStream.stream;
    var audioMediaTrack = mediaStream.getTracks()[0];
    _this79 = _possibleConstructorReturn(this, _getPrototypeOf(AudioSourceTrack).call(this, audioMediaTrack, userID, "local"));
    _this79.sourceType = TrackSourceType.EXTERNAL;
    _this79.isLoop = false;
    _this79.originSource = source;
    _this79.audioManager = audioManager;

    _this79.handleAudioManagerEvents();

    return _this79;
  }
  /**
   * 设置循环播放模式
   */


  _createClass(AudioSourceTrack, [{
    key: "setLoop",
    value: function setLoop(isLoop) {
      this.isLoop = isLoop;
      this.audioManager.setAudioSourceLoop(isLoop);
    }
    /**
     * 播放自定义的 Source
     */

  }, {
    key: "startAudioSource",
    value: function startAudioSource() {
      this.audioManager.playAudioSource();
    }
    /**
     * 暂停播放自定义的 Source
     */

  }, {
    key: "pauseAudioSource",
    value: function pauseAudioSource() {
      this.audioManager.pauseAudioSource();
    }
    /**
     * 恢复播放自定义的 Source
     */

  }, {
    key: "resumeAudioSource",
    value: function resumeAudioSource() {
      this.audioManager.resumeAudioSource();
    }
    /**
     * 停止播放 AudioBuffer 数据
     */

  }, {
    key: "stopAudioSource",
    value: function stopAudioSource() {
      this.audioManager.stopAudioSource();
    }
    /**
     * 获取当前的播放时间
     */

  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.audioManager.getAudioSourceCurrentTime() || 0;
    }
    /**
     * 设置当前的时间
     */

  }, {
    key: "setCurrentTime",
    value: function setCurrentTime(val) {
      this.audioManager.setAudioSourceCurrentTime(val);
    }
    /**
     * 获取播放总时长，对于在线音乐
     * 只有当 audio-state-change 第一次触发 PLAY 后才能获取到
     */

  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.audioManager.getAudioSourceDuration() || 0;
    }
  }, {
    key: "handleAudioManagerEvents",
    value: function handleAudioManagerEvents() {
      var _this80 = this;

      this.audioManager.on("@audio-source-state-change", function (newState, lastState) {
        _this80.emit("audio-state-change", newState, lastState);
      });
    }
  }]);

  return AudioSourceTrack;
}(AudioTrack);
/**
 * v1 版本的 Stream，只会拥有最多一个 videoTrack 以及一个 audioTrack
 */


var Stream =
/*#__PURE__*/
function (_EventEmitter4) {
  _inherits(Stream, _EventEmitter4);

  function Stream(tracks) {
    var _this81;

    var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "send";
    var userID = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck(this, Stream);

    _this81 = _possibleConstructorReturn(this, _getPrototypeOf(Stream).call(this));
    /**
     * 表示这个流下所包含的所有 Track 的信息，用于精细控制每个 Track 的行为
     * 详细结构可以查阅 TrackInfo
     */

    _this81.trackList = [];
    /**
     * 用于标记这个流是否调用了 release 方法，即表示这个流已经被释放
     */

    _this81.isDestroyed = false;
    _this81.enableAudio = true;
    _this81.enableVideo = true;
    _this81.muteAudio = false;
    _this81.muteVideo = false;

    _this81.onAudioEnded = function (event) {
      _this81.emit("audio-ended", event);
    };

    _this81.onVideoEnded = function (event) {
      _this81.emit("video-ended", event);
    };

    _this81.onAudioSourceStateChange = function (curr, last) {
      _this81.emit("audio-source-state-change", curr, last);
    };

    _this81.direction = direction;
    _this81.userID = userID;
    tracks.forEach(function (track) {
      track.setMaster(true);
      track.on("mute", function () {
        _this81.updateTrackState();
      }); // 监听 track 的 release 事件，更新自己的状态

      track.on("release", function () {
        remove(_this81.trackList, function (t) {
          return t === track;
        });

        _this81.updateTrackState(); // 如果自己所有的 track 都 release 了，自己也 release


        if (_this81.trackList.length === 0) {
          _this81.release();
        }
      });

      _this81.trackList.push(track);
    });

    _this81.updateTrackState();

    return _this81;
  }

  _createClass(Stream, [{
    key: "setVolume",

    /**
     * 目前只对采集的流有效
     */
    value: function setVolume(v) {
      if (this._audioTrack) {
        this._audioTrack.setVolume(v);
      }
    }
    /**
     * 将一个 Stream 对象置于页面上指定的元素下播放
     * 会将将所有 track 都置于一个元素下播放
     *
     * 如果想单独控制每一个 track 的播放行为
     * 通过 trackList 获取 Track 对象，调用它的 play 方法
     * @param container 指定一个 HTML 元素用于放置媒体元素
     * @param muted 是否使用静音模式，如果为 true 就不会播放音频，仅播放视频，默认为 false。
     */

  }, {
    key: "play",
    value: function play(container, muted) {
      this.trackList.forEach(function (track) {
        return track.play(container, muted);
      });

      if (this._audioTrack) {
        this.audio = this._audioTrack.mediaElement;
      }

      if (this._videoTrack) {
        this.video = this._videoTrack.mediaElement;
      }
    }
  }, {
    key: "getCurrentTimeDomainData",
    value: function getCurrentTimeDomainData() {
      if (this._audioTrack) {
        return this._audioTrack.getCurrentTimeDomainData();
      }

      return new Uint8Array(0);
    }
  }, {
    key: "getCurrentFrequencyData",
    value: function getCurrentFrequencyData() {
      if (this._audioTrack) {
        return this._audioTrack.getCurrentFrequencyData();
      }

      return new Uint8Array(0);
    }
  }, {
    key: "getCurrentVolumeLevel",
    value: function getCurrentVolumeLevel() {
      if (this._audioTrack) {
        return this._audioTrack.getCurrentVolumeLevel();
      }

      return 0;
    }
  }, {
    key: "getStats",
    value: function getStats() {
      var audioReport = defaultTrackStatsReport();

      if (this._audioTrack) {
        var audioReportList = this._audioTrack.getStats();

        if (audioReportList.length > 0) {
          audioReport = audioReportList[0];
        }
      }

      var videoReport = defaultTrackStatsReport();

      if (this._videoTrack) {
        var videoReportList = this._videoTrack.getStats();

        if (videoReportList.length > 0) {
          videoReport = videoReportList[0];
        }
      }

      return {
        timestamp: Date.now(),
        videoBitrate: videoReport.bitrate,
        audioBitrate: audioReport.bitrate,
        videoPacketLoss: videoReport.packetLoss,
        audioPacketLoss: audioReport.packetLoss,
        videoPackets: videoReport.packets,
        audioPackets: audioReport.packets,
        videoPacketLossRate: videoReport.packetLossRate,
        audioPacketLossRate: audioReport.packetLossRate,
        videoBytes: videoReport.bytes,
        audioBytes: audioReport.bytes,
        pctype: this.direction
      };
    }
  }, {
    key: "getCurrentFrameDataURL",
    value: function getCurrentFrameDataURL() {
      if (!this._videoTrack) {
        return "data:,";
      }

      return this._videoTrack.getCurrentFrameDataURL();
    }
  }, {
    key: "setAudioSourceLoop",
    value: function setAudioSourceLoop(isLoop) {
      if (!(this._audioTrack instanceof AudioSourceTrack)) {
        return;
      }

      this._audioTrack.setLoop(isLoop);
    }
  }, {
    key: "startAudioSource",
    value: function startAudioSource() {
      if (!(this._audioTrack instanceof AudioSourceTrack)) {
        return;
      }

      this._audioTrack.startAudioSource();
    }
  }, {
    key: "pauseAudioSource",
    value: function pauseAudioSource() {
      if (!(this._audioTrack instanceof AudioSourceTrack)) {
        return;
      }

      this._audioTrack.pauseAudioSource();
    }
  }, {
    key: "resumeAudioSource",
    value: function resumeAudioSource() {
      if (!(this._audioTrack instanceof AudioSourceTrack)) {
        return;
      }

      this._audioTrack.resumeAudioSource();
    }
  }, {
    key: "stopAudioSource",
    value: function stopAudioSource() {
      if (!(this._audioTrack instanceof AudioSourceTrack)) {
        return;
      }

      this._audioTrack.stopAudioSource();
    }
  }, {
    key: "getAudioSourceCurrentTime",
    value: function getAudioSourceCurrentTime() {
      if (!(this._audioTrack instanceof AudioSourceTrack)) {
        return 0;
      }

      return this._audioTrack.getCurrentTime();
    }
  }, {
    key: "getAudioSourceDuration",
    value: function getAudioSourceDuration() {
      if (!(this._audioTrack instanceof AudioSourceTrack)) {
        return 0;
      }

      return this._audioTrack.getDuration();
    }
  }, {
    key: "setAudioSourceCurrentTime",
    value: function setAudioSourceCurrentTime(val) {
      if (!(this._audioTrack instanceof AudioSourceTrack)) {
        return;
      }

      return this._audioTrack.setCurrentTime(val);
    }
    /**
     * @internal
     */

  }, {
    key: "setKbps",
    value: function setKbps(video, audio) {
      if (video && this._videoTrack) {
        this._videoTrack.setKbps(video);
      }

      if (audio && this._audioTrack) {
        this._audioTrack.setKbps(audio);
      }
    }
    /* @internal */

  }, {
    key: "updateTrackState",
    value: function updateTrackState() {
      var _this82 = this;

      this.trackList.forEach(function (track) {
        if (track.info.kind === "audio") {
          if (_this82._audioTrack) {
            _this82._audioTrack.off("ended", _this82.onAudioEnded);

            _this82._audioTrack.off("audio-state-change", _this82.onAudioSourceStateChange);
          }

          _this82.audioTrack = track.mediaTrack;
          _this82._audioTrack = track;

          _this82._audioTrack.on("ended", _this82.onAudioEnded);

          if (_this82._audioTrack instanceof AudioSourceTrack) {
            _this82._audioTrack.on("audio-state-change", _this82.onAudioSourceStateChange);
          }
        } else {
          if (_this82._videoTrack) {
            _this82._videoTrack.off("ended", _this82.onVideoEnded);
          }

          _this82.videoTrack = track.mediaTrack;
          _this82._videoTrack = track;

          _this82._videoTrack.on("ended", _this82.onVideoEnded);
        }
      });

      if (this.audioTrack) {
        this.enableAudio = true;
        this.muteAudio = !this.audioTrack.enabled;
      } else {
        this.enableAudio = false;
      }

      if (this.videoTrack) {
        this.enableVideo = true;
        this.muteVideo = !this.videoTrack.enabled;
      } else {
        this.enableVideo = false;
      }
    }
    /**
     * 释放这个流下的所有资源，包括流和用于播放流的媒体元素
     */

  }, {
    key: "release",
    value: function release() {
      if (this.isDestroyed) {
        return;
      }

      for (var i = 0; i < this.trackList.length; i += 1) {
        var track = this.trackList[i];
        track.removeAllListeners("release");
        track.release();
      }

      this.trackList = [];
      this.isDestroyed = true;
      this.emit("release");
      this.removeEvent();
    }
    /**
     * @internal
     * 释放流下一个 track，包括媒体元素
     * 如果 Track 被 Stream 包裹，不要直接调用 Track 的 release 方法
     * @param track 标记要释放的 track
     */

  }, {
    key: "releaseTrack",
    value: function releaseTrack(track) {
      var _removeElementFromArr = removeElementFromArray(this.trackList, "mediaTrack", track.mediaTrack),
          removeElement = _removeElementFromArr.removeElement,
          newArray = _removeElementFromArr.newArray;

      if (!removeElement) {
        return;
      }

      track.release();
      this.trackList = newArray;

      if (this.trackList.length === 0) {
        this.isDestroyed = true;
      }
    }
  }, {
    key: "audioSourceIsLoop",
    get: function get() {
      if (!(this._audioTrack instanceof AudioSourceTrack)) {
        return false;
      }

      return this._audioTrack.isLoop;
    }
  }]);

  return Stream;
}(EventEmitter);

var AudioMixingTrack =
/*#__PURE__*/
function (_AudioTrack2) {
  _inherits(AudioMixingTrack, _AudioTrack2);

  function AudioMixingTrack(userID) {
    var _this83;

    _classCallCheck(this, AudioMixingTrack);

    var destination = audioContext.createMediaStreamDestination();
    var audioTrack = destination.stream.getAudioTracks()[0];
    _this83 = _possibleConstructorReturn(this, _getPrototypeOf(AudioMixingTrack).call(this, audioTrack, userID, "local"));
    _this83.sourceType = TrackSourceType.MIXING;

    _this83.initAudioManager(true);

    _this83.destination = destination;
    _this83.inputList = [];
    return _this83;
  }

  _createClass(AudioMixingTrack, [{
    key: "appendAudioSource",
    value: function appendAudioSource(track) {
      var _this84 = this;

      if (this.inputList.find(function (input) {
        return input.track === track;
      })) {
        log.warning("track is already in the track list");
        return;
      }

      this.inputList.push({
        track: track
      });
      track.on("ended", function () {
        _this84.emit("ended");
      });
      track.audioManager.gainNode.connect(this.destination);
    }
  }, {
    key: "removeAudioSource",
    value: function removeAudioSource(track) {
      var targetInput = this.inputList.find(function (input) {
        return input.track === track;
      });

      if (!targetInput) {
        return;
      }

      try {
        targetInput.track.audioManager.gainNode.disconnect(this.destination);
      } catch (_unused) {// if already disconnected, just ignore
      }

      remove(this.inputList, function (i) {
        return i === targetInput;
      });
    }
  }, {
    key: "release",
    value: function release() {
      // remove all audio source
      var _iteratorNormalCompletion39 = true;
      var _didIteratorError39 = false;
      var _iteratorError39 = undefined;

      try {
        for (var _iterator39 = this.inputList[Symbol.iterator](), _step39; !(_iteratorNormalCompletion39 = (_step39 = _iterator39.next()).done); _iteratorNormalCompletion39 = true) {
          var input = _step39.value;
          this.removeAudioSource(input.track);
        }
      } catch (err) {
        _didIteratorError39 = true;
        _iteratorError39 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion39 && _iterator39.return != null) {
            _iterator39.return();
          }
        } finally {
          if (_didIteratorError39) {
            throw _iteratorError39;
          }
        }
      }

      _get(_getPrototypeOf(AudioMixingTrack.prototype), "release", this).call(this);
    }
  }]);

  return AudioMixingTrack;
}(AudioTrack);

var AudioEffectManager =
/*#__PURE__*/
function () {
  function AudioEffectManager(output, playbackEngine) {
    _classCallCheck(this, AudioEffectManager);

    /** @inrernal */
    this.effectSourceMap = new Map();
    /** @inrernal */

    this.playback = true;
    this.output = output;
    this.playbackEngine = playbackEngine;
  }

  _createClass(AudioEffectManager, [{
    key: "getEffectTrack",
    value: function getEffectTrack(key) {
      return this.effectSourceMap.get(key);
    }
  }, {
    key: "playEffect",
    value: function playEffect(key, volume) {
      var audioTrack = this.effectSourceMap.get(key);

      if (!audioTrack) {
        log.warning("can not find target effect", key);
        return;
      }

      if (volume) {
        audioTrack.setVolume(volume);
      }

      if (this.playback && audioTrack.audioManager.audioSource) {
        this.playbackEngine.addAudioNode(audioTrack.audioManager.gainNode);
      }

      audioTrack.startAudioSource();
    }
    /**
     * 添加音效
     * @param source 音效的源文件，支持本地 File 文件或者在线音乐地址
     * @param key 音效的 key，每个音效需要指定一个唯一的 key，用于之后调用
     */

  }, {
    key: "addEffectSource",
    value: function () {
      var _addEffectSource = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee65(source, key) {
        var audioTrack;
        return _regeneratorRuntime.wrap(function _callee65$(_context65) {
          while (1) {
            switch (_context65.prev = _context65.next) {
              case 0:
                if (!this.effectSourceMap.has(key)) {
                  _context65.next = 3;
                  break;
                }

                log.warning("duplicate effect key!", key);
                return _context65.abrupt("return");

              case 3:
                _context65.next = 5;
                return AudioUtils.createAudioTrackFromSource(source);

              case 5:
                audioTrack = _context65.sent;
                this.effectSourceMap.set(key, audioTrack);
                this.output.appendAudioSource(audioTrack);

              case 8:
              case "end":
                return _context65.stop();
            }
          }
        }, _callee65, this);
      }));

      function addEffectSource(_x99, _x100) {
        return _addEffectSource.apply(this, arguments);
      }

      return addEffectSource;
    }()
    /**
     * 移除并释放已经添加的音效
     * @param key 指定音效的 key，如果不指定默认删除全部的音效
     */

  }, {
    key: "removeEffectSource",
    value: function removeEffectSource(key) {
      var targetKeys = [];

      if (!key) {
        targetKeys = Array.from(this.effectSourceMap.keys());
      } else {
        targetKeys = [key];
      }

      var _iteratorNormalCompletion40 = true;
      var _didIteratorError40 = false;
      var _iteratorError40 = undefined;

      try {
        for (var _iterator40 = targetKeys[Symbol.iterator](), _step40; !(_iteratorNormalCompletion40 = (_step40 = _iterator40.next()).done); _iteratorNormalCompletion40 = true) {
          var k = _step40.value;
          var targetAudioTrack = this.effectSourceMap.get(k);

          if (!targetAudioTrack) {
            return;
          }

          this.output.removeAudioSource(targetAudioTrack);
          targetAudioTrack.release();
          this.effectSourceMap.delete(k);
        }
      } catch (err) {
        _didIteratorError40 = true;
        _iteratorError40 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion40 && _iterator40.return != null) {
            _iterator40.return();
          }
        } finally {
          if (_didIteratorError40) {
            throw _iteratorError40;
          }
        }
      }
    }
  }, {
    key: "effectList",
    get: function get() {
      return Array.from(this.effectSourceMap.keys());
    }
  }]);

  return AudioEffectManager;
}();

var AudioMusicManager =
/*#__PURE__*/
function (_EventEmitter5) {
  _inherits(AudioMusicManager, _EventEmitter5);

  function AudioMusicManager(output, playbackEngine) {
    var _this85;

    _classCallCheck(this, AudioMusicManager);

    _this85 = _possibleConstructorReturn(this, _getPrototypeOf(AudioMusicManager).call(this));
    _this85.musicOption = {
      loop: false,
      volume: 1
    };
    /** @internal */

    _this85.playback = true;
    _this85.output = output;
    _this85.playbackEngine = playbackEngine;
    return _this85;
  }
  /** @internal */


  _createClass(AudioMusicManager, [{
    key: "setMusicOption",

    /**
     * 更新背景音乐混音的各种参数，支持在混音中途更新
     * @param option Partical<AudioMusicOption>
     */
    value: function setMusicOption(option) {
      this.musicOption = Object.assign(this.musicOption, option);

      if (this.musicTrack) {
        this.musicTrack.setVolume(this.musicOption.volume);
        this.musicTrack.setLoop(this.musicOption.loop);
      }
    }
    /**
     * 开始音乐混音
     * @param source 音乐的源文件，支持本地文件对象或者在线音乐地址
     */

  }, {
    key: "startMusicMixing",
    value: function () {
      var _startMusicMixing = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee66(source) {
        var _this86 = this;

        return _regeneratorRuntime.wrap(function _callee66$(_context66) {
          while (1) {
            switch (_context66.prev = _context66.next) {
              case 0:
                if (!this.musicTrack) {
                  _context66.next = 5;
                  break;
                }

                this.stopMusicMixing();
                _context66.next = 4;
                return this.startMusicMixing(source);

              case 4:
                return _context66.abrupt("return", _context66.sent);

              case 5:
                _context66.next = 7;
                return AudioUtils.createAudioTrackFromSource(source);

              case 7:
                this.musicTrack = _context66.sent;
                this.output.appendAudioSource(this.musicTrack);
                this.setMusicOption({});

                if (this.musicTrack.audioManager.audioSource) {
                  _context66.next = 12;
                  break;
                }

                throw ERROR_FATAL("can not find audio source");

              case 12:
                if (this.playback && this.audioNode) {
                  this.playbackEngine.addAudioNode(this.audioNode);
                }

                this.musicTrack.on("audio-state-change", function (curr, last) {
                  _this86.emit("music-state-change", curr, last);
                });
                this.musicTrack.startAudioSource();

              case 15:
              case "end":
                return _context66.stop();
            }
          }
        }, _callee66, this);
      }));

      function startMusicMixing(_x101) {
        return _startMusicMixing.apply(this, arguments);
      }

      return startMusicMixing;
    }()
    /**
     * 暂停音乐混音
     */

  }, {
    key: "pauseMusicMixing",
    value: function pauseMusicMixing() {
      if (!this.musicTrack) {
        log.warning("can not find target music, please run startAudioMixing");
        return;
      }

      this.musicTrack.pauseAudioSource();
    }
    /**
     * 恢复音乐混音
     */

  }, {
    key: "resumeMusicMixing",
    value: function resumeMusicMixing() {
      if (!this.musicTrack) {
        log.warning("can not find target music, please run startAudioMixing");
        return;
      }

      this.musicTrack.resumeAudioSource();
    }
    /**
     * 停止音乐混音
     */

  }, {
    key: "stopMusicMixing",
    value: function stopMusicMixing() {
      if (!this.musicTrack) {
        return;
      }

      this.musicTrack.stopAudioSource();
      this.output.removeAudioSource(this.musicTrack);
      this.musicTrack.release();
      this.musicTrack = undefined;
    }
  }, {
    key: "getMusicDuration",
    value: function getMusicDuration() {
      if (!this.musicTrack) {
        return 0;
      }

      return this.musicTrack.getDuration();
    }
  }, {
    key: "getMusicCurrentTime",
    value: function getMusicCurrentTime() {
      if (!this.musicTrack) {
        return 0;
      }

      return this.musicTrack.getCurrentTime();
    }
  }, {
    key: "setMusicCurrentTime",
    value: function setMusicCurrentTime(currentTime) {
      if (!this.musicTrack) {
        return;
      }

      this.musicTrack.setCurrentTime(currentTime);
      if (!this.musicTrack.audioManager.audioSource) throw ERROR_FATAL("can not find audio source");
    }
  }, {
    key: "audioNode",
    get: function get() {
      if (!this.musicTrack) return null;
      return this.musicTrack.audioManager.gainNode;
    }
  }]);

  return AudioMusicManager;
}(EventEmitter);

var AudioPlaybackEngine =
/*#__PURE__*/
function () {
  function AudioPlaybackEngine() {
    _classCallCheck(this, AudioPlaybackEngine);

    this.volume = 1;
    this.gainNode = audioContext.createGain();
    this.gainNode.connect(audioContext.destination);
  }

  _createClass(AudioPlaybackEngine, [{
    key: "addAudioNode",
    value: function addAudioNode(audioNode) {
      audioNode.connect(this.gainNode);
    }
  }, {
    key: "removeAudioNode",
    value: function removeAudioNode(audioNode) {
      audioNode.disconnect(this.gainNode);
    }
  }, {
    key: "release",
    value: function release() {
      this.gainNode.disconnect();
    }
  }]);

  return AudioPlaybackEngine;
}();

var AudioMixingManager =
/*#__PURE__*/
function () {
  function AudioMixingManager(originSource) {
    _classCallCheck(this, AudioMixingManager);

    this.playbackEngine = new AudioPlaybackEngine();
    this.sourcePlayebackState = false;

    if (originSource instanceof AudioTrack) {
      this.outputTrack = new AudioMixingTrack();
      this.outputTrack.info = originSource.info;
      this.outputTrack.appendAudioSource(originSource);
    } else {
      throw ERROR_FATAL("audio mixing manager: origin track is not audio track");
    }

    this.source = originSource;
    this.effectManager = new AudioEffectManager(this.outputTrack, this.playbackEngine);
    this.musicManager = new AudioMusicManager(this.outputTrack, this.playbackEngine);
  }
  /**
   * 获取背景音乐返听的状态, 默认打开
   */


  _createClass(AudioMixingManager, [{
    key: "getMusicPlaybackState",
    value: function getMusicPlaybackState() {
      return this.musicManager.playback;
    }
    /**
     * 设置背景音乐的返听状态，默认打开
     * @param state boolean
     */

  }, {
    key: "setMusicPlaybackState",
    value: function setMusicPlaybackState(state) {
      if (this.musicManager.playback === state) return;
      this.musicManager.playback = state;
      if (!this.musicManager.audioNode) return;

      if (state) {
        this.playbackEngine.addAudioNode(this.musicManager.audioNode);
      } else {
        this.playbackEngine.removeAudioNode(this.musicManager.audioNode);
      }
    }
    /**
     * 获取输入音源返听的状态，默认关闭
     */

  }, {
    key: "getSourcePlaybackState",
    value: function getSourcePlaybackState() {
      return this.sourcePlayebackState;
    }
    /**
     * 设置输入音源的返听状态，默认关闭
     * @param state boolean
     */

  }, {
    key: "setSourcePlaybackState",
    value: function setSourcePlaybackState(state) {
      if (this.sourcePlayebackState === state) return;
      this.sourcePlayebackState = state;
      if (!this.source.audioManager.audioSource) return;

      if (state) {
        this.playbackEngine.addAudioNode(this.source.audioManager.gainNode);
      } else {
        this.playbackEngine.removeAudioNode(this.source.audioManager.gainNode);
      }
    }
    /**
     * 获取音效返听的状态，默认打开
     */

  }, {
    key: "getEffectPlaybackState",
    value: function getEffectPlaybackState() {
      return this.effectManager.playback;
    }
    /**
     * 设置音效返听的状态，默认打开
     */

  }, {
    key: "setEffectPlaybackState",
    value: function setEffectPlaybackState(state) {
      var _this87 = this;

      if (this.effectManager.playback === state) return;
      this.effectManager.playback = state;
      this.effectManager.effectSourceMap.forEach(function (v, k) {
        if (!v.audioManager.audioSource) return;

        if (state) {
          _this87.playbackEngine.addAudioNode(v.audioManager.gainNode);
        } else {
          _this87.playbackEngine.removeAudioNode(v.audioManager.gainNode);
        }
      });
    }
  }, {
    key: "setBitrate",
    value: function setBitrate(kbps) {
      this.outputTrack.setInfo({
        kbps: kbps
      });
    }
  }, {
    key: "setTag",
    value: function setTag(tag) {
      this.outputTrack.setInfo({
        tag: tag
      });
    }
    /**
     * 释放整个混音模块，清除 output/音乐/音效等资源
     * 但是不会释放构造函数传入的原始源
     */

  }, {
    key: "release",
    value: function release() {
      this.effectManager.removeEffectSource();
      this.musicManager.stopMusicMixing();
      this.outputTrack.removeAudioSource(this.source);
      this.outputTrack.release();
      this.playbackEngine.release();
    }
  }]);

  return AudioMixingManager;
}();

var StreamMixingManager =
/*#__PURE__*/
function (_AudioMixingManager) {
  _inherits(StreamMixingManager, _AudioMixingManager);

  function StreamMixingManager(input) {
    var _this88;

    _classCallCheck(this, StreamMixingManager);

    if (!input._audioTrack) {
      throw ERROR_FATAL("input stream do not have audio track");
    }

    _this88 = _possibleConstructorReturn(this, _getPrototypeOf(StreamMixingManager).call(this, input._audioTrack));
    _this88.input = input;
    var trackList = [_this88.outputTrack];

    if (_this88.input._videoTrack) {
      trackList.push(_this88.input._videoTrack);
    }

    _this88.outputStream = new Stream(trackList, "send", _this88.input.userID);
    return _this88;
  }
  /**
   * 设置输出 Stream 的码率
   * @param audio 音频码率
   * @param video 视频码率
   */


  _createClass(StreamMixingManager, [{
    key: "setBitrate",
    value: function setBitrate(audio, video) {
      if (audio && this.outputStream._audioTrack) {
        this.outputStream._audioTrack.setKbps(audio);
      }

      if (video && this.outputStream._videoTrack) {
        this.outputStream._videoTrack.setKbps(video);
      }
    }
  }]);

  return StreamMixingManager;
}(AudioMixingManager);

var AudioUtils;

(function (AudioUtils) {
  function createAudioTrackFromURL(url) {
    var crossorigin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "anonymous";
    var tag = arguments.length > 2 ? arguments[2] : undefined;
    var bitrate = arguments.length > 3 ? arguments[3] : undefined;
    var audioElement = document.createElement("audio");
    audioElement.preload = "auto";
    audioElement.src = url;
    audioElement.crossOrigin = crossorigin;
    var track = new AudioSourceTrack(audioElement);

    if (bitrate) {
      track.setKbps(bitrate);
    }

    track.setInfo({
      tag: tag
    });
    return track;
  }

  AudioUtils.createAudioTrackFromURL = createAudioTrackFromURL;

  function createAudioTrackFromFile(file, tag, bitrate) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();

      reader.onload = function (e) {
        var data = e.target.result;
        decodeAudioData(data).then(function (buffer) {
          var track = new AudioSourceTrack(buffer);

          if (bitrate) {
            track.setKbps(bitrate);
          }

          track.setInfo({
            tag: tag
          });
          resolve(track);
        }).catch(reject);
      };

      reader.readAsArrayBuffer(file);
    });
  }

  AudioUtils.createAudioTrackFromFile = createAudioTrackFromFile;

  function createAudioTrackFromBuffer(buffer, tag, bitrate) {
    var track = new AudioSourceTrack(buffer);

    if (bitrate) {
      track.setKbps(bitrate);
    }

    track.setInfo({
      tag: tag
    });
    return track;
  }

  AudioUtils.createAudioTrackFromBuffer = createAudioTrackFromBuffer;

  function createAudioTrackFromSource(_x102, _x103, _x104) {
    return _createAudioTrackFromSource.apply(this, arguments);
  }

  function _createAudioTrackFromSource() {
    _createAudioTrackFromSource = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee67(source, tag, bitrate) {
      return _regeneratorRuntime.wrap(function _callee67$(_context67) {
        while (1) {
          switch (_context67.prev = _context67.next) {
            case 0:
              if (!(source instanceof File)) {
                _context67.next = 6;
                break;
              }

              _context67.next = 3;
              return createAudioTrackFromFile(source, tag, bitrate);

            case 3:
              return _context67.abrupt("return", _context67.sent);

            case 6:
              if (!(source instanceof AudioBuffer)) {
                _context67.next = 8;
                break;
              }

              return _context67.abrupt("return", createAudioTrackFromBuffer(source, tag, bitrate));

            case 8:
              return _context67.abrupt("return", createAudioTrackFromURL(source, "anonymous", tag, bitrate));

            case 9:
            case "end":
              return _context67.stop();
          }
        }
      }, _callee67, this);
    }));
    return _createAudioTrackFromSource.apply(this, arguments);
  }

  AudioUtils.createAudioTrackFromSource = createAudioTrackFromSource;

  function decodeAudioData(_x105) {
    return _decodeAudioData.apply(this, arguments);
  }

  function _decodeAudioData() {
    _decodeAudioData = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee68(data) {
      var decodePromise;
      return _regeneratorRuntime.wrap(function _callee68$(_context68) {
        while (1) {
          switch (_context68.prev = _context68.next) {
            case 0:
              if (!(audioContext.state === "suspended")) {
                _context68.next = 3;
                break;
              }

              _context68.next = 3;
              return audioContext.resume();

            case 3:
              decodePromise = function decodePromise() {
                return new Promise(function (resolve, reject) {
                  audioContext.decodeAudioData(data, function (buffer) {
                    resolve(buffer);
                  }, function (e) {
                    reject(ERROR_AUDIO_DECODE_ERROR(e));
                  });
                });
              };

              _context68.next = 6;
              return decodePromise();

            case 6:
              return _context68.abrupt("return", _context68.sent);

            case 7:
            case "end":
              return _context68.stop();
          }
        }
      }, _callee68, this);
    }));
    return _decodeAudioData.apply(this, arguments);
  }

  AudioUtils.decodeAudioData = decodeAudioData;

  function createAudioMixingManagerFromTrack(track) {
    return new AudioMixingManager(track);
  }

  AudioUtils.createAudioMixingManagerFromTrack = createAudioMixingManagerFromTrack;

  function createAudioMixingManagerFromStream(stream) {
    return new StreamMixingManager(stream);
  }

  AudioUtils.createAudioMixingManagerFromStream = createAudioMixingManagerFromStream;
})(AudioUtils || (AudioUtils = {}));

var DEFAULT_RECORD_CONFIG = {
  audio: {
    enabled: true
  },
  video: {
    enabled: true,
    bitrate: 600
  }
};

function setMediaStreamTrackOpMode(track, op) {
  if (track.kind !== 'video') return;

  if (!("contentHint" in track)) {
    log.warning("optimizationMode not support in this browser");
    return;
  }

  track.contentHint = op;

  if (track.contentHint !== op) {
    log.warning("invalid optimizationMode ", op);
  }

  return;
}

var DeviceManager =
/*#__PURE__*/
function (_EventEmitter6) {
  _inherits(DeviceManager, _EventEmitter6);

  function DeviceManager() {
    var _this89;

    _classCallCheck(this, DeviceManager);

    _this89 = _possibleConstructorReturn(this, _getPrototypeOf(DeviceManager).call(this)); // 记录每个 device 存在的 tick 数量

    _this89.deviceMap = {};

    if (!__chunk_1.browserReport.support) {
      return _possibleConstructorReturn(_this89);
    }

    _this89.updateDeivceInfo();

    window.setInterval(_this89.updateDeivceInfo.bind(_assertThisInitialized(_assertThisInitialized(_this89))), 1000);
    return _this89;
  }

  _createClass(DeviceManager, [{
    key: "getDeviceInfo",
    value: function () {
      var _getDeviceInfo = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee69(skipPermissionCheck, deviceType) {
        var config, stream, tracks, i;
        return _regeneratorRuntime.wrap(function _callee69$(_context69) {
          while (1) {
            switch (_context69.prev = _context69.next) {
              case 0:
                if (skipPermissionCheck) {
                  _context69.next = 28;
                  break;
                }

                config = {
                  audio: false,
                  video: false
                };
                _context69.t0 = deviceType;
                _context69.next = _context69.t0 === "all" ? 5 : _context69.t0 === "cameras" ? 8 : _context69.t0 === "microphones" ? 10 : _context69.t0 === "playback" ? 10 : 12;
                break;

              case 5:
                config.audio = true;
                config.video = true;
                return _context69.abrupt("break", 12);

              case 8:
                config.video = true;
                return _context69.abrupt("break", 12);

              case 10:
                config.audio = true;
                return _context69.abrupt("break", 12);

              case 12:
                _context69.prev = 12;
                _context69.next = 15;
                return navigator.mediaDevices.getUserMedia(config);

              case 15:
                stream = _context69.sent;
                this.updateDeivceInfo();
                tracks = stream.getTracks();

                for (i = 0; i < tracks.length; i++) {
                  tracks[i].stop();
                }

                _context69.next = 28;
                break;

              case 21:
                _context69.prev = 21;
                _context69.t1 = _context69["catch"](12);

                if (!(_context69.t1.name === "NotAllowedError")) {
                  _context69.next = 27;
                  break;
                }

                throw ERROR_DEVICE_NOT_ALLOWED("");

              case 27:
                throw _context69.t1;

              case 28:
                if (this.deviceInfo) {
                  _context69.next = 30;
                  break;
                }

                return _context69.abrupt("return", []);

              case 30:
                _context69.t2 = deviceType;
                _context69.next = _context69.t2 === "all" ? 33 : _context69.t2 === "cameras" ? 34 : _context69.t2 === "microphones" ? 35 : _context69.t2 === "playback" ? 36 : 37;
                break;

              case 33:
                return _context69.abrupt("return", this.deviceInfo);

              case 34:
                return _context69.abrupt("return", this.deviceInfo.filter(function (info) {
                  return info.kind === "videoinput";
                }));

              case 35:
                return _context69.abrupt("return", this.deviceInfo.filter(function (info) {
                  return info.kind === "audioinput";
                }));

              case 36:
                return _context69.abrupt("return", this.deviceInfo.filter(function (info) {
                  return info.kind === "audiooutput";
                }));

              case 37:
              case "end":
                return _context69.stop();
            }
          }
        }, _callee69, this, [[12, 21]]);
      }));

      function getDeviceInfo(_x106, _x107) {
        return _getDeviceInfo.apply(this, arguments);
      }

      return getDeviceInfo;
    }()
  }, {
    key: "getElectronScreenSources",
    value: function () {
      var _getElectronScreenSources = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee70(type) {
        var desktopCapturer, _window$require, ipcRenderer, config, rawSources;

        return _regeneratorRuntime.wrap(function _callee70$(_context70) {
          while (1) {
            switch (_context70.prev = _context70.next) {
              case 0:
                _context70.prev = 0;
                _window$require = window.require('electron'), ipcRenderer = _window$require.ipcRenderer;
                desktopCapturer = {
                  getSources: function getSources(opts) {
                    return ipcRenderer.invoke('QNRTC_DESKTOP_CAPTURER_GET_SOURCES', opts);
                  }
                };
                _context70.next = 9;
                break;

              case 5:
                _context70.prev = 5;
                _context70.t0 = _context70["catch"](0);
                log.warning(_context70.t0);
                throw ERROR_ELECTRON_REQUIRE_ERROR(_context70.t0 instanceof Error ? _context70.t0.message : String(_context70.t0));

              case 9:
                config = {
                  types: [],
                  thumbnailSize: {
                    width: 150,
                    height: 150
                  }
                };
                _context70.t1 = type;
                _context70.next = _context70.t1 === undefined ? 13 : _context70.t1 === exports.QNElectronScreenSourceType.ALL ? 13 : _context70.t1 === exports.QNElectronScreenSourceType.SCREEN ? 15 : _context70.t1 === exports.QNElectronScreenSourceType.WINDOW ? 17 : 19;
                break;

              case 13:
                config.types.push('window', 'screen');
                return _context70.abrupt("break", 19);

              case 15:
                config.types.push('screen');
                return _context70.abrupt("break", 19);

              case 17:
                config.types.push('window');
                return _context70.abrupt("break", 19);

              case 19:
                _context70.prev = 19;
                _context70.next = 22;
                return desktopCapturer.getSources(config);

              case 22:
                rawSources = _context70.sent;
                return _context70.abrupt("return", rawSources.map(function (s) {
                  return {
                    ID: s.id,
                    name: s.name,
                    url: s.thumbnail.toDataURL()
                  };
                }));

              case 26:
                _context70.prev = 26;
                _context70.t2 = _context70["catch"](19);
                log.warning(_context70.t2);
                throw ERROR_FATAL("Electron getSources error, ".concat(_context70.t2 instanceof Error ? _context70.t2.message : String(_context70.t2)));

              case 30:
              case "end":
                return _context70.stop();
            }
          }
        }, _callee70, this, [[0, 5], [19, 26]]);
      }));

      function getElectronScreenSources(_x108) {
        return _getElectronScreenSources.apply(this, arguments);
      }

      return getElectronScreenSources;
    }()
  }, {
    key: "createElectronScreenTrack",
    value: function () {
      var _createElectronScreenTrack = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee71() {
        var config,
            constraints,
            sources,
            sourceID,
            stream,
            tracks,
            _iteratorNormalCompletion41,
            _didIteratorError41,
            _iteratorError41,
            _iterator41,
            _step41,
            track,
            _args71 = arguments;

        return _regeneratorRuntime.wrap(function _callee71$(_context71) {
          while (1) {
            switch (_context71.prev = _context71.next) {
              case 0:
                config = _args71.length > 0 && _args71[0] !== undefined ? _args71[0] : {};

                if (!config.sourceID) {
                  _context71.next = 5;
                  break;
                }

                constraints = {
                  video: {
                    mandatory: {
                      chromeMediaSourceId: config.sourceID,
                      chromeMediaSource: 'desktop'
                    }
                  }
                };
                _context71.next = 14;
                break;

              case 5:
                _context71.next = 7;
                return this.getElectronScreenSources();

              case 7:
                sources = _context71.sent;

                if (!(sources.length === 0)) {
                  _context71.next = 10;
                  break;
                }

                return _context71.abrupt("return", []);

              case 10:
                _context71.next = 12;
                return createScreenSelectionUI(sources);

              case 12:
                sourceID = _context71.sent;
                constraints = {
                  video: {
                    mandatory: {
                      chromeMediaSourceId: sourceID,
                      chromeMediaSource: 'desktop'
                    }
                  }
                };

              case 14:
                if (config.width) {
                  constraints.video.maxWidth = config.width;
                  constraints.video.minWidth = config.width;
                }

                if (config.height) {
                  constraints.video.maxHeight = config.height;
                  constraints.video.minHeight = config.height;
                }

                _context71.prev = 16;
                log.log("electron getUserMedia constraints: ", constraints);
                _context71.next = 20;
                return navigator.mediaDevices.getUserMedia(constraints);

              case 20:
                stream = _context71.sent;
                _context71.next = 26;
                break;

              case 23:
                _context71.prev = 23;
                _context71.t0 = _context71["catch"](16);
                throw ERROR_FATAL("Electron getUserMedia error, ".concat(_context71.t0 instanceof Error ? _context71.t0.message : "", ", config: ").concat(JSON.stringify(constraints)));

              case 26:
                tracks = [];
                _iteratorNormalCompletion41 = true;
                _didIteratorError41 = false;
                _iteratorError41 = undefined;
                _context71.prev = 30;

                for (_iterator41 = stream.getTracks()[Symbol.iterator](); !(_iteratorNormalCompletion41 = (_step41 = _iterator41.next()).done); _iteratorNormalCompletion41 = true) {
                  track = _step41.value;

                  if (config.optimizationMode) {
                    setMediaStreamTrackOpMode(track, config.optimizationMode);
                  }

                  tracks.push(createCustomTrack(track, config.tag, config.bitrate));
                }

                _context71.next = 38;
                break;

              case 34:
                _context71.prev = 34;
                _context71.t1 = _context71["catch"](30);
                _didIteratorError41 = true;
                _iteratorError41 = _context71.t1;

              case 38:
                _context71.prev = 38;
                _context71.prev = 39;

                if (!_iteratorNormalCompletion41 && _iterator41.return != null) {
                  _iterator41.return();
                }

              case 41:
                _context71.prev = 41;

                if (!_didIteratorError41) {
                  _context71.next = 44;
                  break;
                }

                throw _iteratorError41;

              case 44:
                return _context71.finish(41);

              case 45:
                return _context71.finish(38);

              case 46:
                return _context71.abrupt("return", tracks);

              case 47:
              case "end":
                return _context71.stop();
            }
          }
        }, _callee71, this, [[16, 23], [30, 34, 38, 46], [39,, 41, 45]]);
      }));

      function createElectronScreenTrack() {
        return _createElectronScreenTrack.apply(this, arguments);
      }

      return createElectronScreenTrack;
    }()
  }, {
    key: "getLocalTracks",
    value: function () {
      var _getLocalTracks = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee72() {
        var config,
            subConfig,
            subConfig2,
            values,
            constraints,
            mediaStream,
            videoKbps,
            audioKbps,
            videoTag,
            audioTag,
            mediaTracks,
            tracks,
            _iteratorNormalCompletion42,
            _didIteratorError42,
            _iteratorError42,
            _iterator42,
            _step42,
            mediaTrack,
            optimizationMode,
            _iteratorNormalCompletion43,
            _didIteratorError43,
            _iteratorError43,
            _iterator43,
            _step43,
            _mediaTrack,
            _track2,
            track,
            _args72 = arguments;

        return _regeneratorRuntime.wrap(function _callee72$(_context72) {
          while (1) {
            switch (_context72.prev = _context72.next) {
              case 0:
                config = _args72.length > 0 && _args72[0] !== undefined ? _args72[0] : DEFAULT_RECORD_CONFIG;
                log.debug("get local tracks", config);
                /**
                 * 如果同时开启了摄像头和屏幕采集，分 2 次采集完成
                 */

                if (!(REC_SCREEN_ENABLE(config) && REC_VIDEO_ENABLE(config))) {
                  _context72.next = 9;
                  break;
                }

                subConfig = {
                  screen: config.screen
                };
                subConfig2 = {
                  video: config.video,
                  audio: config.audio
                };
                _context72.next = 7;
                return Promise.all([this.getLocalTracks(subConfig), this.getLocalTracks(subConfig2)]);

              case 7:
                values = _context72.sent;
                return _context72.abrupt("return", values[0].concat(values[1]));

              case 9:
                _context72.next = 11;
                return transferRecordOptionToMediaConstraints(config);

              case 11:
                constraints = _context72.sent;

                if (constraints.video && typeof constraints.video === "object" && constraints.video.deviceId) {
                  qos.addEvent("DeviceChanged", {
                    type: 0,
                    desc: constraints.video.deviceId
                  });
                }

                if (constraints.audio && typeof constraints.audio === "object" && constraints.audio.deviceId) {
                  qos.addEvent("DeviceChanged", {
                    type: 1,
                    desc: constraints.audio.deviceId
                  });
                }

                _context72.prev = 14;
                _context72.next = 17;
                return this.getUserMedia(config, constraints, true);

              case 17:
                mediaStream = _context72.sent;
                _context72.next = 27;
                break;

              case 20:
                _context72.prev = 20;
                _context72.t0 = _context72["catch"](14);

                if (!(_context72.t0.name === "NotAllowedError")) {
                  _context72.next = 26;
                  break;
                }

                throw ERROR_DEVICE_NOT_ALLOWED("");

              case 26:
                throw _context72.t0;

              case 27:
                videoKbps = undefined;
                audioKbps = undefined;
                videoTag = undefined;
                audioTag = undefined;

                if (REC_AUDIO_ENABLE(config)) {
                  audioKbps = config.audio.bitrate;
                  audioTag = config.audio.tag;
                }

                if (REC_SCREEN_ENABLE(config)) {
                  videoKbps = config.screen.bitrate;
                  videoTag = config.screen.tag;
                  audioTag = config.screen.audioTag;
                }

                if (REC_VIDEO_ENABLE(config)) {
                  videoKbps = config.video.bitrate;
                  videoTag = config.video.tag;
                }

                mediaTracks = mediaStream ? mediaStream.getTracks() : [];
                tracks = []; // 前面 screen 和 video 是分两次采集的，所以这里的 config 里面，只有一个是有效的

                _iteratorNormalCompletion42 = true;
                _didIteratorError42 = false;
                _iteratorError42 = undefined;
                _context72.prev = 39;
                _iterator42 = mediaTracks[Symbol.iterator]();

              case 41:
                if (_iteratorNormalCompletion42 = (_step42 = _iterator42.next()).done) {
                  _context72.next = 52;
                  break;
                }

                mediaTrack = _step42.value;
                optimizationMode = void 0;

                if (config.video && config.video.optimizationMode) {
                  optimizationMode = config.video.optimizationMode;
                }

                if (config.screen && config.screen.optimizationMode) {
                  optimizationMode = config.screen.optimizationMode;
                }

                if (optimizationMode) {
                  _context72.next = 48;
                  break;
                }

                return _context72.abrupt("continue", 49);

              case 48:
                setMediaStreamTrackOpMode(mediaTrack, optimizationMode);

              case 49:
                _iteratorNormalCompletion42 = true;
                _context72.next = 41;
                break;

              case 52:
                _context72.next = 58;
                break;

              case 54:
                _context72.prev = 54;
                _context72.t1 = _context72["catch"](39);
                _didIteratorError42 = true;
                _iteratorError42 = _context72.t1;

              case 58:
                _context72.prev = 58;
                _context72.prev = 59;

                if (!_iteratorNormalCompletion42 && _iterator42.return != null) {
                  _iterator42.return();
                }

              case 61:
                _context72.prev = 61;

                if (!_didIteratorError42) {
                  _context72.next = 64;
                  break;
                }

                throw _iteratorError42;

              case 64:
                return _context72.finish(61);

              case 65:
                return _context72.finish(58);

              case 66:
                _iteratorNormalCompletion43 = true;
                _didIteratorError43 = false;
                _iteratorError43 = undefined;
                _context72.prev = 69;

                for (_iterator43 = mediaTracks[Symbol.iterator](); !(_iteratorNormalCompletion43 = (_step43 = _iterator43.next()).done); _iteratorNormalCompletion43 = true) {
                  _mediaTrack = _step43.value;
                  _track2 = void 0;

                  if (_mediaTrack.kind === "audio") {
                    _track2 = createCustomTrack(_mediaTrack, audioTag, audioKbps);
                  } else {
                    _track2 = createCustomTrack(_mediaTrack, videoTag, videoKbps);
                  }

                  tracks.push(_track2);
                }

                _context72.next = 77;
                break;

              case 73:
                _context72.prev = 73;
                _context72.t2 = _context72["catch"](69);
                _didIteratorError43 = true;
                _iteratorError43 = _context72.t2;

              case 77:
                _context72.prev = 77;
                _context72.prev = 78;

                if (!_iteratorNormalCompletion43 && _iterator43.return != null) {
                  _iterator43.return();
                }

              case 80:
                _context72.prev = 80;

                if (!_didIteratorError43) {
                  _context72.next = 83;
                  break;
                }

                throw _iteratorError43;

              case 83:
                return _context72.finish(80);

              case 84:
                return _context72.finish(77);

              case 85:
                if (!(config.audio && !!config.audio.source)) {
                  _context72.next = 90;
                  break;
                }

                _context72.next = 88;
                return AudioUtils.createAudioTrackFromSource(config.audio.source, audioTag, audioKbps);

              case 88:
                track = _context72.sent;
                tracks.push(track);

              case 90:
                this.updateDeivceInfo();
                return _context72.abrupt("return", tracks);

              case 92:
              case "end":
                return _context72.stop();
            }
          }
        }, _callee72, this, [[14, 20], [39, 54, 58, 66], [59,, 61, 65], [69, 73, 77, 85], [78,, 80, 84]]);
      }));

      function getLocalTracks() {
        return _getLocalTracks.apply(this, arguments);
      }

      return getLocalTracks;
    }()
  }, {
    key: "getLocalStream",
    value: function () {
      var _getLocalStream = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee73(config) {
        var tracks;
        return _regeneratorRuntime.wrap(function _callee73$(_context73) {
          while (1) {
            switch (_context73.prev = _context73.next) {
              case 0:
                if (!(config && REC_SCREEN_ENABLE(config) && REC_VIDEO_ENABLE(config))) {
                  _context73.next = 2;
                  break;
                }

                throw ERROR_FATAL("can not get local stream with video and screen");

              case 2:
                _context73.next = 4;
                return this.getLocalTracks(config);

              case 4:
                tracks = _context73.sent;
                return _context73.abrupt("return", new Stream(tracks, "send"));

              case 6:
              case "end":
                return _context73.stop();
            }
          }
        }, _callee73, this);
      }));

      function getLocalStream(_x109) {
        return _getLocalStream.apply(this, arguments);
      }

      return getLocalStream;
    }()
  }, {
    key: "getUserMedia",
    value: function () {
      var _getUserMedia2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee74(config, constraints) {
        var init,
            mediaStream,
            videoConstraint,
            videoWidth,
            videoHeight,
            tracks,
            firstTrack,
            _firstTrack$getSettin,
            _firstTrack$getSettin2,
            height,
            _firstTrack$getSettin3,
            width,
            diffProduct,
            ratio,
            _args74 = arguments;

        return _regeneratorRuntime.wrap(function _callee74$(_context74) {
          while (1) {
            switch (_context74.prev = _context74.next) {
              case 0:
                init = _args74.length > 2 && _args74[2] !== undefined ? _args74[2] : true;
                log.debug("request to get user media, config", config);
                log.debug("request to get user media, constraints", constraints);

                if (!(!constraints.audio && !constraints.video)) {
                  _context74.next = 5;
                  break;
                }

                return _context74.abrupt("return", null);

              case 5:
                if (!REC_SCREEN_ENABLE(config)) {
                  _context74.next = 11;
                  break;
                }

                _context74.next = 8;
                return this.getDisplayMedia(constraints, config);

              case 8:
                mediaStream = _context74.sent;
                _context74.next = 31;
                break;

              case 11:
                _context74.next = 13;
                return navigator.mediaDevices.getUserMedia(constraints);

              case 13:
                mediaStream = _context74.sent;

                if (!(!__chunk_1.isMobile && __chunk_1.supportGetSettings() && init)) {
                  _context74.next = 31;
                  break;
                }

                videoConstraint = constraints.video;

                if (!(videoConstraint && typeof videoConstraint !== "boolean")) {
                  _context74.next = 31;
                  break;
                }

                videoWidth = videoConstraint.width;
                videoHeight = videoConstraint.height;

                if (!(typeof videoWidth === "number" && typeof videoHeight === "number")) {
                  _context74.next = 31;
                  break;
                }

                tracks = mediaStream.getVideoTracks();
                firstTrack = tracks && tracks[0];
                _firstTrack$getSettin = firstTrack.getSettings(), _firstTrack$getSettin2 = _firstTrack$getSettin.height, height = _firstTrack$getSettin2 === void 0 ? videoHeight : _firstTrack$getSettin2, _firstTrack$getSettin3 = _firstTrack$getSettin.width, width = _firstTrack$getSettin3 === void 0 ? videoWidth : _firstTrack$getSettin3;

                if (!(width && height)) {
                  _context74.next = 31;
                  break;
                }

                diffProduct = (videoHeight - height) * (videoWidth - width);

                if (!(diffProduct * diffProduct > 10)) {
                  _context74.next = 31;
                  break;
                }

                ratio = videoHeight / videoWidth;

                if (height / width < ratio) {
                  videoConstraint.height = height;
                  videoConstraint.width = height / ratio;
                } else {
                  videoConstraint.width = width;
                  videoConstraint.height = width * ratio;
                }

                log.debug("justified constraint constraintHeight, contraintWidth, constraintRatio, screenHeight, screenWidth:", videoHeight, videoWidth, ratio, height, width, videoConstraint); // 递归前将所有tracks全部停用

                mediaStream.getTracks().forEach(function (item) {
                  return item.stop();
                });
                return _context74.abrupt("return", this.getUserMedia(config, __chunk_1._objectSpread({}, constraints, {
                  video: videoConstraint
                }), false));

              case 31:
                return _context74.abrupt("return", mediaStream);

              case 32:
              case "end":
                return _context74.stop();
            }
          }
        }, _callee74, this);
      }));

      function getUserMedia(_x110, _x111) {
        return _getUserMedia2.apply(this, arguments);
      }

      return getUserMedia;
    }()
    /**
     * getDisplayMedia 不支持同时录制屏幕和麦克风
     * 在这种情况下分 2 次请求 stream 之后合并
     */

  }, {
    key: "getDisplayMedia",
    value: function () {
      var _getDisplayMedia = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee75(constraints, config) {
        var audioStream, screenStream, displayConstraints;
        return _regeneratorRuntime.wrap(function _callee75$(_context75) {
          while (1) {
            switch (_context75.prev = _context75.next) {
              case 0:
                if (!constraints.audio) {
                  _context75.next = 4;
                  break;
                }

                _context75.next = 3;
                return navigator.mediaDevices.getUserMedia({
                  audio: constraints.audio
                });

              case 3:
                audioStream = _context75.sent;

              case 4:
                displayConstraints = config.screen && config.screen.audio && !constraints.audio ? {
                  video: constraints.video,
                  audio: config.screen.audio
                } : {
                  video: constraints.video
                };

                if (!(__chunk_1.browserReport.getDisplayMedia && config.screen && !config.screen.forceChromePlugin)) {
                  _context75.next = 11;
                  break;
                }

                _context75.next = 8;
                return navigator.mediaDevices.getDisplayMedia(displayConstraints);

              case 8:
                screenStream = _context75.sent;
                _context75.next = 14;
                break;

              case 11:
                _context75.next = 13;
                return navigator.mediaDevices.getUserMedia(displayConstraints);

              case 13:
                screenStream = _context75.sent;

              case 14:
                if (audioStream) {
                  screenStream.addTrack(audioStream.getAudioTracks()[0]);
                }

                return _context75.abrupt("return", screenStream);

              case 16:
              case "end":
                return _context75.stop();
            }
          }
        }, _callee75, this);
      }));

      function getDisplayMedia(_x112, _x113) {
        return _getDisplayMedia.apply(this, arguments);
      }

      return getDisplayMedia;
    }()
  }, {
    key: "updateDeivceInfo",
    value: function () {
      var _updateDeivceInfo = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee76() {
        var _this90 = this;

        var currentDeviceIds, lastDeviceIds, updateFlag;
        return _regeneratorRuntime.wrap(function _callee76$(_context76) {
          while (1) {
            switch (_context76.prev = _context76.next) {
              case 0:
                _context76.next = 2;
                return navigator.mediaDevices.enumerateDevices();

              case 2:
                this.deviceInfo = _context76.sent;
                currentDeviceIds = this.deviceInfo.map(function (d) {
                  return d.deviceId;
                });
                lastDeviceIds = Object.keys(this.deviceMap);
                updateFlag = false;
                lastDeviceIds.forEach(function (deviceId) {
                  // device 被拔出
                  if (currentDeviceIds.indexOf(deviceId) === -1 && deviceId !== "@default") {
                    _this90.emit("device-remove", _this90.deviceMap[deviceId].device);

                    var device = _this90.deviceMap[deviceId].device;

                    _this90.emit("device-changed", {
                      device: device,
                      state: exports.QNDeviceState.INACTIVE
                    });

                    qos.addEvent(device.kind === "audioinput" || device.kind === "audiooutput" ? "AudioDeviceInOut" : "VideoDeviceInOut", {
                      device_type: device.kind === "audiooutput" ? 1 : 0,
                      device_state: 0,
                      device_label: device.label,
                      device_id: device.deviceId,
                      device_info: device.label
                    });
                    delete _this90.deviceMap[deviceId];
                    updateFlag = true;
                  } else {
                    _this90.deviceMap[deviceId].tick += 1;
                  }
                });
                currentDeviceIds.forEach(function (deviceId, index) {
                  // device 插入
                  if (lastDeviceIds.indexOf(deviceId) === -1 && deviceId !== "@default") {
                    _this90.deviceMap[deviceId] = {
                      device: _this90.deviceInfo[index],
                      tick: 0
                    };
                    var device = _this90.deviceMap[deviceId].device;

                    _this90.emit("device-changed", {
                      device: device,
                      state: exports.QNDeviceState.ACTIVE
                    });

                    _this90.emit("device-add", device);

                    qos.addEvent(device.kind === "audioinput" || device.kind === "audiooutput" ? "AudioDeviceInOut" : "VideoDeviceInOut", {
                      device_type: device.kind === "audiooutput" ? 1 : 0,
                      device_state: 1,
                      device_label: device.label,
                      device_id: device.deviceId
                    });
                    updateFlag = true;
                  }
                });

                if (updateFlag) {
                  this.emit("device-update", this.deviceInfo);
                }

              case 9:
              case "end":
                return _context76.stop();
            }
          }
        }, _callee76, this);
      }));

      function updateDeivceInfo() {
        return _updateDeivceInfo.apply(this, arguments);
      }

      return updateDeivceInfo;
    }()
  }]);

  return DeviceManager;
}(EventEmitter);

var deviceManager = new DeviceManager();
/**
 * @public
 */

var QNRemoteUser =
/*#__PURE__*/
function () {
  // @internal
  function QNRemoteUser(client, user) {
    _classCallCheck(this, QNRemoteUser);

    // @internal
    this.networkQuality = exports.QNNetworkQuality.UNKNOWN;
    this._client = client;
    this._user = user;
    this.userID = user.userID;
    this.userData = user.userData;
  }
  /**
   * 该用户发布的视频 track
   */


  _createClass(QNRemoteUser, [{
    key: "getVideoTracks",
    value: function getVideoTracks() {
      var videoTracks = [];
      var _iteratorNormalCompletion44 = true;
      var _didIteratorError44 = false;
      var _iteratorError44 = undefined;

      try {
        for (var _iterator44 = this._client._remoteTracks[Symbol.iterator](), _step44; !(_iteratorNormalCompletion44 = (_step44 = _iterator44.next()).done); _iteratorNormalCompletion44 = true) {
          var track = _step44.value;

          if (track.isVideo() && track.userID === this.userID) {
            videoTracks.push(track);
          }
        }
      } catch (err) {
        _didIteratorError44 = true;
        _iteratorError44 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion44 && _iterator44.return != null) {
            _iterator44.return();
          }
        } finally {
          if (_didIteratorError44) {
            throw _iteratorError44;
          }
        }
      }

      return videoTracks;
    }
    /**
     * 该用户发布的音频 track
     */

  }, {
    key: "getAudioTracks",
    value: function getAudioTracks() {
      var audioTracks = [];
      var _iteratorNormalCompletion45 = true;
      var _didIteratorError45 = false;
      var _iteratorError45 = undefined;

      try {
        for (var _iterator45 = this._client._remoteTracks[Symbol.iterator](), _step45; !(_iteratorNormalCompletion45 = (_step45 = _iterator45.next()).done); _iteratorNormalCompletion45 = true) {
          var track = _step45.value;

          if (track.isAudio() && track.userID === this.userID) {
            audioTracks.push(track);
          }
        }
      } catch (err) {
        _didIteratorError45 = true;
        _iteratorError45 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion45 && _iterator45.return != null) {
            _iterator45.return();
          }
        } finally {
          if (_didIteratorError45) {
            throw _iteratorError45;
          }
        }
      }

      return audioTracks;
    }
  }]);

  return QNRemoteUser;
}();
/**
 * @public
 */


var QNTrack =
/*#__PURE__*/
function (_EventEmitter7) {
  _inherits(QNTrack, _EventEmitter7);

  function QNTrack() {
    var _this91;

    _classCallCheck(this, QNTrack);

    _this91 = _possibleConstructorReturn(this, _getPrototypeOf(QNTrack).apply(this, arguments)); // @internal

    _this91._isMuted = false;
    return _this91;
  }
  /**
   * 当前播放元素
   */


  _createClass(QNTrack, [{
    key: "play",

    /**
     * 播放
     */
    value: function play(container) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!this._track) return Promise.reject(); // 兼容老的 muted 接口

      if (typeof config === "boolean") {
        return this._track.play(container, config, {});
      }

      return this._track.play(container, undefined, config);
    }
    /**
     * 是否是音频
     */

  }, {
    key: "isAudio",
    value: function isAudio() {
      if (this._kind === "audio") {
        return true;
      }

      return false;
    }
    /**
     * 是否是视频
     */

  }, {
    key: "isVideo",
    value: function isVideo() {
      if (this._kind === "video") {
        return true;
      }

      return false;
    }
    /**
     * 是否 mute
     */

  }, {
    key: "isMuted",
    value: function isMuted() {
      return this._isMuted;
    }
    /**
     * 获取 webrtc 原生的 track 对象
     */

  }, {
    key: "getMediaStreamTrack",
    value: function getMediaStreamTrack() {
      if (this.track) {
        return this.track.mediaTrack;
      } else {
        return undefined;
      }
    }
  }, {
    key: "mediaElement",
    get: function get() {
      return this._track && this._track.mediaElement;
    } // @internal

  }, {
    key: "track",
    get: function get() {
      return this._track;
    } // @internal
    ,
    set: function set(track) {
      if (track) {
        this._track = track;

        this._track.on("ended", function () {
          qnevents.emit("trackEnded", track.mediaTrack.id);
        });

        this._track.on("audioBuffer", function (buffer) {
          qnevents.emit("audioBuffer", buffer, track.mediaTrack.id);
        });

        this.trackID = this._track.info.trackID;
        this.userID = this._track.info.userID;
        this.tag = this._track.info.tag;
        this._kind = this._track.info.kind;
        this._isMuted = !!this._track.info.muted;
      }
    }
  }]);

  return QNTrack;
}(EventEmitter);
/**
 * @public
 */


var QNRemoteTrack =
/*#__PURE__*/
function (_QNTrack) {
  _inherits(QNRemoteTrack, _QNTrack);

  // @internal
  function QNRemoteTrack(trackInfo) {
    var _this92;

    _classCallCheck(this, QNRemoteTrack);

    _this92 = _possibleConstructorReturn(this, _getPrototypeOf(QNRemoteTrack).call(this)); // @internal

    _this92._isSubScribed = false; // @internal

    _this92.uplinkStats = {
      uplinkRTT: 0,
      uplinkLostRate: 0
    };
    _this92._kind = trackInfo.kind;
    _this92.trackID = trackInfo.trackID;
    _this92.userID = trackInfo.userID;
    _this92.tag = trackInfo.tag;
    qnevents.on("remote-track-stats", function (remoteTrackStats) {
      var _iteratorNormalCompletion46 = true;
      var _didIteratorError46 = false;
      var _iteratorError46 = undefined;

      try {
        for (var _iterator46 = remoteTrackStats[Symbol.iterator](), _step46; !(_iteratorNormalCompletion46 = (_step46 = _iterator46.next()).done); _iteratorNormalCompletion46 = true) {
          var stat = _step46.value;

          if (stat.trackID === _this92.trackID) {
            _this92.uplinkStats.uplinkLostRate = stat.packetLossRate;
            _this92.uplinkStats.uplinkRTT = stat.rtt;
          }
        }
      } catch (err) {
        _didIteratorError46 = true;
        _iteratorError46 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion46 && _iterator46.return != null) {
            _iterator46.return();
          }
        } finally {
          if (_didIteratorError46) {
            throw _iteratorError46;
          }
        }
      }
    });
    qnevents.on("mute-tracks", function (tracks) {
      var _iteratorNormalCompletion47 = true;
      var _didIteratorError47 = false;
      var _iteratorError47 = undefined;

      try {
        for (var _iterator47 = tracks[Symbol.iterator](), _step47; !(_iteratorNormalCompletion47 = (_step47 = _iterator47.next()).done); _iteratorNormalCompletion47 = true) {
          var track = _step47.value;

          if (track.trackID === _this92.trackID) {
            _this92._isMuted = track.muted;

            _this92.emit("mute-state-changed", track.muted);
          }
        }
      } catch (err) {
        _didIteratorError47 = true;
        _iteratorError47 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion47 && _iterator47.return != null) {
            _iterator47.return();
          }
        } finally {
          if (_didIteratorError47) {
            throw _iteratorError47;
          }
        }
      }
    });
    return _this92;
  }
  /**
   * 是否已订阅
   */


  _createClass(QNRemoteTrack, [{
    key: "isSubscribed",
    value: function isSubscribed() {
      return this._isSubScribed;
    }
  }]);

  return QNRemoteTrack;
}(QNTrack);
/**
 * @public
 */


var QNRemoteVideoTrack =
/*#__PURE__*/
function (_QNRemoteTrack) {
  _inherits(QNRemoteVideoTrack, _QNRemoteTrack);

  // @internal
  function QNRemoteVideoTrack(trackInfo) {
    var _this93;

    _classCallCheck(this, QNRemoteVideoTrack);

    _this93 = _possibleConstructorReturn(this, _getPrototypeOf(QNRemoteVideoTrack).call(this, trackInfo));
    /**
     * 是否开启大小流
     * @deprecated use isLowStreamEnabled instead
     */

    _this93.isMultiProfileEnabled = false;
    /**
     * 该路远端 video track 是否开启了大小流
     */

    _this93.isLowStreamEnabled = false; // @internal

    _this93.profile = exports.QNTrackProfile.HIGH;

    if (trackInfo.profiles.length > 0) {
      _this93.isMultiProfileEnabled = true;
      _this93.isLowStreamEnabled = true;
    }

    qnevents.on("sub-profile-changed", function (trackID, profile) {
      if (trackID !== _this93.trackID) return;

      switch (profile) {
        case "high":
          _this93.profile = exports.QNTrackProfile.HIGH;

          _this93.emit("profile-changed", exports.QNTrackProfile.HIGH);

          _this93.emit("low-stream-state-changed", false);

          break;

        case "medium":
          _this93.profile = exports.QNTrackProfile.MEDIUM;

          _this93.emit("profile-changed", exports.QNTrackProfile.MEDIUM);

          break;

        case "low":
          _this93.profile = exports.QNTrackProfile.LOW;

          _this93.emit("profile-changed", exports.QNTrackProfile.LOW);

          _this93.emit("low-stream-state-changed", true);

          break;
      }
    });
    return _this93;
  }
  /**
   * 选择订阅视频的清晰度
   * @deprecated use setLowStream instead
   */


  _createClass(QNRemoteVideoTrack, [{
    key: "setProfile",
    value: function setProfile(profile) {
      qnevents.emit("set-profile", this.trackID, profile);
    }
    /**
     * 是否使用小流
     */

  }, {
    key: "setLowStream",
    value: function setLowStream(useLowStream) {
      if (!this.isLowStreamEnabled) {
        throw ERROR_FATAL("isLowStreamEnabled is false, do not setLowStream on normal track");
      }

      var profile = useLowStream ? exports.QNTrackProfile.LOW : exports.QNTrackProfile.HIGH;
      qnevents.emit("set-profile", this.trackID, profile);
    }
    /**
     * 截取当前视频流数据
     */

  }, {
    key: "getCurrentFrameData",
    value: function getCurrentFrameData() {
      if (!this._track) return "data:,";
      return this._track.getCurrentFrameDataURL();
    }
    /**
     * 获取流状态数据
     */

  }, {
    key: "getStats",
    value: function getStats() {
      var defaultRemoteVideoStats = {
        downlinkFrameRate: 0,
        downlinkBitrate: 0,
        downlinkLostRate: 0,
        uplinkRTT: 0,
        uplinkLostRate: 0
      };
      if (!this._track) return defaultRemoteVideoStats;

      var stats = this._track.getStats();

      if (stats.length === 0) return defaultRemoteVideoStats;
      defaultRemoteVideoStats.downlinkBitrate = stats[0].bitrate;
      defaultRemoteVideoStats.downlinkFrameRate = stats[0].frameRate;
      defaultRemoteVideoStats.downlinkLostRate = stats[0].packetLossRate;
      defaultRemoteVideoStats.uplinkLostRate = this.uplinkStats.uplinkLostRate;
      defaultRemoteVideoStats.uplinkRTT = this.uplinkStats.uplinkRTT;
      if (this.isMultiProfileEnabled) defaultRemoteVideoStats.profile = this.profile;
      return defaultRemoteVideoStats;
    }
  }]);

  return QNRemoteVideoTrack;
}(QNRemoteTrack);
/**
 * @public
 */


var QNRemoteAudioTrack =
/*#__PURE__*/
function (_QNRemoteTrack2) {
  _inherits(QNRemoteAudioTrack, _QNRemoteTrack2);

  // @internal
  function QNRemoteAudioTrack(trackInfo) {
    var _this94;

    _classCallCheck(this, QNRemoteAudioTrack);

    _this94 = _possibleConstructorReturn(this, _getPrototypeOf(QNRemoteAudioTrack).call(this, trackInfo));
    qnevents.on("audioBuffer", function (buffer, trackLocalID) {
      if (_this94._track && trackLocalID === _this94._track.mediaTrack.id) {
        _this94.emit("audioFrame", buffer);
      }
    });
    return _this94;
  }
  /**
   * 设置音量
   */


  _createClass(QNRemoteAudioTrack, [{
    key: "setVolume",
    value: function setVolume(volume) {
      if (!this.track) return;
      this.track.setVolume(volume);
    }
    /**
     * 获取当前音量
     */

  }, {
    key: "getVolumeLevel",
    value: function getVolumeLevel() {
      if (!this.track) return;
      return this.track.getCurrentVolumeLevel();
    }
    /**
     * 获取当前时域数据
     */

  }, {
    key: "getCurrentTimeDomainData",
    value: function getCurrentTimeDomainData() {
      if (!this.track) return;
      return this.track.getCurrentTimeDomainData();
    }
    /**
     * 获取当前频域数据
     */

  }, {
    key: "getCurrentFrequencyDomainData",
    value: function getCurrentFrequencyDomainData() {
      if (!this.track) return;
      return this.track.getCurrentFrequencyData();
    }
    /**
     * 设置音频输出设备
     * deviceId 可以从 QNRTC.getPlaybackDevices 接口中获取
     * 该功能仅 chrome 支持，如果在不支持功能的浏览器中调用，会抛出 ERROR_NOT_SUPPORT 错误
     */

  }, {
    key: "setPlaybackDevice",
    value: function () {
      var _setPlaybackDevice2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee77(deviceId) {
        return _regeneratorRuntime.wrap(function _callee77$(_context77) {
          while (1) {
            switch (_context77.prev = _context77.next) {
              case 0:
                if (this.track) {
                  _context77.next = 2;
                  break;
                }

                return _context77.abrupt("return");

              case 2:
                return _context77.abrupt("return", this.track.setPlaybackDevice(deviceId));

              case 3:
              case "end":
                return _context77.stop();
            }
          }
        }, _callee77, this);
      }));

      function setPlaybackDevice(_x114) {
        return _setPlaybackDevice2.apply(this, arguments);
      }

      return setPlaybackDevice;
    }()
    /**
     * 获取流状态
     */

  }, {
    key: "getStats",
    value: function getStats() {
      var defaultRemoteAudioStats = {
        downlinkBitrate: 0,
        downlinkLostRate: 0,
        uplinkRTT: 0,
        uplinkLostRate: 0
      };
      if (!this._track) return defaultRemoteAudioStats;

      var stats = this._track.getStats();

      if (stats.length === 0) return defaultRemoteAudioStats;
      defaultRemoteAudioStats.downlinkBitrate = stats[0].bitrate;
      defaultRemoteAudioStats.downlinkLostRate = stats[0].packetLossRate;
      defaultRemoteAudioStats.uplinkLostRate = this.uplinkStats.uplinkLostRate;
      defaultRemoteAudioStats.uplinkRTT = this.uplinkStats.uplinkRTT;
      return defaultRemoteAudioStats;
    }
  }]);

  return QNRemoteAudioTrack;
}(QNRemoteTrack);
/**
 * @public
 * QNRTCClient
 */


var QNRTCClient =
/*#__PURE__*/
function (_EventEmitter8) {
  _inherits(QNRTCClient, _EventEmitter8);

  // @internal
  function QNRTCClient(transportPolicy) {
    var _this95;

    _classCallCheck(this, QNRTCClient);

    _this95 = _possibleConstructorReturn(this, _getPrototypeOf(QNRTCClient).call(this));
    /**
     * 当前房间连接状态
     */

    _this95.connectionState = exports.QNConnectionState.DISCONNECTED; // @internal

    _this95._localTracks = []; // 已发布
    // @internal

    _this95._remoteTracks = []; // 未订阅 + 已订阅
    // @internal

    _this95._disconnectedInfo = {
      code: 0
    };
    /**
     * 房间当前的远端用户列表
     */

    _this95.remoteUsers = [];
    _this95.session = new TrackModeSession({
      transportPolicy: transportPolicy
    });

    _this95.session.on("user-join", function (user) {
      var qnuser = new QNRemoteUser(_assertThisInitialized(_assertThisInitialized(_this95)), user);

      _this95.remoteUsers.push(qnuser);

      _this95.emit("user-joined", user.userID, user.userData);
    });

    _this95.session.on("user-leave", function (user) {
      _this95.remoteUsers = _this95.remoteUsers.filter(function (remoteUser) {
        return remoteUser.userID !== user.userID;
      });

      _this95.emit("user-left", user.userID);
    });

    _this95.session.on("track-add", function (trackInfos) {
      var _this95$_remoteTracks;

      if (trackInfos.length === 0) return;
      var qntracks = trackInfos.map(function (trackInfo) {
        if (trackInfo.kind === "audio") {
          return new QNRemoteAudioTrack(trackInfo);
        } else {
          return new QNRemoteVideoTrack(trackInfo);
        }
      });

      (_this95$_remoteTracks = _this95._remoteTracks).push.apply(_this95$_remoteTracks, _toConsumableArray(qntracks));

      var grouped = groupBy(qntracks, function (t) {
        return t.userID;
      });
      Object.entries(grouped).forEach(function (_ref26) {
        var _ref27 = _slicedToArray(_ref26, 2),
            userID = _ref27[0],
            qntracks = _ref27[1];

        _this95.emit("user-published", userID, qntracks);
      });
    });

    _this95.session.on("track-remove", function (trackInfos) {
      if (trackInfos.length === 0) return;
      var userID = trackInfos[0].userID;
      var trackIDs = new Set();
      var _iteratorNormalCompletion48 = true;
      var _didIteratorError48 = false;
      var _iteratorError48 = undefined;

      try {
        for (var _iterator48 = trackInfos[Symbol.iterator](), _step48; !(_iteratorNormalCompletion48 = (_step48 = _iterator48.next()).done); _iteratorNormalCompletion48 = true) {
          var trackInfo = _step48.value;
          trackIDs.add(trackInfo.trackID);
        }
      } catch (err) {
        _didIteratorError48 = true;
        _iteratorError48 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion48 && _iterator48.return != null) {
            _iterator48.return();
          }
        } finally {
          if (_didIteratorError48) {
            throw _iteratorError48;
          }
        }
      }

      var unpublishedTracks = [];
      var remainedTracks = [];
      var _iteratorNormalCompletion49 = true;
      var _didIteratorError49 = false;
      var _iteratorError49 = undefined;

      try {
        for (var _iterator49 = _this95._remoteTracks[Symbol.iterator](), _step49; !(_iteratorNormalCompletion49 = (_step49 = _iterator49.next()).done); _iteratorNormalCompletion49 = true) {
          var remoteTrack = _step49.value;

          if (trackIDs.has(remoteTrack.trackID)) {
            unpublishedTracks.push(remoteTrack);
          } else {
            remainedTracks.push(remoteTrack);
          }
        }
      } catch (err) {
        _didIteratorError49 = true;
        _iteratorError49 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion49 && _iterator49.return != null) {
            _iterator49.return();
          }
        } finally {
          if (_didIteratorError49) {
            throw _iteratorError49;
          }
        }
      }

      _this95._remoteTracks = remainedTracks;

      _this95.emit("user-unpublished", userID, unpublishedTracks);
    });

    _this95.session.on("mute-tracks", function (tracks) {
      if (tracks.length === 0) return;
      qnevents.emit("mute-tracks", tracks);
    });

    qnevents.on("set-mute-tracks", function (trackID, isMuted) {
      _this95.session.muteTracks([{
        trackID: trackID,
        muted: isMuted
      }]);
    });

    _this95.session.on("room-state-change", function (state) {
      switch (state) {
        case RoomState.Idle:
          _this95.connectionState = exports.QNConnectionState.DISCONNECTED;
          break;

        case RoomState.Connecting:
          _this95.connectionState = exports.QNConnectionState.CONNECTING;
          break;

        case RoomState.Reconnecting:
          _this95.connectionState = exports.QNConnectionState.RECONNECTING;
          break;

        case RoomState.Connected:
          _this95.connectionState = _this95.connectionState === exports.QNConnectionState.CONNECTING ? exports.QNConnectionState.CONNECTED : exports.QNConnectionState.RECONNECTED;
          break;

        default:
          log.warning("Invalid roomState: ", state);
          break;
      }

      if (_this95.connectionState === exports.QNConnectionState.DISCONNECTED) {
        var reason;

        switch (_this95._disconnectedInfo.code) {
          case 0:
            reason = exports.QNConnectionDisconnectedReason.LEAVE;
            break;

          case 10006:
            reason = exports.QNConnectionDisconnectedReason.KICKED_OUT;
            break;

          default:
            reason = exports.QNConnectionDisconnectedReason.ERROR;
            break;
        }

        var info = {
          reason: reason
        };

        if (reason === exports.QNConnectionDisconnectedReason.ERROR) {
          info.errorCode = _this95._disconnectedInfo.code;

          switch (info.errorCode) {
            case 10001:
              info.errorMessage = "token 错误";
              break;

            case 10002:
              info.errorMessage = "token 过期";
              break;

            case 10004:
              info.errorMessage = "reconnect token 过期";
              break;

            case 10007:
              info.errorMessage = "断线重连失败";
              break;

            case 10022:
              info.errorMessage = "该用户在其他页面或终端登录";
              break;

            case 10011:
              info.errorMessage = "房间人数已满";
              break;

            case 10012:
              info.errorMessage = "房间已关闭";
              break;

            default:
              info.errorMessage = "unexpected error";
              break;
          }
        }

        _this95.release();

        _this95.emit("connection-state-changed", _this95.connectionState, info);
      } else {
        _this95.emit("connection-state-changed", _this95.connectionState);
      }
    });

    _this95.session.on("messages-received", function (messages) {
      var _iteratorNormalCompletion50 = true;
      var _didIteratorError50 = false;
      var _iteratorError50 = undefined;

      try {
        for (var _iterator50 = messages[Symbol.iterator](), _step50; !(_iteratorNormalCompletion50 = (_step50 = _iterator50.next()).done); _iteratorNormalCompletion50 = true) {
          var message = _step50.value;
          var ms = {
            ID: message.msgid,
            userID: message.userID,
            content: message.data,
            timestamp: message.timestamp
          };

          _this95.emit("message-received", ms);
        }
      } catch (err) {
        _didIteratorError50 = true;
        _iteratorError50 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion50 && _iterator50.return != null) {
            _iterator50.return();
          }
        } finally {
          if (_didIteratorError50) {
            throw _iteratorError50;
          }
        }
      }
    });

    _this95.session.on("media-relay-state-changed", function (roomName, state) {
      _this95.emit("media-relay-state-changed", roomName, state);
    });

    _this95.session.on("remote-user-reconnecting", function (user) {
      _this95.emit("user-reconnecting", user.userID);
    });

    _this95.session.on("remote-user-reconnected", function (user) {
      _this95.emit("user-reconnected", user.userID);
    });

    _this95.session.on("forward-job-connected", function (info) {
      _this95.emit("direct-livestreaming-state-changed", info.jobId, exports.QNLiveStreamingState.STARTED);
    });

    _this95.session.on("forward-job-disconnected", function (info) {
      // TODO: 等待后端增加能力后，emit 出第三个参数 reason，表示异常断开的原因
      _this95.emit("direct-livestreaming-state-changed", info.jobId, exports.QNLiveStreamingState.STOPPED);
    });

    _this95.session.on("merge-job-connected", function (info) {
      _this95.emit("transcoding-livestreaming-state-changed", info.jobId, exports.QNLiveStreamingState.STARTED);
    });

    _this95.session.on("merge-job-disconnected", function (info) {
      // TODO: 等待后端增加能力后，emit 出第三个参数 reason，表示异常断开的原因
      _this95.emit("transcoding-livestreaming-state-changed", info.jobId, exports.QNLiveStreamingState.STOPPED);
    });

    _this95.session.on("disconnect", function (d) {
      _this95._disconnectedInfo = d;
    });

    _this95.session.on("on-sub-profile-changed", function (d) {
      qnevents.emit("sub-profile-changed", d.trackid, d.profile);
    });

    _this95.session.on("volume-indicator", function (volumes) {
      _this95.emit("volume-indicator", volumes);
    });

    qnevents.on("remote-track-stats", function (remoteTrackStats) {
      var _iteratorNormalCompletion51 = true;
      var _didIteratorError51 = false;
      var _iteratorError51 = undefined;

      try {
        var _loop20 = function _loop20() {
          var stat = _step51.value;

          var user = _this95.remoteUsers.filter(function (user) {
            return user.userID === stat.userID;
          })[0];

          if (!user) {
            return {
              v: void 0
            };
          }

          switch (stat.networkGrade) {
            case NetworkGrade.INVALID:
              user.networkQuality = exports.QNNetworkQuality.UNKNOWN;
              break;

            case NetworkGrade.POOR:
              user.networkQuality = exports.QNNetworkQuality.POOR;
              break;

            case NetworkGrade.FAIR:
              user.networkQuality = exports.QNNetworkQuality.FAIR;
              break;

            case NetworkGrade.GOOD:
              user.networkQuality = exports.QNNetworkQuality.GOOD;
              break;

            case NetworkGrade.EXCELLENT:
              user.networkQuality = exports.QNNetworkQuality.EXCELLENT;
              break;

            default:
              log.warning("unkonw network grade: ", stat.networkGrade);
              break;
          }
        };

        for (var _iterator51 = remoteTrackStats[Symbol.iterator](), _step51; !(_iteratorNormalCompletion51 = (_step51 = _iterator51.next()).done); _iteratorNormalCompletion51 = true) {
          var _ret11 = _loop20();

          if (typeof _ret11 === "object") return _ret11.v;
        }
      } catch (err) {
        _didIteratorError51 = true;
        _iteratorError51 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion51 && _iterator51.return != null) {
            _iterator51.return();
          }
        } finally {
          if (_didIteratorError51) {
            throw _iteratorError51;
          }
        }
      }
    });
    qnevents.on("set-profile", function (trackID, profile) {
      switch (profile) {
        case exports.QNTrackProfile.HIGH:
          _this95.session.setProfile(trackID, 'high');

          break;

        case exports.QNTrackProfile.MEDIUM:
          _this95.session.setProfile(trackID, 'medium');

          break;

        case exports.QNTrackProfile.LOW:
          _this95.session.setProfile(trackID, 'low');

          break;
      }
    });
    qnevents.on("setMediaStreamTrack", function (trackID, newTrack, cb, errcb) {
      _this95.session.replaceTrack(trackID, newTrack).then(cb).catch(errcb);
    });
    return _this95;
  } // @internal


  _createClass(QNRTCClient, [{
    key: "setTransportPolicy",
    value: function setTransportPolicy(transportPolicy) {
      this.session.config.transportPolicy = transportPolicy;
    }
    /**
     * 本地用户的用户 ID
     */

  }, {
    key: "getRemoteUser",

    /**
     * 获取远端用户
     */
    value: function getRemoteUser(userID) {
      return this.remoteUsers.find(function (user) {
        return user.userID === userID;
      });
    }
    /**
     * 设置场景
     * 仅可 join room 前调用
     */

  }, {
    key: "setClientMode",
    value: function () {
      var _setClientMode2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee78(mode) {
        return _regeneratorRuntime.wrap(function _callee78$(_context78) {
          while (1) {
            switch (_context78.prev = _context78.next) {
              case 0:
                this.session.setClientMode(mode);

              case 1:
              case "end":
                return _context78.stop();
            }
          }
        }, _callee78, this);
      }));

      function setClientMode(_x115) {
        return _setClientMode2.apply(this, arguments);
      }

      return setClientMode;
    }()
    /**
     * 设置角色
     * join room 前后均可以调用
     */

  }, {
    key: "setClientRole",
    value: function () {
      var _setClientRole2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee79(role) {
        return _regeneratorRuntime.wrap(function _callee79$(_context79) {
          while (1) {
            switch (_context79.prev = _context79.next) {
              case 0:
                _context79.next = 2;
                return this.session.setClientRole(role);

              case 2:
              case "end":
                return _context79.stop();
            }
          }
        }, _callee79, this);
      }));

      function setClientRole(_x116) {
        return _setClientRole2.apply(this, arguments);
      }

      return setClientRole;
    }()
    /**
     * 加入房间
     */

  }, {
    key: "join",
    value: function () {
      var _join2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee80(token, userData) {
        return _regeneratorRuntime.wrap(function _callee80$(_context80) {
          while (1) {
            switch (_context80.prev = _context80.next) {
              case 0:
                _context80.next = 2;
                return this.session.joinRoomWithToken(token, userData);

              case 2:
              case "end":
                return _context80.stop();
            }
          }
        }, _callee80, this);
      }));

      function join(_x117, _x118) {
        return _join2.apply(this, arguments);
      }

      return join;
    }()
    /**
     * 离开房间
     */

  }, {
    key: "leave",
    value: function () {
      var _leave = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee81() {
        var _this96 = this;

        return _regeneratorRuntime.wrap(function _callee81$(_context81) {
          while (1) {
            switch (_context81.prev = _context81.next) {
              case 0:
                _context81.next = 2;
                return Promise.resolve().then(function () {
                  return _this96.session.leave();
                });

              case 2:
                this.release();

              case 3:
              case "end":
                return _context81.stop();
            }
          }
        }, _callee81, this);
      }));

      function leave() {
        return _leave.apply(this, arguments);
      }

      return leave;
    }()
  }, {
    key: "release",
    value: function release() {
      this._localTracks = [];
      this._remoteTracks = [];
      this._disconnectedInfo = {
        code: 0
      };
      this.remoteUsers = [];
    }
    /**
     * 发布
     */

  }, {
    key: "publish",
    value: function () {
      var _publish2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee82(tracks) {
        var _this$_localTracks, _iteratorNormalCompletion52, _didIteratorError52, _iteratorError52, _iterator52, _step52, t;

        return _regeneratorRuntime.wrap(function _callee82$(_context82) {
          while (1) {
            switch (_context82.prev = _context82.next) {
              case 0:
                if (!Array.isArray(tracks)) {
                  _context82.next = 26;
                  break;
                }

                if (tracks.find(function (t) {
                  return t.isVideo();
                })) {
                  this.session.simulcast = !!tracks.filter(function (t) {
                    return t.isVideo();
                  }).find(function (t) {
                    return t.isMultiProfileEnabled;
                  });
                }

                _context82.next = 4;
                return this.session.publish(tracks.map(function (t) {
                  return t.track;
                }));

              case 4:
                _iteratorNormalCompletion52 = true;
                _didIteratorError52 = false;
                _iteratorError52 = undefined;
                _context82.prev = 7;

                for (_iterator52 = tracks[Symbol.iterator](); !(_iteratorNormalCompletion52 = (_step52 = _iterator52.next()).done); _iteratorNormalCompletion52 = true) {
                  t = _step52.value;
                  t.trackID = t.track.info.trackID;
                  t.userID = this.session.userID;
                }

                _context82.next = 15;
                break;

              case 11:
                _context82.prev = 11;
                _context82.t0 = _context82["catch"](7);
                _didIteratorError52 = true;
                _iteratorError52 = _context82.t0;

              case 15:
                _context82.prev = 15;
                _context82.prev = 16;

                if (!_iteratorNormalCompletion52 && _iterator52.return != null) {
                  _iterator52.return();
                }

              case 18:
                _context82.prev = 18;

                if (!_didIteratorError52) {
                  _context82.next = 21;
                  break;
                }

                throw _iteratorError52;

              case 21:
                return _context82.finish(18);

              case 22:
                return _context82.finish(15);

              case 23:
                (_this$_localTracks = this._localTracks).push.apply(_this$_localTracks, _toConsumableArray(tracks));

                _context82.next = 32;
                break;

              case 26:
                if (tracks.isVideo() && tracks.isMultiProfileEnabled) {
                  this.session.config.simulcast = true;
                }

                _context82.next = 29;
                return this.session.publish([tracks.track]);

              case 29:
                tracks.trackID = tracks.track.info.trackID;
                tracks.userID = this.session.userID;

                this._localTracks.push(tracks);

              case 32:
              case "end":
                return _context82.stop();
            }
          }
        }, _callee82, this, [[7, 11, 15, 23], [16,, 18, 22]]);
      }));

      function publish(_x119) {
        return _publish2.apply(this, arguments);
      }

      return publish;
    }()
    /**
     * 取消发布
     */

  }, {
    key: "unpublish",
    value: function () {
      var _unpublish4 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee83(tracks) {
        var ts;
        return _regeneratorRuntime.wrap(function _callee83$(_context83) {
          while (1) {
            switch (_context83.prev = _context83.next) {
              case 0:
                if (!Array.isArray(tracks)) {
                  _context83.next = 9;
                  break;
                }

                ts = this._localTracks.filter(function (t) {
                  return tracks.includes(t);
                });

                if (!(ts.length !== tracks.length)) {
                  _context83.next = 4;
                  break;
                }

                throw ERROR_FATAL("target tracks has not published");

              case 4:
                _context83.next = 6;
                return this.session.unpublish(tracks.map(function (t) {
                  return t.trackID;
                }));

              case 6:
                this._localTracks = this._localTracks.filter(function (t) {
                  return !tracks.includes(t);
                });
                _context83.next = 14;
                break;

              case 9:
                if (this._localTracks.includes(tracks)) {
                  _context83.next = 11;
                  break;
                }

                throw ERROR_FATAL("target tracks has not published");

              case 11:
                _context83.next = 13;
                return this.session.unpublish([tracks.trackID]);

              case 13:
                this._localTracks = this._localTracks.filter(function (t) {
                  return t !== tracks;
                });

              case 14:
              case "end":
                return _context83.stop();
            }
          }
        }, _callee83, this);
      }));

      function unpublish(_x120) {
        return _unpublish4.apply(this, arguments);
      }

      return unpublish;
    }()
    /**
     * 订阅
     */

  }, {
    key: "subscribe",
    value: function () {
      var _subscribe2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee84(tracks) {
        var subscribedTracks, videoTracks, audioTracks, _iteratorNormalCompletion53, _didIteratorError53, _iteratorError53, _loop21, _iterator53, _step53, _ret12, t;

        return _regeneratorRuntime.wrap(function _callee84$(_context84) {
          while (1) {
            switch (_context84.prev = _context84.next) {
              case 0:
                if (!Array.isArray(tracks)) {
                  _context84.next = 36;
                  break;
                }

                _context84.next = 3;
                return this.session.subscribe(tracks.map(function (t) {
                  return t.trackID;
                }));

              case 3:
                subscribedTracks = _context84.sent;
                videoTracks = [];
                audioTracks = [];
                _iteratorNormalCompletion53 = true;
                _didIteratorError53 = false;
                _iteratorError53 = undefined;
                _context84.prev = 9;

                _loop21 = function _loop21() {
                  var subscribedTrack = _step53.value;
                  var targetTracks = tracks.filter(function (t) {
                    return t.trackID === subscribedTrack.info.trackID;
                  });
                  if (targetTracks.length === 0) return "continue";
                  var targetTrack = targetTracks[0];
                  targetTrack.track = subscribedTrack;
                  targetTrack._isSubScribed = true;

                  if (subscribedTrack.info.kind === "audio") {
                    audioTracks.push(targetTrack);
                  } else {
                    videoTracks.push(targetTrack);
                  }
                };

                _iterator53 = subscribedTracks[Symbol.iterator]();

              case 12:
                if (_iteratorNormalCompletion53 = (_step53 = _iterator53.next()).done) {
                  _context84.next = 19;
                  break;
                }

                _ret12 = _loop21();

                if (!(_ret12 === "continue")) {
                  _context84.next = 16;
                  break;
                }

                return _context84.abrupt("continue", 16);

              case 16:
                _iteratorNormalCompletion53 = true;
                _context84.next = 12;
                break;

              case 19:
                _context84.next = 25;
                break;

              case 21:
                _context84.prev = 21;
                _context84.t0 = _context84["catch"](9);
                _didIteratorError53 = true;
                _iteratorError53 = _context84.t0;

              case 25:
                _context84.prev = 25;
                _context84.prev = 26;

                if (!_iteratorNormalCompletion53 && _iterator53.return != null) {
                  _iterator53.return();
                }

              case 28:
                _context84.prev = 28;

                if (!_didIteratorError53) {
                  _context84.next = 31;
                  break;
                }

                throw _iteratorError53;

              case 31:
                return _context84.finish(28);

              case 32:
                return _context84.finish(25);

              case 33:
                return _context84.abrupt("return", {
                  audioTracks: audioTracks,
                  videoTracks: videoTracks
                });

              case 36:
                _context84.next = 38;
                return this.session.subscribe([tracks.trackID]);

              case 38:
                subscribedTracks = _context84.sent;

                if (!(subscribedTracks.length > 0)) {
                  _context84.next = 48;
                  break;
                }

                t = subscribedTracks[0];
                tracks.track = t;
                tracks._isSubScribed = true;

                if (!(t.info.kind === "audio")) {
                  _context84.next = 47;
                  break;
                }

                return _context84.abrupt("return", {
                  videoTracks: [],
                  audioTracks: [tracks]
                });

              case 47:
                return _context84.abrupt("return", {
                  audioTracks: [],
                  videoTracks: [tracks]
                });

              case 48:
                return _context84.abrupt("return", {
                  audioTracks: [],
                  videoTracks: []
                });

              case 49:
              case "end":
                return _context84.stop();
            }
          }
        }, _callee84, this, [[9, 21, 25, 33], [26,, 28, 32]]);
      }));

      function subscribe(_x121) {
        return _subscribe2.apply(this, arguments);
      }

      return subscribe;
    }()
    /**
     * 取消订阅
     */

  }, {
    key: "unsubscribe",
    value: function () {
      var _unsubscribe4 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee85(tracks) {
        return _regeneratorRuntime.wrap(function _callee85$(_context85) {
          while (1) {
            switch (_context85.prev = _context85.next) {
              case 0:
                if (!Array.isArray(tracks)) {
                  _context85.next = 6;
                  break;
                }

                _context85.next = 3;
                return this.session.unsubscribe(tracks.map(function (t) {
                  return t.trackID;
                }));

              case 3:
                tracks.forEach(function (t) {
                  t._isSubScribed = false;
                });
                _context85.next = 9;
                break;

              case 6:
                _context85.next = 8;
                return this.session.unsubscribe([tracks.trackID]);

              case 8:
                tracks._isSubScribed = false;

              case 9:
              case "end":
                return _context85.stop();
            }
          }
        }, _callee85, this);
      }));

      function unsubscribe(_x122) {
        return _unsubscribe4.apply(this, arguments);
      }

      return unsubscribe;
    }()
    /**
     * 发送自定义消息
     */

  }, {
    key: "sendMessage",
    value: function () {
      var _sendMessage = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee86(messageID, message, users) {
        var _this97 = this;

        return _regeneratorRuntime.wrap(function _callee86$(_context86) {
          while (1) {
            switch (_context86.prev = _context86.next) {
              case 0:
                if (!Array.isArray(users)) {
                  _context86.next = 5;
                  break;
                }

                _context86.next = 3;
                return Promise.resolve().then(function () {
                  return _this97.session.sendCustomMessage(message, users.map(function (user) {
                    return user.userID;
                  }), messageID);
                });

              case 3:
                _context86.next = 7;
                break;

              case 5:
                _context86.next = 7;
                return Promise.resolve().then(function () {
                  return _this97.session.sendCustomMessage(message, [], messageID);
                });

              case 7:
              case "end":
                return _context86.stop();
            }
          }
        }, _callee86, this);
      }));

      function sendMessage(_x123, _x124, _x125) {
        return _sendMessage.apply(this, arguments);
      }

      return sendMessage;
    }()
    /**
     * 开启单路转推
     */

  }, {
    key: "startDirectLiveStreaming",
    value: function () {
      var _startDirectLiveStreaming = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee87(config) {
        return _regeneratorRuntime.wrap(function _callee87$(_context87) {
          while (1) {
            switch (_context87.prev = _context87.next) {
              case 0:
                _context87.next = 2;
                return this.session.createForwardJob(removeUndefinedKey({
                  userConfigExtraInfo: config.userConfigExtraInfo,
                  jobId: config.streamID,
                  publishUrl: config.url,
                  audioTrackId: config.audioTrack && config.audioTrack.trackID,
                  videoTrackId: config.videoTrack && config.videoTrack.trackID
                }));

              case 2:
              case "end":
                return _context87.stop();
            }
          }
        }, _callee87, this);
      }));

      function startDirectLiveStreaming(_x126) {
        return _startDirectLiveStreaming.apply(this, arguments);
      }

      return startDirectLiveStreaming;
    }()
    /**
     * 停止单路转推
     */

  }, {
    key: "stopDirectLiveStreaming",
    value: function () {
      var _stopDirectLiveStreaming = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee88(streamID) {
        return _regeneratorRuntime.wrap(function _callee88$(_context88) {
          while (1) {
            switch (_context88.prev = _context88.next) {
              case 0:
                _context88.next = 2;
                return this.session.stopForwardJob(streamID);

              case 2:
              case "end":
                return _context88.stop();
            }
          }
        }, _callee88, this);
      }));

      function stopDirectLiveStreaming(_x127) {
        return _stopDirectLiveStreaming.apply(this, arguments);
      }

      return stopDirectLiveStreaming;
    }()
    /**
     * 开启合流转推
     */

  }, {
    key: "startTranscodingLiveStreaming",
    value: function () {
      var _startTranscodingLiveStreaming = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee89(config) {
        return _regeneratorRuntime.wrap(function _callee89$(_context89) {
          while (1) {
            switch (_context89.prev = _context89.next) {
              case 0:
                _context89.next = 2;
                return this.session.createMergeJob(config.streamID, removeUndefinedKey({
                  publishUrl: config.url,
                  height: config.height,
                  width: config.width,
                  fps: config.videoFrameRate,
                  kbps: config.bitrate,
                  stretchMode: config.renderMode,
                  watermarks: config.watermarks && config.watermarks.map(function (watermark) {
                    return {
                      x: watermark.x,
                      y: watermark.y,
                      w: watermark.width,
                      h: watermark.height,
                      url: watermark.url
                    };
                  }),
                  background: config.background && {
                    x: config.background.x,
                    y: config.background.y,
                    w: config.background.width,
                    h: config.background.height,
                    url: config.background.url
                  },
                  maxRate: config.maxBitrate,
                  minRate: config.minBitrate,
                  holdLastFrame: config.holdLastFrame
                }));

              case 2:
                if (!config.transcodingTracks) {
                  _context89.next = 5;
                  break;
                }

                _context89.next = 5;
                return this.setTranscodingLiveStreamingTracks(config.streamID, config.transcodingTracks);

              case 5:
              case "end":
                return _context89.stop();
            }
          }
        }, _callee89, this);
      }));

      function startTranscodingLiveStreaming(_x128) {
        return _startTranscodingLiveStreaming.apply(this, arguments);
      }

      return startTranscodingLiveStreaming;
    }()
    /**
     * 停止合流转推
     */

  }, {
    key: "stopTranscodingLiveStreaming",
    value: function () {
      var _stopTranscodingLiveStreaming = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee90(streamID) {
        return _regeneratorRuntime.wrap(function _callee90$(_context90) {
          while (1) {
            switch (_context90.prev = _context90.next) {
              case 0:
                _context90.next = 2;
                return this.session.stopMergeStream(streamID);

              case 2:
              case "end":
                return _context90.stop();
            }
          }
        }, _callee90, this);
      }));

      function stopTranscodingLiveStreaming(_x129) {
        return _stopTranscodingLiveStreaming.apply(this, arguments);
      }

      return stopTranscodingLiveStreaming;
    }()
    /**
     * 新增、更新合流转推的布局
     */

  }, {
    key: "setTranscodingLiveStreamingTracks",
    value: function () {
      var _setTranscodingLiveStreamingTracks = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee91(streamID, transcodingTracks) {
        var mergeOpts;
        return _regeneratorRuntime.wrap(function _callee91$(_context91) {
          while (1) {
            switch (_context91.prev = _context91.next) {
              case 0:
                mergeOpts = transcodingTracks.map(function (t) {
                  return removeUndefinedKey({
                    trackID: t.trackID,
                    x: t.x,
                    y: t.y,
                    w: t.width,
                    h: t.height,
                    z: t.zOrder,
                    stretchMode: t.renderMode
                  });
                });

                if (!streamID) {
                  _context91.next = 6;
                  break;
                }

                _context91.next = 4;
                return this.session.addMergeStreamTracks(mergeOpts, streamID);

              case 4:
                _context91.next = 8;
                break;

              case 6:
                _context91.next = 8;
                return this.session.addMergeStreamTracks(mergeOpts);

              case 8:
              case "end":
                return _context91.stop();
            }
          }
        }, _callee91, this);
      }));

      function setTranscodingLiveStreamingTracks(_x130, _x131) {
        return _setTranscodingLiveStreamingTracks.apply(this, arguments);
      }

      return setTranscodingLiveStreamingTracks;
    }()
    /**
     * 移除合流转推的布局
     */

  }, {
    key: "removeTranscodingLiveStreamingTracks",
    value: function () {
      var _removeTranscodingLiveStreamingTracks = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee92(streamID, transcodingTracks) {
        return _regeneratorRuntime.wrap(function _callee92$(_context92) {
          while (1) {
            switch (_context92.prev = _context92.next) {
              case 0:
                if (!streamID) {
                  _context92.next = 5;
                  break;
                }

                _context92.next = 3;
                return this.session.removeMergeStreamTracks(transcodingTracks.map(function (t) {
                  return t.trackID;
                }), streamID);

              case 3:
                _context92.next = 7;
                break;

              case 5:
                _context92.next = 7;
                return this.session.removeMergeStreamTracks(transcodingTracks.map(function (t) {
                  return t.trackID;
                }));

              case 7:
              case "end":
                return _context92.stop();
            }
          }
        }, _callee92, this);
      }));

      function removeTranscodingLiveStreamingTracks(_x132, _x133) {
        return _removeTranscodingLiveStreamingTracks.apply(this, arguments);
      }

      return removeTranscodingLiveStreamingTracks;
    }()
    /**
     * 获取自己的网络质量等级
     */

  }, {
    key: "getNetworkQuality",
    value: function getNetworkQuality() {
      var quality = exports.QNNetworkQuality.UNKNOWN; // 取最差的那个返回

      var reduceStart = [];

      var gradeArray = this._localTracks.reduce(function (pre, cur) {
        if (!cur.track) return _toConsumableArray(pre);
        return _toConsumableArray(pre).concat(_toConsumableArray(cur.track.getStats().map(function (stat) {
          return stat.networkGrade;
        })));
      }, reduceStart);

      if (gradeArray.includes(NetworkGrade.POOR)) {
        quality = exports.QNNetworkQuality.POOR;
        return quality;
      }

      if (gradeArray.includes(NetworkGrade.FAIR)) {
        quality = exports.QNNetworkQuality.FAIR;
        return quality;
      }

      if (gradeArray.includes(NetworkGrade.GOOD)) {
        quality = exports.QNNetworkQuality.GOOD;
        return quality;
      }

      if (gradeArray.includes(NetworkGrade.EXCELLENT)) {
        quality = exports.QNNetworkQuality.EXCELLENT;
        return quality;
      }

      return quality;
    }
    /**
     * 获取远端用户的网络质量等级
     */

  }, {
    key: "getUserNetworkQuality",
    value: function getUserNetworkQuality(userID) {
      var quality = exports.QNNetworkQuality.UNKNOWN;
      var user = this.remoteUsers.filter(function (user) {
        return user.userID === userID;
      })[0];

      if (!user) {
        log.warning("cannot find userID: ", userID);
        return quality;
      }

      quality = user.networkQuality;
      return quality;
    }
    /**
     * 启用说话者音量提示。
     * 该方法允许 SDK 定期报告正在说话的远端用户及其音量。
     * 启用音量提示后，无论频道中有没有人说话，SDK 都会每两秒触发 QNRTCClient.on("volume-indicator") 回调。
     */

  }, {
    key: "enableAudioVolumeIndicator",
    value: function enableAudioVolumeIndicator() {
      this.session.registerVolumeIndicatorEvent();
    }
    /**
     * @internal
     * 踢用户出房间
     */

  }, {
    key: "kickOutUser",
    value: function () {
      var _kickOutUser = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee93(userID) {
        var user;
        return _regeneratorRuntime.wrap(function _callee93$(_context93) {
          while (1) {
            switch (_context93.prev = _context93.next) {
              case 0:
                user = this.remoteUsers.find(function (user) {
                  return user.userID === userID;
                });

                if (user) {
                  _context93.next = 4;
                  break;
                }

                log.warning("cannot find userID: ", userID);
                return _context93.abrupt("return");

              case 4:
                _context93.next = 6;
                return this.session.kickoutUser(userID);

              case 6:
              case "end":
                return _context93.stop();
            }
          }
        }, _callee93, this);
      }));

      function kickOutUser(_x134) {
        return _kickOutUser.apply(this, arguments);
      }

      return kickOutUser;
    }()
    /**
     * 开始跨房
     */

  }, {
    key: "startMediaRelay",
    value: function () {
      var _startMediaRelay2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee94(config) {
        return _regeneratorRuntime.wrap(function _callee94$(_context94) {
          while (1) {
            switch (_context94.prev = _context94.next) {
              case 0:
                return _context94.abrupt("return", this.session.startMediaRelay(config));

              case 1:
              case "end":
                return _context94.stop();
            }
          }
        }, _callee94, this);
      }));

      function startMediaRelay(_x135) {
        return _startMediaRelay2.apply(this, arguments);
      }

      return startMediaRelay;
    }()
    /**
     * 更新跨房
     */

  }, {
    key: "updateMediaRelay",
    value: function () {
      var _updateMediaRelay2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee95(config) {
        return _regeneratorRuntime.wrap(function _callee95$(_context95) {
          while (1) {
            switch (_context95.prev = _context95.next) {
              case 0:
                return _context95.abrupt("return", this.session.updateMediaRelay(config));

              case 1:
              case "end":
                return _context95.stop();
            }
          }
        }, _callee95, this);
      }));

      function updateMediaRelay(_x136) {
        return _updateMediaRelay2.apply(this, arguments);
      }

      return updateMediaRelay;
    }()
    /**
     * 结束跨房
     */

  }, {
    key: "stopMediaRelay",
    value: function () {
      var _stopMediaRelay2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee96() {
        return _regeneratorRuntime.wrap(function _callee96$(_context96) {
          while (1) {
            switch (_context96.prev = _context96.next) {
              case 0:
                return _context96.abrupt("return", this.session.stopMediaRelay());

              case 1:
              case "end":
                return _context96.stop();
            }
          }
        }, _callee96, this);
      }));

      function stopMediaRelay() {
        return _stopMediaRelay2.apply(this, arguments);
      }

      return stopMediaRelay;
    }()
  }, {
    key: "userID",
    get: function get() {
      return this.session.userID;
    }
    /**
     * 用户自定义数据
     */

  }, {
    key: "userData",
    get: function get() {
      return this.session.userData;
    }
    /**
     * 当前房间的名称
     */

  }, {
    key: "roomName",
    get: function get() {
      return this.session.roomName;
    }
  }]);

  return QNRTCClient;
}(EventEmitter);
/**
 * @public
 */


var QNLocalTrack =
/*#__PURE__*/
function (_QNTrack2) {
  _inherits(QNLocalTrack, _QNTrack2);

  // @internal
  function QNLocalTrack(track) {
    var _this98;

    _classCallCheck(this, QNLocalTrack);

    _this98 = _possibleConstructorReturn(this, _getPrototypeOf(QNLocalTrack).call(this));
    _this98.track = track;
    qnevents.on("trackEnded", function (trackLocalID) {
      if (_this98._track && trackLocalID === _this98._track.mediaTrack.id) {
        _this98.emit("ended");
      }
    });
    return _this98;
  }
  /**
   * 设置 mute 状态
   */


  _createClass(QNLocalTrack, [{
    key: "setMuted",
    value: function setMuted(isMuted) {
      this._isMuted = isMuted;
      qnevents.emit("set-mute-tracks", this.trackID, isMuted);
    }
    /**
     * 销毁当前流
     */

  }, {
    key: "destroy",
    value: function destroy() {
      if (!this.track) return;
      this.track.release();
    }
  }]);

  return QNLocalTrack;
}(QNTrack);
/**
 * @public
 */


var QNLocalVideoTrack =
/*#__PURE__*/
function (_QNLocalTrack) {
  _inherits(QNLocalVideoTrack, _QNLocalTrack);

  // @internal
  function QNLocalVideoTrack(track) {
    var _this99;

    _classCallCheck(this, QNLocalVideoTrack);

    _this99 = _possibleConstructorReturn(this, _getPrototypeOf(QNLocalVideoTrack).call(this, track));
    /**
     * 是否开启大小流
     * @deprecated use getLowStreamConfig instead
     */

    _this99.isMultiProfileEnabled = false;
    return _this99;
  }

  _createClass(QNLocalVideoTrack, [{
    key: "getLowStreamConfig",
    value: function getLowStreamConfig() {
      if (!this._track) return undefined;
      return this._track.lowStreamConfig;
    }
    /**
     * 截取当前视频流画面
     */

  }, {
    key: "getCurrentFrameData",
    value: function getCurrentFrameData() {
      if (!this._track) return "data:,";
      return this._track.getCurrentFrameDataURL();
    }
    /**
     * 获取流状态数据
     */

  }, {
    key: "getStats",
    value: function getStats() {
      if (!this._track) return [];

      var stats = this._track.getStats();

      if (stats.length === 0) return [];

      if (stats.length === 1) {
        var qnstats = stats.map(function (stat) {
          return {
            uplinkBitrate: stat.bitrate,
            uplinkFrameRate: stat.frameRate,
            uplinkLostRate: stat.packetLossRate,
            uplinkRTT: stat.rtt
          };
        });
        return qnstats;
      } else {
        // 通过码率排序升序，低中高，码率为0去除
        stats = stats.filter(function (s) {
          return s.bitrate !== 0;
        }).sort(function (a, b) {
          return a.bitrate - b.bitrate;
        });

        var _qnstats = stats.map(function (stat) {
          return {
            uplinkBitrate: stat.bitrate,
            uplinkFrameRate: stat.frameRate,
            uplinkLostRate: stat.packetLossRate,
            uplinkRTT: stat.rtt
          };
        });

        if (_qnstats[0]) {
          _qnstats[0].profile = exports.QNTrackProfile.LOW;
        }

        if (_qnstats[1]) {
          _qnstats[1].profile = exports.QNTrackProfile.MEDIUM;
        }

        if (_qnstats[2]) {
          _qnstats[2].profile = exports.QNTrackProfile.HIGH;
        } // 新版本大小流，高的那一路为 HIGH


        if (_qnstats.length == 2 && _qnstats[1].profile === exports.QNTrackProfile.MEDIUM) {
          _qnstats[1].profile = exports.QNTrackProfile.HIGH;
        }

        return _qnstats;
      }
    }
    /**
     * 设置传输优化模式
     */

  }, {
    key: "setOptimizationMode",
    value: function setOptimizationMode(mode) {
      if (!this._track) return false;
      var mediaTrack = this._track.mediaTrack;

      if (!("contentHint" in mediaTrack)) {
        return false;
      }

      mediaTrack.contentHint = mode;

      if (mediaTrack.contentHint !== mode) {
        return false;
      }

      return true;
    }
  }]);

  return QNLocalVideoTrack;
}(QNLocalTrack);
/**
 * @public
 */


var QNCameraVideoTrack =
/*#__PURE__*/
function (_QNLocalVideoTrack) {
  _inherits(QNCameraVideoTrack, _QNLocalVideoTrack);

  // @internal
  function QNCameraVideoTrack(track) {
    _classCallCheck(this, QNCameraVideoTrack);

    return _possibleConstructorReturn(this, _getPrototypeOf(QNCameraVideoTrack).call(this, track));
  }

  _createClass(QNCameraVideoTrack, [{
    key: "play",
    value: function play(container) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (typeof config === "object" && config.mirror === undefined) {
        config.mirror = true;
      }

      return _get(_getPrototypeOf(QNCameraVideoTrack.prototype), "play", this).call(this, container, config);
    }
  }]);

  return QNCameraVideoTrack;
}(QNLocalVideoTrack);
/**
 * @public
 */


var QNLocalAudioTrack =
/*#__PURE__*/
function (_QNLocalTrack2) {
  _inherits(QNLocalAudioTrack, _QNLocalTrack2);

  // @internal
  function QNLocalAudioTrack(track) {
    var _this100;

    _classCallCheck(this, QNLocalAudioTrack);

    _this100 = _possibleConstructorReturn(this, _getPrototypeOf(QNLocalAudioTrack).call(this, track));
    qnevents.on("audioBuffer", function (buffer, trackLocalID) {
      if (trackLocalID === track.mediaTrack.id) {
        _this100.emit("audioFrame", buffer);
      }
    });
    return _this100;
  }
  /**
   * 设置音量
   */


  _createClass(QNLocalAudioTrack, [{
    key: "setVolume",
    value: function setVolume(volume) {
      if (!this.track) return;
      this.track.setVolume(volume);
    }
    /**
     * 获取当前音量
     */

  }, {
    key: "getVolumeLevel",
    value: function getVolumeLevel() {
      if (!this.track) return;
      return this.track.getCurrentVolumeLevel();
    }
    /**
     * 获取当前时域数据
     */

  }, {
    key: "getCurrentTimeDomainData",
    value: function getCurrentTimeDomainData() {
      if (!this.track) return;
      return this.track.getCurrentTimeDomainData();
    }
    /**
     * 获取当前频域数据
     */

  }, {
    key: "getCurrentFrequencyDomainData",
    value: function getCurrentFrequencyDomainData() {
      if (!this.track) return;
      return this.track.getCurrentFrequencyData();
    }
    /**
     * 设置音频输出设备
     * deviceId 可以从 QNRTC.getPlaybackDevices 接口中获取
     * 该功能仅 chrome 支持，如果在不支持功能的浏览器中调用，会抛出 ERROR_NOT_SUPPORT 错误
     */

  }, {
    key: "setPlaybackDevice",
    value: function () {
      var _setPlaybackDevice3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee97(deviceId) {
        return _regeneratorRuntime.wrap(function _callee97$(_context97) {
          while (1) {
            switch (_context97.prev = _context97.next) {
              case 0:
                if (this.track) {
                  _context97.next = 2;
                  break;
                }

                return _context97.abrupt("return");

              case 2:
                return _context97.abrupt("return", this.track.setPlaybackDevice(deviceId));

              case 3:
              case "end":
                return _context97.stop();
            }
          }
        }, _callee97, this);
      }));

      function setPlaybackDevice(_x137) {
        return _setPlaybackDevice3.apply(this, arguments);
      }

      return setPlaybackDevice;
    }()
    /**
     * 获取流状态
     */

  }, {
    key: "getStats",
    value: function getStats() {
      var defaultLocalAudioTrackStats = {
        uplinkBitrate: 0,
        uplinkRTT: 0,
        uplinkLostRate: 0
      };
      if (!this._track) return defaultLocalAudioTrackStats;

      var stats = this._track.getStats();

      if (stats.length === 0) return defaultLocalAudioTrackStats;
      defaultLocalAudioTrackStats.uplinkBitrate = stats[0].bitrate;
      defaultLocalAudioTrackStats.uplinkRTT = stats[0].rtt;
      defaultLocalAudioTrackStats.uplinkLostRate = stats[0].packetLossRate;
      return defaultLocalAudioTrackStats;
    }
  }]);

  return QNLocalAudioTrack;
}(QNLocalTrack);
/**
 * @public
 */


var QNAudioMixer =
/*#__PURE__*/
function (_EventEmitter9) {
  _inherits(QNAudioMixer, _EventEmitter9);

  // @internal
  function QNAudioMixer(mixingManager, source) {
    var _this101;

    _classCallCheck(this, QNAudioMixer);

    _this101 = _possibleConstructorReturn(this, _getPrototypeOf(QNAudioMixer).call(this));
    _this101._mixingManager = mixingManager;
    _this101.source = source;

    _this101._mixingManager.musicManager.on("music-state-change", function (state) {
      switch (state) {
        case AudioSourceState.IDLE:
          return;

        case AudioSourceState.LOADING:
          return;

        case AudioSourceState.PLAY:
          _this101.emit("state-changed", exports.QNAudioSourceState.PlAYING);

          return;

        case AudioSourceState.PAUSE:
          _this101.emit("state-changed", exports.QNAudioSourceState.PAUSED);

          return;

        case AudioSourceState.END:
          _this101.emit("state-changed", exports.QNAudioSourceState.STOPPED);

          return;
      }
    });

    return _this101;
  }
  /**
   * 开始混音并播放
   */


  _createClass(QNAudioMixer, [{
    key: "start",
    value: function () {
      var _start = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee98(loop) {
        return _regeneratorRuntime.wrap(function _callee98$(_context98) {
          while (1) {
            switch (_context98.prev = _context98.next) {
              case 0:
                this._mixingManager.musicManager.setMusicOption({
                  loop: loop
                });

                _context98.next = 3;
                return this._mixingManager.musicManager.startMusicMixing(this.source);

              case 3:
              case "end":
                return _context98.stop();
            }
          }
        }, _callee98, this);
      }));

      function start(_x138) {
        return _start.apply(this, arguments);
      }

      return start;
    }()
    /**
     * 停止混音和播放
     */

  }, {
    key: "stop",
    value: function stop() {
      this._mixingManager.musicManager.stopMusicMixing();
    }
    /**
     * 恢复混音和播放
     */

  }, {
    key: "resume",
    value: function resume() {
      this._mixingManager.musicManager.resumeMusicMixing();
    }
    /**
     * 暂停混音和播放
     */

  }, {
    key: "pause",
    value: function pause() {
      this._mixingManager.musicManager.pauseMusicMixing();
    }
    /**
     * 获取混音音频时长
     */

  }, {
    key: "getDuration",
    value: function getDuration() {
      return this._mixingManager.musicManager.getMusicDuration();
    }
    /**
     * 获取当前混音位置
     */

  }, {
    key: "getCurrentPosition",
    value: function getCurrentPosition() {
      return this._mixingManager.musicManager.getMusicCurrentTime();
    }
    /**
     * 跳转到指定位置混音
     */

  }, {
    key: "seekTo",
    value: function seekTo(time) {
      this._mixingManager.musicManager.setMusicCurrentTime(time);
    }
    /**
     * 设置外部音频本地播放音量
     * 如果不想听到外部音频在本地播放的声音，可以将音频设置为 0
     * @param volume 音量值，默认为 1 表示原始音量
     */

  }, {
    key: "setPlayingVolume",
    value: function setPlayingVolume(volume) {
      this._mixingManager.musicManager.setMusicOption({
        volume: volume
      });
    } // TODO
    // @internal

  }, {
    key: "setMixingVolume",
    value: function setMixingVolume(microphoneVolume, musicVolume) {}
  }]);

  return QNAudioMixer;
}(EventEmitter);
/**
 * @public
 */


var QNMicrophoneAudioTrack =
/*#__PURE__*/
function (_QNLocalAudioTrack) {
  _inherits(QNMicrophoneAudioTrack, _QNLocalAudioTrack);

  // @internal
  function QNMicrophoneAudioTrack(track) {
    var _this102;

    _classCallCheck(this, QNMicrophoneAudioTrack);

    var mixingManager = new AudioMixingManager(track);
    _this102 = _possibleConstructorReturn(this, _getPrototypeOf(QNMicrophoneAudioTrack).call(this, mixingManager.outputTrack));
    _this102._sourceTrack = track;
    _this102._mixingManager = mixingManager;
    _this102.mixerList = [];
    return _this102;
  }
  /**
   * 创建混音管理器
   */


  _createClass(QNMicrophoneAudioTrack, [{
    key: "createAudioMixer",
    value: function createAudioMixer(source) {
      var mixer = new QNAudioMixer(this._mixingManager, source);
      this.mixerList.push(mixer);
      return mixer;
    }
    /**
     * 销毁 track
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this._mixingManager.release();

      this._sourceTrack.release();
    }
  }]);

  return QNMicrophoneAudioTrack;
}(QNLocalAudioTrack);
/**
 * @public
 */


var QNScreenVideoTrack =
/*#__PURE__*/
function (_QNLocalVideoTrack2) {
  _inherits(QNScreenVideoTrack, _QNLocalVideoTrack2);

  // @internal
  function QNScreenVideoTrack(track) {
    _classCallCheck(this, QNScreenVideoTrack);

    return _possibleConstructorReturn(this, _getPrototypeOf(QNScreenVideoTrack).call(this, track));
  }

  return QNScreenVideoTrack;
}(QNLocalVideoTrack);
/**
 * @public
 */


var QNBufferSourceAudioTrack =
/*#__PURE__*/
function (_QNLocalAudioTrack2) {
  _inherits(QNBufferSourceAudioTrack, _QNLocalAudioTrack2);

  // @internal
  function QNBufferSourceAudioTrack(track, source) {
    var _this103;

    _classCallCheck(this, QNBufferSourceAudioTrack);

    _this103 = _possibleConstructorReturn(this, _getPrototypeOf(QNBufferSourceAudioTrack).call(this, track));
    _this103.source = source;
    track.on("audio-state-change", function (state) {
      switch (state) {
        case AudioSourceState.IDLE:
          return;

        case AudioSourceState.LOADING:
          return;

        case AudioSourceState.PLAY:
          _this103.emit("state-changed", exports.QNAudioSourceState.PlAYING);

          return;

        case AudioSourceState.PAUSE:
          _this103.emit("state-changed", exports.QNAudioSourceState.PAUSED);

          return;

        case AudioSourceState.END:
          _this103.emit("state-changed", exports.QNAudioSourceState.STOPPED);

          return;
      }
    });
    return _this103;
  }
  /**
   * 开始
   */


  _createClass(QNBufferSourceAudioTrack, [{
    key: "start",
    value: function () {
      var _start2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee99(loop) {
        return _regeneratorRuntime.wrap(function _callee99$(_context99) {
          while (1) {
            switch (_context99.prev = _context99.next) {
              case 0:
                if (loop) this._track.setLoop(loop);

                this._track.startAudioSource();

              case 2:
              case "end":
                return _context99.stop();
            }
          }
        }, _callee99, this);
      }));

      function start(_x139) {
        return _start2.apply(this, arguments);
      }

      return start;
    }()
    /**
     * 停止
     */

  }, {
    key: "stop",
    value: function stop() {
      this._track.stopAudioSource();
    }
    /**
     * 恢复
     */

  }, {
    key: "resume",
    value: function resume() {
      this._track.resumeAudioSource();
    }
    /**
     * 暂停
     */

  }, {
    key: "pause",
    value: function pause() {
      this._track.pauseAudioSource();
    }
    /**
     * 获取音频时长
     */

  }, {
    key: "getDuration",
    value: function getDuration() {
      return this._track.getDuration();
    }
    /**
     * 获取当前位置
     */

  }, {
    key: "getCurrentPosition",
    value: function getCurrentPosition() {
      return this._track.getCurrentTime();
    }
    /**
     * 跳转到指定位置
     */

  }, {
    key: "seekTo",
    value: function seekTo(time) {
      this._track.setCurrentTime(time);
    }
  }]);

  return QNBufferSourceAudioTrack;
}(QNLocalAudioTrack);
/**
 * @public
 */


var QNCustomAudioTrack =
/*#__PURE__*/
function (_QNLocalAudioTrack3) {
  _inherits(QNCustomAudioTrack, _QNLocalAudioTrack3);

  // @internal
  function QNCustomAudioTrack(track) {
    _classCallCheck(this, QNCustomAudioTrack);

    return _possibleConstructorReturn(this, _getPrototypeOf(QNCustomAudioTrack).call(this, track));
  }
  /**
   * @internal
   * 切换原生 mediaStreamTrack
   */


  _createClass(QNCustomAudioTrack, [{
    key: "setMediaStreamTrack",
    value: function () {
      var _setMediaStreamTrack = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee100(newTrack) {
        return _regeneratorRuntime.wrap(function _callee100$(_context100) {
          while (1) {
            switch (_context100.prev = _context100.next) {
              case 0:
                return _context100.abrupt("return", qnevents.safeEmitAsPromise("setMediaStreamTrack", this.trackID, newTrack));

              case 1:
              case "end":
                return _context100.stop();
            }
          }
        }, _callee100, this);
      }));

      function setMediaStreamTrack(_x140) {
        return _setMediaStreamTrack.apply(this, arguments);
      }

      return setMediaStreamTrack;
    }()
  }]);

  return QNCustomAudioTrack;
}(QNLocalAudioTrack);
/**
 * @public
 */


var QNCustomVideoTrack =
/*#__PURE__*/
function (_QNLocalVideoTrack3) {
  _inherits(QNCustomVideoTrack, _QNLocalVideoTrack3);

  // @internal
  function QNCustomVideoTrack(track) {
    _classCallCheck(this, QNCustomVideoTrack);

    return _possibleConstructorReturn(this, _getPrototypeOf(QNCustomVideoTrack).call(this, track));
  }
  /**
   * @internal
   * 切换原生 mediaStreamTrack
   */


  _createClass(QNCustomVideoTrack, [{
    key: "setMediaStreamTrack",
    value: function () {
      var _setMediaStreamTrack2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee101(newTrack) {
        return _regeneratorRuntime.wrap(function _callee101$(_context101) {
          while (1) {
            switch (_context101.prev = _context101.next) {
              case 0:
                return _context101.abrupt("return", qnevents.safeEmitAsPromise("setMediaStreamTrack", this.trackID, newTrack));

              case 1:
              case "end":
                return _context101.stop();
            }
          }
        }, _callee101, this);
      }));

      function setMediaStreamTrack(_x141) {
        return _setMediaStreamTrack2.apply(this, arguments);
      }

      return setMediaStreamTrack;
    }()
  }]);

  return QNCustomVideoTrack;
}(QNLocalVideoTrack);

var audioData = "data:audio/mpeg;base64,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";
/**
 * @public
 */

var QNCanvasVideoTrack =
/*#__PURE__*/
function (_QNLocalVideoTrack4) {
  _inherits(QNCanvasVideoTrack, _QNLocalVideoTrack4);

  // @internal
  function QNCanvasVideoTrack(track, canvas, ctx, sources) {
    var _this104;

    _classCallCheck(this, QNCanvasVideoTrack);

    _this104 = _possibleConstructorReturn(this, _getPrototypeOf(QNCanvasVideoTrack).call(this, track)); // @internal

    _this104.drawImage = function () {
      _this104.drawImageOnce();

      requestAnimationFrame(_this104.drawImage);
    }; // @internal


    _this104.drawImageOnce = function () {
      if (!_this104.ctx) return;
      var _iteratorNormalCompletion54 = true;
      var _didIteratorError54 = false;
      var _iteratorError54 = undefined;

      try {
        for (var _iterator54 = _this104.canvasSources[Symbol.iterator](), _step54; !(_iteratorNormalCompletion54 = (_step54 = _iterator54.next()).done); _iteratorNormalCompletion54 = true) {
          var item = _step54.value;

          _this104.ctx.drawImage(item.source, item.x, item.y, item.width, item.heigth);
        }
      } catch (err) {
        _didIteratorError54 = true;
        _iteratorError54 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion54 && _iterator54.return != null) {
            _iterator54.return();
          }
        } finally {
          if (_didIteratorError54) {
            throw _iteratorError54;
          }
        }
      }
    };

    _this104.canvas = canvas;
    _this104.ctx = ctx;

    _this104.updateSources(sources).then(_this104.drawImage).catch(function (e) {
      log.warning(e);
    });

    var audio = new Audio();
    audio.src = audioData;
    audio.autoplay = true;
    audio.loop = true;
    audio.muted = true;

    audio.ontimeupdate = function () {
      _this104.drawImageOnce();
    };

    _this104.audioElement = audio;
    return _this104;
  }
  /**
   * 修改画布内容
   */


  _createClass(QNCanvasVideoTrack, [{
    key: "updateSources",
    value: function () {
      var _updateSources = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee102(sources) {
        var resSources, i;
        return _regeneratorRuntime.wrap(function _callee102$(_context102) {
          while (1) {
            switch (_context102.prev = _context102.next) {
              case 0:
                this.sources = sources;
                this.canvasSources = [];
                _context102.next = 4;
                return Promise.all(sources.map(function (item) {
                  return ImageUtils.loadImage(item.source);
                }));

              case 4:
                resSources = _context102.sent;

                if (this.ctx) {
                  this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
                }

                for (i = 0; i < sources.length; i++) {
                  this.canvasSources.push({
                    source: resSources[i],
                    x: sources[i].x,
                    y: sources[i].y,
                    width: sources[i].width || resSources[i].width,
                    heigth: sources[i].height || resSources[i].height
                  });
                }

              case 7:
              case "end":
                return _context102.stop();
            }
          }
        }, _callee102, this);
      }));

      function updateSources(_x142) {
        return _updateSources.apply(this, arguments);
      }

      return updateSources;
    }()
  }, {
    key: "play",
    value: function play(container) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // 图片 track 默认不镜像
      if (config.mirror === undefined) {
        config.mirror = false;
      }

      return _get(_getPrototypeOf(QNCanvasVideoTrack.prototype), "play", this).call(this, container, config);
    }
    /**
     * 销毁当前流
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.ctx = null;
      this.canvas.remove();
      this.sources = [];
      this.canvasSources = [];
      this.audioElement.ontimeupdate = null;
      this.audioElement.src = "";
      this.audioElement.remove();

      _get(_getPrototypeOf(QNCanvasVideoTrack.prototype), "destroy", this).call(this);
    }
  }]);

  return QNCanvasVideoTrack;
}(QNLocalVideoTrack);
/**
 * @public
 */


var QNRTC =
/*#__PURE__*/
function () {
  function QNRTC() {
    _classCallCheck(this, QNRTC);
  }

  _createClass(QNRTC, null, [{
    key: "isBrowserSupported",

    /**
     * 获取浏览器兼容报告
     */
    value: function isBrowserSupported() {
      return __chunk_1.browserReport.support;
    }
    /**
     * 系统兼容检测(约需30s-60s)
     */

  }, {
    key: "checkSystemRequirements",
    value: function () {
      var _checkSystemRequirements3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee103() {
        return _regeneratorRuntime.wrap(function _callee103$(_context103) {
          while (1) {
            switch (_context103.prev = _context103.next) {
              case 0:
                _context103.next = 2;
                return _checkSystemRequirements2();

              case 2:
                return _context103.abrupt("return", _context103.sent);

              case 3:
              case "end":
                return _context103.stop();
            }
          }
        }, _callee103, this);
      }));

      function checkSystemRequirements() {
        return _checkSystemRequirements3.apply(this, arguments);
      }

      return checkSystemRequirements;
    }()
    /**
     * 设置日志打印等级
     */

  }, {
    key: "setLogLevel",
    value: function setLogLevel(level) {
      switch (level) {
        case exports.QNLogLevel.VERBOSE:
          log.setLevel("log");
          break;

        case exports.QNLogLevel.INFO:
          log.setLevel("debug");
          break;

        case exports.QNLogLevel.WARNING:
        case exports.QNLogLevel.ERROR:
          log.setLevel("warning");
          break;

        case exports.QNLogLevel.NONE:
          log.setLevel("disable");
          break;
      }
    }
    /**
     * 检查 Chrome 浏览器插件是否按安装
     */

  }, {
    key: "isChromeExtensionAvailable",
    value: function () {
      var _isChromeExtensionAvailable3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee104() {
        return _regeneratorRuntime.wrap(function _callee104$(_context104) {
          while (1) {
            switch (_context104.prev = _context104.next) {
              case 0:
                _context104.next = 2;
                return _isChromeExtensionAvailable2();

              case 2:
                return _context104.abrupt("return", _context104.sent);

              case 3:
              case "end":
                return _context104.stop();
            }
          }
        }, _callee104, this);
      }));

      function isChromeExtensionAvailable() {
        return _isChromeExtensionAvailable3.apply(this, arguments);
      }

      return isChromeExtensionAvailable;
    }()
    /**
     * 创建 QNRTCClient 对象
     */

  }, {
    key: "createClient",
    value: function createClient() {
      var client = new QNRTCClient(this._transportPolicy);

      QNRTC._clients.push(client);

      return client;
    }
    /**
     * 枚举可用的视频输入设备，比如摄像头
     */

  }, {
    key: "getCameras",
    value: function () {
      var _getCameras = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee105() {
        var skipPermissionCheck,
            _args105 = arguments;
        return _regeneratorRuntime.wrap(function _callee105$(_context105) {
          while (1) {
            switch (_context105.prev = _context105.next) {
              case 0:
                skipPermissionCheck = _args105.length > 0 && _args105[0] !== undefined ? _args105[0] : false;
                return _context105.abrupt("return", deviceManager.getDeviceInfo(skipPermissionCheck, "cameras"));

              case 2:
              case "end":
                return _context105.stop();
            }
          }
        }, _callee105, this);
      }));

      function getCameras() {
        return _getCameras.apply(this, arguments);
      }

      return getCameras;
    }()
    /**
     * 枚举可用的音频输入设备，比如麦克风
     */

  }, {
    key: "getMicrophones",
    value: function () {
      var _getMicrophones = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee106() {
        var skipPermissionCheck,
            _args106 = arguments;
        return _regeneratorRuntime.wrap(function _callee106$(_context106) {
          while (1) {
            switch (_context106.prev = _context106.next) {
              case 0:
                skipPermissionCheck = _args106.length > 0 && _args106[0] !== undefined ? _args106[0] : false;
                return _context106.abrupt("return", deviceManager.getDeviceInfo(skipPermissionCheck, "microphones"));

              case 2:
              case "end":
                return _context106.stop();
            }
          }
        }, _callee106, this);
      }));

      function getMicrophones() {
        return _getMicrophones.apply(this, arguments);
      }

      return getMicrophones;
    }()
    /**
     * 枚举可用的音频播放设备，比如扬声器
     */

  }, {
    key: "getPlaybackDevices",
    value: function () {
      var _getPlaybackDevices = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee107() {
        var skipPermissionCheck,
            _args107 = arguments;
        return _regeneratorRuntime.wrap(function _callee107$(_context107) {
          while (1) {
            switch (_context107.prev = _context107.next) {
              case 0:
                skipPermissionCheck = _args107.length > 0 && _args107[0] !== undefined ? _args107[0] : false;
                return _context107.abrupt("return", deviceManager.getDeviceInfo(skipPermissionCheck, "playback"));

              case 2:
              case "end":
                return _context107.stop();
            }
          }
        }, _callee107, this);
      }));

      function getPlaybackDevices() {
        return _getPlaybackDevices.apply(this, arguments);
      }

      return getPlaybackDevices;
    }()
    /**
     * 枚举可用的媒体输入和输出设备，比如麦克风、摄像头、耳机等
     */

  }, {
    key: "getDevices",
    value: function () {
      var _getDevices = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee108() {
        var skipPermissionCheck,
            _args108 = arguments;
        return _regeneratorRuntime.wrap(function _callee108$(_context108) {
          while (1) {
            switch (_context108.prev = _context108.next) {
              case 0:
                skipPermissionCheck = _args108.length > 0 && _args108[0] !== undefined ? _args108[0] : false;
                return _context108.abrupt("return", deviceManager.getDeviceInfo(skipPermissionCheck, "all"));

              case 2:
              case "end":
                return _context108.stop();
            }
          }
        }, _callee108, this);
      }));

      function getDevices() {
        return _getDevices.apply(this, arguments);
      }

      return getDevices;
    }()
    /**
     * 通过摄像头采集的视频创建一个视频轨道
     */

  }, {
    key: "createCameraVideoTrack",
    value: function () {
      var _createCameraVideoTrack = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee109(config) {
        var encoderConfig, tracks, videoTrack, qntrack;
        return _regeneratorRuntime.wrap(function _callee109$(_context109) {
          while (1) {
            switch (_context109.prev = _context109.next) {
              case 0:
                log.log("createCameraVideoTrack start", config);

                if (!(!config || !config.encoderConfig)) {
                  _context109.next = 5;
                  break;
                }

                encoderConfig = defaultVideoEncoderConfiguration;
                _context109.next = 12;
                break;

              case 5:
                if (!(typeof config.encoderConfig === "string")) {
                  _context109.next = 11;
                  break;
                }

                encoderConfig = SUPPORT_VIDEO_ENCODER_CONFIG_LIST[config.encoderConfig];

                if (encoderConfig) {
                  _context109.next = 9;
                  break;
                }

                throw PRESET_NOT_FOUND();

              case 9:
                _context109.next = 12;
                break;

              case 11:
                encoderConfig = __chunk_1._objectSpread({}, defaultVideoEncoderConfiguration, config.encoderConfig);

              case 12:
                _context109.next = 14;
                return deviceManager.getLocalTracks({
                  video: removeUndefinedKey({
                    enabled: true,
                    width: encoderConfig.width,
                    height: encoderConfig.height,
                    frameRate: encoderConfig.frameRate,
                    bitrate: encoderConfig.bitrate,
                    tag: config && config.tag,
                    facingMode: config && config.facingMode,
                    optimizationMode: config && config.optimizationMode,
                    deviceId: config && config.cameraId
                  })
                });

              case 14:
                tracks = _context109.sent;
                videoTrack = tracks[0];

                if (config && config.encoderConfig && typeof config.encoderConfig !== "string" && config.encoderConfig.lowStreamConfig) {
                  videoTrack.lowStreamConfig = config.encoderConfig.lowStreamConfig;
                }

                qntrack = new QNCameraVideoTrack(videoTrack);

                if (encoderConfig.isMultiProfileEnabled !== undefined) {
                  qntrack.isMultiProfileEnabled = encoderConfig.isMultiProfileEnabled;
                }

                log.log("createCameraVideoTrack end", qntrack);
                return _context109.abrupt("return", qntrack);

              case 21:
              case "end":
                return _context109.stop();
            }
          }
        }, _callee109, this);
      }));

      function createCameraVideoTrack(_x143) {
        return _createCameraVideoTrack.apply(this, arguments);
      }

      return createCameraVideoTrack;
    }()
    /**
     * 通过麦克风采集的音频创建一个音频轨道
     */

  }, {
    key: "createMicrophoneAudioTrack",
    value: function () {
      var _createMicrophoneAudioTrack = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee110(config) {
        var encoderConfig, tracks, qntrack;
        return _regeneratorRuntime.wrap(function _callee110$(_context110) {
          while (1) {
            switch (_context110.prev = _context110.next) {
              case 0:
                log.log("createMicrophoneAudioTrack start", config);

                if (!(!config || !config.encoderConfig)) {
                  _context110.next = 5;
                  break;
                }

                encoderConfig = defaultAudioEncoderConfiguration;
                _context110.next = 12;
                break;

              case 5:
                if (!(typeof config.encoderConfig === "string")) {
                  _context110.next = 11;
                  break;
                }

                encoderConfig = AUDIO_ENCODER_CONFIG_SETTINGS[config.encoderConfig];

                if (encoderConfig) {
                  _context110.next = 9;
                  break;
                }

                throw PRESET_NOT_FOUND();

              case 9:
                _context110.next = 12;
                break;

              case 11:
                encoderConfig = __chunk_1._objectSpread({}, defaultAudioEncoderConfiguration, config.encoderConfig);

              case 12:
                _context110.next = 14;
                return deviceManager.getLocalTracks({
                  audio: removeUndefinedKey({
                    enabled: true,
                    bitrate: encoderConfig.bitrate,
                    sampleRate: encoderConfig.sampleRate,
                    sampleSize: encoderConfig.sampleSize,
                    channelCount: encoderConfig.stereo ? 2 : 1,
                    autoGainControl: config && config.AGC,
                    noiseSuppression: config && config.ANS,
                    echoCancellation: config && config.AEC,
                    deviceId: config && config.microphoneId,
                    tag: config && config.tag
                  })
                });

              case 14:
                tracks = _context110.sent;
                qntrack = new QNMicrophoneAudioTrack(tracks[0]);
                log.log("createMicrophoneAudioTrack end", qntrack);
                return _context110.abrupt("return", qntrack);

              case 18:
              case "end":
                return _context110.stop();
            }
          }
        }, _callee110, this);
      }));

      function createMicrophoneAudioTrack(_x144) {
        return _createMicrophoneAudioTrack.apply(this, arguments);
      }

      return createMicrophoneAudioTrack;
    }()
    /**
     * 创建用于屏幕共享的视频轨道
     */

  }, {
    key: "createScreenVideoTrack",
    value: function () {
      var _createScreenVideoTrack = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee111(config, withAudio) {
        var encoderConfig, tracks, screenConfig, videoTrack, qnt, audioTrack, _videoTrack, qnat, qnvt;

        return _regeneratorRuntime.wrap(function _callee111$(_context111) {
          while (1) {
            switch (_context111.prev = _context111.next) {
              case 0:
                log.log("createScreenVideoTrack start", config, withAudio);

                if (!(!config || !config.encoderConfig)) {
                  _context111.next = 5;
                  break;
                }

                encoderConfig = defaultScreenEncoderConfiguration;
                _context111.next = 12;
                break;

              case 5:
                if (!(typeof config.encoderConfig === "string")) {
                  _context111.next = 11;
                  break;
                }

                encoderConfig = SUPPORT_SCREEN_ENCODER_CONFIG_LIST[config.encoderConfig];

                if (encoderConfig) {
                  _context111.next = 9;
                  break;
                }

                throw PRESET_NOT_FOUND();

              case 9:
                _context111.next = 12;
                break;

              case 11:
                encoderConfig = __chunk_1._objectSpread({}, defaultScreenEncoderConfiguration, config.encoderConfig);

              case 12:
                if (__chunk_1.isElectron && withAudio === "enable") {
                  ERROR_NOT_SUPPORT("withAudio not support in Electron environment");
                }

                tracks = [];

                if (!__chunk_1.isElectron) {
                  _context111.next = 20;
                  break;
                }

                _context111.next = 17;
                return deviceManager.createElectronScreenTrack(removeUndefinedKey({
                  sourceID: config && config.electronScreenSourceID,
                  screenBitrate: encoderConfig.bitrate,
                  width: encoderConfig.width,
                  height: encoderConfig.height,
                  optimizationMode: config && config.optimizationMode,
                  tag: config && config.screenVideoTag
                }));

              case 17:
                tracks = _context111.sent;
                _context111.next = 32;
                break;

              case 20:
                screenConfig = removeUndefinedKey({
                  enabled: true,
                  width: encoderConfig.width,
                  height: encoderConfig.height,
                  bitrate: encoderConfig.bitrate,
                  optimizationMode: config && config.optimizationMode,
                  tag: config && config.screenVideoTag,
                  audio: withAudio && ["enable", "auto"].includes(withAudio) ? true : undefined,
                  audioTag: config && config.screenAudioTag
                });

                if (!(config && config.chromeExtensionSourceType)) {
                  _context111.next = 29;
                  break;
                }

                _context111.t0 = config.chromeExtensionSourceType;
                _context111.next = _context111.t0 === exports.QNChromeExtensionSourceType.ALL ? 25 : _context111.t0 === exports.QNChromeExtensionSourceType.SCREEN ? 27 : _context111.t0 === exports.QNChromeExtensionSourceType.WINDOW ? 27 : 29;
                break;

              case 25:
                screenConfig = __chunk_1._objectSpread({}, screenConfig, {
                  forceChromePlugin: true
                });
                return _context111.abrupt("break", 29);

              case 27:
                screenConfig = __chunk_1._objectSpread({}, screenConfig, {
                  forceChromePlugin: true,
                  source: config.chromeExtensionSourceType
                });
                return _context111.abrupt("break", 29);

              case 29:
                _context111.next = 31;
                return deviceManager.getLocalTracks({
                  screen: screenConfig
                });

              case 31:
                tracks = _context111.sent;

              case 32:
                if (!(tracks.length === 1 && tracks[0].info.kind === "video" && withAudio === "enable")) {
                  _context111.next = 35;
                  break;
                }

                tracks[0].release();
                throw CREATE_SCREEN_AUDIO_ERROR();

              case 35:
                if (!(tracks.length === 1 && tracks[0].info.kind === "video")) {
                  _context111.next = 44;
                  break;
                }

                videoTrack = tracks[0];

                if (config && config.encoderConfig && typeof config.encoderConfig !== "string" && config.encoderConfig.lowStreamConfig) {
                  videoTrack.lowStreamConfig = config.encoderConfig.lowStreamConfig;
                }

                qnt = new QNScreenVideoTrack(videoTrack);

                if (encoderConfig.isMultiProfileEnabled !== undefined) {
                  qnt.isMultiProfileEnabled = encoderConfig.isMultiProfileEnabled;
                }

                log.log("createScreenVideoTrack end", qnt);
                return _context111.abrupt("return", qnt);

              case 44:
                audioTrack = tracks.filter(function (t) {
                  return t.info.kind === "audio";
                })[0];
                _videoTrack = tracks.filter(function (t) {
                  return t.info.kind === "video";
                })[0];

                if (!(!audioTrack || !_videoTrack)) {
                  _context111.next = 48;
                  break;
                }

                throw ERROR_FATAL("createScreenVideoTrack error, audioTrack: ".concat(audioTrack, ", videoTrack: ").concat(_videoTrack));

              case 48:
                if (config && config.encoderConfig && typeof config.encoderConfig !== "string" && config.encoderConfig.lowStreamConfig) {
                  _videoTrack.lowStreamConfig = config.encoderConfig.lowStreamConfig;
                }

                qnat = new QNLocalAudioTrack(audioTrack);
                qnvt = new QNScreenVideoTrack(_videoTrack);

                if (encoderConfig.isMultiProfileEnabled !== undefined) {
                  qnvt.isMultiProfileEnabled = encoderConfig.isMultiProfileEnabled;
                }

                log.log("createScreenVideoTrack end", [qnvt, qnat]);
                return _context111.abrupt("return", [qnvt, qnat]);

              case 54:
              case "end":
                return _context111.stop();
            }
          }
        }, _callee111, this);
      }));

      function createScreenVideoTrack(_x145, _x146) {
        return _createScreenVideoTrack.apply(this, arguments);
      }

      return createScreenVideoTrack;
    }()
    /**
     * 同时采集麦克风音频和摄像头视频轨道
     */

  }, {
    key: "createMicrophoneAndCameraTracks",
    value: function () {
      var _createMicrophoneAndCameraTracks = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee112(audioConfig, videoConfig) {
        var audioEncoderConfig, videoEncoderConfig, tracks, audioTrack, videoTrack, qnat, qnvt;
        return _regeneratorRuntime.wrap(function _callee112$(_context112) {
          while (1) {
            switch (_context112.prev = _context112.next) {
              case 0:
                log.log("createMicrophoneAndCameraTracks start", audioConfig, videoConfig);

                if (!(!audioConfig || !audioConfig.encoderConfig)) {
                  _context112.next = 5;
                  break;
                }

                audioEncoderConfig = defaultAudioEncoderConfiguration;
                _context112.next = 12;
                break;

              case 5:
                if (!(typeof audioConfig.encoderConfig === "string")) {
                  _context112.next = 11;
                  break;
                }

                audioEncoderConfig = AUDIO_ENCODER_CONFIG_SETTINGS[audioConfig.encoderConfig];

                if (audioEncoderConfig) {
                  _context112.next = 9;
                  break;
                }

                throw PRESET_NOT_FOUND();

              case 9:
                _context112.next = 12;
                break;

              case 11:
                audioEncoderConfig = __chunk_1._objectSpread({}, defaultAudioEncoderConfiguration, audioConfig.encoderConfig);

              case 12:
                if (!(!videoConfig || !videoConfig.encoderConfig)) {
                  _context112.next = 16;
                  break;
                }

                videoEncoderConfig = defaultVideoEncoderConfiguration;
                _context112.next = 23;
                break;

              case 16:
                if (!(typeof videoConfig.encoderConfig === "string")) {
                  _context112.next = 22;
                  break;
                }

                videoEncoderConfig = SUPPORT_VIDEO_ENCODER_CONFIG_LIST[videoConfig.encoderConfig];

                if (videoEncoderConfig) {
                  _context112.next = 20;
                  break;
                }

                throw PRESET_NOT_FOUND();

              case 20:
                _context112.next = 23;
                break;

              case 22:
                videoEncoderConfig = __chunk_1._objectSpread({}, defaultVideoEncoderConfiguration, videoConfig.encoderConfig);

              case 23:
                _context112.next = 25;
                return deviceManager.getLocalTracks({
                  audio: removeUndefinedKey({
                    enabled: true,
                    bitrate: audioEncoderConfig.bitrate,
                    sampleRate: audioEncoderConfig.sampleRate,
                    sampleSize: audioEncoderConfig.sampleSize,
                    channelCount: audioEncoderConfig.stereo ? 2 : 1,
                    autoGainControl: audioConfig && audioConfig.AGC,
                    noiseSuppression: audioConfig && audioConfig.ANS,
                    echoCancellation: audioConfig && audioConfig.AEC,
                    deviceId: audioConfig && audioConfig.microphoneId,
                    tag: audioConfig && audioConfig.tag
                  }),
                  video: removeUndefinedKey({
                    enabled: true,
                    width: videoEncoderConfig.width,
                    height: videoEncoderConfig.height,
                    frameRate: videoEncoderConfig.frameRate,
                    bitrate: videoEncoderConfig.bitrate,
                    tag: videoConfig && videoConfig.tag,
                    facingMode: videoConfig && videoConfig.facingMode,
                    deviceId: videoConfig && videoConfig.cameraId
                  })
                });

              case 25:
                tracks = _context112.sent;
                audioTrack = tracks.filter(function (t) {
                  return t.info.kind === "audio";
                })[0];
                videoTrack = tracks.filter(function (t) {
                  return t.info.kind === "video";
                })[0];

                if (!(!audioTrack || !videoTrack)) {
                  _context112.next = 30;
                  break;
                }

                throw ERROR_FATAL("createMicrophoneAndCameraTracks error, audioTrack: ".concat(audioTrack, ", videoTrack: ").concat(videoTrack));

              case 30:
                if (videoConfig && videoConfig.encoderConfig && typeof videoConfig.encoderConfig !== "string" && videoConfig.encoderConfig.lowStreamConfig) {
                  videoTrack.lowStreamConfig = videoConfig.encoderConfig.lowStreamConfig;
                }

                qnat = new QNMicrophoneAudioTrack(audioTrack);
                qnvt = new QNCameraVideoTrack(videoTrack);

                if (videoEncoderConfig.isMultiProfileEnabled !== undefined) {
                  qnvt.isMultiProfileEnabled = videoEncoderConfig.isMultiProfileEnabled;
                }

                log.log("createMicrophoneAndCameraTracks end", [qnat, qnvt]);
                return _context112.abrupt("return", [qnat, qnvt]);

              case 36:
              case "end":
                return _context112.stop();
            }
          }
        }, _callee112, this);
      }));

      function createMicrophoneAndCameraTracks(_x147, _x148) {
        return _createMicrophoneAndCameraTracks.apply(this, arguments);
      }

      return createMicrophoneAndCameraTracks;
    }()
    /**
     * 通过音频文件或者 AudioBuffer 对象创建一个音频轨道
     */

  }, {
    key: "createBufferSourceAudioTrack",
    value: function () {
      var _createBufferSourceAudioTrack = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee113(config) {
        var encoderConfig, tracks, qntrack;
        return _regeneratorRuntime.wrap(function _callee113$(_context113) {
          while (1) {
            switch (_context113.prev = _context113.next) {
              case 0:
                log.log("createBufferSourceAudioTrack start", config);

                if (!(!config || !config.encoderConfig)) {
                  _context113.next = 5;
                  break;
                }

                encoderConfig = defaultAudioEncoderConfiguration;
                _context113.next = 12;
                break;

              case 5:
                if (!(typeof config.encoderConfig === "string")) {
                  _context113.next = 11;
                  break;
                }

                encoderConfig = AUDIO_ENCODER_CONFIG_SETTINGS[config.encoderConfig];

                if (encoderConfig) {
                  _context113.next = 9;
                  break;
                }

                throw PRESET_NOT_FOUND();

              case 9:
                _context113.next = 12;
                break;

              case 11:
                encoderConfig = __chunk_1._objectSpread({}, defaultAudioEncoderConfiguration, config.encoderConfig);

              case 12:
                _context113.next = 14;
                return deviceManager.getLocalTracks({
                  audio: removeUndefinedKey({
                    enabled: true,
                    source: config.source,
                    bitrate: encoderConfig.bitrate,
                    sampleRate: encoderConfig.sampleRate,
                    sampleSize: encoderConfig.sampleSize,
                    channelCount: encoderConfig.stereo ? 2 : 1,
                    tag: config && config.tag
                  })
                });

              case 14:
                tracks = _context113.sent;
                qntrack = new QNBufferSourceAudioTrack(tracks[0], config.source);
                log.log("createBufferSourceAudioTrack end", qntrack);
                return _context113.abrupt("return", qntrack);

              case 18:
              case "end":
                return _context113.stop();
            }
          }
        }, _callee113, this);
      }));

      function createBufferSourceAudioTrack(_x149) {
        return _createBufferSourceAudioTrack.apply(this, arguments);
      }

      return createBufferSourceAudioTrack;
    }()
    /**
     * 创建 canvas video track
     */

  }, {
    key: "createCanvasVideoTrack",
    value: function createCanvasVideoTrack(config) {
      var canvas = document.createElement("canvas");
      canvas.width = config.width;
      canvas.height = config.height;
      var frameRate = 15; // 图片 track，暂定默认帧率 15

      var ctx = canvas.getContext("2d");

      if (ctx === null) {
        throw ERROR_NOT_SUPPORT("get context error, canvas track not supported");
      }

      var stream;

      if (canvas.captureStream) {
        stream = canvas.captureStream(frameRate);
      } else if (canvas.mozCaptureStream) {
        stream = canvas.mozCaptureStream(frameRate);
      } else {
        throw ERROR_NOT_SUPPORT("capture stream error, canvas track not supported");
      }

      var mediaStreamTrack = stream.getTracks()[0];

      if (config.optimizationMode && "contentHint" in mediaStreamTrack) {
        mediaStreamTrack.contentHint = config.optimizationMode;
      }

      var track = createCustomTrack(mediaStreamTrack, config.tag);
      var qntrack = new QNCanvasVideoTrack(track, canvas, ctx, config.sources);
      return qntrack;
    }
    /**
     * 创建一个自定义的音频轨道
     */

  }, {
    key: "createCustomAudioTrack",
    value: function createCustomAudioTrack(config) {
      var track = createCustomTrack(config.mediaStreamTrack, config.tag, config.bitrate);
      var qntrack = new QNCustomAudioTrack(track);
      return qntrack;
    }
    /**
     * 创建一个自定义的视频轨道
     */

  }, {
    key: "createCustomVideoTrack",
    value: function createCustomVideoTrack(config) {
      if (config.optimizationMode && "contentHint" in config.mediaStreamTrack) {
        config.mediaStreamTrack.contentHint = config.optimizationMode;
      }

      var track = createCustomTrack(config.mediaStreamTrack, config.tag, config.bitrate);
      var qntrack = new QNCustomVideoTrack(track);
      return qntrack;
    }
    /**
     * 设置传输模式
     */

  }, {
    key: "setTransportPolicy",
    value: function setTransportPolicy(policy) {
      var _this105 = this;

      if (policy === exports.QNTransportPolicy.FORCE_TCP) {
        this._transportPolicy = "forceTcp";
      }

      if (policy === exports.QNTransportPolicy.FORCE_UDP) {
        this._transportPolicy = "forceUdp";
      }

      this._clients.forEach(function (client) {
        return client.setTransportPolicy(_this105._transportPolicy);
      });
    }
    /**
     * 检测音频轨道是否活跃。
     * 在一定时间内检测音频轨道声音是否有变化或者是否低于正常值。
     * 可以在开始通话前对音频输入设备进行可用性检测。
     * sdk 最低检测事件为200 ms，若传入值小于60，则 sdk 会自动调整为 200ms。
     */

  }, {
    key: "checkAudioTrackIsActive",
    value: function () {
      var _checkAudioTrackIsActive = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee114(track) {
        var timeout,
            _timer,
            _args114 = arguments;

        return _regeneratorRuntime.wrap(function _callee114$(_context114) {
          while (1) {
            switch (_context114.prev = _context114.next) {
              case 0:
                timeout = _args114.length > 1 && _args114[1] !== undefined ? _args114[1] : 5000;
                _timer = Math.min(200, timeout);
                return _context114.abrupt("return", new Promise(function (resolve, reject) {
                  if (track.isAudio()) {
                    // 最低异常声音阀值
                    var minLevel = 0.01; // 定时间隔

                    var interval = 200; // 上一次检测音量值

                    var lastLevel = track.getVolumeLevel() || 0; // 当前检测音量值

                    var curLevel = track.getVolumeLevel() || 0; // 低音量异常

                    var lowVolume = curLevel <= minLevel; // 音量无变化异常

                    var equalVolume = true; // 被静音的话直接返回 false

                    if (track.isMuted()) {
                      resolve(false);
                    } else {
                      var timer = setInterval(function () {
                        // 中途被静音的话，直接返回 false
                        if (track.isMuted()) {
                          resolve(false);
                          clearInterval(timer);
                        } else {
                          lastLevel = curLevel;
                          curLevel = track.getVolumeLevel() || 0; // 只要有一次音量大于阀值，则无低音量异常

                          curLevel > minLevel && (lowVolume = false); // 只要有一次前后间隔音量不同，则无音量无变化异常

                          curLevel !== lastLevel && (equalVolume = false);
                        }
                      }, interval);
                      setTimeout(function () {
                        return setTimeout(function () {
                          timer && (clearInterval(timer), resolve(!lowVolume && !equalVolume));
                        }, 0);
                      }, _timer);
                    }
                  } else {
                    reject(ERROR_FATAL("only support audio track"));
                  }
                }));

              case 3:
              case "end":
                return _context114.stop();
            }
          }
        }, _callee114, this);
      }));

      function checkAudioTrackIsActive(_x150) {
        return _checkAudioTrackIsActive.apply(this, arguments);
      }

      return checkAudioTrackIsActive;
    }()
    /**
     * 检测视频轨道是否活跃。
     * 在一定时间内检测视频轨道画面是否有变化。
     * 可以在开始通话前对视频输入设备进行可用性检测。
     * 当视频轨被 muted 的时候返回 false。
     * sdk 最低检测事件为60 ms，若传入值小于60，则 sdk 会自动调整为 60ms。
     */

  }, {
    key: "checkVideoTrackIsActive",
    value: function () {
      var _checkVideoTrackIsActive = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee115(track) {
        var timeout,
            _args115 = arguments;
        return _regeneratorRuntime.wrap(function _callee115$(_context115) {
          while (1) {
            switch (_context115.prev = _context115.next) {
              case 0:
                timeout = _args115.length > 1 && _args115[1] !== undefined ? _args115[1] : 5000;
                return _context115.abrupt("return", new Promise(function (resolve, reject) {
                  if (track.isVideo()) {
                    var mediaStreamTrack = track.getMediaStreamTrack();

                    if (track.isMuted()) {
                      resolve(false);
                    }

                    if (mediaStreamTrack === undefined) {
                      reject(ERROR_FATAL("cannot find mediaStreamTrack"));
                    } else {
                      // 插入 video 标签并播放 track
                      var video = document.createElement("video");
                      video.style.width = "1px";
                      video.style.height = "1px";
                      video.setAttribute("muted", "");
                      video.muted = true;
                      video.setAttribute("playsinline", "");
                      video.controls = false;
                      video.style.opacity = "0.01";
                      video.style.position = "fixed";
                      video.style.left = "0";
                      video.style.top = "0";
                      document.body.appendChild(video);
                      video.srcObject = new MediaStream([mediaStreamTrack]);
                      video.play(); // 通过 canvas 绘制 video 获取对应的 imageData

                      var canvas = document.createElement("canvas");
                      canvas.width = 160;
                      canvas.height = 120;
                      var canvasCtx = canvas.getContext("2d");

                      if (canvasCtx) {
                        var active = false;
                        var data = null;
                        var timer = setInterval(function () {
                          if (track.isMuted()) {
                            timer && (clearInterval(timer), resolve(false));
                            video && video.remove();
                          }

                          canvasCtx.drawImage(video, 0, 0, 160, 120);
                          var imageData = canvasCtx.getImageData(0, 0, canvas.width, canvas.height); // 随机取样图片数据，判断前后图片数据是否一致，只要有一次不一致即认为视频轨是活动的

                          var result = Math.floor(imageData.data.length / 3);

                          if (data) {
                            for (var i = 0; i < result; i += 3) {
                              if (imageData.data[i] !== data[i]) {
                                active = true;
                                break;
                              }
                            }
                          } else {
                            data = imageData.data;
                          }
                        }, 30); // 一定时间后停止采样，并返回结果

                        setTimeout(function () {
                          setTimeout(function () {
                            timer && (clearInterval(timer), resolve(active));
                            video && video.remove();
                          }, 0);
                        }, timeout);
                      } else {
                        reject(ERROR_FATAL("can not get canvas 2d context"));
                      }
                    }
                  } else {
                    reject(ERROR_FATAL("only support video track"));
                  }
                }));

              case 2:
              case "end":
                return _context115.stop();
            }
          }
        }, _callee115, this);
      }));

      function checkVideoTrackIsActive(_x151) {
        return _checkVideoTrackIsActive.apply(this, arguments);
      }

      return checkVideoTrackIsActive;
    }()
    /**
     * 在 Electron 环境下获取屏幕共享源
     */

  }, {
    key: "getElectronScreenSources",
    value: function () {
      var _getElectronScreenSources2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee116(type) {
        return _regeneratorRuntime.wrap(function _callee116$(_context116) {
          while (1) {
            switch (_context116.prev = _context116.next) {
              case 0:
                return _context116.abrupt("return", deviceManager.getElectronScreenSources(type));

              case 1:
              case "end":
                return _context116.stop();
            }
          }
        }, _callee116, this);
      }));

      function getElectronScreenSources(_x152) {
        return _getElectronScreenSources2.apply(this, arguments);
      }

      return getElectronScreenSources;
    }()
  }, {
    key: "VERSION",

    /**
     * 获取 SDK 版本号
     */
    get: function get() {
      return version;
    }
  }]);

  return QNRTC;
}(); // @internal


QNRTC._clients = []; // @internal

QNRTC._transportPolicy = "preferUdp";
deviceManager.on("device-changed", function (deviceInfo) {
  switch (deviceInfo.device.kind) {
    case "audioinput":
      if (QNRTC.onMicrophoneChanged) QNRTC.onMicrophoneChanged(deviceInfo);
      break;

    case "audiooutput":
      if (QNRTC.onPlaybackDeviceChanged) QNRTC.onPlaybackDeviceChanged(deviceInfo);
      break;

    case "videoinput":
      if (QNRTC.onCameraChanged) QNRTC.onCameraChanged(deviceInfo);
      break;
  }
});
/*
 * index.ts
 * Copyright (C) 2018 disoul <disoul@DiSouldeMacBook-Pro.local>
 *
 * Distributed under terms of the MIT license.
*/

exports.default = QNRTC;
exports.QNRemoteUser = QNRemoteUser;
exports.QNRTCClient = QNRTCClient;
exports.QNTrack = QNTrack;
exports.QNRemoteTrack = QNRemoteTrack;
exports.QNRemoteAudioTrack = QNRemoteAudioTrack;
exports.QNRemoteVideoTrack = QNRemoteVideoTrack;
exports.QNLocalAudioTrack = QNLocalAudioTrack;
exports.QNLocalTrack = QNLocalTrack;
exports.QNLocalVideoTrack = QNLocalVideoTrack;
exports.QNCameraVideoTrack = QNCameraVideoTrack;
exports.QNMicrophoneAudioTrack = QNMicrophoneAudioTrack;
exports.QNScreenVideoTrack = QNScreenVideoTrack;
exports.QNCustomAudioTrack = QNCustomAudioTrack;
exports.QNCustomVideoTrack = QNCustomVideoTrack;
exports.QNBufferSourceAudioTrack = QNBufferSourceAudioTrack;
exports.QNAudioMixer = QNAudioMixer;
exports.QNCanvasVideoTrack = QNCanvasVideoTrack;
exports.SUPPORT_VIDEO_ENCODER_CONFIG_LIST = SUPPORT_VIDEO_ENCODER_CONFIG_LIST;
exports.defaultVideoEncoderConfiguration = defaultVideoEncoderConfiguration;
exports.AUDIO_ENCODER_CONFIG_SETTINGS = AUDIO_ENCODER_CONFIG_SETTINGS;
exports.defaultAudioEncoderConfiguration = defaultAudioEncoderConfiguration;
exports.SUPPORT_SCREEN_ENCODER_CONFIG_LIST = SUPPORT_SCREEN_ENCODER_CONFIG_LIST;
exports.defaultScreenEncoderConfiguration = defaultScreenEncoderConfiguration;